import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  apmode: any;
  bridgetype: any;
  cidr: any;
  firmwarecategory: any;
  inet: any;
  numeric: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** columns and relationships of "Carrier" */
export type Carrier = {
  __typename?: 'Carrier';
  /** An object relationship */
  Partner: Partner;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "Carrier" */
export type Carrier_Aggregate = {
  __typename?: 'Carrier_aggregate';
  aggregate?: Maybe<Carrier_Aggregate_Fields>;
  nodes: Array<Carrier>;
};

/** aggregate fields of "Carrier" */
export type Carrier_Aggregate_Fields = {
  __typename?: 'Carrier_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Carrier_Max_Fields>;
  min?: Maybe<Carrier_Min_Fields>;
};


/** aggregate fields of "Carrier" */
export type Carrier_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Carrier_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Carrier" */
export type Carrier_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Carrier_Max_Order_By>;
  min?: InputMaybe<Carrier_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Carrier" */
export type Carrier_Arr_Rel_Insert_Input = {
  data: Array<Carrier_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Carrier". All fields are combined with a logical 'AND'. */
export type Carrier_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  _and?: InputMaybe<Array<Carrier_Bool_Exp>>;
  _not?: InputMaybe<Carrier_Bool_Exp>;
  _or?: InputMaybe<Array<Carrier_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "Carrier" */
export enum Carrier_Constraint {
  /** unique or primary key constraint */
  CarrierPkey = 'Carrier_pkey'
}

/** input type for inserting data into table "Carrier" */
export type Carrier_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Carrier_Max_Fields = {
  __typename?: 'Carrier_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "Carrier" */
export type Carrier_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Carrier_Min_Fields = {
  __typename?: 'Carrier_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "Carrier" */
export type Carrier_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Carrier" */
export type Carrier_Mutation_Response = {
  __typename?: 'Carrier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Carrier>;
};

/** on_conflict condition type for table "Carrier" */
export type Carrier_On_Conflict = {
  constraint: Carrier_Constraint;
  update_columns?: Array<Carrier_Update_Column>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};

/** Ordering options when selecting data from "Carrier". */
export type Carrier_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Carrier */
export type Carrier_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Carrier" */
export enum Carrier_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "Carrier" */
export type Carrier_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "Carrier" */
export enum Carrier_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "ClientCompany" */
export type ClientCompany = {
  __typename?: 'ClientCompany';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  Quicklinks: Array<Quicklink>;
  /** An aggregate relationship */
  Quicklinks_aggregate: Quicklink_Aggregate;
  /** An array relationship */
  Sites: Array<Site>;
  /** An aggregate relationship */
  Sites_aggregate: Site_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "ClientCompany" */
export type ClientCompanyQuicklinksArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


/** columns and relationships of "ClientCompany" */
export type ClientCompanyQuicklinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


/** columns and relationships of "ClientCompany" */
export type ClientCompanySitesArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


/** columns and relationships of "ClientCompany" */
export type ClientCompanySites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** aggregated selection of "ClientCompany" */
export type ClientCompany_Aggregate = {
  __typename?: 'ClientCompany_aggregate';
  aggregate?: Maybe<ClientCompany_Aggregate_Fields>;
  nodes: Array<ClientCompany>;
};

/** aggregate fields of "ClientCompany" */
export type ClientCompany_Aggregate_Fields = {
  __typename?: 'ClientCompany_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ClientCompany_Max_Fields>;
  min?: Maybe<ClientCompany_Min_Fields>;
};


/** aggregate fields of "ClientCompany" */
export type ClientCompany_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClientCompany_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ClientCompany" */
export type ClientCompany_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ClientCompany_Max_Order_By>;
  min?: InputMaybe<ClientCompany_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ClientCompany" */
export type ClientCompany_Arr_Rel_Insert_Input = {
  data: Array<ClientCompany_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ClientCompany_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ClientCompany". All fields are combined with a logical 'AND'. */
export type ClientCompany_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  Quicklinks?: InputMaybe<Quicklink_Bool_Exp>;
  Sites?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<ClientCompany_Bool_Exp>>;
  _not?: InputMaybe<ClientCompany_Bool_Exp>;
  _or?: InputMaybe<Array<ClientCompany_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ClientCompany" */
export enum ClientCompany_Constraint {
  /** unique or primary key constraint */
  ClientCompanyPkey = 'ClientCompany_pkey'
}

/** input type for inserting data into table "ClientCompany" */
export type ClientCompany_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  Quicklinks?: InputMaybe<Quicklink_Arr_Rel_Insert_Input>;
  Sites?: InputMaybe<Site_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ClientCompany_Max_Fields = {
  __typename?: 'ClientCompany_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ClientCompany" */
export type ClientCompany_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ClientCompany_Min_Fields = {
  __typename?: 'ClientCompany_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ClientCompany" */
export type ClientCompany_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ClientCompany" */
export type ClientCompany_Mutation_Response = {
  __typename?: 'ClientCompany_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClientCompany>;
};

/** input type for inserting object relation for remote table "ClientCompany" */
export type ClientCompany_Obj_Rel_Insert_Input = {
  data: ClientCompany_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ClientCompany_On_Conflict>;
};

/** on_conflict condition type for table "ClientCompany" */
export type ClientCompany_On_Conflict = {
  constraint: ClientCompany_Constraint;
  update_columns?: Array<ClientCompany_Update_Column>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};

/** Ordering options when selecting data from "ClientCompany". */
export type ClientCompany_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  Quicklinks_aggregate?: InputMaybe<Quicklink_Aggregate_Order_By>;
  Sites_aggregate?: InputMaybe<Site_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ClientCompany */
export type ClientCompany_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ClientCompany" */
export enum ClientCompany_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ClientCompany" */
export type ClientCompany_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  industry?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ClientCompany" */
export enum ClientCompany_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Firmware" */
export type Firmware = {
  __typename?: 'Firmware';
  URI: Scalars['String'];
  category: Scalars['firmwarecategory'];
  created_at: Scalars['timestamptz'];
  hash: Scalars['String'];
  id: Scalars['uuid'];
  isActive?: Maybe<Scalars['Boolean']>;
  track: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['String'];
};

/** aggregated selection of "Firmware" */
export type Firmware_Aggregate = {
  __typename?: 'Firmware_aggregate';
  aggregate?: Maybe<Firmware_Aggregate_Fields>;
  nodes: Array<Firmware>;
};

/** aggregate fields of "Firmware" */
export type Firmware_Aggregate_Fields = {
  __typename?: 'Firmware_aggregate_fields';
  avg?: Maybe<Firmware_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Firmware_Max_Fields>;
  min?: Maybe<Firmware_Min_Fields>;
  stddev?: Maybe<Firmware_Stddev_Fields>;
  stddev_pop?: Maybe<Firmware_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Firmware_Stddev_Samp_Fields>;
  sum?: Maybe<Firmware_Sum_Fields>;
  var_pop?: Maybe<Firmware_Var_Pop_Fields>;
  var_samp?: Maybe<Firmware_Var_Samp_Fields>;
  variance?: Maybe<Firmware_Variance_Fields>;
};


/** aggregate fields of "Firmware" */
export type Firmware_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Firmware_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Firmware_Avg_Fields = {
  __typename?: 'Firmware_avg_fields';
  track?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "Firmware". All fields are combined with a logical 'AND'. */
export type Firmware_Bool_Exp = {
  URI?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Firmware_Bool_Exp>>;
  _not?: InputMaybe<Firmware_Bool_Exp>;
  _or?: InputMaybe<Array<Firmware_Bool_Exp>>;
  category?: InputMaybe<Firmwarecategory_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  track?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Firmware" */
export enum Firmware_Constraint {
  /** unique or primary key constraint */
  FirmwareHashKey = 'Firmware_hash_key',
  /** unique or primary key constraint */
  FirmwarePkey = 'Firmware_pkey'
}

/** input type for incrementing numeric columns in table "Firmware" */
export type Firmware_Inc_Input = {
  track?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Firmware" */
export type Firmware_Insert_Input = {
  URI?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['firmwarecategory']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  track?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Firmware_Max_Fields = {
  __typename?: 'Firmware_max_fields';
  URI?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  track?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Firmware_Min_Fields = {
  __typename?: 'Firmware_min_fields';
  URI?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  track?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "Firmware" */
export type Firmware_Mutation_Response = {
  __typename?: 'Firmware_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Firmware>;
};

/** on_conflict condition type for table "Firmware" */
export type Firmware_On_Conflict = {
  constraint: Firmware_Constraint;
  update_columns?: Array<Firmware_Update_Column>;
  where?: InputMaybe<Firmware_Bool_Exp>;
};

/** Ordering options when selecting data from "Firmware". */
export type Firmware_Order_By = {
  URI?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  track?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Firmware */
export type Firmware_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Firmware" */
export enum Firmware_Select_Column {
  /** column name */
  Uri = 'URI',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Track = 'track',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "Firmware" */
export type Firmware_Set_Input = {
  URI?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['firmwarecategory']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  track?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Firmware_Stddev_Fields = {
  __typename?: 'Firmware_stddev_fields';
  track?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Firmware_Stddev_Pop_Fields = {
  __typename?: 'Firmware_stddev_pop_fields';
  track?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Firmware_Stddev_Samp_Fields = {
  __typename?: 'Firmware_stddev_samp_fields';
  track?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Firmware_Sum_Fields = {
  __typename?: 'Firmware_sum_fields';
  track?: Maybe<Scalars['Int']>;
};

/** update columns of table "Firmware" */
export enum Firmware_Update_Column {
  /** column name */
  Uri = 'URI',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Track = 'track',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Firmware_Var_Pop_Fields = {
  __typename?: 'Firmware_var_pop_fields';
  track?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Firmware_Var_Samp_Fields = {
  __typename?: 'Firmware_var_samp_fields';
  track?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Firmware_Variance_Fields = {
  __typename?: 'Firmware_variance_fields';
  track?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "Gateway" */
export type Gateway = {
  __typename?: 'Gateway';
  /** An array relationship */
  GatewayBridges: Array<GatewayBridge>;
  /** An aggregate relationship */
  GatewayBridges_aggregate: GatewayBridge_Aggregate;
  /** An array relationship */
  GatewaySubnets: Array<GatewaySubnet>;
  /** An aggregate relationship */
  GatewaySubnets_aggregate: GatewaySubnet_Aggregate;
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  Servers: Array<Server>;
  /** An aggregate relationship */
  Servers_aggregate: Server_Aggregate;
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  ipAddress?: Maybe<Scalars['inet']>;
  isVps?: Maybe<Scalars['Boolean']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  region?: Maybe<Scalars['String']>;
  routerIP?: Maybe<Scalars['inet']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  vpsProvider?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Gateway" */
export type GatewayGatewayBridgesArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


/** columns and relationships of "Gateway" */
export type GatewayGatewayBridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


/** columns and relationships of "Gateway" */
export type GatewayGatewaySubnetsArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


/** columns and relationships of "Gateway" */
export type GatewayGatewaySubnets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


/** columns and relationships of "Gateway" */
export type GatewayServersArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


/** columns and relationships of "Gateway" */
export type GatewayServers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};

/** columns and relationships of "GatewayBridge" */
export type GatewayBridge = {
  __typename?: 'GatewayBridge';
  /** An object relationship */
  Gateway: Gateway;
  /** An array relationship */
  ServerBridges: Array<ServerBridge>;
  /** An aggregate relationship */
  ServerBridges_aggregate: ServerBridge_Aggregate;
  bridgeType: Scalars['bridgetype'];
  created_at: Scalars['timestamptz'];
  gatewayId: Scalars['uuid'];
  id: Scalars['uuid'];
  ipAddress?: Maybe<Scalars['inet']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "GatewayBridge" */
export type GatewayBridgeServerBridgesArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


/** columns and relationships of "GatewayBridge" */
export type GatewayBridgeServerBridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};

/** aggregated selection of "GatewayBridge" */
export type GatewayBridge_Aggregate = {
  __typename?: 'GatewayBridge_aggregate';
  aggregate?: Maybe<GatewayBridge_Aggregate_Fields>;
  nodes: Array<GatewayBridge>;
};

/** aggregate fields of "GatewayBridge" */
export type GatewayBridge_Aggregate_Fields = {
  __typename?: 'GatewayBridge_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GatewayBridge_Max_Fields>;
  min?: Maybe<GatewayBridge_Min_Fields>;
};


/** aggregate fields of "GatewayBridge" */
export type GatewayBridge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "GatewayBridge" */
export type GatewayBridge_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GatewayBridge_Max_Order_By>;
  min?: InputMaybe<GatewayBridge_Min_Order_By>;
};

/** input type for inserting array relation for remote table "GatewayBridge" */
export type GatewayBridge_Arr_Rel_Insert_Input = {
  data: Array<GatewayBridge_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GatewayBridge_On_Conflict>;
};

/** Boolean expression to filter rows from the table "GatewayBridge". All fields are combined with a logical 'AND'. */
export type GatewayBridge_Bool_Exp = {
  Gateway?: InputMaybe<Gateway_Bool_Exp>;
  ServerBridges?: InputMaybe<ServerBridge_Bool_Exp>;
  _and?: InputMaybe<Array<GatewayBridge_Bool_Exp>>;
  _not?: InputMaybe<GatewayBridge_Bool_Exp>;
  _or?: InputMaybe<Array<GatewayBridge_Bool_Exp>>;
  bridgeType?: InputMaybe<Bridgetype_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gatewayId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ipAddress?: InputMaybe<Inet_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "GatewayBridge" */
export enum GatewayBridge_Constraint {
  /** unique or primary key constraint */
  GatewayBridgePkey = 'GatewayBridge_pkey'
}

/** input type for inserting data into table "GatewayBridge" */
export type GatewayBridge_Insert_Input = {
  Gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  ServerBridges?: InputMaybe<ServerBridge_Arr_Rel_Insert_Input>;
  bridgeType?: InputMaybe<Scalars['bridgetype']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAddress?: InputMaybe<Scalars['inet']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type GatewayBridge_Max_Fields = {
  __typename?: 'GatewayBridge_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "GatewayBridge" */
export type GatewayBridge_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GatewayBridge_Min_Fields = {
  __typename?: 'GatewayBridge_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "GatewayBridge" */
export type GatewayBridge_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "GatewayBridge" */
export type GatewayBridge_Mutation_Response = {
  __typename?: 'GatewayBridge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GatewayBridge>;
};

/** input type for inserting object relation for remote table "GatewayBridge" */
export type GatewayBridge_Obj_Rel_Insert_Input = {
  data: GatewayBridge_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<GatewayBridge_On_Conflict>;
};

/** on_conflict condition type for table "GatewayBridge" */
export type GatewayBridge_On_Conflict = {
  constraint: GatewayBridge_Constraint;
  update_columns?: Array<GatewayBridge_Update_Column>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};

/** Ordering options when selecting data from "GatewayBridge". */
export type GatewayBridge_Order_By = {
  Gateway?: InputMaybe<Gateway_Order_By>;
  ServerBridges_aggregate?: InputMaybe<ServerBridge_Aggregate_Order_By>;
  bridgeType?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipAddress?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: GatewayBridge */
export type GatewayBridge_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "GatewayBridge" */
export enum GatewayBridge_Select_Column {
  /** column name */
  BridgeType = 'bridgeType',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ipAddress',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "GatewayBridge" */
export type GatewayBridge_Set_Input = {
  bridgeType?: InputMaybe<Scalars['bridgetype']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAddress?: InputMaybe<Scalars['inet']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "GatewayBridge" */
export enum GatewayBridge_Update_Column {
  /** column name */
  BridgeType = 'bridgeType',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ipAddress',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "GatewaySubnet" */
export type GatewaySubnet = {
  __typename?: 'GatewaySubnet';
  /** An object relationship */
  Gateway: Gateway;
  address?: Maybe<Scalars['String']>;
  cidr?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  gatewayId: Scalars['uuid'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "GatewaySubnet" */
export type GatewaySubnet_Aggregate = {
  __typename?: 'GatewaySubnet_aggregate';
  aggregate?: Maybe<GatewaySubnet_Aggregate_Fields>;
  nodes: Array<GatewaySubnet>;
};

/** aggregate fields of "GatewaySubnet" */
export type GatewaySubnet_Aggregate_Fields = {
  __typename?: 'GatewaySubnet_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<GatewaySubnet_Max_Fields>;
  min?: Maybe<GatewaySubnet_Min_Fields>;
};


/** aggregate fields of "GatewaySubnet" */
export type GatewaySubnet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "GatewaySubnet" */
export type GatewaySubnet_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<GatewaySubnet_Max_Order_By>;
  min?: InputMaybe<GatewaySubnet_Min_Order_By>;
};

/** input type for inserting array relation for remote table "GatewaySubnet" */
export type GatewaySubnet_Arr_Rel_Insert_Input = {
  data: Array<GatewaySubnet_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<GatewaySubnet_On_Conflict>;
};

/** Boolean expression to filter rows from the table "GatewaySubnet". All fields are combined with a logical 'AND'. */
export type GatewaySubnet_Bool_Exp = {
  Gateway?: InputMaybe<Gateway_Bool_Exp>;
  _and?: InputMaybe<Array<GatewaySubnet_Bool_Exp>>;
  _not?: InputMaybe<GatewaySubnet_Bool_Exp>;
  _or?: InputMaybe<Array<GatewaySubnet_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  cidr?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gatewayId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "GatewaySubnet" */
export enum GatewaySubnet_Constraint {
  /** unique or primary key constraint */
  GatewaySubnetPkey = 'GatewaySubnet_pkey'
}

/** input type for inserting data into table "GatewaySubnet" */
export type GatewaySubnet_Insert_Input = {
  Gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  address?: InputMaybe<Scalars['String']>;
  cidr?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type GatewaySubnet_Max_Fields = {
  __typename?: 'GatewaySubnet_max_fields';
  address?: Maybe<Scalars['String']>;
  cidr?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "GatewaySubnet" */
export type GatewaySubnet_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type GatewaySubnet_Min_Fields = {
  __typename?: 'GatewaySubnet_min_fields';
  address?: Maybe<Scalars['String']>;
  cidr?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "GatewaySubnet" */
export type GatewaySubnet_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "GatewaySubnet" */
export type GatewaySubnet_Mutation_Response = {
  __typename?: 'GatewaySubnet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<GatewaySubnet>;
};

/** on_conflict condition type for table "GatewaySubnet" */
export type GatewaySubnet_On_Conflict = {
  constraint: GatewaySubnet_Constraint;
  update_columns?: Array<GatewaySubnet_Update_Column>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};

/** Ordering options when selecting data from "GatewaySubnet". */
export type GatewaySubnet_Order_By = {
  Gateway?: InputMaybe<Gateway_Order_By>;
  address?: InputMaybe<Order_By>;
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: GatewaySubnet */
export type GatewaySubnet_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "GatewaySubnet" */
export enum GatewaySubnet_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Cidr = 'cidr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "GatewaySubnet" */
export type GatewaySubnet_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  cidr?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "GatewaySubnet" */
export enum GatewaySubnet_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Cidr = 'cidr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregated selection of "Gateway" */
export type Gateway_Aggregate = {
  __typename?: 'Gateway_aggregate';
  aggregate?: Maybe<Gateway_Aggregate_Fields>;
  nodes: Array<Gateway>;
};

/** aggregate fields of "Gateway" */
export type Gateway_Aggregate_Fields = {
  __typename?: 'Gateway_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gateway_Max_Fields>;
  min?: Maybe<Gateway_Min_Fields>;
};


/** aggregate fields of "Gateway" */
export type Gateway_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gateway_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Gateway" */
export type Gateway_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gateway_Max_Order_By>;
  min?: InputMaybe<Gateway_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Gateway" */
export type Gateway_Arr_Rel_Insert_Input = {
  data: Array<Gateway_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Gateway". All fields are combined with a logical 'AND'. */
export type Gateway_Bool_Exp = {
  GatewayBridges?: InputMaybe<GatewayBridge_Bool_Exp>;
  GatewaySubnets?: InputMaybe<GatewaySubnet_Bool_Exp>;
  Partner?: InputMaybe<Partner_Bool_Exp>;
  Servers?: InputMaybe<Server_Bool_Exp>;
  _and?: InputMaybe<Array<Gateway_Bool_Exp>>;
  _not?: InputMaybe<Gateway_Bool_Exp>;
  _or?: InputMaybe<Array<Gateway_Bool_Exp>>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ipAddress?: InputMaybe<Inet_Comparison_Exp>;
  isVps?: InputMaybe<Boolean_Comparison_Exp>;
  monitorEndpoint?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  routerIP?: InputMaybe<Inet_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vpsProvider?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Gateway" */
export enum Gateway_Constraint {
  /** unique or primary key constraint */
  GatewayPkey = 'Gateway_pkey'
}

/** input type for inserting data into table "Gateway" */
export type Gateway_Insert_Input = {
  GatewayBridges?: InputMaybe<GatewayBridge_Arr_Rel_Insert_Input>;
  GatewaySubnets?: InputMaybe<GatewaySubnet_Arr_Rel_Insert_Input>;
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  Servers?: InputMaybe<Server_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAddress?: InputMaybe<Scalars['inet']>;
  isVps?: InputMaybe<Scalars['Boolean']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  region?: InputMaybe<Scalars['String']>;
  routerIP?: InputMaybe<Scalars['inet']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vpsProvider?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gateway_Max_Fields = {
  __typename?: 'Gateway_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vpsProvider?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Gateway" */
export type Gateway_Max_Order_By = {
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vpsProvider?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gateway_Min_Fields = {
  __typename?: 'Gateway_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vpsProvider?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Gateway" */
export type Gateway_Min_Order_By = {
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vpsProvider?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Gateway" */
export type Gateway_Mutation_Response = {
  __typename?: 'Gateway_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gateway>;
};

/** input type for inserting object relation for remote table "Gateway" */
export type Gateway_Obj_Rel_Insert_Input = {
  data: Gateway_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};

/** on_conflict condition type for table "Gateway" */
export type Gateway_On_Conflict = {
  constraint: Gateway_Constraint;
  update_columns?: Array<Gateway_Update_Column>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};

/** Ordering options when selecting data from "Gateway". */
export type Gateway_Order_By = {
  GatewayBridges_aggregate?: InputMaybe<GatewayBridge_Aggregate_Order_By>;
  GatewaySubnets_aggregate?: InputMaybe<GatewaySubnet_Aggregate_Order_By>;
  Partner?: InputMaybe<Partner_Order_By>;
  Servers_aggregate?: InputMaybe<Server_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipAddress?: InputMaybe<Order_By>;
  isVps?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  routerIP?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vpsProvider?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Gateway */
export type Gateway_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Gateway" */
export enum Gateway_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ipAddress',
  /** column name */
  IsVps = 'isVps',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Region = 'region',
  /** column name */
  RouterIp = 'routerIP',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VpsProvider = 'vpsProvider'
}

/** input type for updating data in table "Gateway" */
export type Gateway_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAddress?: InputMaybe<Scalars['inet']>;
  isVps?: InputMaybe<Scalars['Boolean']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  region?: InputMaybe<Scalars['String']>;
  routerIP?: InputMaybe<Scalars['inet']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vpsProvider?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Gateway" */
export enum Gateway_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ipAddress',
  /** column name */
  IsVps = 'isVps',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Region = 'region',
  /** column name */
  RouterIp = 'routerIP',
  /** column name */
  State = 'state',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VpsProvider = 'vpsProvider'
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "LanNode" */
export type LanNode = {
  __typename?: 'LanNode';
  /** An object relationship */
  PublicIp: PublicIp;
  /** An object relationship */
  SiteLan: SiteLan;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  ip4Address?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  publicIpId: Scalars['uuid'];
  siteLanId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "LanNode" */
export type LanNode_Aggregate = {
  __typename?: 'LanNode_aggregate';
  aggregate?: Maybe<LanNode_Aggregate_Fields>;
  nodes: Array<LanNode>;
};

/** aggregate fields of "LanNode" */
export type LanNode_Aggregate_Fields = {
  __typename?: 'LanNode_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LanNode_Max_Fields>;
  min?: Maybe<LanNode_Min_Fields>;
};


/** aggregate fields of "LanNode" */
export type LanNode_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LanNode_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "LanNode" */
export type LanNode_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LanNode_Max_Order_By>;
  min?: InputMaybe<LanNode_Min_Order_By>;
};

/** input type for inserting array relation for remote table "LanNode" */
export type LanNode_Arr_Rel_Insert_Input = {
  data: Array<LanNode_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<LanNode_On_Conflict>;
};

/** Boolean expression to filter rows from the table "LanNode". All fields are combined with a logical 'AND'. */
export type LanNode_Bool_Exp = {
  PublicIp?: InputMaybe<PublicIp_Bool_Exp>;
  SiteLan?: InputMaybe<SiteLan_Bool_Exp>;
  _and?: InputMaybe<Array<LanNode_Bool_Exp>>;
  _not?: InputMaybe<LanNode_Bool_Exp>;
  _or?: InputMaybe<Array<LanNode_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip4Address?: InputMaybe<String_Comparison_Exp>;
  isPublic?: InputMaybe<Boolean_Comparison_Exp>;
  publicIpId?: InputMaybe<Uuid_Comparison_Exp>;
  siteLanId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "LanNode" */
export enum LanNode_Constraint {
  /** unique or primary key constraint */
  LanNodePkey = 'LanNode_pkey'
}

/** input type for inserting data into table "LanNode" */
export type LanNode_Insert_Input = {
  PublicIp?: InputMaybe<PublicIp_Obj_Rel_Insert_Input>;
  SiteLan?: InputMaybe<SiteLan_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Address?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  publicIpId?: InputMaybe<Scalars['uuid']>;
  siteLanId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LanNode_Max_Fields = {
  __typename?: 'LanNode_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Address?: Maybe<Scalars['String']>;
  publicIpId?: Maybe<Scalars['uuid']>;
  siteLanId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "LanNode" */
export type LanNode_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  publicIpId?: InputMaybe<Order_By>;
  siteLanId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LanNode_Min_Fields = {
  __typename?: 'LanNode_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Address?: Maybe<Scalars['String']>;
  publicIpId?: Maybe<Scalars['uuid']>;
  siteLanId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "LanNode" */
export type LanNode_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  publicIpId?: InputMaybe<Order_By>;
  siteLanId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "LanNode" */
export type LanNode_Mutation_Response = {
  __typename?: 'LanNode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LanNode>;
};

/** on_conflict condition type for table "LanNode" */
export type LanNode_On_Conflict = {
  constraint: LanNode_Constraint;
  update_columns?: Array<LanNode_Update_Column>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};

/** Ordering options when selecting data from "LanNode". */
export type LanNode_Order_By = {
  PublicIp?: InputMaybe<PublicIp_Order_By>;
  SiteLan?: InputMaybe<SiteLan_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  isPublic?: InputMaybe<Order_By>;
  publicIpId?: InputMaybe<Order_By>;
  siteLanId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: LanNode */
export type LanNode_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "LanNode" */
export enum LanNode_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Address = 'ip4Address',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  PublicIpId = 'publicIpId',
  /** column name */
  SiteLanId = 'siteLanId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "LanNode" */
export type LanNode_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Address?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  publicIpId?: InputMaybe<Scalars['uuid']>;
  siteLanId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "LanNode" */
export enum LanNode_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Address = 'ip4Address',
  /** column name */
  IsPublic = 'isPublic',
  /** column name */
  PublicIpId = 'publicIpId',
  /** column name */
  SiteLanId = 'siteLanId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "LicenseKeys" */
export type LicenseKeys = {
  __typename?: 'LicenseKeys';
  createdAt: Scalars['timestamptz'];
  id: Scalars['String'];
  partnerId: Scalars['uuid'];
  siteId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "LicenseKeys" */
export type LicenseKeys_Aggregate = {
  __typename?: 'LicenseKeys_aggregate';
  aggregate?: Maybe<LicenseKeys_Aggregate_Fields>;
  nodes: Array<LicenseKeys>;
};

/** aggregate fields of "LicenseKeys" */
export type LicenseKeys_Aggregate_Fields = {
  __typename?: 'LicenseKeys_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LicenseKeys_Max_Fields>;
  min?: Maybe<LicenseKeys_Min_Fields>;
};


/** aggregate fields of "LicenseKeys" */
export type LicenseKeys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LicenseKeys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "LicenseKeys". All fields are combined with a logical 'AND'. */
export type LicenseKeys_Bool_Exp = {
  _and?: InputMaybe<Array<LicenseKeys_Bool_Exp>>;
  _not?: InputMaybe<LicenseKeys_Bool_Exp>;
  _or?: InputMaybe<Array<LicenseKeys_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  siteId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "LicenseKeys" */
export enum LicenseKeys_Constraint {
  /** unique or primary key constraint */
  LicenseKeysPk = 'license_keys_pk'
}

/** input type for inserting data into table "LicenseKeys" */
export type LicenseKeys_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LicenseKeys_Max_Fields = {
  __typename?: 'LicenseKeys_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  siteId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type LicenseKeys_Min_Fields = {
  __typename?: 'LicenseKeys_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  siteId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "LicenseKeys" */
export type LicenseKeys_Mutation_Response = {
  __typename?: 'LicenseKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LicenseKeys>;
};

/** on_conflict condition type for table "LicenseKeys" */
export type LicenseKeys_On_Conflict = {
  constraint: LicenseKeys_Constraint;
  update_columns?: Array<LicenseKeys_Update_Column>;
  where?: InputMaybe<LicenseKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "LicenseKeys". */
export type LicenseKeys_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: LicenseKeys */
export type LicenseKeys_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "LicenseKeys" */
export enum LicenseKeys_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "LicenseKeys" */
export type LicenseKeys_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "LicenseKeys" */
export enum LicenseKeys_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** columns and relationships of "Link" */
export type Link = {
  __typename?: 'Link';
  /** An object relationship */
  Tunnel: Tunnel;
  addressType?: Maybe<Scalars['String']>;
  carrierName?: Maybe<Scalars['String']>;
  cpeBindIp: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dataLimit?: Maybe<Scalars['numeric']>;
  dataLimitReset?: Maybe<Scalars['timestamptz']>;
  dataLimitUpdated?: Maybe<Scalars['timestamptz']>;
  dataLimitUsed?: Maybe<Scalars['numeric']>;
  downloadThroughput?: Maybe<Scalars['numeric']>;
  downloadThroughputCap?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
  interfaceName?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  isCapEnabled?: Maybe<Scalars['Boolean']>;
  isCapped?: Maybe<Scalars['Boolean']>;
  isDHCP?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isEncrypted?: Maybe<Scalars['Boolean']>;
  isMacOverride?: Maybe<Scalars['Boolean']>;
  isMetered?: Maybe<Scalars['Boolean']>;
  isPPPoE?: Maybe<Scalars['Boolean']>;
  isPassthrough?: Maybe<Scalars['Boolean']>;
  isStandby?: Maybe<Scalars['Boolean']>;
  isWWAN?: Maybe<Scalars['Boolean']>;
  macAddress?: Maybe<Scalars['String']>;
  metric?: Maybe<Scalars['Int']>;
  modemAPN?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pppoePassword?: Maybe<Scalars['String']>;
  pppoeUsername?: Maybe<Scalars['String']>;
  serverBindIp?: Maybe<Scalars['String']>;
  serverPort?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  staticDnsIp?: Maybe<Scalars['String']>;
  staticGatewayIp?: Maybe<Scalars['String']>;
  staticIp?: Maybe<Scalars['String']>;
  tunnelId: Scalars['uuid'];
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uploadThroughput?: Maybe<Scalars['numeric']>;
  uploadThroughputCap?: Maybe<Scalars['numeric']>;
  vlanId?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "LinkType" */
export type LinkType = {
  __typename?: 'LinkType';
  /** An object relationship */
  Partner: Partner;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isAPN?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "LinkType" */
export type LinkType_Aggregate = {
  __typename?: 'LinkType_aggregate';
  aggregate?: Maybe<LinkType_Aggregate_Fields>;
  nodes: Array<LinkType>;
};

/** aggregate fields of "LinkType" */
export type LinkType_Aggregate_Fields = {
  __typename?: 'LinkType_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<LinkType_Max_Fields>;
  min?: Maybe<LinkType_Min_Fields>;
};


/** aggregate fields of "LinkType" */
export type LinkType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<LinkType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "LinkType" */
export type LinkType_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<LinkType_Max_Order_By>;
  min?: InputMaybe<LinkType_Min_Order_By>;
};

/** input type for inserting array relation for remote table "LinkType" */
export type LinkType_Arr_Rel_Insert_Input = {
  data: Array<LinkType_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<LinkType_On_Conflict>;
};

/** Boolean expression to filter rows from the table "LinkType". All fields are combined with a logical 'AND'. */
export type LinkType_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  _and?: InputMaybe<Array<LinkType_Bool_Exp>>;
  _not?: InputMaybe<LinkType_Bool_Exp>;
  _or?: InputMaybe<Array<LinkType_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAPN?: InputMaybe<Boolean_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "LinkType" */
export enum LinkType_Constraint {
  /** unique or primary key constraint */
  LinkTypePkey = 'LinkType_pkey'
}

/** input type for inserting data into table "LinkType" */
export type LinkType_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAPN?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LinkType_Max_Fields = {
  __typename?: 'LinkType_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "LinkType" */
export type LinkType_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type LinkType_Min_Fields = {
  __typename?: 'LinkType_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "LinkType" */
export type LinkType_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "LinkType" */
export type LinkType_Mutation_Response = {
  __typename?: 'LinkType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LinkType>;
};

/** on_conflict condition type for table "LinkType" */
export type LinkType_On_Conflict = {
  constraint: LinkType_Constraint;
  update_columns?: Array<LinkType_Update_Column>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};

/** Ordering options when selecting data from "LinkType". */
export type LinkType_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAPN?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: LinkType */
export type LinkType_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "LinkType" */
export enum LinkType_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsApn = 'isAPN',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "LinkType" */
export type LinkType_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAPN?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "LinkType" */
export enum LinkType_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsApn = 'isAPN',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregated selection of "Link" */
export type Link_Aggregate = {
  __typename?: 'Link_aggregate';
  aggregate?: Maybe<Link_Aggregate_Fields>;
  nodes: Array<Link>;
};

/** aggregate fields of "Link" */
export type Link_Aggregate_Fields = {
  __typename?: 'Link_aggregate_fields';
  avg?: Maybe<Link_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Link_Max_Fields>;
  min?: Maybe<Link_Min_Fields>;
  stddev?: Maybe<Link_Stddev_Fields>;
  stddev_pop?: Maybe<Link_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Link_Stddev_Samp_Fields>;
  sum?: Maybe<Link_Sum_Fields>;
  var_pop?: Maybe<Link_Var_Pop_Fields>;
  var_samp?: Maybe<Link_Var_Samp_Fields>;
  variance?: Maybe<Link_Variance_Fields>;
};


/** aggregate fields of "Link" */
export type Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Link" */
export type Link_Aggregate_Order_By = {
  avg?: InputMaybe<Link_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Link_Max_Order_By>;
  min?: InputMaybe<Link_Min_Order_By>;
  stddev?: InputMaybe<Link_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Link_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Link_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Link_Sum_Order_By>;
  var_pop?: InputMaybe<Link_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Link_Var_Samp_Order_By>;
  variance?: InputMaybe<Link_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Link" */
export type Link_Arr_Rel_Insert_Input = {
  data: Array<Link_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Link_On_Conflict>;
};

/** aggregate avg on columns */
export type Link_Avg_Fields = {
  __typename?: 'Link_avg_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Link" */
export type Link_Avg_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Link". All fields are combined with a logical 'AND'. */
export type Link_Bool_Exp = {
  Tunnel?: InputMaybe<Tunnel_Bool_Exp>;
  _and?: InputMaybe<Array<Link_Bool_Exp>>;
  _not?: InputMaybe<Link_Bool_Exp>;
  _or?: InputMaybe<Array<Link_Bool_Exp>>;
  carrierName?: InputMaybe<String_Comparison_Exp>;
  cpeBindIp?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dataLimit?: InputMaybe<Numeric_Comparison_Exp>;
  dataLimitReset?: InputMaybe<Timestamptz_Comparison_Exp>;
  dataLimitUpdated?: InputMaybe<Timestamptz_Comparison_Exp>;
  dataLimitUsed?: InputMaybe<Numeric_Comparison_Exp>;
  downloadThroughput?: InputMaybe<Numeric_Comparison_Exp>;
  downloadThroughputCap?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interfaceName?: InputMaybe<String_Comparison_Exp>;
  ip4Cidr?: InputMaybe<String_Comparison_Exp>;
  ip4Router?: InputMaybe<String_Comparison_Exp>;
  isCapEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isCapped?: InputMaybe<Boolean_Comparison_Exp>;
  isDHCP?: InputMaybe<Boolean_Comparison_Exp>;
  isEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isEncrypted?: InputMaybe<Boolean_Comparison_Exp>;
  isMacOverride?: InputMaybe<Boolean_Comparison_Exp>;
  isMetered?: InputMaybe<Boolean_Comparison_Exp>;
  isPPPoE?: InputMaybe<Boolean_Comparison_Exp>;
  isPassthrough?: InputMaybe<Boolean_Comparison_Exp>;
  isStandby?: InputMaybe<Boolean_Comparison_Exp>;
  isWWAN?: InputMaybe<Boolean_Comparison_Exp>;
  macAddress?: InputMaybe<String_Comparison_Exp>;
  metric?: InputMaybe<Int_Comparison_Exp>;
  modemAPN?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  pppoePassword?: InputMaybe<String_Comparison_Exp>;
  pppoeUsername?: InputMaybe<String_Comparison_Exp>;
  serverBindIp?: InputMaybe<String_Comparison_Exp>;
  serverPort?: InputMaybe<Int_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  staticDnsIp?: InputMaybe<String_Comparison_Exp>;
  staticGatewayIp?: InputMaybe<String_Comparison_Exp>;
  staticIp?: InputMaybe<String_Comparison_Exp>;
  tunnelId?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadThroughput?: InputMaybe<Numeric_Comparison_Exp>;
  uploadThroughputCap?: InputMaybe<Numeric_Comparison_Exp>;
  vlanId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "Link" */
export enum Link_Constraint {
  /** unique or primary key constraint */
  LinkPkey = 'Link_pkey'
}

/** input type for incrementing numeric columns in table "Link" */
export type Link_Inc_Input = {
  dataLimit?: InputMaybe<Scalars['numeric']>;
  dataLimitUsed?: InputMaybe<Scalars['numeric']>;
  downloadThroughput?: InputMaybe<Scalars['numeric']>;
  downloadThroughputCap?: InputMaybe<Scalars['numeric']>;
  metric?: InputMaybe<Scalars['Int']>;
  serverPort?: InputMaybe<Scalars['Int']>;
  uploadThroughput?: InputMaybe<Scalars['numeric']>;
  uploadThroughputCap?: InputMaybe<Scalars['numeric']>;
  vlanId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Link" */
export type Link_Insert_Input = {
  Tunnel?: InputMaybe<Tunnel_Obj_Rel_Insert_Input>;
  carrierName?: InputMaybe<Scalars['String']>;
  cpeBindIp?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dataLimit?: InputMaybe<Scalars['numeric']>;
  dataLimitReset?: InputMaybe<Scalars['timestamptz']>;
  dataLimitUpdated?: InputMaybe<Scalars['timestamptz']>;
  dataLimitUsed?: InputMaybe<Scalars['numeric']>;
  downloadThroughput?: InputMaybe<Scalars['numeric']>;
  downloadThroughputCap?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  ip4Router?: InputMaybe<Scalars['String']>;
  isCapEnabled?: InputMaybe<Scalars['Boolean']>;
  isCapped?: InputMaybe<Scalars['Boolean']>;
  isDHCP?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  isMacOverride?: InputMaybe<Scalars['Boolean']>;
  isMetered?: InputMaybe<Scalars['Boolean']>;
  isPPPoE?: InputMaybe<Scalars['Boolean']>;
  isPassthrough?: InputMaybe<Scalars['Boolean']>;
  isStandby?: InputMaybe<Scalars['Boolean']>;
  isWWAN?: InputMaybe<Scalars['Boolean']>;
  macAddress?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Scalars['Int']>;
  modemAPN?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pppoePassword?: InputMaybe<Scalars['String']>;
  pppoeUsername?: InputMaybe<Scalars['String']>;
  serverBindIp?: InputMaybe<Scalars['String']>;
  serverPort?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  staticDnsIp?: InputMaybe<Scalars['String']>;
  staticGatewayIp?: InputMaybe<Scalars['String']>;
  staticIp?: InputMaybe<Scalars['String']>;
  tunnelId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uploadThroughput?: InputMaybe<Scalars['numeric']>;
  uploadThroughputCap?: InputMaybe<Scalars['numeric']>;
  vlanId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Link_Max_Fields = {
  __typename?: 'Link_max_fields';
  carrierName?: Maybe<Scalars['String']>;
  cpeBindIp?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dataLimit?: Maybe<Scalars['numeric']>;
  dataLimitReset?: Maybe<Scalars['timestamptz']>;
  dataLimitUpdated?: Maybe<Scalars['timestamptz']>;
  dataLimitUsed?: Maybe<Scalars['numeric']>;
  downloadThroughput?: Maybe<Scalars['numeric']>;
  downloadThroughputCap?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  metric?: Maybe<Scalars['Int']>;
  modemAPN?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pppoePassword?: Maybe<Scalars['String']>;
  pppoeUsername?: Maybe<Scalars['String']>;
  serverBindIp?: Maybe<Scalars['String']>;
  serverPort?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  staticDnsIp?: Maybe<Scalars['String']>;
  staticGatewayIp?: Maybe<Scalars['String']>;
  staticIp?: Maybe<Scalars['String']>;
  tunnelId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadThroughput?: Maybe<Scalars['numeric']>;
  uploadThroughputCap?: Maybe<Scalars['numeric']>;
  vlanId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "Link" */
export type Link_Max_Order_By = {
  carrierName?: InputMaybe<Order_By>;
  cpeBindIp?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dataLimit?: InputMaybe<Order_By>;
  dataLimitReset?: InputMaybe<Order_By>;
  dataLimitUpdated?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  macAddress?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  modemAPN?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pppoePassword?: InputMaybe<Order_By>;
  pppoeUsername?: InputMaybe<Order_By>;
  serverBindIp?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  staticDnsIp?: InputMaybe<Order_By>;
  staticGatewayIp?: InputMaybe<Order_By>;
  staticIp?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Link_Min_Fields = {
  __typename?: 'Link_min_fields';
  carrierName?: Maybe<Scalars['String']>;
  cpeBindIp?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dataLimit?: Maybe<Scalars['numeric']>;
  dataLimitReset?: Maybe<Scalars['timestamptz']>;
  dataLimitUpdated?: Maybe<Scalars['timestamptz']>;
  dataLimitUsed?: Maybe<Scalars['numeric']>;
  downloadThroughput?: Maybe<Scalars['numeric']>;
  downloadThroughputCap?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  macAddress?: Maybe<Scalars['String']>;
  metric?: Maybe<Scalars['Int']>;
  modemAPN?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pppoePassword?: Maybe<Scalars['String']>;
  pppoeUsername?: Maybe<Scalars['String']>;
  serverBindIp?: Maybe<Scalars['String']>;
  serverPort?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  staticDnsIp?: Maybe<Scalars['String']>;
  staticGatewayIp?: Maybe<Scalars['String']>;
  staticIp?: Maybe<Scalars['String']>;
  tunnelId?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadThroughput?: Maybe<Scalars['numeric']>;
  uploadThroughputCap?: Maybe<Scalars['numeric']>;
  vlanId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "Link" */
export type Link_Min_Order_By = {
  carrierName?: InputMaybe<Order_By>;
  cpeBindIp?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dataLimit?: InputMaybe<Order_By>;
  dataLimitReset?: InputMaybe<Order_By>;
  dataLimitUpdated?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  macAddress?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  modemAPN?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pppoePassword?: InputMaybe<Order_By>;
  pppoeUsername?: InputMaybe<Order_By>;
  serverBindIp?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  staticDnsIp?: InputMaybe<Order_By>;
  staticGatewayIp?: InputMaybe<Order_By>;
  staticIp?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Link" */
export type Link_Mutation_Response = {
  __typename?: 'Link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Link>;
};

/** on_conflict condition type for table "Link" */
export type Link_On_Conflict = {
  constraint: Link_Constraint;
  update_columns?: Array<Link_Update_Column>;
  where?: InputMaybe<Link_Bool_Exp>;
};

/** Ordering options when selecting data from "Link". */
export type Link_Order_By = {
  Tunnel?: InputMaybe<Tunnel_Order_By>;
  carrierName?: InputMaybe<Order_By>;
  cpeBindIp?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dataLimit?: InputMaybe<Order_By>;
  dataLimitReset?: InputMaybe<Order_By>;
  dataLimitUpdated?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  isCapEnabled?: InputMaybe<Order_By>;
  isCapped?: InputMaybe<Order_By>;
  isDHCP?: InputMaybe<Order_By>;
  isEnabled?: InputMaybe<Order_By>;
  isEncrypted?: InputMaybe<Order_By>;
  isMacOverride?: InputMaybe<Order_By>;
  isMetered?: InputMaybe<Order_By>;
  isPPPoE?: InputMaybe<Order_By>;
  isPassthrough?: InputMaybe<Order_By>;
  isStandby?: InputMaybe<Order_By>;
  isWWAN?: InputMaybe<Order_By>;
  macAddress?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  modemAPN?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  pppoePassword?: InputMaybe<Order_By>;
  pppoeUsername?: InputMaybe<Order_By>;
  serverBindIp?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  staticDnsIp?: InputMaybe<Order_By>;
  staticGatewayIp?: InputMaybe<Order_By>;
  staticIp?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Link */
export type Link_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Link" */
export enum Link_Select_Column {
  /** column name */
  CarrierName = 'carrierName',
  /** column name */
  CpeBindIp = 'cpeBindIp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataLimit = 'dataLimit',
  /** column name */
  DataLimitReset = 'dataLimitReset',
  /** column name */
  DataLimitUpdated = 'dataLimitUpdated',
  /** column name */
  DataLimitUsed = 'dataLimitUsed',
  /** column name */
  DownloadThroughput = 'downloadThroughput',
  /** column name */
  DownloadThroughputCap = 'downloadThroughputCap',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  Ip4Router = 'ip4Router',
  /** column name */
  IsCapEnabled = 'isCapEnabled',
  /** column name */
  IsCapped = 'isCapped',
  /** column name */
  IsDhcp = 'isDHCP',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsEncrypted = 'isEncrypted',
  /** column name */
  IsMacOverride = 'isMacOverride',
  /** column name */
  IsMetered = 'isMetered',
  /** column name */
  IsPpPoE = 'isPPPoE',
  /** column name */
  IsPassthrough = 'isPassthrough',
  /** column name */
  IsStandby = 'isStandby',
  /** column name */
  IsWwan = 'isWWAN',
  /** column name */
  MacAddress = 'macAddress',
  /** column name */
  Metric = 'metric',
  /** column name */
  ModemApn = 'modemAPN',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PppoePassword = 'pppoePassword',
  /** column name */
  PppoeUsername = 'pppoeUsername',
  /** column name */
  ServerBindIp = 'serverBindIp',
  /** column name */
  ServerPort = 'serverPort',
  /** column name */
  State = 'state',
  /** column name */
  StaticDnsIp = 'staticDnsIp',
  /** column name */
  StaticGatewayIp = 'staticGatewayIp',
  /** column name */
  StaticIp = 'staticIp',
  /** column name */
  TunnelId = 'tunnelId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadThroughput = 'uploadThroughput',
  /** column name */
  UploadThroughputCap = 'uploadThroughputCap',
  /** column name */
  VlanId = 'vlanId'
}

/** input type for updating data in table "Link" */
export type Link_Set_Input = {
  carrierName?: InputMaybe<Scalars['String']>;
  cpeBindIp?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dataLimit?: InputMaybe<Scalars['numeric']>;
  dataLimitReset?: InputMaybe<Scalars['timestamptz']>;
  dataLimitUpdated?: InputMaybe<Scalars['timestamptz']>;
  dataLimitUsed?: InputMaybe<Scalars['numeric']>;
  downloadThroughput?: InputMaybe<Scalars['numeric']>;
  downloadThroughputCap?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  ip4Router?: InputMaybe<Scalars['String']>;
  isCapEnabled?: InputMaybe<Scalars['Boolean']>;
  isCapped?: InputMaybe<Scalars['Boolean']>;
  isDHCP?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  isMacOverride?: InputMaybe<Scalars['Boolean']>;
  isMetered?: InputMaybe<Scalars['Boolean']>;
  isPPPoE?: InputMaybe<Scalars['Boolean']>;
  isPassthrough?: InputMaybe<Scalars['Boolean']>;
  isStandby?: InputMaybe<Scalars['Boolean']>;
  isWWAN?: InputMaybe<Scalars['Boolean']>;
  macAddress?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<Scalars['Int']>;
  modemAPN?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pppoePassword?: InputMaybe<Scalars['String']>;
  pppoeUsername?: InputMaybe<Scalars['String']>;
  serverBindIp?: InputMaybe<Scalars['String']>;
  serverPort?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  staticDnsIp?: InputMaybe<Scalars['String']>;
  staticGatewayIp?: InputMaybe<Scalars['String']>;
  staticIp?: InputMaybe<Scalars['String']>;
  tunnelId?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uploadThroughput?: InputMaybe<Scalars['numeric']>;
  uploadThroughputCap?: InputMaybe<Scalars['numeric']>;
  vlanId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Link_Stddev_Fields = {
  __typename?: 'Link_stddev_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Link" */
export type Link_Stddev_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Link_Stddev_Pop_Fields = {
  __typename?: 'Link_stddev_pop_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Link" */
export type Link_Stddev_Pop_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Link_Stddev_Samp_Fields = {
  __typename?: 'Link_stddev_samp_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Link" */
export type Link_Stddev_Samp_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Link_Sum_Fields = {
  __typename?: 'Link_sum_fields';
  dataLimit?: Maybe<Scalars['numeric']>;
  dataLimitUsed?: Maybe<Scalars['numeric']>;
  downloadThroughput?: Maybe<Scalars['numeric']>;
  downloadThroughputCap?: Maybe<Scalars['numeric']>;
  metric?: Maybe<Scalars['Int']>;
  serverPort?: Maybe<Scalars['Int']>;
  uploadThroughput?: Maybe<Scalars['numeric']>;
  uploadThroughputCap?: Maybe<Scalars['numeric']>;
  vlanId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "Link" */
export type Link_Sum_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** update columns of table "Link" */
export enum Link_Update_Column {
  /** column name */
  CarrierName = 'carrierName',
  /** column name */
  CpeBindIp = 'cpeBindIp',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataLimit = 'dataLimit',
  /** column name */
  DataLimitReset = 'dataLimitReset',
  /** column name */
  DataLimitUpdated = 'dataLimitUpdated',
  /** column name */
  DataLimitUsed = 'dataLimitUsed',
  /** column name */
  DownloadThroughput = 'downloadThroughput',
  /** column name */
  DownloadThroughputCap = 'downloadThroughputCap',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  Ip4Router = 'ip4Router',
  /** column name */
  IsCapEnabled = 'isCapEnabled',
  /** column name */
  IsCapped = 'isCapped',
  /** column name */
  IsDhcp = 'isDHCP',
  /** column name */
  IsEnabled = 'isEnabled',
  /** column name */
  IsEncrypted = 'isEncrypted',
  /** column name */
  IsMacOverride = 'isMacOverride',
  /** column name */
  IsMetered = 'isMetered',
  /** column name */
  IsPpPoE = 'isPPPoE',
  /** column name */
  IsPassthrough = 'isPassthrough',
  /** column name */
  IsStandby = 'isStandby',
  /** column name */
  IsWwan = 'isWWAN',
  /** column name */
  MacAddress = 'macAddress',
  /** column name */
  Metric = 'metric',
  /** column name */
  ModemApn = 'modemAPN',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PppoePassword = 'pppoePassword',
  /** column name */
  PppoeUsername = 'pppoeUsername',
  /** column name */
  ServerBindIp = 'serverBindIp',
  /** column name */
  ServerPort = 'serverPort',
  /** column name */
  State = 'state',
  /** column name */
  StaticDnsIp = 'staticDnsIp',
  /** column name */
  StaticGatewayIp = 'staticGatewayIp',
  /** column name */
  StaticIp = 'staticIp',
  /** column name */
  TunnelId = 'tunnelId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadThroughput = 'uploadThroughput',
  /** column name */
  UploadThroughputCap = 'uploadThroughputCap',
  /** column name */
  VlanId = 'vlanId'
}

/** aggregate var_pop on columns */
export type Link_Var_Pop_Fields = {
  __typename?: 'Link_var_pop_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Link" */
export type Link_Var_Pop_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Link_Var_Samp_Fields = {
  __typename?: 'Link_var_samp_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Link" */
export type Link_Var_Samp_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Link_Variance_Fields = {
  __typename?: 'Link_variance_fields';
  dataLimit?: Maybe<Scalars['Float']>;
  dataLimitUsed?: Maybe<Scalars['Float']>;
  downloadThroughput?: Maybe<Scalars['Float']>;
  downloadThroughputCap?: Maybe<Scalars['Float']>;
  metric?: Maybe<Scalars['Float']>;
  serverPort?: Maybe<Scalars['Float']>;
  uploadThroughput?: Maybe<Scalars['Float']>;
  uploadThroughputCap?: Maybe<Scalars['Float']>;
  vlanId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Link" */
export type Link_Variance_Order_By = {
  dataLimit?: InputMaybe<Order_By>;
  dataLimitUsed?: InputMaybe<Order_By>;
  downloadThroughput?: InputMaybe<Order_By>;
  downloadThroughputCap?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  serverPort?: InputMaybe<Order_By>;
  uploadThroughput?: InputMaybe<Order_By>;
  uploadThroughputCap?: InputMaybe<Order_By>;
  vlanId?: InputMaybe<Order_By>;
};

/** columns and relationships of "MeshWan" */
export type MeshWan = {
  __typename?: 'MeshWan';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  Sites: Array<Site>;
  /** An aggregate relationship */
  Sites_aggregate: Site_Aggregate;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "MeshWan" */
export type MeshWanSitesArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


/** columns and relationships of "MeshWan" */
export type MeshWanSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** aggregated selection of "MeshWan" */
export type MeshWan_Aggregate = {
  __typename?: 'MeshWan_aggregate';
  aggregate?: Maybe<MeshWan_Aggregate_Fields>;
  nodes: Array<MeshWan>;
};

/** aggregate fields of "MeshWan" */
export type MeshWan_Aggregate_Fields = {
  __typename?: 'MeshWan_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<MeshWan_Max_Fields>;
  min?: Maybe<MeshWan_Min_Fields>;
};


/** aggregate fields of "MeshWan" */
export type MeshWan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MeshWan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "MeshWan" */
export type MeshWan_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MeshWan_Max_Order_By>;
  min?: InputMaybe<MeshWan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "MeshWan" */
export type MeshWan_Arr_Rel_Insert_Input = {
  data: Array<MeshWan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MeshWan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "MeshWan". All fields are combined with a logical 'AND'. */
export type MeshWan_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  Sites?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<MeshWan_Bool_Exp>>;
  _not?: InputMaybe<MeshWan_Bool_Exp>;
  _or?: InputMaybe<Array<MeshWan_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "MeshWan" */
export enum MeshWan_Constraint {
  /** unique or primary key constraint */
  MeshWanPkey = 'MeshWan_pkey'
}

/** input type for inserting data into table "MeshWan" */
export type MeshWan_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  Sites?: InputMaybe<Site_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MeshWan_Max_Fields = {
  __typename?: 'MeshWan_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "MeshWan" */
export type MeshWan_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MeshWan_Min_Fields = {
  __typename?: 'MeshWan_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "MeshWan" */
export type MeshWan_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "MeshWan" */
export type MeshWan_Mutation_Response = {
  __typename?: 'MeshWan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MeshWan>;
};

/** input type for inserting object relation for remote table "MeshWan" */
export type MeshWan_Obj_Rel_Insert_Input = {
  data: MeshWan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MeshWan_On_Conflict>;
};

/** on_conflict condition type for table "MeshWan" */
export type MeshWan_On_Conflict = {
  constraint: MeshWan_Constraint;
  update_columns?: Array<MeshWan_Update_Column>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};

/** Ordering options when selecting data from "MeshWan". */
export type MeshWan_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  Sites_aggregate?: InputMaybe<Site_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: MeshWan */
export type MeshWan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "MeshWan" */
export enum MeshWan_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "MeshWan" */
export type MeshWan_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "MeshWan" */
export enum MeshWan_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Monitor" */
export type Monitor = {
  __typename?: 'Monitor';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  Servers: Array<Server>;
  /** An aggregate relationship */
  Servers_aggregate: Server_Aggregate;
  /** An array relationship */
  Sites: Array<Site>;
  /** An aggregate relationship */
  Sites_aggregate: Site_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  logURI?: Maybe<Scalars['String']>;
  metricsURI?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  password?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  username?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Monitor" */
export type MonitorServersArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


/** columns and relationships of "Monitor" */
export type MonitorServers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


/** columns and relationships of "Monitor" */
export type MonitorSitesArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


/** columns and relationships of "Monitor" */
export type MonitorSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** aggregated selection of "Monitor" */
export type Monitor_Aggregate = {
  __typename?: 'Monitor_aggregate';
  aggregate?: Maybe<Monitor_Aggregate_Fields>;
  nodes: Array<Monitor>;
};

/** aggregate fields of "Monitor" */
export type Monitor_Aggregate_Fields = {
  __typename?: 'Monitor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Monitor_Max_Fields>;
  min?: Maybe<Monitor_Min_Fields>;
};


/** aggregate fields of "Monitor" */
export type Monitor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Monitor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Monitor" */
export type Monitor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Monitor_Max_Order_By>;
  min?: InputMaybe<Monitor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Monitor" */
export type Monitor_Arr_Rel_Insert_Input = {
  data: Array<Monitor_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Monitor". All fields are combined with a logical 'AND'. */
export type Monitor_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  Servers?: InputMaybe<Server_Bool_Exp>;
  Sites?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<Monitor_Bool_Exp>>;
  _not?: InputMaybe<Monitor_Bool_Exp>;
  _or?: InputMaybe<Array<Monitor_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isDefault?: InputMaybe<Boolean_Comparison_Exp>;
  logURI?: InputMaybe<String_Comparison_Exp>;
  metricsURI?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Monitor" */
export enum Monitor_Constraint {
  /** unique or primary key constraint */
  MonitorPkey = 'Monitor_pkey'
}

/** input type for inserting data into table "Monitor" */
export type Monitor_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  Servers?: InputMaybe<Server_Arr_Rel_Insert_Input>;
  Sites?: InputMaybe<Site_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  logURI?: InputMaybe<Scalars['String']>;
  metricsURI?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Monitor_Max_Fields = {
  __typename?: 'Monitor_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  logURI?: Maybe<Scalars['String']>;
  metricsURI?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Monitor" */
export type Monitor_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logURI?: InputMaybe<Order_By>;
  metricsURI?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Monitor_Min_Fields = {
  __typename?: 'Monitor_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  logURI?: Maybe<Scalars['String']>;
  metricsURI?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Monitor" */
export type Monitor_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logURI?: InputMaybe<Order_By>;
  metricsURI?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Monitor" */
export type Monitor_Mutation_Response = {
  __typename?: 'Monitor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Monitor>;
};

/** input type for inserting object relation for remote table "Monitor" */
export type Monitor_Obj_Rel_Insert_Input = {
  data: Monitor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Monitor_On_Conflict>;
};

/** on_conflict condition type for table "Monitor" */
export type Monitor_On_Conflict = {
  constraint: Monitor_Constraint;
  update_columns?: Array<Monitor_Update_Column>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};

/** Ordering options when selecting data from "Monitor". */
export type Monitor_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  Servers_aggregate?: InputMaybe<Server_Aggregate_Order_By>;
  Sites_aggregate?: InputMaybe<Site_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isDefault?: InputMaybe<Order_By>;
  logURI?: InputMaybe<Order_By>;
  metricsURI?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Monitor */
export type Monitor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Monitor" */
export enum Monitor_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  LogUri = 'logURI',
  /** column name */
  MetricsUri = 'metricsURI',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Password = 'password',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "Monitor" */
export type Monitor_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  logURI?: InputMaybe<Scalars['String']>;
  metricsURI?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  username?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Monitor" */
export enum Monitor_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsDefault = 'isDefault',
  /** column name */
  LogUri = 'logURI',
  /** column name */
  MetricsUri = 'metricsURI',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Password = 'password',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

/** columns and relationships of "Partner" */
export type Partner = {
  __typename?: 'Partner';
  /** An array relationship */
  Carriers: Array<Carrier>;
  /** An aggregate relationship */
  Carriers_aggregate: Carrier_Aggregate;
  /** An array relationship */
  ClientCompanies: Array<ClientCompany>;
  /** An aggregate relationship */
  ClientCompanies_aggregate: ClientCompany_Aggregate;
  /** An array relationship */
  Gateways: Array<Gateway>;
  /** An aggregate relationship */
  Gateways_aggregate: Gateway_Aggregate;
  /** An array relationship */
  LinkTypes: Array<LinkType>;
  /** An aggregate relationship */
  LinkTypes_aggregate: LinkType_Aggregate;
  /** An array relationship */
  MeshWans: Array<MeshWan>;
  /** An aggregate relationship */
  MeshWans_aggregate: MeshWan_Aggregate;
  /** An array relationship */
  Monitors: Array<Monitor>;
  /** An aggregate relationship */
  Monitors_aggregate: Monitor_Aggregate;
  /** An array relationship */
  Profiles: Array<Profile>;
  /** An aggregate relationship */
  Profiles_aggregate: Profile_Aggregate;
  /** An array relationship */
  Users: Array<User>;
  /** An aggregate relationship */
  Users_aggregate: User_Aggregate;
  /** An array relationship */
  Wans: Array<Wan>;
  /** An aggregate relationship */
  Wans_aggregate: Wan_Aggregate;
  acknowledgedTerms?: Maybe<Scalars['timestamptz']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingAddress1?: Maybe<Scalars['String']>;
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingContact?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingExt?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  primaryLanguage?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "Partner" */
export type PartnerCarriersArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerCarriers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerClientCompaniesArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerClientCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerGatewaysArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerGateways_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerLinkTypesArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerLinkTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerMeshWansArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerMeshWans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerMonitorsArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerMonitors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerWansArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};


/** columns and relationships of "Partner" */
export type PartnerWans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};

/** columns and relationships of "PartnerPreferences" */
export type PartnerPreferences = {
  __typename?: 'PartnerPreferences';
  faviconFilename?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  logoFilename?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
};

/** aggregated selection of "PartnerPreferences" */
export type PartnerPreferences_Aggregate = {
  __typename?: 'PartnerPreferences_aggregate';
  aggregate?: Maybe<PartnerPreferences_Aggregate_Fields>;
  nodes: Array<PartnerPreferences>;
};

/** aggregate fields of "PartnerPreferences" */
export type PartnerPreferences_Aggregate_Fields = {
  __typename?: 'PartnerPreferences_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PartnerPreferences_Max_Fields>;
  min?: Maybe<PartnerPreferences_Min_Fields>;
};


/** aggregate fields of "PartnerPreferences" */
export type PartnerPreferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PartnerPreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "PartnerPreferences". All fields are combined with a logical 'AND'. */
export type PartnerPreferences_Bool_Exp = {
  _and?: InputMaybe<Array<PartnerPreferences_Bool_Exp>>;
  _not?: InputMaybe<PartnerPreferences_Bool_Exp>;
  _or?: InputMaybe<Array<PartnerPreferences_Bool_Exp>>;
  faviconFilename?: InputMaybe<String_Comparison_Exp>;
  headerColor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logoFilename?: InputMaybe<String_Comparison_Exp>;
  pageTitle?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "PartnerPreferences" */
export type PartnerPreferences_Insert_Input = {
  faviconFilename?: InputMaybe<Scalars['String']>;
  headerColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logoFilename?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PartnerPreferences_Max_Fields = {
  __typename?: 'PartnerPreferences_max_fields';
  faviconFilename?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoFilename?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PartnerPreferences_Min_Fields = {
  __typename?: 'PartnerPreferences_min_fields';
  faviconFilename?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  logoFilename?: Maybe<Scalars['String']>;
  pageTitle?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "PartnerPreferences" */
export type PartnerPreferences_Mutation_Response = {
  __typename?: 'PartnerPreferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PartnerPreferences>;
};

/** Ordering options when selecting data from "PartnerPreferences". */
export type PartnerPreferences_Order_By = {
  faviconFilename?: InputMaybe<Order_By>;
  headerColor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logoFilename?: InputMaybe<Order_By>;
  pageTitle?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
};

/** select columns of table "PartnerPreferences" */
export enum PartnerPreferences_Select_Column {
  /** column name */
  FaviconFilename = 'faviconFilename',
  /** column name */
  HeaderColor = 'headerColor',
  /** column name */
  Id = 'id',
  /** column name */
  LogoFilename = 'logoFilename',
  /** column name */
  PageTitle = 'pageTitle',
  /** column name */
  PartnerId = 'partnerId'
}

/** input type for updating data in table "PartnerPreferences" */
export type PartnerPreferences_Set_Input = {
  faviconFilename?: InputMaybe<Scalars['String']>;
  headerColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  logoFilename?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
};

/** aggregated selection of "Partner" */
export type Partner_Aggregate = {
  __typename?: 'Partner_aggregate';
  aggregate?: Maybe<Partner_Aggregate_Fields>;
  nodes: Array<Partner>;
};

/** aggregate fields of "Partner" */
export type Partner_Aggregate_Fields = {
  __typename?: 'Partner_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Partner_Max_Fields>;
  min?: Maybe<Partner_Min_Fields>;
};


/** aggregate fields of "Partner" */
export type Partner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Partner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "Partner". All fields are combined with a logical 'AND'. */
export type Partner_Bool_Exp = {
  Carriers?: InputMaybe<Carrier_Bool_Exp>;
  ClientCompanies?: InputMaybe<ClientCompany_Bool_Exp>;
  Gateways?: InputMaybe<Gateway_Bool_Exp>;
  LinkTypes?: InputMaybe<LinkType_Bool_Exp>;
  MeshWans?: InputMaybe<MeshWan_Bool_Exp>;
  Monitors?: InputMaybe<Monitor_Bool_Exp>;
  Profiles?: InputMaybe<Profile_Bool_Exp>;
  Users?: InputMaybe<User_Bool_Exp>;
  Wans?: InputMaybe<Wan_Bool_Exp>;
  _and?: InputMaybe<Array<Partner_Bool_Exp>>;
  _not?: InputMaybe<Partner_Bool_Exp>;
  _or?: InputMaybe<Array<Partner_Bool_Exp>>;
  acknowledgedTerms?: InputMaybe<Timestamptz_Comparison_Exp>;
  billingAddress?: InputMaybe<String_Comparison_Exp>;
  billingAddress1?: InputMaybe<String_Comparison_Exp>;
  billingAddress2?: InputMaybe<String_Comparison_Exp>;
  billingCity?: InputMaybe<String_Comparison_Exp>;
  billingContact?: InputMaybe<String_Comparison_Exp>;
  billingCountry?: InputMaybe<String_Comparison_Exp>;
  billingEmail?: InputMaybe<String_Comparison_Exp>;
  billingExt?: InputMaybe<String_Comparison_Exp>;
  billingPhone?: InputMaybe<String_Comparison_Exp>;
  billingPostalCode?: InputMaybe<String_Comparison_Exp>;
  billingState?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primaryLanguage?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "Partner" */
export enum Partner_Constraint {
  /** unique or primary key constraint */
  PartnerPkey = 'Partner_pkey'
}

/** input type for inserting data into table "Partner" */
export type Partner_Insert_Input = {
  Carriers?: InputMaybe<Carrier_Arr_Rel_Insert_Input>;
  ClientCompanies?: InputMaybe<ClientCompany_Arr_Rel_Insert_Input>;
  Gateways?: InputMaybe<Gateway_Arr_Rel_Insert_Input>;
  LinkTypes?: InputMaybe<LinkType_Arr_Rel_Insert_Input>;
  MeshWans?: InputMaybe<MeshWan_Arr_Rel_Insert_Input>;
  Monitors?: InputMaybe<Monitor_Arr_Rel_Insert_Input>;
  Profiles?: InputMaybe<Profile_Arr_Rel_Insert_Input>;
  Users?: InputMaybe<User_Arr_Rel_Insert_Input>;
  Wans?: InputMaybe<Wan_Arr_Rel_Insert_Input>;
  acknowledgedTerms?: InputMaybe<Scalars['timestamptz']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingAddress1?: InputMaybe<Scalars['String']>;
  billingAddress2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingContact?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingExt?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  primaryLanguage?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Partner_Max_Fields = {
  __typename?: 'Partner_max_fields';
  acknowledgedTerms?: Maybe<Scalars['timestamptz']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingAddress1?: Maybe<Scalars['String']>;
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingContact?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingExt?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  primaryLanguage?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Partner_Min_Fields = {
  __typename?: 'Partner_min_fields';
  acknowledgedTerms?: Maybe<Scalars['timestamptz']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingAddress1?: Maybe<Scalars['String']>;
  billingAddress2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingContact?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingExt?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostalCode?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  primaryLanguage?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "Partner" */
export type Partner_Mutation_Response = {
  __typename?: 'Partner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Partner>;
};

/** input type for inserting object relation for remote table "Partner" */
export type Partner_Obj_Rel_Insert_Input = {
  data: Partner_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};

/** on_conflict condition type for table "Partner" */
export type Partner_On_Conflict = {
  constraint: Partner_Constraint;
  update_columns?: Array<Partner_Update_Column>;
  where?: InputMaybe<Partner_Bool_Exp>;
};

/** Ordering options when selecting data from "Partner". */
export type Partner_Order_By = {
  Carriers_aggregate?: InputMaybe<Carrier_Aggregate_Order_By>;
  ClientCompanies_aggregate?: InputMaybe<ClientCompany_Aggregate_Order_By>;
  Gateways_aggregate?: InputMaybe<Gateway_Aggregate_Order_By>;
  LinkTypes_aggregate?: InputMaybe<LinkType_Aggregate_Order_By>;
  MeshWans_aggregate?: InputMaybe<MeshWan_Aggregate_Order_By>;
  Monitors_aggregate?: InputMaybe<Monitor_Aggregate_Order_By>;
  Profiles_aggregate?: InputMaybe<Profile_Aggregate_Order_By>;
  Users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  Wans_aggregate?: InputMaybe<Wan_Aggregate_Order_By>;
  acknowledgedTerms?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingAddress1?: InputMaybe<Order_By>;
  billingAddress2?: InputMaybe<Order_By>;
  billingCity?: InputMaybe<Order_By>;
  billingContact?: InputMaybe<Order_By>;
  billingCountry?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingExt?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  billingPostalCode?: InputMaybe<Order_By>;
  billingState?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primaryLanguage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Partner */
export type Partner_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Partner" */
export enum Partner_Select_Column {
  /** column name */
  AcknowledgedTerms = 'acknowledgedTerms',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingAddress1 = 'billingAddress1',
  /** column name */
  BillingAddress2 = 'billingAddress2',
  /** column name */
  BillingCity = 'billingCity',
  /** column name */
  BillingContact = 'billingContact',
  /** column name */
  BillingCountry = 'billingCountry',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingExt = 'billingExt',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BillingPostalCode = 'billingPostalCode',
  /** column name */
  BillingState = 'billingState',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PrimaryLanguage = 'primaryLanguage',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "Partner" */
export type Partner_Set_Input = {
  acknowledgedTerms?: InputMaybe<Scalars['timestamptz']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingAddress1?: InputMaybe<Scalars['String']>;
  billingAddress2?: InputMaybe<Scalars['String']>;
  billingCity?: InputMaybe<Scalars['String']>;
  billingContact?: InputMaybe<Scalars['String']>;
  billingCountry?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingExt?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  billingState?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  primaryLanguage?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "Partner" */
export enum Partner_Update_Column {
  /** column name */
  AcknowledgedTerms = 'acknowledgedTerms',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingAddress1 = 'billingAddress1',
  /** column name */
  BillingAddress2 = 'billingAddress2',
  /** column name */
  BillingCity = 'billingCity',
  /** column name */
  BillingContact = 'billingContact',
  /** column name */
  BillingCountry = 'billingCountry',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingExt = 'billingExt',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BillingPostalCode = 'billingPostalCode',
  /** column name */
  BillingState = 'billingState',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PrimaryLanguage = 'primaryLanguage',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Profile" */
export type Profile = {
  __typename?: 'Profile';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  TunnelProfiles: Array<TunnelProfile>;
  /** An aggregate relationship */
  TunnelProfiles_aggregate: TunnelProfile_Aggregate;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isUniversal?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partnerId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Profile" */
export type ProfileTunnelProfilesArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


/** columns and relationships of "Profile" */
export type ProfileTunnelProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};

/** aggregated selection of "Profile" */
export type Profile_Aggregate = {
  __typename?: 'Profile_aggregate';
  aggregate?: Maybe<Profile_Aggregate_Fields>;
  nodes: Array<Profile>;
};

/** aggregate fields of "Profile" */
export type Profile_Aggregate_Fields = {
  __typename?: 'Profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Profile_Max_Fields>;
  min?: Maybe<Profile_Min_Fields>;
};


/** aggregate fields of "Profile" */
export type Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Profile" */
export type Profile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Profile_Max_Order_By>;
  min?: InputMaybe<Profile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Profile" */
export type Profile_Arr_Rel_Insert_Input = {
  data: Array<Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Profile". All fields are combined with a logical 'AND'. */
export type Profile_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  TunnelProfiles?: InputMaybe<TunnelProfile_Bool_Exp>;
  _and?: InputMaybe<Array<Profile_Bool_Exp>>;
  _not?: InputMaybe<Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isUniversal?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Profile" */
export enum Profile_Constraint {
  /** unique or primary key constraint */
  ProfilePkey = 'Profile_pkey'
}

/** input type for inserting data into table "Profile" */
export type Profile_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  TunnelProfiles?: InputMaybe<TunnelProfile_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isUniversal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profile_Max_Fields = {
  __typename?: 'Profile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Profile" */
export type Profile_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Profile_Min_Fields = {
  __typename?: 'Profile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Profile" */
export type Profile_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Profile" */
export type Profile_Mutation_Response = {
  __typename?: 'Profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile>;
};

/** input type for inserting object relation for remote table "Profile" */
export type Profile_Obj_Rel_Insert_Input = {
  data: Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};

/** on_conflict condition type for table "Profile" */
export type Profile_On_Conflict = {
  constraint: Profile_Constraint;
  update_columns?: Array<Profile_Update_Column>;
  where?: InputMaybe<Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "Profile". */
export type Profile_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  TunnelProfiles_aggregate?: InputMaybe<TunnelProfile_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isUniversal?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Profile */
export type Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Profile" */
export enum Profile_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsUniversal = 'isUniversal',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "Profile" */
export type Profile_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isUniversal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "Profile" */
export enum Profile_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsUniversal = 'isUniversal',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** columns and relationships of "PublicIp" */
export type PublicIp = {
  __typename?: 'PublicIp';
  /** An array relationship */
  LanNodes: Array<LanNode>;
  /** An aggregate relationship */
  LanNodes_aggregate: LanNode_Aggregate;
  /** An object relationship */
  Server: Server;
  address?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  ip4Cidr?: Maybe<Scalars['String']>;
  isV6?: Maybe<Scalars['Boolean']>;
  serverId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "PublicIp" */
export type PublicIpLanNodesArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


/** columns and relationships of "PublicIp" */
export type PublicIpLanNodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};

/** aggregated selection of "PublicIp" */
export type PublicIp_Aggregate = {
  __typename?: 'PublicIp_aggregate';
  aggregate?: Maybe<PublicIp_Aggregate_Fields>;
  nodes: Array<PublicIp>;
};

/** aggregate fields of "PublicIp" */
export type PublicIp_Aggregate_Fields = {
  __typename?: 'PublicIp_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<PublicIp_Max_Fields>;
  min?: Maybe<PublicIp_Min_Fields>;
};


/** aggregate fields of "PublicIp" */
export type PublicIp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PublicIp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "PublicIp" */
export type PublicIp_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PublicIp_Max_Order_By>;
  min?: InputMaybe<PublicIp_Min_Order_By>;
};

/** input type for inserting array relation for remote table "PublicIp" */
export type PublicIp_Arr_Rel_Insert_Input = {
  data: Array<PublicIp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicIp_On_Conflict>;
};

/** Boolean expression to filter rows from the table "PublicIp". All fields are combined with a logical 'AND'. */
export type PublicIp_Bool_Exp = {
  LanNodes?: InputMaybe<LanNode_Bool_Exp>;
  Server?: InputMaybe<Server_Bool_Exp>;
  _and?: InputMaybe<Array<PublicIp_Bool_Exp>>;
  _not?: InputMaybe<PublicIp_Bool_Exp>;
  _or?: InputMaybe<Array<PublicIp_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip4Cidr?: InputMaybe<String_Comparison_Exp>;
  isV6?: InputMaybe<Boolean_Comparison_Exp>;
  serverId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "PublicIp" */
export enum PublicIp_Constraint {
  /** unique or primary key constraint */
  PublicIpPkey = 'PublicIp_pkey'
}

/** input type for inserting data into table "PublicIp" */
export type PublicIp_Insert_Input = {
  LanNodes?: InputMaybe<LanNode_Arr_Rel_Insert_Input>;
  Server?: InputMaybe<Server_Obj_Rel_Insert_Input>;
  address?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  isV6?: InputMaybe<Scalars['Boolean']>;
  serverId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PublicIp_Max_Fields = {
  __typename?: 'PublicIp_max_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  serverId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "PublicIp" */
export type PublicIp_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type PublicIp_Min_Fields = {
  __typename?: 'PublicIp_min_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  serverId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "PublicIp" */
export type PublicIp_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "PublicIp" */
export type PublicIp_Mutation_Response = {
  __typename?: 'PublicIp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PublicIp>;
};

/** input type for inserting object relation for remote table "PublicIp" */
export type PublicIp_Obj_Rel_Insert_Input = {
  data: PublicIp_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PublicIp_On_Conflict>;
};

/** on_conflict condition type for table "PublicIp" */
export type PublicIp_On_Conflict = {
  constraint: PublicIp_Constraint;
  update_columns?: Array<PublicIp_Update_Column>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};

/** Ordering options when selecting data from "PublicIp". */
export type PublicIp_Order_By = {
  LanNodes_aggregate?: InputMaybe<LanNode_Aggregate_Order_By>;
  Server?: InputMaybe<Server_Order_By>;
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  isV6?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: PublicIp */
export type PublicIp_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "PublicIp" */
export enum PublicIp_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  IsV6 = 'isV6',
  /** column name */
  ServerId = 'serverId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "PublicIp" */
export type PublicIp_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  isV6?: InputMaybe<Scalars['Boolean']>;
  serverId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "PublicIp" */
export enum PublicIp_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  IsV6 = 'isV6',
  /** column name */
  ServerId = 'serverId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Quicklink" */
export type Quicklink = {
  __typename?: 'Quicklink';
  /** An object relationship */
  ClientCompany: ClientCompany;
  clientCompanyId: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  link?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "Quicklink" */
export type Quicklink_Aggregate = {
  __typename?: 'Quicklink_aggregate';
  aggregate?: Maybe<Quicklink_Aggregate_Fields>;
  nodes: Array<Quicklink>;
};

/** aggregate fields of "Quicklink" */
export type Quicklink_Aggregate_Fields = {
  __typename?: 'Quicklink_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Quicklink_Max_Fields>;
  min?: Maybe<Quicklink_Min_Fields>;
};


/** aggregate fields of "Quicklink" */
export type Quicklink_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quicklink_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Quicklink" */
export type Quicklink_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quicklink_Max_Order_By>;
  min?: InputMaybe<Quicklink_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Quicklink" */
export type Quicklink_Arr_Rel_Insert_Input = {
  data: Array<Quicklink_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quicklink_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Quicklink". All fields are combined with a logical 'AND'. */
export type Quicklink_Bool_Exp = {
  ClientCompany?: InputMaybe<ClientCompany_Bool_Exp>;
  _and?: InputMaybe<Array<Quicklink_Bool_Exp>>;
  _not?: InputMaybe<Quicklink_Bool_Exp>;
  _or?: InputMaybe<Array<Quicklink_Bool_Exp>>;
  clientCompanyId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "Quicklink" */
export enum Quicklink_Constraint {
  /** unique or primary key constraint */
  QuicklinkPkey = 'Quicklink_pkey'
}

/** input type for inserting data into table "Quicklink" */
export type Quicklink_Insert_Input = {
  ClientCompany?: InputMaybe<ClientCompany_Obj_Rel_Insert_Input>;
  clientCompanyId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Quicklink_Max_Fields = {
  __typename?: 'Quicklink_max_fields';
  clientCompanyId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "Quicklink" */
export type Quicklink_Max_Order_By = {
  clientCompanyId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quicklink_Min_Fields = {
  __typename?: 'Quicklink_min_fields';
  clientCompanyId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "Quicklink" */
export type Quicklink_Min_Order_By = {
  clientCompanyId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Quicklink" */
export type Quicklink_Mutation_Response = {
  __typename?: 'Quicklink_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Quicklink>;
};

/** on_conflict condition type for table "Quicklink" */
export type Quicklink_On_Conflict = {
  constraint: Quicklink_Constraint;
  update_columns?: Array<Quicklink_Update_Column>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};

/** Ordering options when selecting data from "Quicklink". */
export type Quicklink_Order_By = {
  ClientCompany?: InputMaybe<ClientCompany_Order_By>;
  clientCompanyId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Quicklink */
export type Quicklink_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Quicklink" */
export enum Quicklink_Select_Column {
  /** column name */
  ClientCompanyId = 'clientCompanyId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "Quicklink" */
export type Quicklink_Set_Input = {
  clientCompanyId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "Quicklink" */
export enum Quicklink_Update_Column {
  /** column name */
  ClientCompanyId = 'clientCompanyId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Server" */
export type Server = {
  __typename?: 'Server';
  /** An object relationship */
  Gateway: Gateway;
  /** An object relationship */
  Monitor?: Maybe<Monitor>;
  /** An array relationship */
  PublicIps: Array<PublicIp>;
  /** An aggregate relationship */
  PublicIps_aggregate: PublicIp_Aggregate;
  /** An array relationship */
  ServerBridges: Array<ServerBridge>;
  /** An aggregate relationship */
  ServerBridges_aggregate: ServerBridge_Aggregate;
  /** An array relationship */
  Tunnels: Array<Tunnel>;
  /** An aggregate relationship */
  Tunnels_aggregate: Tunnel_Aggregate;
  created_at: Scalars['timestamptz'];
  gatewayId: Scalars['uuid'];
  id: Scalars['uuid'];
  ip4Address?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "Server" */
export type ServerPublicIpsArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


/** columns and relationships of "Server" */
export type ServerPublicIps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


/** columns and relationships of "Server" */
export type ServerServerBridgesArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


/** columns and relationships of "Server" */
export type ServerServerBridges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


/** columns and relationships of "Server" */
export type ServerTunnelsArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


/** columns and relationships of "Server" */
export type ServerTunnels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};

/** columns and relationships of "ServerBridge" */
export type ServerBridge = {
  __typename?: 'ServerBridge';
  /** An object relationship */
  GatewayBridge: GatewayBridge;
  /** An object relationship */
  Server: Server;
  gatewayBridgeId: Scalars['uuid'];
  serverId: Scalars['uuid'];
};

/** aggregated selection of "ServerBridge" */
export type ServerBridge_Aggregate = {
  __typename?: 'ServerBridge_aggregate';
  aggregate?: Maybe<ServerBridge_Aggregate_Fields>;
  nodes: Array<ServerBridge>;
};

/** aggregate fields of "ServerBridge" */
export type ServerBridge_Aggregate_Fields = {
  __typename?: 'ServerBridge_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ServerBridge_Max_Fields>;
  min?: Maybe<ServerBridge_Min_Fields>;
};


/** aggregate fields of "ServerBridge" */
export type ServerBridge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServerBridge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ServerBridge" */
export type ServerBridge_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServerBridge_Max_Order_By>;
  min?: InputMaybe<ServerBridge_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ServerBridge" */
export type ServerBridge_Arr_Rel_Insert_Input = {
  data: Array<ServerBridge_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServerBridge_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ServerBridge". All fields are combined with a logical 'AND'. */
export type ServerBridge_Bool_Exp = {
  GatewayBridge?: InputMaybe<GatewayBridge_Bool_Exp>;
  Server?: InputMaybe<Server_Bool_Exp>;
  _and?: InputMaybe<Array<ServerBridge_Bool_Exp>>;
  _not?: InputMaybe<ServerBridge_Bool_Exp>;
  _or?: InputMaybe<Array<ServerBridge_Bool_Exp>>;
  gatewayBridgeId?: InputMaybe<Uuid_Comparison_Exp>;
  serverId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ServerBridge" */
export enum ServerBridge_Constraint {
  /** unique or primary key constraint */
  ServerBridgePkey = 'ServerBridge_pkey'
}

/** input type for inserting data into table "ServerBridge" */
export type ServerBridge_Insert_Input = {
  GatewayBridge?: InputMaybe<GatewayBridge_Obj_Rel_Insert_Input>;
  Server?: InputMaybe<Server_Obj_Rel_Insert_Input>;
  gatewayBridgeId?: InputMaybe<Scalars['uuid']>;
  serverId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ServerBridge_Max_Fields = {
  __typename?: 'ServerBridge_max_fields';
  gatewayBridgeId?: Maybe<Scalars['uuid']>;
  serverId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "ServerBridge" */
export type ServerBridge_Max_Order_By = {
  gatewayBridgeId?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServerBridge_Min_Fields = {
  __typename?: 'ServerBridge_min_fields';
  gatewayBridgeId?: Maybe<Scalars['uuid']>;
  serverId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "ServerBridge" */
export type ServerBridge_Min_Order_By = {
  gatewayBridgeId?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ServerBridge" */
export type ServerBridge_Mutation_Response = {
  __typename?: 'ServerBridge_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ServerBridge>;
};

/** on_conflict condition type for table "ServerBridge" */
export type ServerBridge_On_Conflict = {
  constraint: ServerBridge_Constraint;
  update_columns?: Array<ServerBridge_Update_Column>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};

/** Ordering options when selecting data from "ServerBridge". */
export type ServerBridge_Order_By = {
  GatewayBridge?: InputMaybe<GatewayBridge_Order_By>;
  Server?: InputMaybe<Server_Order_By>;
  gatewayBridgeId?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ServerBridge */
export type ServerBridge_Pk_Columns_Input = {
  gatewayBridgeId: Scalars['uuid'];
  serverId: Scalars['uuid'];
};

/** select columns of table "ServerBridge" */
export enum ServerBridge_Select_Column {
  /** column name */
  GatewayBridgeId = 'gatewayBridgeId',
  /** column name */
  ServerId = 'serverId'
}

/** input type for updating data in table "ServerBridge" */
export type ServerBridge_Set_Input = {
  gatewayBridgeId?: InputMaybe<Scalars['uuid']>;
  serverId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ServerBridge" */
export enum ServerBridge_Update_Column {
  /** column name */
  GatewayBridgeId = 'gatewayBridgeId',
  /** column name */
  ServerId = 'serverId'
}

/** aggregated selection of "Server" */
export type Server_Aggregate = {
  __typename?: 'Server_aggregate';
  aggregate?: Maybe<Server_Aggregate_Fields>;
  nodes: Array<Server>;
};

/** aggregate fields of "Server" */
export type Server_Aggregate_Fields = {
  __typename?: 'Server_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Server_Max_Fields>;
  min?: Maybe<Server_Min_Fields>;
};


/** aggregate fields of "Server" */
export type Server_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Server_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Server" */
export type Server_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Server_Max_Order_By>;
  min?: InputMaybe<Server_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Server" */
export type Server_Arr_Rel_Insert_Input = {
  data: Array<Server_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Server_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Server". All fields are combined with a logical 'AND'. */
export type Server_Bool_Exp = {
  Gateway?: InputMaybe<Gateway_Bool_Exp>;
  Monitor?: InputMaybe<Monitor_Bool_Exp>;
  PublicIps?: InputMaybe<PublicIp_Bool_Exp>;
  ServerBridges?: InputMaybe<ServerBridge_Bool_Exp>;
  Tunnels?: InputMaybe<Tunnel_Bool_Exp>;
  _and?: InputMaybe<Array<Server_Bool_Exp>>;
  _not?: InputMaybe<Server_Bool_Exp>;
  _or?: InputMaybe<Array<Server_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  gatewayId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip4Address?: InputMaybe<String_Comparison_Exp>;
  ip4Cidr?: InputMaybe<String_Comparison_Exp>;
  ip4Router?: InputMaybe<String_Comparison_Exp>;
  monitorEndpoint?: InputMaybe<String_Comparison_Exp>;
  monitorId?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  osVersion?: InputMaybe<String_Comparison_Exp>;
  rebootRequest?: InputMaybe<Timestamptz_Comparison_Exp>;
  softwareVersion?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "Server" */
export enum Server_Constraint {
  /** unique or primary key constraint */
  ServerPkey = 'Server_pkey'
}

/** input type for inserting data into table "Server" */
export type Server_Insert_Input = {
  Gateway?: InputMaybe<Gateway_Obj_Rel_Insert_Input>;
  Monitor?: InputMaybe<Monitor_Obj_Rel_Insert_Input>;
  PublicIps?: InputMaybe<PublicIp_Arr_Rel_Insert_Input>;
  ServerBridges?: InputMaybe<ServerBridge_Arr_Rel_Insert_Input>;
  Tunnels?: InputMaybe<Tunnel_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Address?: InputMaybe<Scalars['String']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  ip4Router?: InputMaybe<Scalars['String']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  monitorId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  rebootRequest?: InputMaybe<Scalars['timestamptz']>;
  softwareVersion?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Server_Max_Fields = {
  __typename?: 'Server_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Address?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "Server" */
export type Server_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Server_Min_Fields = {
  __typename?: 'Server_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  gatewayId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  ip4Address?: Maybe<Scalars['String']>;
  ip4Cidr?: Maybe<Scalars['String']>;
  ip4Router?: Maybe<Scalars['String']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "Server" */
export type Server_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Server" */
export type Server_Mutation_Response = {
  __typename?: 'Server_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Server>;
};

/** input type for inserting object relation for remote table "Server" */
export type Server_Obj_Rel_Insert_Input = {
  data: Server_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Server_On_Conflict>;
};

/** on_conflict condition type for table "Server" */
export type Server_On_Conflict = {
  constraint: Server_Constraint;
  update_columns?: Array<Server_Update_Column>;
  where?: InputMaybe<Server_Bool_Exp>;
};

/** Ordering options when selecting data from "Server". */
export type Server_Order_By = {
  Gateway?: InputMaybe<Gateway_Order_By>;
  Monitor?: InputMaybe<Monitor_Order_By>;
  PublicIps_aggregate?: InputMaybe<PublicIp_Aggregate_Order_By>;
  ServerBridges_aggregate?: InputMaybe<ServerBridge_Aggregate_Order_By>;
  Tunnels_aggregate?: InputMaybe<Tunnel_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  gatewayId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip4Address?: InputMaybe<Order_By>;
  ip4Cidr?: InputMaybe<Order_By>;
  ip4Router?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Server */
export type Server_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Server" */
export enum Server_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Address = 'ip4Address',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  Ip4Router = 'ip4Router',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  MonitorId = 'monitorId',
  /** column name */
  Name = 'name',
  /** column name */
  OsVersion = 'osVersion',
  /** column name */
  RebootRequest = 'rebootRequest',
  /** column name */
  SoftwareVersion = 'softwareVersion',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "Server" */
export type Server_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  gatewayId?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip4Address?: InputMaybe<Scalars['String']>;
  ip4Cidr?: InputMaybe<Scalars['String']>;
  ip4Router?: InputMaybe<Scalars['String']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  monitorId?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  rebootRequest?: InputMaybe<Scalars['timestamptz']>;
  softwareVersion?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "Server" */
export enum Server_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GatewayId = 'gatewayId',
  /** column name */
  Id = 'id',
  /** column name */
  Ip4Address = 'ip4Address',
  /** column name */
  Ip4Cidr = 'ip4Cidr',
  /** column name */
  Ip4Router = 'ip4Router',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  MonitorId = 'monitorId',
  /** column name */
  Name = 'name',
  /** column name */
  OsVersion = 'osVersion',
  /** column name */
  RebootRequest = 'rebootRequest',
  /** column name */
  SoftwareVersion = 'softwareVersion',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "Site" */
export type Site = {
  __typename?: 'Site';
  /** An object relationship */
  ClientCompany: ClientCompany;
  /** An object relationship */
  MeshWan?: Maybe<MeshWan>;
  /** An object relationship */
  Monitor?: Maybe<Monitor>;
  /** An array relationship */
  SiteContacts: Array<SiteContact>;
  /** An aggregate relationship */
  SiteContacts_aggregate: SiteContact_Aggregate;
  /** An array relationship */
  SiteLans: Array<SiteLan>;
  /** An aggregate relationship */
  SiteLans_aggregate: SiteLan_Aggregate;
  /** An array relationship */
  SiteRoutes: Array<SiteRoute>;
  /** An aggregate relationship */
  SiteRoutes_aggregate: SiteRoute_Aggregate;
  /** An array relationship */
  Tunnels: Array<Tunnel>;
  /** An aggregate relationship */
  Tunnels_aggregate: Tunnel_Aggregate;
  /** An object relationship */
  Wan?: Maybe<Wan>;
  accessibleIps?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientCompanyId: Scalars['uuid'];
  country?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  ipAccessLevel: Scalars['String'];
  isServerless: Scalars['Boolean'];
  meshWanId?: Maybe<Scalars['uuid']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  osVersion?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  wanId?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "Site" */
export type SiteSiteContactsArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteSiteContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteSiteLansArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteSiteLans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteSiteRoutesArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteSiteRoutes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteTunnelsArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


/** columns and relationships of "Site" */
export type SiteTunnels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};

/** columns and relationships of "SiteContact" */
export type SiteContact = {
  __typename?: 'SiteContact';
  /** An object relationship */
  Site: Site;
  created_at: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  emailAlert: Scalars['Boolean'];
  ext?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  siteId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "SiteContact" */
export type SiteContact_Aggregate = {
  __typename?: 'SiteContact_aggregate';
  aggregate?: Maybe<SiteContact_Aggregate_Fields>;
  nodes: Array<SiteContact>;
};

/** aggregate fields of "SiteContact" */
export type SiteContact_Aggregate_Fields = {
  __typename?: 'SiteContact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<SiteContact_Max_Fields>;
  min?: Maybe<SiteContact_Min_Fields>;
};


/** aggregate fields of "SiteContact" */
export type SiteContact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SiteContact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "SiteContact" */
export type SiteContact_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteContact_Max_Order_By>;
  min?: InputMaybe<SiteContact_Min_Order_By>;
};

/** input type for inserting array relation for remote table "SiteContact" */
export type SiteContact_Arr_Rel_Insert_Input = {
  data: Array<SiteContact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteContact_On_Conflict>;
};

/** Boolean expression to filter rows from the table "SiteContact". All fields are combined with a logical 'AND'. */
export type SiteContact_Bool_Exp = {
  Site?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<SiteContact_Bool_Exp>>;
  _not?: InputMaybe<SiteContact_Bool_Exp>;
  _or?: InputMaybe<Array<SiteContact_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailAlert?: InputMaybe<Boolean_Comparison_Exp>;
  ext?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  siteId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "SiteContact" */
export enum SiteContact_Constraint {
  /** unique or primary key constraint */
  SiteContactPkey = 'SiteContact_pkey'
}

/** input type for inserting data into table "SiteContact" */
export type SiteContact_Insert_Input = {
  Site?: InputMaybe<Site_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emailAlert?: InputMaybe<Scalars['Boolean']>;
  ext?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SiteContact_Max_Fields = {
  __typename?: 'SiteContact_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "SiteContact" */
export type SiteContact_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  ext?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SiteContact_Min_Fields = {
  __typename?: 'SiteContact_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "SiteContact" */
export type SiteContact_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  ext?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "SiteContact" */
export type SiteContact_Mutation_Response = {
  __typename?: 'SiteContact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SiteContact>;
};

/** on_conflict condition type for table "SiteContact" */
export type SiteContact_On_Conflict = {
  constraint: SiteContact_Constraint;
  update_columns?: Array<SiteContact_Update_Column>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};

/** Ordering options when selecting data from "SiteContact". */
export type SiteContact_Order_By = {
  Site?: InputMaybe<Site_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailAlert?: InputMaybe<Order_By>;
  ext?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: SiteContact */
export type SiteContact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "SiteContact" */
export enum SiteContact_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAlert = 'emailAlert',
  /** column name */
  Ext = 'ext',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Phone = 'phone',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "SiteContact" */
export type SiteContact_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emailAlert?: InputMaybe<Scalars['Boolean']>;
  ext?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "SiteContact" */
export enum SiteContact_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAlert = 'emailAlert',
  /** column name */
  Ext = 'ext',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Phone = 'phone',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** columns and relationships of "SiteLan" */
export type SiteLan = {
  __typename?: 'SiteLan';
  /** An array relationship */
  LanNodes: Array<LanNode>;
  /** An aggregate relationship */
  LanNodes_aggregate: LanNode_Aggregate;
  /** An object relationship */
  Site: Site;
  ap5Channel?: Maybe<Scalars['Int']>;
  ap5Password?: Maybe<Scalars['String']>;
  ap5SSID?: Maybe<Scalars['String']>;
  apChannel?: Maybe<Scalars['Int']>;
  apCountryCode?: Maybe<Scalars['String']>;
  apMode: Scalars['apmode'];
  apPassword?: Maybe<Scalars['String']>;
  apSSID?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  dhcpDefaultLease?: Maybe<Scalars['String']>;
  dhcpMaxLease?: Maybe<Scalars['String']>;
  dhcpRangeEnd?: Maybe<Scalars['String']>;
  dhcpRangeStart?: Maybe<Scalars['String']>;
  dnsServer1?: Maybe<Scalars['String']>;
  dnsServer2?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  interfaceName: Scalars['String'];
  ip4DMZ?: Maybe<Scalars['String']>;
  isAP: Scalars['Boolean'];
  isDMZ: Scalars['Boolean'];
  isDhcpRequired?: Maybe<Scalars['Boolean']>;
  lanCidrIp4?: Maybe<Scalars['String']>;
  lanSegmentIp4?: Maybe<Scalars['String']>;
  siteId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  vlanId?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "SiteLan" */
export type SiteLanLanNodesArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


/** columns and relationships of "SiteLan" */
export type SiteLanLanNodes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};

/** aggregated selection of "SiteLan" */
export type SiteLan_Aggregate = {
  __typename?: 'SiteLan_aggregate';
  aggregate?: Maybe<SiteLan_Aggregate_Fields>;
  nodes: Array<SiteLan>;
};

/** aggregate fields of "SiteLan" */
export type SiteLan_Aggregate_Fields = {
  __typename?: 'SiteLan_aggregate_fields';
  avg?: Maybe<SiteLan_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SiteLan_Max_Fields>;
  min?: Maybe<SiteLan_Min_Fields>;
  stddev?: Maybe<SiteLan_Stddev_Fields>;
  stddev_pop?: Maybe<SiteLan_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SiteLan_Stddev_Samp_Fields>;
  sum?: Maybe<SiteLan_Sum_Fields>;
  var_pop?: Maybe<SiteLan_Var_Pop_Fields>;
  var_samp?: Maybe<SiteLan_Var_Samp_Fields>;
  variance?: Maybe<SiteLan_Variance_Fields>;
};


/** aggregate fields of "SiteLan" */
export type SiteLan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SiteLan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "SiteLan" */
export type SiteLan_Aggregate_Order_By = {
  avg?: InputMaybe<SiteLan_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteLan_Max_Order_By>;
  min?: InputMaybe<SiteLan_Min_Order_By>;
  stddev?: InputMaybe<SiteLan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SiteLan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SiteLan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SiteLan_Sum_Order_By>;
  var_pop?: InputMaybe<SiteLan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SiteLan_Var_Samp_Order_By>;
  variance?: InputMaybe<SiteLan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "SiteLan" */
export type SiteLan_Arr_Rel_Insert_Input = {
  data: Array<SiteLan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteLan_On_Conflict>;
};

/** aggregate avg on columns */
export type SiteLan_Avg_Fields = {
  __typename?: 'SiteLan_avg_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "SiteLan" */
export type SiteLan_Avg_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "SiteLan". All fields are combined with a logical 'AND'. */
export type SiteLan_Bool_Exp = {
  LanNodes?: InputMaybe<LanNode_Bool_Exp>;
  Site?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<SiteLan_Bool_Exp>>;
  _not?: InputMaybe<SiteLan_Bool_Exp>;
  _or?: InputMaybe<Array<SiteLan_Bool_Exp>>;
  ap5Channel?: InputMaybe<Int_Comparison_Exp>;
  ap5Password?: InputMaybe<String_Comparison_Exp>;
  ap5SSID?: InputMaybe<String_Comparison_Exp>;
  apChannel?: InputMaybe<Int_Comparison_Exp>;
  apCountryCode?: InputMaybe<String_Comparison_Exp>;
  apMode?: InputMaybe<Apmode_Comparison_Exp>;
  apPassword?: InputMaybe<String_Comparison_Exp>;
  apSSID?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dhcpDefaultLease?: InputMaybe<String_Comparison_Exp>;
  dhcpMaxLease?: InputMaybe<String_Comparison_Exp>;
  dhcpRangeEnd?: InputMaybe<String_Comparison_Exp>;
  dhcpRangeStart?: InputMaybe<String_Comparison_Exp>;
  dnsServer1?: InputMaybe<String_Comparison_Exp>;
  dnsServer2?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interfaceName?: InputMaybe<String_Comparison_Exp>;
  ip4DMZ?: InputMaybe<String_Comparison_Exp>;
  isAP?: InputMaybe<Boolean_Comparison_Exp>;
  isDMZ?: InputMaybe<Boolean_Comparison_Exp>;
  isDhcpRequired?: InputMaybe<Boolean_Comparison_Exp>;
  lanCidrIp4?: InputMaybe<String_Comparison_Exp>;
  lanSegmentIp4?: InputMaybe<String_Comparison_Exp>;
  siteId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "SiteLan" */
export enum SiteLan_Constraint {
  /** unique or primary key constraint */
  SiteLanPkey = 'SiteLan_pkey'
}

/** input type for incrementing numeric columns in table "SiteLan" */
export type SiteLan_Inc_Input = {
  ap5Channel?: InputMaybe<Scalars['Int']>;
  apChannel?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "SiteLan" */
export type SiteLan_Insert_Input = {
  LanNodes?: InputMaybe<LanNode_Arr_Rel_Insert_Input>;
  Site?: InputMaybe<Site_Obj_Rel_Insert_Input>;
  ap5Channel?: InputMaybe<Scalars['Int']>;
  ap5Password?: InputMaybe<Scalars['String']>;
  ap5SSID?: InputMaybe<Scalars['String']>;
  apChannel?: InputMaybe<Scalars['Int']>;
  apCountryCode?: InputMaybe<Scalars['String']>;
  apMode?: InputMaybe<Scalars['apmode']>;
  apPassword?: InputMaybe<Scalars['String']>;
  apSSID?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dhcpDefaultLease?: InputMaybe<Scalars['String']>;
  dhcpMaxLease?: InputMaybe<Scalars['String']>;
  dhcpRangeEnd?: InputMaybe<Scalars['String']>;
  dhcpRangeStart?: InputMaybe<Scalars['String']>;
  dnsServer1?: InputMaybe<Scalars['String']>;
  dnsServer2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  ip4DMZ?: InputMaybe<Scalars['String']>;
  isAP?: InputMaybe<Scalars['Boolean']>;
  isDMZ?: InputMaybe<Scalars['Boolean']>;
  isDhcpRequired?: InputMaybe<Scalars['Boolean']>;
  lanCidrIp4?: InputMaybe<Scalars['String']>;
  lanSegmentIp4?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vlanId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type SiteLan_Max_Fields = {
  __typename?: 'SiteLan_max_fields';
  ap5Channel?: Maybe<Scalars['Int']>;
  ap5Password?: Maybe<Scalars['String']>;
  ap5SSID?: Maybe<Scalars['String']>;
  apChannel?: Maybe<Scalars['Int']>;
  apCountryCode?: Maybe<Scalars['String']>;
  apPassword?: Maybe<Scalars['String']>;
  apSSID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dhcpDefaultLease?: Maybe<Scalars['String']>;
  dhcpMaxLease?: Maybe<Scalars['String']>;
  dhcpRangeEnd?: Maybe<Scalars['String']>;
  dhcpRangeStart?: Maybe<Scalars['String']>;
  dnsServer1?: Maybe<Scalars['String']>;
  dnsServer2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  ip4DMZ?: Maybe<Scalars['String']>;
  lanCidrIp4?: Maybe<Scalars['String']>;
  lanSegmentIp4?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "SiteLan" */
export type SiteLan_Max_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  ap5Password?: InputMaybe<Order_By>;
  ap5SSID?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
  apCountryCode?: InputMaybe<Order_By>;
  apPassword?: InputMaybe<Order_By>;
  apSSID?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dhcpDefaultLease?: InputMaybe<Order_By>;
  dhcpMaxLease?: InputMaybe<Order_By>;
  dhcpRangeEnd?: InputMaybe<Order_By>;
  dhcpRangeStart?: InputMaybe<Order_By>;
  dnsServer1?: InputMaybe<Order_By>;
  dnsServer2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4DMZ?: InputMaybe<Order_By>;
  lanCidrIp4?: InputMaybe<Order_By>;
  lanSegmentIp4?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SiteLan_Min_Fields = {
  __typename?: 'SiteLan_min_fields';
  ap5Channel?: Maybe<Scalars['Int']>;
  ap5Password?: Maybe<Scalars['String']>;
  ap5SSID?: Maybe<Scalars['String']>;
  apChannel?: Maybe<Scalars['Int']>;
  apCountryCode?: Maybe<Scalars['String']>;
  apPassword?: Maybe<Scalars['String']>;
  apSSID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dhcpDefaultLease?: Maybe<Scalars['String']>;
  dhcpMaxLease?: Maybe<Scalars['String']>;
  dhcpRangeEnd?: Maybe<Scalars['String']>;
  dhcpRangeStart?: Maybe<Scalars['String']>;
  dnsServer1?: Maybe<Scalars['String']>;
  dnsServer2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  ip4DMZ?: Maybe<Scalars['String']>;
  lanCidrIp4?: Maybe<Scalars['String']>;
  lanSegmentIp4?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "SiteLan" */
export type SiteLan_Min_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  ap5Password?: InputMaybe<Order_By>;
  ap5SSID?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
  apCountryCode?: InputMaybe<Order_By>;
  apPassword?: InputMaybe<Order_By>;
  apSSID?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dhcpDefaultLease?: InputMaybe<Order_By>;
  dhcpMaxLease?: InputMaybe<Order_By>;
  dhcpRangeEnd?: InputMaybe<Order_By>;
  dhcpRangeStart?: InputMaybe<Order_By>;
  dnsServer1?: InputMaybe<Order_By>;
  dnsServer2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4DMZ?: InputMaybe<Order_By>;
  lanCidrIp4?: InputMaybe<Order_By>;
  lanSegmentIp4?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "SiteLan" */
export type SiteLan_Mutation_Response = {
  __typename?: 'SiteLan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SiteLan>;
};

/** input type for inserting object relation for remote table "SiteLan" */
export type SiteLan_Obj_Rel_Insert_Input = {
  data: SiteLan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteLan_On_Conflict>;
};

/** on_conflict condition type for table "SiteLan" */
export type SiteLan_On_Conflict = {
  constraint: SiteLan_Constraint;
  update_columns?: Array<SiteLan_Update_Column>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};

/** Ordering options when selecting data from "SiteLan". */
export type SiteLan_Order_By = {
  LanNodes_aggregate?: InputMaybe<LanNode_Aggregate_Order_By>;
  Site?: InputMaybe<Site_Order_By>;
  ap5Channel?: InputMaybe<Order_By>;
  ap5Password?: InputMaybe<Order_By>;
  ap5SSID?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
  apCountryCode?: InputMaybe<Order_By>;
  apMode?: InputMaybe<Order_By>;
  apPassword?: InputMaybe<Order_By>;
  apSSID?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dhcpDefaultLease?: InputMaybe<Order_By>;
  dhcpMaxLease?: InputMaybe<Order_By>;
  dhcpRangeEnd?: InputMaybe<Order_By>;
  dhcpRangeStart?: InputMaybe<Order_By>;
  dnsServer1?: InputMaybe<Order_By>;
  dnsServer2?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  ip4DMZ?: InputMaybe<Order_By>;
  isAP?: InputMaybe<Order_By>;
  isDMZ?: InputMaybe<Order_By>;
  isDhcpRequired?: InputMaybe<Order_By>;
  lanCidrIp4?: InputMaybe<Order_By>;
  lanSegmentIp4?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: SiteLan */
export type SiteLan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "SiteLan" */
export enum SiteLan_Select_Column {
  /** column name */
  Ap5Channel = 'ap5Channel',
  /** column name */
  Ap5Password = 'ap5Password',
  /** column name */
  Ap5Ssid = 'ap5SSID',
  /** column name */
  ApChannel = 'apChannel',
  /** column name */
  ApCountryCode = 'apCountryCode',
  /** column name */
  ApMode = 'apMode',
  /** column name */
  ApPassword = 'apPassword',
  /** column name */
  ApSsid = 'apSSID',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DhcpDefaultLease = 'dhcpDefaultLease',
  /** column name */
  DhcpMaxLease = 'dhcpMaxLease',
  /** column name */
  DhcpRangeEnd = 'dhcpRangeEnd',
  /** column name */
  DhcpRangeStart = 'dhcpRangeStart',
  /** column name */
  DnsServer1 = 'dnsServer1',
  /** column name */
  DnsServer2 = 'dnsServer2',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  Ip4Dmz = 'ip4DMZ',
  /** column name */
  IsAp = 'isAP',
  /** column name */
  IsDmz = 'isDMZ',
  /** column name */
  IsDhcpRequired = 'isDhcpRequired',
  /** column name */
  LanCidrIp4 = 'lanCidrIp4',
  /** column name */
  LanSegmentIp4 = 'lanSegmentIp4',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "SiteLan" */
export type SiteLan_Set_Input = {
  ap5Channel?: InputMaybe<Scalars['Int']>;
  ap5Password?: InputMaybe<Scalars['String']>;
  ap5SSID?: InputMaybe<Scalars['String']>;
  apChannel?: InputMaybe<Scalars['Int']>;
  apCountryCode?: InputMaybe<Scalars['String']>;
  apMode?: InputMaybe<Scalars['apmode']>;
  apPassword?: InputMaybe<Scalars['String']>;
  apSSID?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dhcpDefaultLease?: InputMaybe<Scalars['String']>;
  dhcpMaxLease?: InputMaybe<Scalars['String']>;
  dhcpRangeEnd?: InputMaybe<Scalars['String']>;
  dhcpRangeStart?: InputMaybe<Scalars['String']>;
  dnsServer1?: InputMaybe<Scalars['String']>;
  dnsServer2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  ip4DMZ?: InputMaybe<Scalars['String']>;
  isAP?: InputMaybe<Scalars['Boolean']>;
  isDMZ?: InputMaybe<Scalars['Boolean']>;
  isDhcpRequired?: InputMaybe<Scalars['Boolean']>;
  lanCidrIp4?: InputMaybe<Scalars['String']>;
  lanSegmentIp4?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vlanId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type SiteLan_Stddev_Fields = {
  __typename?: 'SiteLan_stddev_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "SiteLan" */
export type SiteLan_Stddev_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SiteLan_Stddev_Pop_Fields = {
  __typename?: 'SiteLan_stddev_pop_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "SiteLan" */
export type SiteLan_Stddev_Pop_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SiteLan_Stddev_Samp_Fields = {
  __typename?: 'SiteLan_stddev_samp_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "SiteLan" */
export type SiteLan_Stddev_Samp_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type SiteLan_Sum_Fields = {
  __typename?: 'SiteLan_sum_fields';
  ap5Channel?: Maybe<Scalars['Int']>;
  apChannel?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "SiteLan" */
export type SiteLan_Sum_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** update columns of table "SiteLan" */
export enum SiteLan_Update_Column {
  /** column name */
  Ap5Channel = 'ap5Channel',
  /** column name */
  Ap5Password = 'ap5Password',
  /** column name */
  Ap5Ssid = 'ap5SSID',
  /** column name */
  ApChannel = 'apChannel',
  /** column name */
  ApCountryCode = 'apCountryCode',
  /** column name */
  ApMode = 'apMode',
  /** column name */
  ApPassword = 'apPassword',
  /** column name */
  ApSsid = 'apSSID',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DhcpDefaultLease = 'dhcpDefaultLease',
  /** column name */
  DhcpMaxLease = 'dhcpMaxLease',
  /** column name */
  DhcpRangeEnd = 'dhcpRangeEnd',
  /** column name */
  DhcpRangeStart = 'dhcpRangeStart',
  /** column name */
  DnsServer1 = 'dnsServer1',
  /** column name */
  DnsServer2 = 'dnsServer2',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  Ip4Dmz = 'ip4DMZ',
  /** column name */
  IsAp = 'isAP',
  /** column name */
  IsDmz = 'isDMZ',
  /** column name */
  IsDhcpRequired = 'isDhcpRequired',
  /** column name */
  LanCidrIp4 = 'lanCidrIp4',
  /** column name */
  LanSegmentIp4 = 'lanSegmentIp4',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type SiteLan_Var_Pop_Fields = {
  __typename?: 'SiteLan_var_pop_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "SiteLan" */
export type SiteLan_Var_Pop_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SiteLan_Var_Samp_Fields = {
  __typename?: 'SiteLan_var_samp_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "SiteLan" */
export type SiteLan_Var_Samp_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SiteLan_Variance_Fields = {
  __typename?: 'SiteLan_variance_fields';
  ap5Channel?: Maybe<Scalars['Float']>;
  apChannel?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "SiteLan" */
export type SiteLan_Variance_Order_By = {
  ap5Channel?: InputMaybe<Order_By>;
  apChannel?: InputMaybe<Order_By>;
};

/** columns and relationships of "SiteRoute" */
export type SiteRoute = {
  __typename?: 'SiteRoute';
  /** An object relationship */
  Site: Site;
  id: Scalars['uuid'];
  isActive?: Maybe<Scalars['Boolean']>;
  isInbound?: Maybe<Scalars['Boolean']>;
  metric?: Maybe<Scalars['Int']>;
  routerIP?: Maybe<Scalars['inet']>;
  routerInterface?: Maybe<Scalars['String']>;
  siteId: Scalars['uuid'];
  subnet?: Maybe<Scalars['cidr']>;
};

/** aggregated selection of "SiteRoute" */
export type SiteRoute_Aggregate = {
  __typename?: 'SiteRoute_aggregate';
  aggregate?: Maybe<SiteRoute_Aggregate_Fields>;
  nodes: Array<SiteRoute>;
};

/** aggregate fields of "SiteRoute" */
export type SiteRoute_Aggregate_Fields = {
  __typename?: 'SiteRoute_aggregate_fields';
  avg?: Maybe<SiteRoute_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SiteRoute_Max_Fields>;
  min?: Maybe<SiteRoute_Min_Fields>;
  stddev?: Maybe<SiteRoute_Stddev_Fields>;
  stddev_pop?: Maybe<SiteRoute_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SiteRoute_Stddev_Samp_Fields>;
  sum?: Maybe<SiteRoute_Sum_Fields>;
  var_pop?: Maybe<SiteRoute_Var_Pop_Fields>;
  var_samp?: Maybe<SiteRoute_Var_Samp_Fields>;
  variance?: Maybe<SiteRoute_Variance_Fields>;
};


/** aggregate fields of "SiteRoute" */
export type SiteRoute_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SiteRoute_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "SiteRoute" */
export type SiteRoute_Aggregate_Order_By = {
  avg?: InputMaybe<SiteRoute_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SiteRoute_Max_Order_By>;
  min?: InputMaybe<SiteRoute_Min_Order_By>;
  stddev?: InputMaybe<SiteRoute_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SiteRoute_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SiteRoute_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SiteRoute_Sum_Order_By>;
  var_pop?: InputMaybe<SiteRoute_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SiteRoute_Var_Samp_Order_By>;
  variance?: InputMaybe<SiteRoute_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "SiteRoute" */
export type SiteRoute_Arr_Rel_Insert_Input = {
  data: Array<SiteRoute_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SiteRoute_On_Conflict>;
};

/** aggregate avg on columns */
export type SiteRoute_Avg_Fields = {
  __typename?: 'SiteRoute_avg_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "SiteRoute" */
export type SiteRoute_Avg_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "SiteRoute". All fields are combined with a logical 'AND'. */
export type SiteRoute_Bool_Exp = {
  Site?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<SiteRoute_Bool_Exp>>;
  _not?: InputMaybe<SiteRoute_Bool_Exp>;
  _or?: InputMaybe<Array<SiteRoute_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  isInbound?: InputMaybe<Boolean_Comparison_Exp>;
  metric?: InputMaybe<Int_Comparison_Exp>;
  routerIP?: InputMaybe<Inet_Comparison_Exp>;
  routerInterface?: InputMaybe<String_Comparison_Exp>;
  siteId?: InputMaybe<Uuid_Comparison_Exp>;
  subnet?: InputMaybe<Cidr_Comparison_Exp>;
};

/** unique or primary key constraints on table "SiteRoute" */
export enum SiteRoute_Constraint {
  /** unique or primary key constraint */
  SiteRoutePkey = 'SiteRoute_pkey'
}

/** input type for incrementing numeric columns in table "SiteRoute" */
export type SiteRoute_Inc_Input = {
  metric?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "SiteRoute" */
export type SiteRoute_Insert_Input = {
  Site?: InputMaybe<Site_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInbound?: InputMaybe<Scalars['Boolean']>;
  metric?: InputMaybe<Scalars['Int']>;
  routerIP?: InputMaybe<Scalars['inet']>;
  routerInterface?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  subnet?: InputMaybe<Scalars['cidr']>;
};

/** aggregate max on columns */
export type SiteRoute_Max_Fields = {
  __typename?: 'SiteRoute_max_fields';
  id?: Maybe<Scalars['uuid']>;
  metric?: Maybe<Scalars['Int']>;
  routerInterface?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "SiteRoute" */
export type SiteRoute_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  routerInterface?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SiteRoute_Min_Fields = {
  __typename?: 'SiteRoute_min_fields';
  id?: Maybe<Scalars['uuid']>;
  metric?: Maybe<Scalars['Int']>;
  routerInterface?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "SiteRoute" */
export type SiteRoute_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  routerInterface?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "SiteRoute" */
export type SiteRoute_Mutation_Response = {
  __typename?: 'SiteRoute_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SiteRoute>;
};

/** on_conflict condition type for table "SiteRoute" */
export type SiteRoute_On_Conflict = {
  constraint: SiteRoute_Constraint;
  update_columns?: Array<SiteRoute_Update_Column>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};

/** Ordering options when selecting data from "SiteRoute". */
export type SiteRoute_Order_By = {
  Site?: InputMaybe<Site_Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  isInbound?: InputMaybe<Order_By>;
  metric?: InputMaybe<Order_By>;
  routerIP?: InputMaybe<Order_By>;
  routerInterface?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  subnet?: InputMaybe<Order_By>;
};

/** primary key columns input for table: SiteRoute */
export type SiteRoute_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "SiteRoute" */
export enum SiteRoute_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsInbound = 'isInbound',
  /** column name */
  Metric = 'metric',
  /** column name */
  RouterIp = 'routerIP',
  /** column name */
  RouterInterface = 'routerInterface',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  Subnet = 'subnet'
}

/** input type for updating data in table "SiteRoute" */
export type SiteRoute_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInbound?: InputMaybe<Scalars['Boolean']>;
  metric?: InputMaybe<Scalars['Int']>;
  routerIP?: InputMaybe<Scalars['inet']>;
  routerInterface?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  subnet?: InputMaybe<Scalars['cidr']>;
};

/** aggregate stddev on columns */
export type SiteRoute_Stddev_Fields = {
  __typename?: 'SiteRoute_stddev_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "SiteRoute" */
export type SiteRoute_Stddev_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SiteRoute_Stddev_Pop_Fields = {
  __typename?: 'SiteRoute_stddev_pop_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "SiteRoute" */
export type SiteRoute_Stddev_Pop_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SiteRoute_Stddev_Samp_Fields = {
  __typename?: 'SiteRoute_stddev_samp_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "SiteRoute" */
export type SiteRoute_Stddev_Samp_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type SiteRoute_Sum_Fields = {
  __typename?: 'SiteRoute_sum_fields';
  metric?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "SiteRoute" */
export type SiteRoute_Sum_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** update columns of table "SiteRoute" */
export enum SiteRoute_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  IsInbound = 'isInbound',
  /** column name */
  Metric = 'metric',
  /** column name */
  RouterIp = 'routerIP',
  /** column name */
  RouterInterface = 'routerInterface',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  Subnet = 'subnet'
}

/** aggregate var_pop on columns */
export type SiteRoute_Var_Pop_Fields = {
  __typename?: 'SiteRoute_var_pop_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "SiteRoute" */
export type SiteRoute_Var_Pop_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SiteRoute_Var_Samp_Fields = {
  __typename?: 'SiteRoute_var_samp_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "SiteRoute" */
export type SiteRoute_Var_Samp_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SiteRoute_Variance_Fields = {
  __typename?: 'SiteRoute_variance_fields';
  metric?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "SiteRoute" */
export type SiteRoute_Variance_Order_By = {
  metric?: InputMaybe<Order_By>;
};

/** aggregated selection of "Site" */
export type Site_Aggregate = {
  __typename?: 'Site_aggregate';
  aggregate?: Maybe<Site_Aggregate_Fields>;
  nodes: Array<Site>;
};

/** aggregate fields of "Site" */
export type Site_Aggregate_Fields = {
  __typename?: 'Site_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Site_Max_Fields>;
  min?: Maybe<Site_Min_Fields>;
};


/** aggregate fields of "Site" */
export type Site_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Site_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Site" */
export type Site_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Site_Max_Order_By>;
  min?: InputMaybe<Site_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Site" */
export type Site_Arr_Rel_Insert_Input = {
  data: Array<Site_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Site_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Site". All fields are combined with a logical 'AND'. */
export type Site_Bool_Exp = {
  ClientCompany?: InputMaybe<ClientCompany_Bool_Exp>;
  MeshWan?: InputMaybe<MeshWan_Bool_Exp>;
  Monitor?: InputMaybe<Monitor_Bool_Exp>;
  SiteContacts?: InputMaybe<SiteContact_Bool_Exp>;
  SiteLans?: InputMaybe<SiteLan_Bool_Exp>;
  SiteRoutes?: InputMaybe<SiteRoute_Bool_Exp>;
  Tunnels?: InputMaybe<Tunnel_Bool_Exp>;
  Wan?: InputMaybe<Wan_Bool_Exp>;
  _and?: InputMaybe<Array<Site_Bool_Exp>>;
  _not?: InputMaybe<Site_Bool_Exp>;
  _or?: InputMaybe<Array<Site_Bool_Exp>>;
  accessibleIps?: InputMaybe<String_Comparison_Exp>;
  address1?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  clientCompanyId?: InputMaybe<Uuid_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ipAccessLevel?: InputMaybe<String_Comparison_Exp>;
  isServerless?: InputMaybe<Boolean_Comparison_Exp>;
  meshWanId?: InputMaybe<Uuid_Comparison_Exp>;
  monitorEndpoint?: InputMaybe<String_Comparison_Exp>;
  monitorId?: InputMaybe<Uuid_Comparison_Exp>;
  osVersion?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  rebootRequest?: InputMaybe<Timestamptz_Comparison_Exp>;
  softwareVersion?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wanId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: Scalars['Int'];
};

/** unique or primary key constraints on table "Site" */
export enum Site_Constraint {
  /** unique or primary key constraint */
  SitePkey = 'Site_pkey'
}

/** input type for inserting data into table "Site" */
export type Site_Insert_Input = {
  ClientCompany?: InputMaybe<ClientCompany_Obj_Rel_Insert_Input>;
  MeshWan?: InputMaybe<MeshWan_Obj_Rel_Insert_Input>;
  Monitor?: InputMaybe<Monitor_Obj_Rel_Insert_Input>;
  SiteContacts?: InputMaybe<SiteContact_Arr_Rel_Insert_Input>;
  SiteLans?: InputMaybe<SiteLan_Arr_Rel_Insert_Input>;
  SiteRoutes?: InputMaybe<SiteRoute_Arr_Rel_Insert_Input>;
  Tunnels?: InputMaybe<Tunnel_Arr_Rel_Insert_Input>;
  Wan?: InputMaybe<Wan_Obj_Rel_Insert_Input>;
  accessibleIps?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientCompanyId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAccessLevel?: InputMaybe<Scalars['String']>;
  isServerless?: InputMaybe<Scalars['Boolean']>;
  meshWanId?: InputMaybe<Scalars['uuid']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  monitorId?: InputMaybe<Scalars['uuid']>;
  osVersion?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  rebootRequest?: InputMaybe<Scalars['timestamptz']>;
  softwareVersion?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wanId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Site_Max_Fields = {
  __typename?: 'Site_max_fields';
  accessibleIps?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientCompanyId?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ipAccessLevel?: Maybe<Scalars['String']>;
  meshWanId?: Maybe<Scalars['uuid']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  osVersion?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wanId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "Site" */
export type Site_Max_Order_By = {
  accessibleIps?: InputMaybe<Order_By>;
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientCompanyId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipAccessLevel?: InputMaybe<Order_By>;
  meshWanId?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wanId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Site_Min_Fields = {
  __typename?: 'Site_min_fields';
  accessibleIps?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientCompanyId?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ipAccessLevel?: Maybe<Scalars['String']>;
  meshWanId?: Maybe<Scalars['uuid']>;
  monitorEndpoint?: Maybe<Scalars['String']>;
  monitorId?: Maybe<Scalars['uuid']>;
  osVersion?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  rebootRequest?: Maybe<Scalars['timestamptz']>;
  softwareVersion?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  wanId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "Site" */
export type Site_Min_Order_By = {
  accessibleIps?: InputMaybe<Order_By>;
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientCompanyId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipAccessLevel?: InputMaybe<Order_By>;
  meshWanId?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wanId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Site" */
export type Site_Mutation_Response = {
  __typename?: 'Site_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Site>;
};

/** input type for inserting object relation for remote table "Site" */
export type Site_Obj_Rel_Insert_Input = {
  data: Site_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Site_On_Conflict>;
};

/** on_conflict condition type for table "Site" */
export type Site_On_Conflict = {
  constraint: Site_Constraint;
  update_columns?: Array<Site_Update_Column>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** Ordering options when selecting data from "Site". */
export type Site_Order_By = {
  ClientCompany?: InputMaybe<ClientCompany_Order_By>;
  MeshWan?: InputMaybe<MeshWan_Order_By>;
  Monitor?: InputMaybe<Monitor_Order_By>;
  SiteContacts_aggregate?: InputMaybe<SiteContact_Aggregate_Order_By>;
  SiteLans_aggregate?: InputMaybe<SiteLan_Aggregate_Order_By>;
  SiteRoutes_aggregate?: InputMaybe<SiteRoute_Aggregate_Order_By>;
  Tunnels_aggregate?: InputMaybe<Tunnel_Aggregate_Order_By>;
  Wan?: InputMaybe<Wan_Order_By>;
  accessibleIps?: InputMaybe<Order_By>;
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clientCompanyId?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipAccessLevel?: InputMaybe<Order_By>;
  isServerless?: InputMaybe<Order_By>;
  meshWanId?: InputMaybe<Order_By>;
  monitorEndpoint?: InputMaybe<Order_By>;
  monitorId?: InputMaybe<Order_By>;
  osVersion?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  rebootRequest?: InputMaybe<Order_By>;
  softwareVersion?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wanId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Site */
export type Site_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Site" */
export enum Site_Select_Column {
  /** column name */
  AccessibleIps = 'accessibleIps',
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  ClientCompanyId = 'clientCompanyId',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAccessLevel = 'ipAccessLevel',
  /** column name */
  IsServerless = 'isServerless',
  /** column name */
  MeshWanId = 'meshWanId',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  MonitorId = 'monitorId',
  /** column name */
  OsVersion = 'osVersion',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RebootRequest = 'rebootRequest',
  /** column name */
  SoftwareVersion = 'softwareVersion',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WanId = 'wanId'
}

/** input type for updating data in table "Site" */
export type Site_Set_Input = {
  accessibleIps?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  clientCompanyId?: InputMaybe<Scalars['uuid']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ipAccessLevel?: InputMaybe<Scalars['String']>;
  isServerless?: InputMaybe<Scalars['Boolean']>;
  meshWanId?: InputMaybe<Scalars['uuid']>;
  monitorEndpoint?: InputMaybe<Scalars['String']>;
  monitorId?: InputMaybe<Scalars['uuid']>;
  osVersion?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  rebootRequest?: InputMaybe<Scalars['timestamptz']>;
  softwareVersion?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  wanId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "Site" */
export enum Site_Update_Column {
  /** column name */
  AccessibleIps = 'accessibleIps',
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  ClientCompanyId = 'clientCompanyId',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAccessLevel = 'ipAccessLevel',
  /** column name */
  IsServerless = 'isServerless',
  /** column name */
  MeshWanId = 'meshWanId',
  /** column name */
  MonitorEndpoint = 'monitorEndpoint',
  /** column name */
  MonitorId = 'monitorId',
  /** column name */
  OsVersion = 'osVersion',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  RebootRequest = 'rebootRequest',
  /** column name */
  SoftwareVersion = 'softwareVersion',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WanId = 'wanId'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "Tunnel" */
export type Tunnel = {
  __typename?: 'Tunnel';
  /** An array relationship */
  Links: Array<Link>;
  /** An aggregate relationship */
  Links_aggregate: Link_Aggregate;
  /** An object relationship */
  Server: Server;
  /** An object relationship */
  Site: Site;
  /** An array relationship */
  TunnelProfiles: Array<TunnelProfile>;
  /** An aggregate relationship */
  TunnelProfiles_aggregate: TunnelProfile_Aggregate;
  autoMTU: Scalars['Boolean'];
  cidr?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  downloadCap?: Maybe<Scalars['String']>;
  flowlet?: Maybe<Scalars['Boolean']>;
  hasTrafficManagement?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  interfaceName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isCapEnabled?: Maybe<Scalars['Boolean']>;
  isClearTextData: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  isQOSEnabled?: Maybe<Scalars['Boolean']>;
  lbAlgo?: Maybe<Scalars['String']>;
  lossTolerance?: Maybe<Scalars['String']>;
  mtu?: Maybe<Scalars['String']>;
  portRangeEnd: Scalars['numeric'];
  portRangeStart: Scalars['numeric'];
  reorderBufferTime?: Maybe<Scalars['Int']>;
  serverId: Scalars['uuid'];
  shouldReorderBuffer: Scalars['Boolean'];
  siteId: Scalars['uuid'];
  status?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['String']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Int']>;
  tunnelPassword?: Maybe<Scalars['String']>;
  tuntap?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  uploadCap?: Maybe<Scalars['String']>;
};


/** columns and relationships of "Tunnel" */
export type TunnelLinksArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


/** columns and relationships of "Tunnel" */
export type TunnelLinks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


/** columns and relationships of "Tunnel" */
export type TunnelTunnelProfilesArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


/** columns and relationships of "Tunnel" */
export type TunnelTunnelProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};

/** columns and relationships of "TunnelProfile" */
export type TunnelProfile = {
  __typename?: 'TunnelProfile';
  /** An object relationship */
  Profile: Profile;
  /** An object relationship */
  Tunnel: Tunnel;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  profileId: Scalars['uuid'];
  tunnelId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "TunnelProfile" */
export type TunnelProfile_Aggregate = {
  __typename?: 'TunnelProfile_aggregate';
  aggregate?: Maybe<TunnelProfile_Aggregate_Fields>;
  nodes: Array<TunnelProfile>;
};

/** aggregate fields of "TunnelProfile" */
export type TunnelProfile_Aggregate_Fields = {
  __typename?: 'TunnelProfile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<TunnelProfile_Max_Fields>;
  min?: Maybe<TunnelProfile_Min_Fields>;
};


/** aggregate fields of "TunnelProfile" */
export type TunnelProfile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "TunnelProfile" */
export type TunnelProfile_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TunnelProfile_Max_Order_By>;
  min?: InputMaybe<TunnelProfile_Min_Order_By>;
};

/** input type for inserting array relation for remote table "TunnelProfile" */
export type TunnelProfile_Arr_Rel_Insert_Input = {
  data: Array<TunnelProfile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TunnelProfile_On_Conflict>;
};

/** Boolean expression to filter rows from the table "TunnelProfile". All fields are combined with a logical 'AND'. */
export type TunnelProfile_Bool_Exp = {
  Profile?: InputMaybe<Profile_Bool_Exp>;
  Tunnel?: InputMaybe<Tunnel_Bool_Exp>;
  _and?: InputMaybe<Array<TunnelProfile_Bool_Exp>>;
  _not?: InputMaybe<TunnelProfile_Bool_Exp>;
  _or?: InputMaybe<Array<TunnelProfile_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  tunnelId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "TunnelProfile" */
export enum TunnelProfile_Constraint {
  /** unique or primary key constraint */
  TunnelProfilePkey = 'TunnelProfile_pkey'
}

/** input type for inserting data into table "TunnelProfile" */
export type TunnelProfile_Insert_Input = {
  Profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  Tunnel?: InputMaybe<Tunnel_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  tunnelId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TunnelProfile_Max_Fields = {
  __typename?: 'TunnelProfile_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  tunnelId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "TunnelProfile" */
export type TunnelProfile_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TunnelProfile_Min_Fields = {
  __typename?: 'TunnelProfile_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  tunnelId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "TunnelProfile" */
export type TunnelProfile_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "TunnelProfile" */
export type TunnelProfile_Mutation_Response = {
  __typename?: 'TunnelProfile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TunnelProfile>;
};

/** on_conflict condition type for table "TunnelProfile" */
export type TunnelProfile_On_Conflict = {
  constraint: TunnelProfile_Constraint;
  update_columns?: Array<TunnelProfile_Update_Column>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};

/** Ordering options when selecting data from "TunnelProfile". */
export type TunnelProfile_Order_By = {
  Profile?: InputMaybe<Profile_Order_By>;
  Tunnel?: InputMaybe<Tunnel_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  tunnelId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: TunnelProfile */
export type TunnelProfile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "TunnelProfile" */
export enum TunnelProfile_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  TunnelId = 'tunnelId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "TunnelProfile" */
export type TunnelProfile_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  tunnelId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "TunnelProfile" */
export enum TunnelProfile_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  TunnelId = 'tunnelId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregated selection of "Tunnel" */
export type Tunnel_Aggregate = {
  __typename?: 'Tunnel_aggregate';
  aggregate?: Maybe<Tunnel_Aggregate_Fields>;
  nodes: Array<Tunnel>;
};

/** aggregate fields of "Tunnel" */
export type Tunnel_Aggregate_Fields = {
  __typename?: 'Tunnel_aggregate_fields';
  avg?: Maybe<Tunnel_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tunnel_Max_Fields>;
  min?: Maybe<Tunnel_Min_Fields>;
  stddev?: Maybe<Tunnel_Stddev_Fields>;
  stddev_pop?: Maybe<Tunnel_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tunnel_Stddev_Samp_Fields>;
  sum?: Maybe<Tunnel_Sum_Fields>;
  var_pop?: Maybe<Tunnel_Var_Pop_Fields>;
  var_samp?: Maybe<Tunnel_Var_Samp_Fields>;
  variance?: Maybe<Tunnel_Variance_Fields>;
};


/** aggregate fields of "Tunnel" */
export type Tunnel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tunnel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Tunnel" */
export type Tunnel_Aggregate_Order_By = {
  avg?: InputMaybe<Tunnel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tunnel_Max_Order_By>;
  min?: InputMaybe<Tunnel_Min_Order_By>;
  stddev?: InputMaybe<Tunnel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tunnel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tunnel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tunnel_Sum_Order_By>;
  var_pop?: InputMaybe<Tunnel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tunnel_Var_Samp_Order_By>;
  variance?: InputMaybe<Tunnel_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "Tunnel" */
export type Tunnel_Arr_Rel_Insert_Input = {
  data: Array<Tunnel_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tunnel_On_Conflict>;
};

/** aggregate avg on columns */
export type Tunnel_Avg_Fields = {
  __typename?: 'Tunnel_avg_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "Tunnel" */
export type Tunnel_Avg_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "Tunnel". All fields are combined with a logical 'AND'. */
export type Tunnel_Bool_Exp = {
  Links?: InputMaybe<Link_Bool_Exp>;
  Server?: InputMaybe<Server_Bool_Exp>;
  Site?: InputMaybe<Site_Bool_Exp>;
  TunnelProfiles?: InputMaybe<TunnelProfile_Bool_Exp>;
  _and?: InputMaybe<Array<Tunnel_Bool_Exp>>;
  _not?: InputMaybe<Tunnel_Bool_Exp>;
  _or?: InputMaybe<Array<Tunnel_Bool_Exp>>;
  autoMTU?: InputMaybe<Boolean_Comparison_Exp>;
  cidr?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  downloadCap?: InputMaybe<String_Comparison_Exp>;
  hasTrafficManagement?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interfaceName?: InputMaybe<String_Comparison_Exp>;
  isCapEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isClearTextData?: InputMaybe<Boolean_Comparison_Exp>;
  isPrimary?: InputMaybe<Boolean_Comparison_Exp>;
  isQOSEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  lossTolerance?: InputMaybe<String_Comparison_Exp>;
  mtu?: InputMaybe<String_Comparison_Exp>;
  portRangeEnd?: InputMaybe<Numeric_Comparison_Exp>;
  portRangeStart?: InputMaybe<Numeric_Comparison_Exp>;
  reorderBufferTime?: InputMaybe<Int_Comparison_Exp>;
  serverId?: InputMaybe<Uuid_Comparison_Exp>;
  shouldReorderBuffer?: InputMaybe<Boolean_Comparison_Exp>;
  siteId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  timeout?: InputMaybe<String_Comparison_Exp>;
  tunnelAddressPairSeed?: InputMaybe<Int_Comparison_Exp>;
  tunnelPassword?: InputMaybe<String_Comparison_Exp>;
  tuntap?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadCap?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Tunnel" */
export enum Tunnel_Constraint {
  /** unique or primary key constraint */
  TunnelPkey = 'Tunnel_pkey'
}

/** input type for incrementing numeric columns in table "Tunnel" */
export type Tunnel_Inc_Input = {
  portRangeEnd?: InputMaybe<Scalars['numeric']>;
  portRangeStart?: InputMaybe<Scalars['numeric']>;
  reorderBufferTime?: InputMaybe<Scalars['Int']>;
  tunnelAddressPairSeed?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "Tunnel" */
export type Tunnel_Insert_Input = {
  Links?: InputMaybe<Link_Arr_Rel_Insert_Input>;
  Server?: InputMaybe<Server_Obj_Rel_Insert_Input>;
  Site?: InputMaybe<Site_Obj_Rel_Insert_Input>;
  TunnelProfiles?: InputMaybe<TunnelProfile_Arr_Rel_Insert_Input>;
  autoMTU?: InputMaybe<Scalars['Boolean']>;
  cidr?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  downloadCap?: InputMaybe<Scalars['String']>;
  hasTrafficManagement?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  isCapEnabled?: InputMaybe<Scalars['Boolean']>;
  isClearTextData?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  isQOSEnabled?: InputMaybe<Scalars['Boolean']>;
  lossTolerance?: InputMaybe<Scalars['String']>;
  mtu?: InputMaybe<Scalars['String']>;
  portRangeEnd?: InputMaybe<Scalars['numeric']>;
  portRangeStart?: InputMaybe<Scalars['numeric']>;
  reorderBufferTime?: InputMaybe<Scalars['Int']>;
  serverId?: InputMaybe<Scalars['uuid']>;
  shouldReorderBuffer?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  timeout?: InputMaybe<Scalars['String']>;
  tunnelAddressPairSeed?: InputMaybe<Scalars['Int']>;
  tunnelPassword?: InputMaybe<Scalars['String']>;
  tuntap?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uploadCap?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tunnel_Max_Fields = {
  __typename?: 'Tunnel_max_fields';
  cidr?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  downloadCap?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  lossTolerance?: Maybe<Scalars['String']>;
  mtu?: Maybe<Scalars['String']>;
  portRangeEnd?: Maybe<Scalars['numeric']>;
  portRangeStart?: Maybe<Scalars['numeric']>;
  reorderBufferTime?: Maybe<Scalars['Int']>;
  serverId?: Maybe<Scalars['uuid']>;
  siteId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['String']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Int']>;
  tunnelPassword?: Maybe<Scalars['String']>;
  tuntap?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadCap?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "Tunnel" */
export type Tunnel_Max_Order_By = {
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  downloadCap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  lossTolerance?: InputMaybe<Order_By>;
  mtu?: InputMaybe<Order_By>;
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timeout?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
  tunnelPassword?: InputMaybe<Order_By>;
  tuntap?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadCap?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tunnel_Min_Fields = {
  __typename?: 'Tunnel_min_fields';
  cidr?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  downloadCap?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interfaceName?: Maybe<Scalars['String']>;
  lossTolerance?: Maybe<Scalars['String']>;
  mtu?: Maybe<Scalars['String']>;
  portRangeEnd?: Maybe<Scalars['numeric']>;
  portRangeStart?: Maybe<Scalars['numeric']>;
  reorderBufferTime?: Maybe<Scalars['Int']>;
  serverId?: Maybe<Scalars['uuid']>;
  siteId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['String']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Int']>;
  tunnelPassword?: Maybe<Scalars['String']>;
  tuntap?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadCap?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "Tunnel" */
export type Tunnel_Min_Order_By = {
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  downloadCap?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  lossTolerance?: InputMaybe<Order_By>;
  mtu?: InputMaybe<Order_By>;
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timeout?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
  tunnelPassword?: InputMaybe<Order_By>;
  tuntap?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadCap?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Tunnel" */
export type Tunnel_Mutation_Response = {
  __typename?: 'Tunnel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tunnel>;
};

/** input type for inserting object relation for remote table "Tunnel" */
export type Tunnel_Obj_Rel_Insert_Input = {
  data: Tunnel_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tunnel_On_Conflict>;
};

/** on_conflict condition type for table "Tunnel" */
export type Tunnel_On_Conflict = {
  constraint: Tunnel_Constraint;
  update_columns?: Array<Tunnel_Update_Column>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};

/** Ordering options when selecting data from "Tunnel". */
export type Tunnel_Order_By = {
  Links_aggregate?: InputMaybe<Link_Aggregate_Order_By>;
  Server?: InputMaybe<Server_Order_By>;
  Site?: InputMaybe<Site_Order_By>;
  TunnelProfiles_aggregate?: InputMaybe<TunnelProfile_Aggregate_Order_By>;
  autoMTU?: InputMaybe<Order_By>;
  cidr?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  downloadCap?: InputMaybe<Order_By>;
  hasTrafficManagement?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interfaceName?: InputMaybe<Order_By>;
  isCapEnabled?: InputMaybe<Order_By>;
  isClearTextData?: InputMaybe<Order_By>;
  isPrimary?: InputMaybe<Order_By>;
  isQOSEnabled?: InputMaybe<Order_By>;
  lossTolerance?: InputMaybe<Order_By>;
  mtu?: InputMaybe<Order_By>;
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  serverId?: InputMaybe<Order_By>;
  shouldReorderBuffer?: InputMaybe<Order_By>;
  siteId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  timeout?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
  tunnelPassword?: InputMaybe<Order_By>;
  tuntap?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploadCap?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Tunnel */
export type Tunnel_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Tunnel" */
export enum Tunnel_Select_Column {
  /** column name */
  AutoMtu = 'autoMTU',
  /** column name */
  Cidr = 'cidr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DownloadCap = 'downloadCap',
  /** column name */
  HasTrafficManagement = 'hasTrafficManagement',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  IsCapEnabled = 'isCapEnabled',
  /** column name */
  IsClearTextData = 'isClearTextData',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsQosEnabled = 'isQOSEnabled',
  /** column name */
  LossTolerance = 'lossTolerance',
  /** column name */
  Mtu = 'mtu',
  /** column name */
  PortRangeEnd = 'portRangeEnd',
  /** column name */
  PortRangeStart = 'portRangeStart',
  /** column name */
  ReorderBufferTime = 'reorderBufferTime',
  /** column name */
  ServerId = 'serverId',
  /** column name */
  ShouldReorderBuffer = 'shouldReorderBuffer',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  Status = 'status',
  /** column name */
  Timeout = 'timeout',
  /** column name */
  TunnelAddressPairSeed = 'tunnelAddressPairSeed',
  /** column name */
  TunnelPassword = 'tunnelPassword',
  /** column name */
  Tuntap = 'tuntap',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadCap = 'uploadCap'
}

/** input type for updating data in table "Tunnel" */
export type Tunnel_Set_Input = {
  autoMTU?: InputMaybe<Scalars['Boolean']>;
  cidr?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  downloadCap?: InputMaybe<Scalars['String']>;
  hasTrafficManagement?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  interfaceName?: InputMaybe<Scalars['String']>;
  isCapEnabled?: InputMaybe<Scalars['Boolean']>;
  isClearTextData?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  isQOSEnabled?: InputMaybe<Scalars['Boolean']>;
  lossTolerance?: InputMaybe<Scalars['String']>;
  mtu?: InputMaybe<Scalars['String']>;
  portRangeEnd?: InputMaybe<Scalars['numeric']>;
  portRangeStart?: InputMaybe<Scalars['numeric']>;
  reorderBufferTime?: InputMaybe<Scalars['Int']>;
  serverId?: InputMaybe<Scalars['uuid']>;
  shouldReorderBuffer?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  timeout?: InputMaybe<Scalars['String']>;
  tunnelAddressPairSeed?: InputMaybe<Scalars['Int']>;
  tunnelPassword?: InputMaybe<Scalars['String']>;
  tuntap?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uploadCap?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tunnel_Stddev_Fields = {
  __typename?: 'Tunnel_stddev_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "Tunnel" */
export type Tunnel_Stddev_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tunnel_Stddev_Pop_Fields = {
  __typename?: 'Tunnel_stddev_pop_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "Tunnel" */
export type Tunnel_Stddev_Pop_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tunnel_Stddev_Samp_Fields = {
  __typename?: 'Tunnel_stddev_samp_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "Tunnel" */
export type Tunnel_Stddev_Samp_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Tunnel_Sum_Fields = {
  __typename?: 'Tunnel_sum_fields';
  portRangeEnd?: Maybe<Scalars['numeric']>;
  portRangeStart?: Maybe<Scalars['numeric']>;
  reorderBufferTime?: Maybe<Scalars['Int']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "Tunnel" */
export type Tunnel_Sum_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** update columns of table "Tunnel" */
export enum Tunnel_Update_Column {
  /** column name */
  AutoMtu = 'autoMTU',
  /** column name */
  Cidr = 'cidr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DownloadCap = 'downloadCap',
  /** column name */
  HasTrafficManagement = 'hasTrafficManagement',
  /** column name */
  Id = 'id',
  /** column name */
  InterfaceName = 'interfaceName',
  /** column name */
  IsCapEnabled = 'isCapEnabled',
  /** column name */
  IsClearTextData = 'isClearTextData',
  /** column name */
  IsPrimary = 'isPrimary',
  /** column name */
  IsQosEnabled = 'isQOSEnabled',
  /** column name */
  LossTolerance = 'lossTolerance',
  /** column name */
  Mtu = 'mtu',
  /** column name */
  PortRangeEnd = 'portRangeEnd',
  /** column name */
  PortRangeStart = 'portRangeStart',
  /** column name */
  ReorderBufferTime = 'reorderBufferTime',
  /** column name */
  ServerId = 'serverId',
  /** column name */
  ShouldReorderBuffer = 'shouldReorderBuffer',
  /** column name */
  SiteId = 'siteId',
  /** column name */
  Status = 'status',
  /** column name */
  Timeout = 'timeout',
  /** column name */
  TunnelAddressPairSeed = 'tunnelAddressPairSeed',
  /** column name */
  TunnelPassword = 'tunnelPassword',
  /** column name */
  Tuntap = 'tuntap',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadCap = 'uploadCap'
}

/** aggregate var_pop on columns */
export type Tunnel_Var_Pop_Fields = {
  __typename?: 'Tunnel_var_pop_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "Tunnel" */
export type Tunnel_Var_Pop_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tunnel_Var_Samp_Fields = {
  __typename?: 'Tunnel_var_samp_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "Tunnel" */
export type Tunnel_Var_Samp_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tunnel_Variance_Fields = {
  __typename?: 'Tunnel_variance_fields';
  portRangeEnd?: Maybe<Scalars['Float']>;
  portRangeStart?: Maybe<Scalars['Float']>;
  reorderBufferTime?: Maybe<Scalars['Float']>;
  tunnelAddressPairSeed?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "Tunnel" */
export type Tunnel_Variance_Order_By = {
  portRangeEnd?: InputMaybe<Order_By>;
  portRangeStart?: InputMaybe<Order_By>;
  reorderBufferTime?: InputMaybe<Order_By>;
  tunnelAddressPairSeed?: InputMaybe<Order_By>;
};

/** columns and relationships of "User" */
export type User = {
  __typename?: 'User';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  UserHistories: Array<UserHistory>;
  /** An aggregate relationship */
  UserHistories_aggregate: UserHistory_Aggregate;
  /** An object relationship */
  UserRole: UserRole;
  accountStatus?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  emailAlert: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fromUserId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isInvited?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  login_at?: Maybe<Scalars['timestamptz']>;
  partnerId: Scalars['uuid'];
  phone?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  userRoleId: Scalars['uuid'];
};


/** columns and relationships of "User" */
export type UserUserHistoriesArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};


/** columns and relationships of "User" */
export type UserUserHistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};

/** columns and relationships of "UserHistory" */
export type UserHistory = {
  __typename?: 'UserHistory';
  /** An object relationship */
  User: User;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  userId: Scalars['uuid'];
};

/** aggregated selection of "UserHistory" */
export type UserHistory_Aggregate = {
  __typename?: 'UserHistory_aggregate';
  aggregate?: Maybe<UserHistory_Aggregate_Fields>;
  nodes: Array<UserHistory>;
};

/** aggregate fields of "UserHistory" */
export type UserHistory_Aggregate_Fields = {
  __typename?: 'UserHistory_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserHistory_Max_Fields>;
  min?: Maybe<UserHistory_Min_Fields>;
};


/** aggregate fields of "UserHistory" */
export type UserHistory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "UserHistory" */
export type UserHistory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserHistory_Max_Order_By>;
  min?: InputMaybe<UserHistory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "UserHistory" */
export type UserHistory_Arr_Rel_Insert_Input = {
  data: Array<UserHistory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserHistory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "UserHistory". All fields are combined with a logical 'AND'. */
export type UserHistory_Bool_Exp = {
  User?: InputMaybe<User_Bool_Exp>;
  _and?: InputMaybe<Array<UserHistory_Bool_Exp>>;
  _not?: InputMaybe<UserHistory_Bool_Exp>;
  _or?: InputMaybe<Array<UserHistory_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "UserHistory" */
export enum UserHistory_Constraint {
  /** unique or primary key constraint */
  UserHistoryPkey = 'UserHistory_pkey'
}

/** input type for inserting data into table "UserHistory" */
export type UserHistory_Insert_Input = {
  User?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserHistory_Max_Fields = {
  __typename?: 'UserHistory_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "UserHistory" */
export type UserHistory_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserHistory_Min_Fields = {
  __typename?: 'UserHistory_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "UserHistory" */
export type UserHistory_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "UserHistory" */
export type UserHistory_Mutation_Response = {
  __typename?: 'UserHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserHistory>;
};

/** on_conflict condition type for table "UserHistory" */
export type UserHistory_On_Conflict = {
  constraint: UserHistory_Constraint;
  update_columns?: Array<UserHistory_Update_Column>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};

/** Ordering options when selecting data from "UserHistory". */
export type UserHistory_Order_By = {
  User?: InputMaybe<User_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UserHistory */
export type UserHistory_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "UserHistory" */
export enum UserHistory_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "UserHistory" */
export type UserHistory_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "UserHistory" */
export enum UserHistory_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

/** columns and relationships of "UserRole" */
export type UserRole = {
  __typename?: 'UserRole';
  /** An array relationship */
  Users: Array<User>;
  /** An aggregate relationship */
  Users_aggregate: User_Aggregate;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  roleName?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "UserRole" */
export type UserRoleUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "UserRole" */
export type UserRoleUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** aggregated selection of "UserRole" */
export type UserRole_Aggregate = {
  __typename?: 'UserRole_aggregate';
  aggregate?: Maybe<UserRole_Aggregate_Fields>;
  nodes: Array<UserRole>;
};

/** aggregate fields of "UserRole" */
export type UserRole_Aggregate_Fields = {
  __typename?: 'UserRole_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<UserRole_Max_Fields>;
  min?: Maybe<UserRole_Min_Fields>;
};


/** aggregate fields of "UserRole" */
export type UserRole_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "UserRole". All fields are combined with a logical 'AND'. */
export type UserRole_Bool_Exp = {
  Users?: InputMaybe<User_Bool_Exp>;
  _and?: InputMaybe<Array<UserRole_Bool_Exp>>;
  _not?: InputMaybe<UserRole_Bool_Exp>;
  _or?: InputMaybe<Array<UserRole_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  roleName?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "UserRole" */
export enum UserRole_Constraint {
  /** unique or primary key constraint */
  UserRolePkey = 'UserRole_pkey'
}

/** input type for inserting data into table "UserRole" */
export type UserRole_Insert_Input = {
  Users?: InputMaybe<User_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  roleName?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UserRole_Max_Fields = {
  __typename?: 'UserRole_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  roleName?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UserRole_Min_Fields = {
  __typename?: 'UserRole_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  roleName?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "UserRole" */
export type UserRole_Mutation_Response = {
  __typename?: 'UserRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRole>;
};

/** input type for inserting object relation for remote table "UserRole" */
export type UserRole_Obj_Rel_Insert_Input = {
  data: UserRole_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};

/** on_conflict condition type for table "UserRole" */
export type UserRole_On_Conflict = {
  constraint: UserRole_Constraint;
  update_columns?: Array<UserRole_Update_Column>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};

/** Ordering options when selecting data from "UserRole". */
export type UserRole_Order_By = {
  Users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roleName?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: UserRole */
export type UserRole_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "UserRole" */
export enum UserRole_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RoleName = 'roleName',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "UserRole" */
export type UserRole_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  roleName?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "UserRole" */
export enum UserRole_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RoleName = 'roleName',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregated selection of "User" */
export type User_Aggregate = {
  __typename?: 'User_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "User" */
export type User_Aggregate_Fields = {
  __typename?: 'User_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "User" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "User" */
export type User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "User" */
export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "User". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  UserHistories?: InputMaybe<UserHistory_Bool_Exp>;
  UserRole?: InputMaybe<UserRole_Bool_Exp>;
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  accountStatus?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailAlert?: InputMaybe<Boolean_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  fromUserId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isInvited?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  login_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userRoleId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "User" */
export enum User_Constraint {
  /** unique or primary key constraint */
  UserEmailKey = 'User_email_key',
  /** unique or primary key constraint */
  UserPkey = 'User_pkey'
}

/** input type for inserting data into table "User" */
export type User_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  UserHistories?: InputMaybe<UserHistory_Arr_Rel_Insert_Input>;
  UserRole?: InputMaybe<UserRole_Obj_Rel_Insert_Input>;
  accountStatus?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emailAlert?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInvited?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  login_at?: InputMaybe<Scalars['timestamptz']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'User_max_fields';
  accountStatus?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  login_at?: Maybe<Scalars['timestamptz']>;
  partnerId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "User" */
export type User_Max_Order_By = {
  accountStatus?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  login_at?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'User_min_fields';
  accountStatus?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fromUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  login_at?: Maybe<Scalars['timestamptz']>;
  partnerId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "User" */
export type User_Min_Order_By = {
  accountStatus?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  login_at?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "User" */
export type User_Mutation_Response = {
  __typename?: 'User_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "User" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "User" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "User". */
export type User_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  UserHistories_aggregate?: InputMaybe<UserHistory_Aggregate_Order_By>;
  UserRole?: InputMaybe<UserRole_Order_By>;
  accountStatus?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailAlert?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  fromUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInvited?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  login_at?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userRoleId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: User */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "User" */
export enum User_Select_Column {
  /** column name */
  AccountStatus = 'accountStatus',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAlert = 'emailAlert',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvited = 'isInvited',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LoginAt = 'login_at',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserRoleId = 'userRoleId'
}

/** input type for updating data in table "User" */
export type User_Set_Input = {
  accountStatus?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  emailAlert?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  fromUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isInvited?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  login_at?: InputMaybe<Scalars['timestamptz']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userRoleId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "User" */
export enum User_Update_Column {
  /** column name */
  AccountStatus = 'accountStatus',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAlert = 'emailAlert',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  FromUserId = 'fromUserId',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvited = 'isInvited',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LoginAt = 'login_at',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserRoleId = 'userRoleId'
}

/** columns and relationships of "Wan" */
export type Wan = {
  __typename?: 'Wan';
  /** An object relationship */
  Partner: Partner;
  /** An array relationship */
  Sites: Array<Site>;
  /** An aggregate relationship */
  Sites_aggregate: Site_Aggregate;
  activeGatewayId: Scalars['uuid'];
  activeServerId: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isEncrypted: Scalars['Boolean'];
  name: Scalars['String'];
  partnerId: Scalars['uuid'];
  standbyGatewayId?: Maybe<Scalars['uuid']>;
  standbyServerId?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "Wan" */
export type WanSitesArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


/** columns and relationships of "Wan" */
export type WanSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** aggregated selection of "Wan" */
export type Wan_Aggregate = {
  __typename?: 'Wan_aggregate';
  aggregate?: Maybe<Wan_Aggregate_Fields>;
  nodes: Array<Wan>;
};

/** aggregate fields of "Wan" */
export type Wan_Aggregate_Fields = {
  __typename?: 'Wan_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Wan_Max_Fields>;
  min?: Maybe<Wan_Min_Fields>;
};


/** aggregate fields of "Wan" */
export type Wan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Wan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "Wan" */
export type Wan_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Wan_Max_Order_By>;
  min?: InputMaybe<Wan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "Wan" */
export type Wan_Arr_Rel_Insert_Input = {
  data: Array<Wan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Wan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "Wan". All fields are combined with a logical 'AND'. */
export type Wan_Bool_Exp = {
  Partner?: InputMaybe<Partner_Bool_Exp>;
  Sites?: InputMaybe<Site_Bool_Exp>;
  _and?: InputMaybe<Array<Wan_Bool_Exp>>;
  _not?: InputMaybe<Wan_Bool_Exp>;
  _or?: InputMaybe<Array<Wan_Bool_Exp>>;
  activeGatewayId?: InputMaybe<Uuid_Comparison_Exp>;
  activeServerId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isEncrypted?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partnerId?: InputMaybe<Uuid_Comparison_Exp>;
  standbyGatewayId?: InputMaybe<Uuid_Comparison_Exp>;
  standbyServerId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "Wan" */
export enum Wan_Constraint {
  /** unique or primary key constraint */
  WanPkey = 'Wan_pkey'
}

/** input type for inserting data into table "Wan" */
export type Wan_Insert_Input = {
  Partner?: InputMaybe<Partner_Obj_Rel_Insert_Input>;
  Sites?: InputMaybe<Site_Arr_Rel_Insert_Input>;
  activeGatewayId?: InputMaybe<Scalars['uuid']>;
  activeServerId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  standbyGatewayId?: InputMaybe<Scalars['uuid']>;
  standbyServerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Wan_Max_Fields = {
  __typename?: 'Wan_max_fields';
  activeGatewayId?: Maybe<Scalars['uuid']>;
  activeServerId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  standbyGatewayId?: Maybe<Scalars['uuid']>;
  standbyServerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "Wan" */
export type Wan_Max_Order_By = {
  activeGatewayId?: InputMaybe<Order_By>;
  activeServerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  standbyGatewayId?: InputMaybe<Order_By>;
  standbyServerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Wan_Min_Fields = {
  __typename?: 'Wan_min_fields';
  activeGatewayId?: Maybe<Scalars['uuid']>;
  activeServerId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['uuid']>;
  standbyGatewayId?: Maybe<Scalars['uuid']>;
  standbyServerId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "Wan" */
export type Wan_Min_Order_By = {
  activeGatewayId?: InputMaybe<Order_By>;
  activeServerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  standbyGatewayId?: InputMaybe<Order_By>;
  standbyServerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "Wan" */
export type Wan_Mutation_Response = {
  __typename?: 'Wan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Wan>;
};

/** input type for inserting object relation for remote table "Wan" */
export type Wan_Obj_Rel_Insert_Input = {
  data: Wan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Wan_On_Conflict>;
};

/** on_conflict condition type for table "Wan" */
export type Wan_On_Conflict = {
  constraint: Wan_Constraint;
  update_columns?: Array<Wan_Update_Column>;
  where?: InputMaybe<Wan_Bool_Exp>;
};

/** Ordering options when selecting data from "Wan". */
export type Wan_Order_By = {
  Partner?: InputMaybe<Partner_Order_By>;
  Sites_aggregate?: InputMaybe<Site_Aggregate_Order_By>;
  activeGatewayId?: InputMaybe<Order_By>;
  activeServerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEncrypted?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partnerId?: InputMaybe<Order_By>;
  standbyGatewayId?: InputMaybe<Order_By>;
  standbyServerId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Wan */
export type Wan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "Wan" */
export enum Wan_Select_Column {
  /** column name */
  ActiveGatewayId = 'activeGatewayId',
  /** column name */
  ActiveServerId = 'activeServerId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'isEncrypted',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  StandbyGatewayId = 'standbyGatewayId',
  /** column name */
  StandbyServerId = 'standbyServerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "Wan" */
export type Wan_Set_Input = {
  activeGatewayId?: InputMaybe<Scalars['uuid']>;
  activeServerId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isEncrypted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['uuid']>;
  standbyGatewayId?: InputMaybe<Scalars['uuid']>;
  standbyServerId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "Wan" */
export enum Wan_Update_Column {
  /** column name */
  ActiveGatewayId = 'activeGatewayId',
  /** column name */
  ActiveServerId = 'activeServerId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsEncrypted = 'isEncrypted',
  /** column name */
  Name = 'name',
  /** column name */
  PartnerId = 'partnerId',
  /** column name */
  StandbyGatewayId = 'standbyGatewayId',
  /** column name */
  StandbyServerId = 'standbyServerId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Boolean expression to compare columns of type "apmode". All fields are combined with logical 'AND'. */
export type Apmode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['apmode']>;
  _gt?: InputMaybe<Scalars['apmode']>;
  _gte?: InputMaybe<Scalars['apmode']>;
  _in?: InputMaybe<Array<Scalars['apmode']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['apmode']>;
  _lte?: InputMaybe<Scalars['apmode']>;
  _neq?: InputMaybe<Scalars['apmode']>;
  _nin?: InputMaybe<Array<Scalars['apmode']>>;
};

/** Boolean expression to compare columns of type "bridgetype". All fields are combined with logical 'AND'. */
export type Bridgetype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bridgetype']>;
  _gt?: InputMaybe<Scalars['bridgetype']>;
  _gte?: InputMaybe<Scalars['bridgetype']>;
  _in?: InputMaybe<Array<Scalars['bridgetype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bridgetype']>;
  _lte?: InputMaybe<Scalars['bridgetype']>;
  _neq?: InputMaybe<Scalars['bridgetype']>;
  _nin?: InputMaybe<Array<Scalars['bridgetype']>>;
};

/** Boolean expression to compare columns of type "cidr". All fields are combined with logical 'AND'. */
export type Cidr_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['cidr']>;
  _gt?: InputMaybe<Scalars['cidr']>;
  _gte?: InputMaybe<Scalars['cidr']>;
  _in?: InputMaybe<Array<Scalars['cidr']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['cidr']>;
  _lte?: InputMaybe<Scalars['cidr']>;
  _neq?: InputMaybe<Scalars['cidr']>;
  _nin?: InputMaybe<Array<Scalars['cidr']>>;
};

/** Boolean expression to compare columns of type "firmwarecategory". All fields are combined with logical 'AND'. */
export type Firmwarecategory_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['firmwarecategory']>;
  _gt?: InputMaybe<Scalars['firmwarecategory']>;
  _gte?: InputMaybe<Scalars['firmwarecategory']>;
  _in?: InputMaybe<Array<Scalars['firmwarecategory']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['firmwarecategory']>;
  _lte?: InputMaybe<Scalars['firmwarecategory']>;
  _neq?: InputMaybe<Scalars['firmwarecategory']>;
  _nin?: InputMaybe<Array<Scalars['firmwarecategory']>>;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type Inet_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['inet']>;
  _gt?: InputMaybe<Scalars['inet']>;
  _gte?: InputMaybe<Scalars['inet']>;
  _in?: InputMaybe<Array<Scalars['inet']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['inet']>;
  _lte?: InputMaybe<Scalars['inet']>;
  _neq?: InputMaybe<Scalars['inet']>;
  _nin?: InputMaybe<Array<Scalars['inet']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "Carrier" */
  delete_Carrier?: Maybe<Carrier_Mutation_Response>;
  /** delete single row from the table: "Carrier" */
  delete_Carrier_by_pk?: Maybe<Carrier>;
  /** delete data from the table: "ClientCompany" */
  delete_ClientCompany?: Maybe<ClientCompany_Mutation_Response>;
  /** delete single row from the table: "ClientCompany" */
  delete_ClientCompany_by_pk?: Maybe<ClientCompany>;
  /** delete data from the table: "Firmware" */
  delete_Firmware?: Maybe<Firmware_Mutation_Response>;
  /** delete single row from the table: "Firmware" */
  delete_Firmware_by_pk?: Maybe<Firmware>;
  /** delete data from the table: "Gateway" */
  delete_Gateway?: Maybe<Gateway_Mutation_Response>;
  /** delete data from the table: "GatewayBridge" */
  delete_GatewayBridge?: Maybe<GatewayBridge_Mutation_Response>;
  /** delete single row from the table: "GatewayBridge" */
  delete_GatewayBridge_by_pk?: Maybe<GatewayBridge>;
  /** delete data from the table: "GatewaySubnet" */
  delete_GatewaySubnet?: Maybe<GatewaySubnet_Mutation_Response>;
  /** delete single row from the table: "GatewaySubnet" */
  delete_GatewaySubnet_by_pk?: Maybe<GatewaySubnet>;
  /** delete single row from the table: "Gateway" */
  delete_Gateway_by_pk?: Maybe<Gateway>;
  /** delete data from the table: "LanNode" */
  delete_LanNode?: Maybe<LanNode_Mutation_Response>;
  /** delete single row from the table: "LanNode" */
  delete_LanNode_by_pk?: Maybe<LanNode>;
  /** delete data from the table: "LicenseKeys" */
  delete_LicenseKeys?: Maybe<LicenseKeys_Mutation_Response>;
  /** delete single row from the table: "LicenseKeys" */
  delete_LicenseKeys_by_pk?: Maybe<LicenseKeys>;
  /** delete data from the table: "Link" */
  delete_Link?: Maybe<Link_Mutation_Response>;
  /** delete data from the table: "LinkType" */
  delete_LinkType?: Maybe<LinkType_Mutation_Response>;
  /** delete single row from the table: "LinkType" */
  delete_LinkType_by_pk?: Maybe<LinkType>;
  /** delete single row from the table: "Link" */
  delete_Link_by_pk?: Maybe<Link>;
  /** delete data from the table: "MeshWan" */
  delete_MeshWan?: Maybe<MeshWan_Mutation_Response>;
  /** delete single row from the table: "MeshWan" */
  delete_MeshWan_by_pk?: Maybe<MeshWan>;
  /** delete data from the table: "Monitor" */
  delete_Monitor?: Maybe<Monitor_Mutation_Response>;
  /** delete single row from the table: "Monitor" */
  delete_Monitor_by_pk?: Maybe<Monitor>;
  /** delete data from the table: "Partner" */
  delete_Partner?: Maybe<Partner_Mutation_Response>;
  /** delete data from the table: "PartnerPreferences" */
  delete_PartnerPreferences?: Maybe<PartnerPreferences_Mutation_Response>;
  /** delete single row from the table: "Partner" */
  delete_Partner_by_pk?: Maybe<Partner>;
  /** delete data from the table: "Profile" */
  delete_Profile?: Maybe<Profile_Mutation_Response>;
  /** delete single row from the table: "Profile" */
  delete_Profile_by_pk?: Maybe<Profile>;
  /** delete data from the table: "PublicIp" */
  delete_PublicIp?: Maybe<PublicIp_Mutation_Response>;
  /** delete single row from the table: "PublicIp" */
  delete_PublicIp_by_pk?: Maybe<PublicIp>;
  /** delete data from the table: "Quicklink" */
  delete_Quicklink?: Maybe<Quicklink_Mutation_Response>;
  /** delete single row from the table: "Quicklink" */
  delete_Quicklink_by_pk?: Maybe<Quicklink>;
  /** delete data from the table: "Server" */
  delete_Server?: Maybe<Server_Mutation_Response>;
  /** delete data from the table: "ServerBridge" */
  delete_ServerBridge?: Maybe<ServerBridge_Mutation_Response>;
  /** delete single row from the table: "ServerBridge" */
  delete_ServerBridge_by_pk?: Maybe<ServerBridge>;
  /** delete single row from the table: "Server" */
  delete_Server_by_pk?: Maybe<Server>;
  /** delete data from the table: "Site" */
  delete_Site?: Maybe<Site_Mutation_Response>;
  /** delete data from the table: "SiteContact" */
  delete_SiteContact?: Maybe<SiteContact_Mutation_Response>;
  /** delete single row from the table: "SiteContact" */
  delete_SiteContact_by_pk?: Maybe<SiteContact>;
  /** delete data from the table: "SiteLan" */
  delete_SiteLan?: Maybe<SiteLan_Mutation_Response>;
  /** delete single row from the table: "SiteLan" */
  delete_SiteLan_by_pk?: Maybe<SiteLan>;
  /** delete data from the table: "SiteRoute" */
  delete_SiteRoute?: Maybe<SiteRoute_Mutation_Response>;
  /** delete single row from the table: "SiteRoute" */
  delete_SiteRoute_by_pk?: Maybe<SiteRoute>;
  /** delete single row from the table: "Site" */
  delete_Site_by_pk?: Maybe<Site>;
  /** delete data from the table: "Tunnel" */
  delete_Tunnel?: Maybe<Tunnel_Mutation_Response>;
  /** delete data from the table: "TunnelProfile" */
  delete_TunnelProfile?: Maybe<TunnelProfile_Mutation_Response>;
  /** delete single row from the table: "TunnelProfile" */
  delete_TunnelProfile_by_pk?: Maybe<TunnelProfile>;
  /** delete single row from the table: "Tunnel" */
  delete_Tunnel_by_pk?: Maybe<Tunnel>;
  /** delete data from the table: "User" */
  delete_User?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "UserHistory" */
  delete_UserHistory?: Maybe<UserHistory_Mutation_Response>;
  /** delete single row from the table: "UserHistory" */
  delete_UserHistory_by_pk?: Maybe<UserHistory>;
  /** delete data from the table: "UserRole" */
  delete_UserRole?: Maybe<UserRole_Mutation_Response>;
  /** delete single row from the table: "UserRole" */
  delete_UserRole_by_pk?: Maybe<UserRole>;
  /** delete single row from the table: "User" */
  delete_User_by_pk?: Maybe<User>;
  /** delete data from the table: "Wan" */
  delete_Wan?: Maybe<Wan_Mutation_Response>;
  /** delete single row from the table: "Wan" */
  delete_Wan_by_pk?: Maybe<Wan>;
  /** insert data into the table: "Carrier" */
  insert_Carrier?: Maybe<Carrier_Mutation_Response>;
  /** insert a single row into the table: "Carrier" */
  insert_Carrier_one?: Maybe<Carrier>;
  /** insert data into the table: "ClientCompany" */
  insert_ClientCompany?: Maybe<ClientCompany_Mutation_Response>;
  /** insert a single row into the table: "ClientCompany" */
  insert_ClientCompany_one?: Maybe<ClientCompany>;
  /** insert data into the table: "Firmware" */
  insert_Firmware?: Maybe<Firmware_Mutation_Response>;
  /** insert a single row into the table: "Firmware" */
  insert_Firmware_one?: Maybe<Firmware>;
  /** insert data into the table: "Gateway" */
  insert_Gateway?: Maybe<Gateway_Mutation_Response>;
  /** insert data into the table: "GatewayBridge" */
  insert_GatewayBridge?: Maybe<GatewayBridge_Mutation_Response>;
  /** insert a single row into the table: "GatewayBridge" */
  insert_GatewayBridge_one?: Maybe<GatewayBridge>;
  /** insert data into the table: "GatewaySubnet" */
  insert_GatewaySubnet?: Maybe<GatewaySubnet_Mutation_Response>;
  /** insert a single row into the table: "GatewaySubnet" */
  insert_GatewaySubnet_one?: Maybe<GatewaySubnet>;
  /** insert a single row into the table: "Gateway" */
  insert_Gateway_one?: Maybe<Gateway>;
  /** insert data into the table: "LanNode" */
  insert_LanNode?: Maybe<LanNode_Mutation_Response>;
  /** insert a single row into the table: "LanNode" */
  insert_LanNode_one?: Maybe<LanNode>;
  /** insert data into the table: "LicenseKeys" */
  insert_LicenseKeys?: Maybe<LicenseKeys_Mutation_Response>;
  /** insert a single row into the table: "LicenseKeys" */
  insert_LicenseKeys_one?: Maybe<LicenseKeys>;
  /** insert data into the table: "Link" */
  insert_Link?: Maybe<Link_Mutation_Response>;
  /** insert data into the table: "LinkType" */
  insert_LinkType?: Maybe<LinkType_Mutation_Response>;
  /** insert a single row into the table: "LinkType" */
  insert_LinkType_one?: Maybe<LinkType>;
  /** insert a single row into the table: "Link" */
  insert_Link_one?: Maybe<Link>;
  /** insert data into the table: "MeshWan" */
  insert_MeshWan?: Maybe<MeshWan_Mutation_Response>;
  /** insert a single row into the table: "MeshWan" */
  insert_MeshWan_one?: Maybe<MeshWan>;
  /** insert data into the table: "Monitor" */
  insert_Monitor?: Maybe<Monitor_Mutation_Response>;
  /** insert a single row into the table: "Monitor" */
  insert_Monitor_one?: Maybe<Monitor>;
  /** insert data into the table: "Partner" */
  insert_Partner?: Maybe<Partner_Mutation_Response>;
  /** insert data into the table: "PartnerPreferences" */
  insert_PartnerPreferences?: Maybe<PartnerPreferences_Mutation_Response>;
  /** insert a single row into the table: "PartnerPreferences" */
  insert_PartnerPreferences_one?: Maybe<PartnerPreferences>;
  /** insert a single row into the table: "Partner" */
  insert_Partner_one?: Maybe<Partner>;
  /** insert data into the table: "Profile" */
  insert_Profile?: Maybe<Profile_Mutation_Response>;
  /** insert a single row into the table: "Profile" */
  insert_Profile_one?: Maybe<Profile>;
  /** insert data into the table: "PublicIp" */
  insert_PublicIp?: Maybe<PublicIp_Mutation_Response>;
  /** insert a single row into the table: "PublicIp" */
  insert_PublicIp_one?: Maybe<PublicIp>;
  /** insert data into the table: "Quicklink" */
  insert_Quicklink?: Maybe<Quicklink_Mutation_Response>;
  /** insert a single row into the table: "Quicklink" */
  insert_Quicklink_one?: Maybe<Quicklink>;
  /** insert data into the table: "Server" */
  insert_Server?: Maybe<Server_Mutation_Response>;
  /** insert data into the table: "ServerBridge" */
  insert_ServerBridge?: Maybe<ServerBridge_Mutation_Response>;
  /** insert a single row into the table: "ServerBridge" */
  insert_ServerBridge_one?: Maybe<ServerBridge>;
  /** insert a single row into the table: "Server" */
  insert_Server_one?: Maybe<Server>;
  /** insert data into the table: "Site" */
  insert_Site?: Maybe<Site_Mutation_Response>;
  /** insert data into the table: "SiteContact" */
  insert_SiteContact?: Maybe<SiteContact_Mutation_Response>;
  /** insert a single row into the table: "SiteContact" */
  insert_SiteContact_one?: Maybe<SiteContact>;
  /** insert data into the table: "SiteLan" */
  insert_SiteLan?: Maybe<SiteLan_Mutation_Response>;
  /** insert a single row into the table: "SiteLan" */
  insert_SiteLan_one?: Maybe<SiteLan>;
  /** insert data into the table: "SiteRoute" */
  insert_SiteRoute?: Maybe<SiteRoute_Mutation_Response>;
  /** insert a single row into the table: "SiteRoute" */
  insert_SiteRoute_one?: Maybe<SiteRoute>;
  /** insert a single row into the table: "Site" */
  insert_Site_one?: Maybe<Site>;
  /** insert data into the table: "Tunnel" */
  insert_Tunnel?: Maybe<Tunnel_Mutation_Response>;
  /** insert data into the table: "TunnelProfile" */
  insert_TunnelProfile?: Maybe<TunnelProfile_Mutation_Response>;
  /** insert a single row into the table: "TunnelProfile" */
  insert_TunnelProfile_one?: Maybe<TunnelProfile>;
  /** insert a single row into the table: "Tunnel" */
  insert_Tunnel_one?: Maybe<Tunnel>;
  /** insert data into the table: "User" */
  insert_User?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "UserHistory" */
  insert_UserHistory?: Maybe<UserHistory_Mutation_Response>;
  /** insert a single row into the table: "UserHistory" */
  insert_UserHistory_one?: Maybe<UserHistory>;
  /** insert data into the table: "UserRole" */
  insert_UserRole?: Maybe<UserRole_Mutation_Response>;
  /** insert a single row into the table: "UserRole" */
  insert_UserRole_one?: Maybe<UserRole>;
  /** insert a single row into the table: "User" */
  insert_User_one?: Maybe<User>;
  /** insert data into the table: "Wan" */
  insert_Wan?: Maybe<Wan_Mutation_Response>;
  /** insert a single row into the table: "Wan" */
  insert_Wan_one?: Maybe<Wan>;
  /** update data of the table: "Carrier" */
  update_Carrier?: Maybe<Carrier_Mutation_Response>;
  /** update single row of the table: "Carrier" */
  update_Carrier_by_pk?: Maybe<Carrier>;
  /** update data of the table: "ClientCompany" */
  update_ClientCompany?: Maybe<ClientCompany_Mutation_Response>;
  /** update single row of the table: "ClientCompany" */
  update_ClientCompany_by_pk?: Maybe<ClientCompany>;
  /** update data of the table: "Firmware" */
  update_Firmware?: Maybe<Firmware_Mutation_Response>;
  /** update single row of the table: "Firmware" */
  update_Firmware_by_pk?: Maybe<Firmware>;
  /** update data of the table: "Gateway" */
  update_Gateway?: Maybe<Gateway_Mutation_Response>;
  /** update data of the table: "GatewayBridge" */
  update_GatewayBridge?: Maybe<GatewayBridge_Mutation_Response>;
  /** update single row of the table: "GatewayBridge" */
  update_GatewayBridge_by_pk?: Maybe<GatewayBridge>;
  /** update data of the table: "GatewaySubnet" */
  update_GatewaySubnet?: Maybe<GatewaySubnet_Mutation_Response>;
  /** update single row of the table: "GatewaySubnet" */
  update_GatewaySubnet_by_pk?: Maybe<GatewaySubnet>;
  /** update single row of the table: "Gateway" */
  update_Gateway_by_pk?: Maybe<Gateway>;
  /** update data of the table: "LanNode" */
  update_LanNode?: Maybe<LanNode_Mutation_Response>;
  /** update single row of the table: "LanNode" */
  update_LanNode_by_pk?: Maybe<LanNode>;
  /** update data of the table: "LicenseKeys" */
  update_LicenseKeys?: Maybe<LicenseKeys_Mutation_Response>;
  /** update single row of the table: "LicenseKeys" */
  update_LicenseKeys_by_pk?: Maybe<LicenseKeys>;
  /** update data of the table: "Link" */
  update_Link?: Maybe<Link_Mutation_Response>;
  /** update data of the table: "LinkType" */
  update_LinkType?: Maybe<LinkType_Mutation_Response>;
  /** update single row of the table: "LinkType" */
  update_LinkType_by_pk?: Maybe<LinkType>;
  /** update single row of the table: "Link" */
  update_Link_by_pk?: Maybe<Link>;
  /** update data of the table: "MeshWan" */
  update_MeshWan?: Maybe<MeshWan_Mutation_Response>;
  /** update single row of the table: "MeshWan" */
  update_MeshWan_by_pk?: Maybe<MeshWan>;
  /** update data of the table: "Monitor" */
  update_Monitor?: Maybe<Monitor_Mutation_Response>;
  /** update single row of the table: "Monitor" */
  update_Monitor_by_pk?: Maybe<Monitor>;
  /** update data of the table: "Partner" */
  update_Partner?: Maybe<Partner_Mutation_Response>;
  /** update data of the table: "PartnerPreferences" */
  update_PartnerPreferences?: Maybe<PartnerPreferences_Mutation_Response>;
  /** update single row of the table: "Partner" */
  update_Partner_by_pk?: Maybe<Partner>;
  /** update data of the table: "Profile" */
  update_Profile?: Maybe<Profile_Mutation_Response>;
  /** update single row of the table: "Profile" */
  update_Profile_by_pk?: Maybe<Profile>;
  /** update data of the table: "PublicIp" */
  update_PublicIp?: Maybe<PublicIp_Mutation_Response>;
  /** update single row of the table: "PublicIp" */
  update_PublicIp_by_pk?: Maybe<PublicIp>;
  /** update data of the table: "Quicklink" */
  update_Quicklink?: Maybe<Quicklink_Mutation_Response>;
  /** update single row of the table: "Quicklink" */
  update_Quicklink_by_pk?: Maybe<Quicklink>;
  /** update data of the table: "Server" */
  update_Server?: Maybe<Server_Mutation_Response>;
  /** update data of the table: "ServerBridge" */
  update_ServerBridge?: Maybe<ServerBridge_Mutation_Response>;
  /** update single row of the table: "ServerBridge" */
  update_ServerBridge_by_pk?: Maybe<ServerBridge>;
  /** update single row of the table: "Server" */
  update_Server_by_pk?: Maybe<Server>;
  /** update data of the table: "Site" */
  update_Site?: Maybe<Site_Mutation_Response>;
  /** update data of the table: "SiteContact" */
  update_SiteContact?: Maybe<SiteContact_Mutation_Response>;
  /** update single row of the table: "SiteContact" */
  update_SiteContact_by_pk?: Maybe<SiteContact>;
  /** update data of the table: "SiteLan" */
  update_SiteLan?: Maybe<SiteLan_Mutation_Response>;
  /** update single row of the table: "SiteLan" */
  update_SiteLan_by_pk?: Maybe<SiteLan>;
  /** update data of the table: "SiteRoute" */
  update_SiteRoute?: Maybe<SiteRoute_Mutation_Response>;
  /** update single row of the table: "SiteRoute" */
  update_SiteRoute_by_pk?: Maybe<SiteRoute>;
  /** update single row of the table: "Site" */
  update_Site_by_pk?: Maybe<Site>;
  /** update data of the table: "Tunnel" */
  update_Tunnel?: Maybe<Tunnel_Mutation_Response>;
  /** update data of the table: "TunnelProfile" */
  update_TunnelProfile?: Maybe<TunnelProfile_Mutation_Response>;
  /** update single row of the table: "TunnelProfile" */
  update_TunnelProfile_by_pk?: Maybe<TunnelProfile>;
  /** update single row of the table: "Tunnel" */
  update_Tunnel_by_pk?: Maybe<Tunnel>;
  /** update data of the table: "User" */
  update_User?: Maybe<User_Mutation_Response>;
  /** update data of the table: "UserHistory" */
  update_UserHistory?: Maybe<UserHistory_Mutation_Response>;
  /** update single row of the table: "UserHistory" */
  update_UserHistory_by_pk?: Maybe<UserHistory>;
  /** update data of the table: "UserRole" */
  update_UserRole?: Maybe<UserRole_Mutation_Response>;
  /** update single row of the table: "UserRole" */
  update_UserRole_by_pk?: Maybe<UserRole>;
  /** update single row of the table: "User" */
  update_User_by_pk?: Maybe<User>;
  /** update data of the table: "Wan" */
  update_Wan?: Maybe<Wan_Mutation_Response>;
  /** update single row of the table: "Wan" */
  update_Wan_by_pk?: Maybe<Wan>;
};


/** mutation root */
export type Mutation_RootDelete_CarrierArgs = {
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Carrier_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClientCompanyArgs = {
  where: ClientCompany_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ClientCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FirmwareArgs = {
  where: Firmware_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Firmware_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GatewayArgs = {
  where: Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GatewayBridgeArgs = {
  where: GatewayBridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GatewayBridge_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GatewaySubnetArgs = {
  where: GatewaySubnet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GatewaySubnet_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gateway_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LanNodeArgs = {
  where: LanNode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LanNode_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LicenseKeysArgs = {
  where: LicenseKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LicenseKeys_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_LinkArgs = {
  where: Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LinkTypeArgs = {
  where: LinkType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LinkType_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MeshWanArgs = {
  where: MeshWan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MeshWan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MonitorArgs = {
  where: Monitor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Monitor_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PartnerArgs = {
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PartnerPreferencesArgs = {
  where: PartnerPreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Partner_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProfileArgs = {
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PublicIpArgs = {
  where: PublicIp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PublicIp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_QuicklinkArgs = {
  where: Quicklink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quicklink_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ServerArgs = {
  where: Server_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServerBridgeArgs = {
  where: ServerBridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServerBridge_By_PkArgs = {
  gatewayBridgeId: Scalars['uuid'];
  serverId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Server_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SiteArgs = {
  where: Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SiteContactArgs = {
  where: SiteContact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SiteContact_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SiteLanArgs = {
  where: SiteLan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SiteLan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SiteRouteArgs = {
  where: SiteRoute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SiteRoute_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Site_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TunnelArgs = {
  where: Tunnel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TunnelProfileArgs = {
  where: TunnelProfile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TunnelProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tunnel_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserHistoryArgs = {
  where: UserHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserRoleArgs = {
  where: UserRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRole_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_WanArgs = {
  where: Wan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Wan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_CarrierArgs = {
  objects: Array<Carrier_Insert_Input>;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Carrier_OneArgs = {
  object: Carrier_Insert_Input;
  on_conflict?: InputMaybe<Carrier_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClientCompanyArgs = {
  objects: Array<ClientCompany_Insert_Input>;
  on_conflict?: InputMaybe<ClientCompany_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClientCompany_OneArgs = {
  object: ClientCompany_Insert_Input;
  on_conflict?: InputMaybe<ClientCompany_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FirmwareArgs = {
  objects: Array<Firmware_Insert_Input>;
  on_conflict?: InputMaybe<Firmware_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Firmware_OneArgs = {
  object: Firmware_Insert_Input;
  on_conflict?: InputMaybe<Firmware_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewayArgs = {
  objects: Array<Gateway_Insert_Input>;
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewayBridgeArgs = {
  objects: Array<GatewayBridge_Insert_Input>;
  on_conflict?: InputMaybe<GatewayBridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewayBridge_OneArgs = {
  object: GatewayBridge_Insert_Input;
  on_conflict?: InputMaybe<GatewayBridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewaySubnetArgs = {
  objects: Array<GatewaySubnet_Insert_Input>;
  on_conflict?: InputMaybe<GatewaySubnet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GatewaySubnet_OneArgs = {
  object: GatewaySubnet_Insert_Input;
  on_conflict?: InputMaybe<GatewaySubnet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gateway_OneArgs = {
  object: Gateway_Insert_Input;
  on_conflict?: InputMaybe<Gateway_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanNodeArgs = {
  objects: Array<LanNode_Insert_Input>;
  on_conflict?: InputMaybe<LanNode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanNode_OneArgs = {
  object: LanNode_Insert_Input;
  on_conflict?: InputMaybe<LanNode_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LicenseKeysArgs = {
  objects: Array<LicenseKeys_Insert_Input>;
  on_conflict?: InputMaybe<LicenseKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LicenseKeys_OneArgs = {
  object: LicenseKeys_Insert_Input;
  on_conflict?: InputMaybe<LicenseKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LinkArgs = {
  objects: Array<Link_Insert_Input>;
  on_conflict?: InputMaybe<Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LinkTypeArgs = {
  objects: Array<LinkType_Insert_Input>;
  on_conflict?: InputMaybe<LinkType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LinkType_OneArgs = {
  object: LinkType_Insert_Input;
  on_conflict?: InputMaybe<LinkType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Link_OneArgs = {
  object: Link_Insert_Input;
  on_conflict?: InputMaybe<Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MeshWanArgs = {
  objects: Array<MeshWan_Insert_Input>;
  on_conflict?: InputMaybe<MeshWan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MeshWan_OneArgs = {
  object: MeshWan_Insert_Input;
  on_conflict?: InputMaybe<MeshWan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MonitorArgs = {
  objects: Array<Monitor_Insert_Input>;
  on_conflict?: InputMaybe<Monitor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Monitor_OneArgs = {
  object: Monitor_Insert_Input;
  on_conflict?: InputMaybe<Monitor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnerArgs = {
  objects: Array<Partner_Insert_Input>;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartnerPreferencesArgs = {
  objects: Array<PartnerPreferences_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_PartnerPreferences_OneArgs = {
  object: PartnerPreferences_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Partner_OneArgs = {
  object: Partner_Insert_Input;
  on_conflict?: InputMaybe<Partner_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProfileArgs = {
  objects: Array<Profile_Insert_Input>;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_OneArgs = {
  object: Profile_Insert_Input;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicIpArgs = {
  objects: Array<PublicIp_Insert_Input>;
  on_conflict?: InputMaybe<PublicIp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PublicIp_OneArgs = {
  object: PublicIp_Insert_Input;
  on_conflict?: InputMaybe<PublicIp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuicklinkArgs = {
  objects: Array<Quicklink_Insert_Input>;
  on_conflict?: InputMaybe<Quicklink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quicklink_OneArgs = {
  object: Quicklink_Insert_Input;
  on_conflict?: InputMaybe<Quicklink_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServerArgs = {
  objects: Array<Server_Insert_Input>;
  on_conflict?: InputMaybe<Server_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServerBridgeArgs = {
  objects: Array<ServerBridge_Insert_Input>;
  on_conflict?: InputMaybe<ServerBridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServerBridge_OneArgs = {
  object: ServerBridge_Insert_Input;
  on_conflict?: InputMaybe<ServerBridge_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Server_OneArgs = {
  object: Server_Insert_Input;
  on_conflict?: InputMaybe<Server_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteArgs = {
  objects: Array<Site_Insert_Input>;
  on_conflict?: InputMaybe<Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteContactArgs = {
  objects: Array<SiteContact_Insert_Input>;
  on_conflict?: InputMaybe<SiteContact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteContact_OneArgs = {
  object: SiteContact_Insert_Input;
  on_conflict?: InputMaybe<SiteContact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteLanArgs = {
  objects: Array<SiteLan_Insert_Input>;
  on_conflict?: InputMaybe<SiteLan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteLan_OneArgs = {
  object: SiteLan_Insert_Input;
  on_conflict?: InputMaybe<SiteLan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteRouteArgs = {
  objects: Array<SiteRoute_Insert_Input>;
  on_conflict?: InputMaybe<SiteRoute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SiteRoute_OneArgs = {
  object: SiteRoute_Insert_Input;
  on_conflict?: InputMaybe<SiteRoute_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Site_OneArgs = {
  object: Site_Insert_Input;
  on_conflict?: InputMaybe<Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TunnelArgs = {
  objects: Array<Tunnel_Insert_Input>;
  on_conflict?: InputMaybe<Tunnel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TunnelProfileArgs = {
  objects: Array<TunnelProfile_Insert_Input>;
  on_conflict?: InputMaybe<TunnelProfile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TunnelProfile_OneArgs = {
  object: TunnelProfile_Insert_Input;
  on_conflict?: InputMaybe<TunnelProfile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tunnel_OneArgs = {
  object: Tunnel_Insert_Input;
  on_conflict?: InputMaybe<Tunnel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserHistoryArgs = {
  objects: Array<UserHistory_Insert_Input>;
  on_conflict?: InputMaybe<UserHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserHistory_OneArgs = {
  object: UserHistory_Insert_Input;
  on_conflict?: InputMaybe<UserHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoleArgs = {
  objects: Array<UserRole_Insert_Input>;
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRole_OneArgs = {
  object: UserRole_Insert_Input;
  on_conflict?: InputMaybe<UserRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WanArgs = {
  objects: Array<Wan_Insert_Input>;
  on_conflict?: InputMaybe<Wan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Wan_OneArgs = {
  object: Wan_Insert_Input;
  on_conflict?: InputMaybe<Wan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_CarrierArgs = {
  _set?: InputMaybe<Carrier_Set_Input>;
  where: Carrier_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Carrier_By_PkArgs = {
  _set?: InputMaybe<Carrier_Set_Input>;
  pk_columns: Carrier_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ClientCompanyArgs = {
  _set?: InputMaybe<ClientCompany_Set_Input>;
  where: ClientCompany_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ClientCompany_By_PkArgs = {
  _set?: InputMaybe<ClientCompany_Set_Input>;
  pk_columns: ClientCompany_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FirmwareArgs = {
  _inc?: InputMaybe<Firmware_Inc_Input>;
  _set?: InputMaybe<Firmware_Set_Input>;
  where: Firmware_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Firmware_By_PkArgs = {
  _inc?: InputMaybe<Firmware_Inc_Input>;
  _set?: InputMaybe<Firmware_Set_Input>;
  pk_columns: Firmware_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GatewayArgs = {
  _set?: InputMaybe<Gateway_Set_Input>;
  where: Gateway_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GatewayBridgeArgs = {
  _set?: InputMaybe<GatewayBridge_Set_Input>;
  where: GatewayBridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GatewayBridge_By_PkArgs = {
  _set?: InputMaybe<GatewayBridge_Set_Input>;
  pk_columns: GatewayBridge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GatewaySubnetArgs = {
  _set?: InputMaybe<GatewaySubnet_Set_Input>;
  where: GatewaySubnet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GatewaySubnet_By_PkArgs = {
  _set?: InputMaybe<GatewaySubnet_Set_Input>;
  pk_columns: GatewaySubnet_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gateway_By_PkArgs = {
  _set?: InputMaybe<Gateway_Set_Input>;
  pk_columns: Gateway_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LanNodeArgs = {
  _set?: InputMaybe<LanNode_Set_Input>;
  where: LanNode_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LanNode_By_PkArgs = {
  _set?: InputMaybe<LanNode_Set_Input>;
  pk_columns: LanNode_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LicenseKeysArgs = {
  _set?: InputMaybe<LicenseKeys_Set_Input>;
  where: LicenseKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LicenseKeys_By_PkArgs = {
  _set?: InputMaybe<LicenseKeys_Set_Input>;
  pk_columns: LicenseKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LinkArgs = {
  _inc?: InputMaybe<Link_Inc_Input>;
  _set?: InputMaybe<Link_Set_Input>;
  where: Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LinkTypeArgs = {
  _set?: InputMaybe<LinkType_Set_Input>;
  where: LinkType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_LinkType_By_PkArgs = {
  _set?: InputMaybe<LinkType_Set_Input>;
  pk_columns: LinkType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Link_By_PkArgs = {
  _inc?: InputMaybe<Link_Inc_Input>;
  _set?: InputMaybe<Link_Set_Input>;
  pk_columns: Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MeshWanArgs = {
  _set?: InputMaybe<MeshWan_Set_Input>;
  where: MeshWan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MeshWan_By_PkArgs = {
  _set?: InputMaybe<MeshWan_Set_Input>;
  pk_columns: MeshWan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MonitorArgs = {
  _set?: InputMaybe<Monitor_Set_Input>;
  where: Monitor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Monitor_By_PkArgs = {
  _set?: InputMaybe<Monitor_Set_Input>;
  pk_columns: Monitor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PartnerArgs = {
  _set?: InputMaybe<Partner_Set_Input>;
  where: Partner_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PartnerPreferencesArgs = {
  _set?: InputMaybe<PartnerPreferences_Set_Input>;
  where: PartnerPreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Partner_By_PkArgs = {
  _set?: InputMaybe<Partner_Set_Input>;
  pk_columns: Partner_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ProfileArgs = {
  _set?: InputMaybe<Profile_Set_Input>;
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_PkArgs = {
  _set?: InputMaybe<Profile_Set_Input>;
  pk_columns: Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PublicIpArgs = {
  _set?: InputMaybe<PublicIp_Set_Input>;
  where: PublicIp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PublicIp_By_PkArgs = {
  _set?: InputMaybe<PublicIp_Set_Input>;
  pk_columns: PublicIp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_QuicklinkArgs = {
  _set?: InputMaybe<Quicklink_Set_Input>;
  where: Quicklink_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quicklink_By_PkArgs = {
  _set?: InputMaybe<Quicklink_Set_Input>;
  pk_columns: Quicklink_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServerArgs = {
  _set?: InputMaybe<Server_Set_Input>;
  where: Server_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServerBridgeArgs = {
  _set?: InputMaybe<ServerBridge_Set_Input>;
  where: ServerBridge_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServerBridge_By_PkArgs = {
  _set?: InputMaybe<ServerBridge_Set_Input>;
  pk_columns: ServerBridge_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Server_By_PkArgs = {
  _set?: InputMaybe<Server_Set_Input>;
  pk_columns: Server_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SiteArgs = {
  _set?: InputMaybe<Site_Set_Input>;
  where: Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SiteContactArgs = {
  _set?: InputMaybe<SiteContact_Set_Input>;
  where: SiteContact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SiteContact_By_PkArgs = {
  _set?: InputMaybe<SiteContact_Set_Input>;
  pk_columns: SiteContact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SiteLanArgs = {
  _inc?: InputMaybe<SiteLan_Inc_Input>;
  _set?: InputMaybe<SiteLan_Set_Input>;
  where: SiteLan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SiteLan_By_PkArgs = {
  _inc?: InputMaybe<SiteLan_Inc_Input>;
  _set?: InputMaybe<SiteLan_Set_Input>;
  pk_columns: SiteLan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SiteRouteArgs = {
  _inc?: InputMaybe<SiteRoute_Inc_Input>;
  _set?: InputMaybe<SiteRoute_Set_Input>;
  where: SiteRoute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SiteRoute_By_PkArgs = {
  _inc?: InputMaybe<SiteRoute_Inc_Input>;
  _set?: InputMaybe<SiteRoute_Set_Input>;
  pk_columns: SiteRoute_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Site_By_PkArgs = {
  _set?: InputMaybe<Site_Set_Input>;
  pk_columns: Site_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TunnelArgs = {
  _inc?: InputMaybe<Tunnel_Inc_Input>;
  _set?: InputMaybe<Tunnel_Set_Input>;
  where: Tunnel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TunnelProfileArgs = {
  _set?: InputMaybe<TunnelProfile_Set_Input>;
  where: TunnelProfile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TunnelProfile_By_PkArgs = {
  _set?: InputMaybe<TunnelProfile_Set_Input>;
  pk_columns: TunnelProfile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tunnel_By_PkArgs = {
  _inc?: InputMaybe<Tunnel_Inc_Input>;
  _set?: InputMaybe<Tunnel_Set_Input>;
  pk_columns: Tunnel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserHistoryArgs = {
  _set?: InputMaybe<UserHistory_Set_Input>;
  where: UserHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserHistory_By_PkArgs = {
  _set?: InputMaybe<UserHistory_Set_Input>;
  pk_columns: UserHistory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoleArgs = {
  _set?: InputMaybe<UserRole_Set_Input>;
  where: UserRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRole_By_PkArgs = {
  _set?: InputMaybe<UserRole_Set_Input>;
  pk_columns: UserRole_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_WanArgs = {
  _set?: InputMaybe<Wan_Set_Input>;
  where: Wan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Wan_By_PkArgs = {
  _set?: InputMaybe<Wan_Set_Input>;
  pk_columns: Wan_Pk_Columns_Input;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "Carrier" */
  Carrier: Array<Carrier>;
  /** fetch aggregated fields from the table: "Carrier" */
  Carrier_aggregate: Carrier_Aggregate;
  /** fetch data from the table: "Carrier" using primary key columns */
  Carrier_by_pk?: Maybe<Carrier>;
  /** fetch data from the table: "ClientCompany" */
  ClientCompany: Array<ClientCompany>;
  /** fetch aggregated fields from the table: "ClientCompany" */
  ClientCompany_aggregate: ClientCompany_Aggregate;
  /** fetch data from the table: "ClientCompany" using primary key columns */
  ClientCompany_by_pk?: Maybe<ClientCompany>;
  /** fetch data from the table: "Firmware" */
  Firmware: Array<Firmware>;
  /** fetch aggregated fields from the table: "Firmware" */
  Firmware_aggregate: Firmware_Aggregate;
  /** fetch data from the table: "Firmware" using primary key columns */
  Firmware_by_pk?: Maybe<Firmware>;
  /** fetch data from the table: "Gateway" */
  Gateway: Array<Gateway>;
  /** fetch data from the table: "GatewayBridge" */
  GatewayBridge: Array<GatewayBridge>;
  /** fetch aggregated fields from the table: "GatewayBridge" */
  GatewayBridge_aggregate: GatewayBridge_Aggregate;
  /** fetch data from the table: "GatewayBridge" using primary key columns */
  GatewayBridge_by_pk?: Maybe<GatewayBridge>;
  /** fetch data from the table: "GatewaySubnet" */
  GatewaySubnet: Array<GatewaySubnet>;
  /** fetch aggregated fields from the table: "GatewaySubnet" */
  GatewaySubnet_aggregate: GatewaySubnet_Aggregate;
  /** fetch data from the table: "GatewaySubnet" using primary key columns */
  GatewaySubnet_by_pk?: Maybe<GatewaySubnet>;
  /** fetch aggregated fields from the table: "Gateway" */
  Gateway_aggregate: Gateway_Aggregate;
  /** fetch data from the table: "Gateway" using primary key columns */
  Gateway_by_pk?: Maybe<Gateway>;
  /** fetch data from the table: "LanNode" */
  LanNode: Array<LanNode>;
  /** fetch aggregated fields from the table: "LanNode" */
  LanNode_aggregate: LanNode_Aggregate;
  /** fetch data from the table: "LanNode" using primary key columns */
  LanNode_by_pk?: Maybe<LanNode>;
  /** fetch data from the table: "LicenseKeys" */
  LicenseKeys: Array<LicenseKeys>;
  /** fetch aggregated fields from the table: "LicenseKeys" */
  LicenseKeys_aggregate: LicenseKeys_Aggregate;
  /** fetch data from the table: "LicenseKeys" using primary key columns */
  LicenseKeys_by_pk?: Maybe<LicenseKeys>;
  /** fetch data from the table: "Link" */
  Link: Array<Link>;
  /** fetch data from the table: "LinkType" */
  LinkType: Array<LinkType>;
  /** fetch aggregated fields from the table: "LinkType" */
  LinkType_aggregate: LinkType_Aggregate;
  /** fetch data from the table: "LinkType" using primary key columns */
  LinkType_by_pk?: Maybe<LinkType>;
  /** fetch aggregated fields from the table: "Link" */
  Link_aggregate: Link_Aggregate;
  /** fetch data from the table: "Link" using primary key columns */
  Link_by_pk?: Maybe<Link>;
  /** fetch data from the table: "MeshWan" */
  MeshWan: Array<MeshWan>;
  /** fetch aggregated fields from the table: "MeshWan" */
  MeshWan_aggregate: MeshWan_Aggregate;
  /** fetch data from the table: "MeshWan" using primary key columns */
  MeshWan_by_pk?: Maybe<MeshWan>;
  /** fetch data from the table: "Monitor" */
  Monitor: Array<Monitor>;
  /** fetch aggregated fields from the table: "Monitor" */
  Monitor_aggregate: Monitor_Aggregate;
  /** fetch data from the table: "Monitor" using primary key columns */
  Monitor_by_pk?: Maybe<Monitor>;
  /** fetch data from the table: "Partner" */
  Partner: Array<Partner>;
  /** fetch data from the table: "PartnerPreferences" */
  PartnerPreferences: Array<PartnerPreferences>;
  /** fetch aggregated fields from the table: "PartnerPreferences" */
  PartnerPreferences_aggregate: PartnerPreferences_Aggregate;
  /** fetch aggregated fields from the table: "Partner" */
  Partner_aggregate: Partner_Aggregate;
  /** fetch data from the table: "Partner" using primary key columns */
  Partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table: "Profile" */
  Profile: Array<Profile>;
  /** fetch aggregated fields from the table: "Profile" */
  Profile_aggregate: Profile_Aggregate;
  /** fetch data from the table: "Profile" using primary key columns */
  Profile_by_pk?: Maybe<Profile>;
  /** fetch data from the table: "PublicIp" */
  PublicIp: Array<PublicIp>;
  /** fetch aggregated fields from the table: "PublicIp" */
  PublicIp_aggregate: PublicIp_Aggregate;
  /** fetch data from the table: "PublicIp" using primary key columns */
  PublicIp_by_pk?: Maybe<PublicIp>;
  /** fetch data from the table: "Quicklink" */
  Quicklink: Array<Quicklink>;
  /** fetch aggregated fields from the table: "Quicklink" */
  Quicklink_aggregate: Quicklink_Aggregate;
  /** fetch data from the table: "Quicklink" using primary key columns */
  Quicklink_by_pk?: Maybe<Quicklink>;
  /** fetch data from the table: "Server" */
  Server: Array<Server>;
  /** fetch data from the table: "ServerBridge" */
  ServerBridge: Array<ServerBridge>;
  /** fetch aggregated fields from the table: "ServerBridge" */
  ServerBridge_aggregate: ServerBridge_Aggregate;
  /** fetch data from the table: "ServerBridge" using primary key columns */
  ServerBridge_by_pk?: Maybe<ServerBridge>;
  /** fetch aggregated fields from the table: "Server" */
  Server_aggregate: Server_Aggregate;
  /** fetch data from the table: "Server" using primary key columns */
  Server_by_pk?: Maybe<Server>;
  /** fetch data from the table: "Site" */
  Site: Array<Site>;
  /** fetch data from the table: "SiteContact" */
  SiteContact: Array<SiteContact>;
  /** fetch aggregated fields from the table: "SiteContact" */
  SiteContact_aggregate: SiteContact_Aggregate;
  /** fetch data from the table: "SiteContact" using primary key columns */
  SiteContact_by_pk?: Maybe<SiteContact>;
  /** fetch data from the table: "SiteLan" */
  SiteLan: Array<SiteLan>;
  /** fetch aggregated fields from the table: "SiteLan" */
  SiteLan_aggregate: SiteLan_Aggregate;
  /** fetch data from the table: "SiteLan" using primary key columns */
  SiteLan_by_pk?: Maybe<SiteLan>;
  /** fetch data from the table: "SiteRoute" */
  SiteRoute: Array<SiteRoute>;
  /** fetch aggregated fields from the table: "SiteRoute" */
  SiteRoute_aggregate: SiteRoute_Aggregate;
  /** fetch data from the table: "SiteRoute" using primary key columns */
  SiteRoute_by_pk?: Maybe<SiteRoute>;
  /** fetch aggregated fields from the table: "Site" */
  Site_aggregate: Site_Aggregate;
  /** fetch data from the table: "Site" using primary key columns */
  Site_by_pk?: Maybe<Site>;
  /** fetch data from the table: "Tunnel" */
  Tunnel: Array<Tunnel>;
  /** fetch data from the table: "TunnelProfile" */
  TunnelProfile: Array<TunnelProfile>;
  /** fetch aggregated fields from the table: "TunnelProfile" */
  TunnelProfile_aggregate: TunnelProfile_Aggregate;
  /** fetch data from the table: "TunnelProfile" using primary key columns */
  TunnelProfile_by_pk?: Maybe<TunnelProfile>;
  /** fetch aggregated fields from the table: "Tunnel" */
  Tunnel_aggregate: Tunnel_Aggregate;
  /** fetch data from the table: "Tunnel" using primary key columns */
  Tunnel_by_pk?: Maybe<Tunnel>;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserHistory" */
  UserHistory: Array<UserHistory>;
  /** fetch aggregated fields from the table: "UserHistory" */
  UserHistory_aggregate: UserHistory_Aggregate;
  /** fetch data from the table: "UserHistory" using primary key columns */
  UserHistory_by_pk?: Maybe<UserHistory>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_Aggregate;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_Aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table: "Wan" */
  Wan: Array<Wan>;
  /** fetch aggregated fields from the table: "Wan" */
  Wan_aggregate: Wan_Aggregate;
  /** fetch data from the table: "Wan" using primary key columns */
  Wan_by_pk?: Maybe<Wan>;
};


export type Query_RootCarrierArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootCarrier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Query_RootCarrier_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClientCompanyArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


export type Query_RootClientCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


export type Query_RootClientCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFirmwareArgs = {
  distinct_on?: InputMaybe<Array<Firmware_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By>>;
  where?: InputMaybe<Firmware_Bool_Exp>;
};


export type Query_RootFirmware_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firmware_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By>>;
  where?: InputMaybe<Firmware_Bool_Exp>;
};


export type Query_RootFirmware_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGatewayArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Query_RootGatewayBridgeArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


export type Query_RootGatewayBridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


export type Query_RootGatewayBridge_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGatewaySubnetArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


export type Query_RootGatewaySubnet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


export type Query_RootGatewaySubnet_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGateway_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Query_RootGateway_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLanNodeArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


export type Query_RootLanNode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


export type Query_RootLanNode_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLicenseKeysArgs = {
  distinct_on?: InputMaybe<Array<LicenseKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LicenseKeys_Order_By>>;
  where?: InputMaybe<LicenseKeys_Bool_Exp>;
};


export type Query_RootLicenseKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LicenseKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LicenseKeys_Order_By>>;
  where?: InputMaybe<LicenseKeys_Bool_Exp>;
};


export type Query_RootLicenseKeys_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootLinkArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Query_RootLinkTypeArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


export type Query_RootLinkType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


export type Query_RootLinkType_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Query_RootLink_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMeshWanArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


export type Query_RootMeshWan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


export type Query_RootMeshWan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMonitorArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


export type Query_RootMonitor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


export type Query_RootMonitor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartnerPreferencesArgs = {
  distinct_on?: InputMaybe<Array<PartnerPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartnerPreferences_Order_By>>;
  where?: InputMaybe<PartnerPreferences_Bool_Exp>;
};


export type Query_RootPartnerPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnerPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartnerPreferences_Order_By>>;
  where?: InputMaybe<PartnerPreferences_Bool_Exp>;
};


export type Query_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Query_RootPartner_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProfileArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPublicIpArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


export type Query_RootPublicIp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


export type Query_RootPublicIp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootQuicklinkArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


export type Query_RootQuicklink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


export type Query_RootQuicklink_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootServerArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


export type Query_RootServerBridgeArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


export type Query_RootServerBridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


export type Query_RootServerBridge_By_PkArgs = {
  gatewayBridgeId: Scalars['uuid'];
  serverId: Scalars['uuid'];
};


export type Query_RootServer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


export type Query_RootServer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSiteArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Query_RootSiteContactArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


export type Query_RootSiteContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


export type Query_RootSiteContact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSiteLanArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


export type Query_RootSiteLan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


export type Query_RootSiteLan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSiteRouteArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


export type Query_RootSiteRoute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


export type Query_RootSiteRoute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Query_RootSite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTunnelArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


export type Query_RootTunnelProfileArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


export type Query_RootTunnelProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


export type Query_RootTunnelProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTunnel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


export type Query_RootTunnel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUserHistoryArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};


export type Query_RootUserHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};


export type Query_RootUserHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Query_RootUserRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Query_RootUserRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWanArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};


export type Query_RootWan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};


export type Query_RootWan_By_PkArgs = {
  id: Scalars['uuid'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "Carrier" */
  Carrier: Array<Carrier>;
  /** fetch aggregated fields from the table: "Carrier" */
  Carrier_aggregate: Carrier_Aggregate;
  /** fetch data from the table: "Carrier" using primary key columns */
  Carrier_by_pk?: Maybe<Carrier>;
  /** fetch data from the table: "ClientCompany" */
  ClientCompany: Array<ClientCompany>;
  /** fetch aggregated fields from the table: "ClientCompany" */
  ClientCompany_aggregate: ClientCompany_Aggregate;
  /** fetch data from the table: "ClientCompany" using primary key columns */
  ClientCompany_by_pk?: Maybe<ClientCompany>;
  /** fetch data from the table: "Firmware" */
  Firmware: Array<Firmware>;
  /** fetch aggregated fields from the table: "Firmware" */
  Firmware_aggregate: Firmware_Aggregate;
  /** fetch data from the table: "Firmware" using primary key columns */
  Firmware_by_pk?: Maybe<Firmware>;
  /** fetch data from the table: "Gateway" */
  Gateway: Array<Gateway>;
  /** fetch data from the table: "GatewayBridge" */
  GatewayBridge: Array<GatewayBridge>;
  /** fetch aggregated fields from the table: "GatewayBridge" */
  GatewayBridge_aggregate: GatewayBridge_Aggregate;
  /** fetch data from the table: "GatewayBridge" using primary key columns */
  GatewayBridge_by_pk?: Maybe<GatewayBridge>;
  /** fetch data from the table: "GatewaySubnet" */
  GatewaySubnet: Array<GatewaySubnet>;
  /** fetch aggregated fields from the table: "GatewaySubnet" */
  GatewaySubnet_aggregate: GatewaySubnet_Aggregate;
  /** fetch data from the table: "GatewaySubnet" using primary key columns */
  GatewaySubnet_by_pk?: Maybe<GatewaySubnet>;
  /** fetch aggregated fields from the table: "Gateway" */
  Gateway_aggregate: Gateway_Aggregate;
  /** fetch data from the table: "Gateway" using primary key columns */
  Gateway_by_pk?: Maybe<Gateway>;
  /** fetch data from the table: "LanNode" */
  LanNode: Array<LanNode>;
  /** fetch aggregated fields from the table: "LanNode" */
  LanNode_aggregate: LanNode_Aggregate;
  /** fetch data from the table: "LanNode" using primary key columns */
  LanNode_by_pk?: Maybe<LanNode>;
  /** fetch data from the table: "LicenseKeys" */
  LicenseKeys: Array<LicenseKeys>;
  /** fetch aggregated fields from the table: "LicenseKeys" */
  LicenseKeys_aggregate: LicenseKeys_Aggregate;
  /** fetch data from the table: "LicenseKeys" using primary key columns */
  LicenseKeys_by_pk?: Maybe<LicenseKeys>;
  /** fetch data from the table: "Link" */
  Link: Array<Link>;
  /** fetch data from the table: "LinkType" */
  LinkType: Array<LinkType>;
  /** fetch aggregated fields from the table: "LinkType" */
  LinkType_aggregate: LinkType_Aggregate;
  /** fetch data from the table: "LinkType" using primary key columns */
  LinkType_by_pk?: Maybe<LinkType>;
  /** fetch aggregated fields from the table: "Link" */
  Link_aggregate: Link_Aggregate;
  /** fetch data from the table: "Link" using primary key columns */
  Link_by_pk?: Maybe<Link>;
  /** fetch data from the table: "MeshWan" */
  MeshWan: Array<MeshWan>;
  /** fetch aggregated fields from the table: "MeshWan" */
  MeshWan_aggregate: MeshWan_Aggregate;
  /** fetch data from the table: "MeshWan" using primary key columns */
  MeshWan_by_pk?: Maybe<MeshWan>;
  /** fetch data from the table: "Monitor" */
  Monitor: Array<Monitor>;
  /** fetch aggregated fields from the table: "Monitor" */
  Monitor_aggregate: Monitor_Aggregate;
  /** fetch data from the table: "Monitor" using primary key columns */
  Monitor_by_pk?: Maybe<Monitor>;
  /** fetch data from the table: "Partner" */
  Partner: Array<Partner>;
  /** fetch data from the table: "PartnerPreferences" */
  PartnerPreferences: Array<PartnerPreferences>;
  /** fetch aggregated fields from the table: "PartnerPreferences" */
  PartnerPreferences_aggregate: PartnerPreferences_Aggregate;
  /** fetch aggregated fields from the table: "Partner" */
  Partner_aggregate: Partner_Aggregate;
  /** fetch data from the table: "Partner" using primary key columns */
  Partner_by_pk?: Maybe<Partner>;
  /** fetch data from the table: "Profile" */
  Profile: Array<Profile>;
  /** fetch aggregated fields from the table: "Profile" */
  Profile_aggregate: Profile_Aggregate;
  /** fetch data from the table: "Profile" using primary key columns */
  Profile_by_pk?: Maybe<Profile>;
  /** fetch data from the table: "PublicIp" */
  PublicIp: Array<PublicIp>;
  /** fetch aggregated fields from the table: "PublicIp" */
  PublicIp_aggregate: PublicIp_Aggregate;
  /** fetch data from the table: "PublicIp" using primary key columns */
  PublicIp_by_pk?: Maybe<PublicIp>;
  /** fetch data from the table: "Quicklink" */
  Quicklink: Array<Quicklink>;
  /** fetch aggregated fields from the table: "Quicklink" */
  Quicklink_aggregate: Quicklink_Aggregate;
  /** fetch data from the table: "Quicklink" using primary key columns */
  Quicklink_by_pk?: Maybe<Quicklink>;
  /** fetch data from the table: "Server" */
  Server: Array<Server>;
  /** fetch data from the table: "ServerBridge" */
  ServerBridge: Array<ServerBridge>;
  /** fetch aggregated fields from the table: "ServerBridge" */
  ServerBridge_aggregate: ServerBridge_Aggregate;
  /** fetch data from the table: "ServerBridge" using primary key columns */
  ServerBridge_by_pk?: Maybe<ServerBridge>;
  /** fetch aggregated fields from the table: "Server" */
  Server_aggregate: Server_Aggregate;
  /** fetch data from the table: "Server" using primary key columns */
  Server_by_pk?: Maybe<Server>;
  /** fetch data from the table: "Site" */
  Site: Array<Site>;
  /** fetch data from the table: "SiteContact" */
  SiteContact: Array<SiteContact>;
  /** fetch aggregated fields from the table: "SiteContact" */
  SiteContact_aggregate: SiteContact_Aggregate;
  /** fetch data from the table: "SiteContact" using primary key columns */
  SiteContact_by_pk?: Maybe<SiteContact>;
  /** fetch data from the table: "SiteLan" */
  SiteLan: Array<SiteLan>;
  /** fetch aggregated fields from the table: "SiteLan" */
  SiteLan_aggregate: SiteLan_Aggregate;
  /** fetch data from the table: "SiteLan" using primary key columns */
  SiteLan_by_pk?: Maybe<SiteLan>;
  /** fetch data from the table: "SiteRoute" */
  SiteRoute: Array<SiteRoute>;
  /** fetch aggregated fields from the table: "SiteRoute" */
  SiteRoute_aggregate: SiteRoute_Aggregate;
  /** fetch data from the table: "SiteRoute" using primary key columns */
  SiteRoute_by_pk?: Maybe<SiteRoute>;
  /** fetch aggregated fields from the table: "Site" */
  Site_aggregate: Site_Aggregate;
  /** fetch data from the table: "Site" using primary key columns */
  Site_by_pk?: Maybe<Site>;
  /** fetch data from the table: "Tunnel" */
  Tunnel: Array<Tunnel>;
  /** fetch data from the table: "TunnelProfile" */
  TunnelProfile: Array<TunnelProfile>;
  /** fetch aggregated fields from the table: "TunnelProfile" */
  TunnelProfile_aggregate: TunnelProfile_Aggregate;
  /** fetch data from the table: "TunnelProfile" using primary key columns */
  TunnelProfile_by_pk?: Maybe<TunnelProfile>;
  /** fetch aggregated fields from the table: "Tunnel" */
  Tunnel_aggregate: Tunnel_Aggregate;
  /** fetch data from the table: "Tunnel" using primary key columns */
  Tunnel_by_pk?: Maybe<Tunnel>;
  /** fetch data from the table: "User" */
  User: Array<User>;
  /** fetch data from the table: "UserHistory" */
  UserHistory: Array<UserHistory>;
  /** fetch aggregated fields from the table: "UserHistory" */
  UserHistory_aggregate: UserHistory_Aggregate;
  /** fetch data from the table: "UserHistory" using primary key columns */
  UserHistory_by_pk?: Maybe<UserHistory>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_Aggregate;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole>;
  /** fetch aggregated fields from the table: "User" */
  User_aggregate: User_Aggregate;
  /** fetch data from the table: "User" using primary key columns */
  User_by_pk?: Maybe<User>;
  /** fetch data from the table: "Wan" */
  Wan: Array<Wan>;
  /** fetch aggregated fields from the table: "Wan" */
  Wan_aggregate: Wan_Aggregate;
  /** fetch data from the table: "Wan" using primary key columns */
  Wan_by_pk?: Maybe<Wan>;
};


export type Subscription_RootCarrierArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCarrier_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carrier_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By>>;
  where?: InputMaybe<Carrier_Bool_Exp>;
};


export type Subscription_RootCarrier_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClientCompanyArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


export type Subscription_RootClientCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By>>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
};


export type Subscription_RootClientCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFirmwareArgs = {
  distinct_on?: InputMaybe<Array<Firmware_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By>>;
  where?: InputMaybe<Firmware_Bool_Exp>;
};


export type Subscription_RootFirmware_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Firmware_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By>>;
  where?: InputMaybe<Firmware_Bool_Exp>;
};


export type Subscription_RootFirmware_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGatewayArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Subscription_RootGatewayBridgeArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


export type Subscription_RootGatewayBridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By>>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
};


export type Subscription_RootGatewayBridge_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGatewaySubnetArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


export type Subscription_RootGatewaySubnet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By>>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
};


export type Subscription_RootGatewaySubnet_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGateway_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gateway_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By>>;
  where?: InputMaybe<Gateway_Bool_Exp>;
};


export type Subscription_RootGateway_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLanNodeArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


export type Subscription_RootLanNode_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LanNode_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By>>;
  where?: InputMaybe<LanNode_Bool_Exp>;
};


export type Subscription_RootLanNode_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLicenseKeysArgs = {
  distinct_on?: InputMaybe<Array<LicenseKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LicenseKeys_Order_By>>;
  where?: InputMaybe<LicenseKeys_Bool_Exp>;
};


export type Subscription_RootLicenseKeys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LicenseKeys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LicenseKeys_Order_By>>;
  where?: InputMaybe<LicenseKeys_Bool_Exp>;
};


export type Subscription_RootLicenseKeys_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootLinkArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Subscription_RootLinkTypeArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


export type Subscription_RootLinkType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<LinkType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By>>;
  where?: InputMaybe<LinkType_Bool_Exp>;
};


export type Subscription_RootLinkType_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By>>;
  where?: InputMaybe<Link_Bool_Exp>;
};


export type Subscription_RootLink_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMeshWanArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


export type Subscription_RootMeshWan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By>>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
};


export type Subscription_RootMeshWan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMonitorArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


export type Subscription_RootMonitor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Monitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By>>;
  where?: InputMaybe<Monitor_Bool_Exp>;
};


export type Subscription_RootMonitor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPartnerArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartnerPreferencesArgs = {
  distinct_on?: InputMaybe<Array<PartnerPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartnerPreferences_Order_By>>;
  where?: InputMaybe<PartnerPreferences_Bool_Exp>;
};


export type Subscription_RootPartnerPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PartnerPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PartnerPreferences_Order_By>>;
  where?: InputMaybe<PartnerPreferences_Bool_Exp>;
};


export type Subscription_RootPartner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Partner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By>>;
  where?: InputMaybe<Partner_Bool_Exp>;
};


export type Subscription_RootPartner_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProfileArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPublicIpArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


export type Subscription_RootPublicIp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By>>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
};


export type Subscription_RootPublicIp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootQuicklinkArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


export type Subscription_RootQuicklink_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By>>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
};


export type Subscription_RootQuicklink_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootServerArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


export type Subscription_RootServerBridgeArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


export type Subscription_RootServerBridge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By>>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
};


export type Subscription_RootServerBridge_By_PkArgs = {
  gatewayBridgeId: Scalars['uuid'];
  serverId: Scalars['uuid'];
};


export type Subscription_RootServer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Server_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By>>;
  where?: InputMaybe<Server_Bool_Exp>;
};


export type Subscription_RootServer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSiteArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Subscription_RootSiteContactArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


export type Subscription_RootSiteContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By>>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
};


export type Subscription_RootSiteContact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSiteLanArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


export type Subscription_RootSiteLan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By>>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
};


export type Subscription_RootSiteLan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSiteRouteArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


export type Subscription_RootSiteRoute_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By>>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
};


export type Subscription_RootSiteRoute_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Subscription_RootSite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTunnelArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


export type Subscription_RootTunnelProfileArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


export type Subscription_RootTunnelProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By>>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
};


export type Subscription_RootTunnelProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTunnel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By>>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
};


export type Subscription_RootTunnel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUserHistoryArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};


export type Subscription_RootUserHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By>>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
};


export type Subscription_RootUserHistory_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUserRoleArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Subscription_RootUserRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By>>;
  where?: InputMaybe<UserRole_Bool_Exp>;
};


export type Subscription_RootUserRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWanArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};


export type Subscription_RootWan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Wan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By>>;
  where?: InputMaybe<Wan_Bool_Exp>;
};


export type Subscription_RootWan_By_PkArgs = {
  id: Scalars['uuid'];
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type CarrierFragment = { __typename?: 'Carrier', id: any, name?: string | null, partnerId: any };

export type ClientCompanyFragment = { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> };

export type GatewayFragment = { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> };

export type PartnerFragment = { __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> };

export type QuicklinkFragment = { __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } };

export type FirmwareFragment = { __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string };

export type GatewayBridgeFragment = { __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null };

export type GatewaySubnetFragment = { __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null };

export type LanNodeFragment = { __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any };

export type LinkFragment = { __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null };

export type LinkTypeFragment = { __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null };

export type MeshWanFragment = { __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null };

export type MonitorFragment = { __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null };

export type ProfileFragment = { __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null };

export type PublicIpFragment = { __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any };

export type ServerFragment = { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> };

export type ServerBridgeFragment = { __typename?: 'ServerBridge', gatewayBridgeId: any, serverId: any };

export type SiteFragment = { __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null };

export type SiteContactFragment = { __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any };

export type SiteLanFragment = { __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null };

export type SiteRouteFragment = { __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null };

export type TunnelFragment = { __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null };

export type TunnelProfileFragment = { __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any };

export type UserFragment = { __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any };

export type UserHistoryFragment = { __typename?: 'UserHistory', id: any, status?: string | null, userId: any };

export type UserRoleFragment = { __typename?: 'UserRole', id: any, roleName?: string | null };

export type WanFragment = { __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null };

export type QueryCarrierByIdQueryVariables = Exact<{
  carrierId: Scalars['uuid'];
}>;


export type QueryCarrierByIdQuery = { __typename?: 'query_root', Carrier_by_pk?: { __typename?: 'Carrier', id: any, name?: string | null, partnerId: any } | null };

export type QueryCarrierObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Carrier_Select_Column> | Carrier_Select_Column>;
  where?: InputMaybe<Carrier_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By> | Carrier_Order_By>;
}>;


export type QueryCarrierObjectsQuery = { __typename?: 'query_root', Carrier: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> };

export type SubscribeToCarrierByIdSubscriptionVariables = Exact<{
  carrierId: Scalars['uuid'];
}>;


export type SubscribeToCarrierByIdSubscription = { __typename?: 'subscription_root', Carrier_by_pk?: { __typename?: 'Carrier', id: any, name?: string | null, partnerId: any } | null };

export type SubscribeToCarrierObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Carrier_Select_Column> | Carrier_Select_Column>;
  where?: InputMaybe<Carrier_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Carrier_Order_By> | Carrier_Order_By>;
}>;


export type SubscribeToCarrierObjectsSubscription = { __typename?: 'subscription_root', Carrier: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> };

export type InsertCarrierMutationVariables = Exact<{
  objects: Array<Carrier_Insert_Input> | Carrier_Insert_Input;
}>;


export type InsertCarrierMutation = { __typename?: 'mutation_root', insert_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> } | null };

export type InsertCarrierWithOnConflictMutationVariables = Exact<{
  objects: Array<Carrier_Insert_Input> | Carrier_Insert_Input;
  onConflict?: InputMaybe<Carrier_On_Conflict>;
}>;


export type InsertCarrierWithOnConflictMutation = { __typename?: 'mutation_root', insert_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> } | null };

export type UpdateCarrierByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Carrier_Set_Input>;
}>;


export type UpdateCarrierByIdMutation = { __typename?: 'mutation_root', update_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> } | null };

export type UpdateCarrierMutationVariables = Exact<{
  set?: InputMaybe<Carrier_Set_Input>;
  where: Carrier_Bool_Exp;
}>;


export type UpdateCarrierMutation = { __typename?: 'mutation_root', update_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Carrier', id: any, name?: string | null, partnerId: any }> } | null };

export type RemoveCarrierModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveCarrierModelByIdMutation = { __typename?: 'mutation_root', delete_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number } | null };

export type RemoveCarrierModelMutationVariables = Exact<{
  where: Carrier_Bool_Exp;
}>;


export type RemoveCarrierModelMutation = { __typename?: 'mutation_root', delete_Carrier?: { __typename?: 'Carrier_mutation_response', affected_rows: number } | null };

export type QueryClientCompanyByIdQueryVariables = Exact<{
  clientCompanyId: Scalars['uuid'];
}>;


export type QueryClientCompanyByIdQuery = { __typename?: 'query_root', ClientCompany_by_pk?: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> } | null };

export type QueryClientCompanyObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column> | ClientCompany_Select_Column>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By> | ClientCompany_Order_By>;
}>;


export type QueryClientCompanyObjectsQuery = { __typename?: 'query_root', ClientCompany: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> };

export type SubscribeToClientCompanyByIdSubscriptionVariables = Exact<{
  clientCompanyId: Scalars['uuid'];
}>;


export type SubscribeToClientCompanyByIdSubscription = { __typename?: 'subscription_root', ClientCompany_by_pk?: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> } | null };

export type SubscribeToClientCompanyObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<ClientCompany_Select_Column> | ClientCompany_Select_Column>;
  where?: InputMaybe<ClientCompany_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientCompany_Order_By> | ClientCompany_Order_By>;
}>;


export type SubscribeToClientCompanyObjectsSubscription = { __typename?: 'subscription_root', ClientCompany: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> };

export type InsertClientCompanyMutationVariables = Exact<{
  objects: Array<ClientCompany_Insert_Input> | ClientCompany_Insert_Input;
}>;


export type InsertClientCompanyMutation = { __typename?: 'mutation_root', insert_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> } | null };

export type InsertClientCompanyWithOnConflictMutationVariables = Exact<{
  objects: Array<ClientCompany_Insert_Input> | ClientCompany_Insert_Input;
  onConflict?: InputMaybe<ClientCompany_On_Conflict>;
}>;


export type InsertClientCompanyWithOnConflictMutation = { __typename?: 'mutation_root', insert_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> } | null };

export type UpdateClientCompanyByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<ClientCompany_Set_Input>;
}>;


export type UpdateClientCompanyByIdMutation = { __typename?: 'mutation_root', update_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> } | null };

export type UpdateClientCompanyMutationVariables = Exact<{
  set?: InputMaybe<ClientCompany_Set_Input>;
  where: ClientCompany_Bool_Exp;
}>;


export type UpdateClientCompanyMutation = { __typename?: 'mutation_root', update_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }> } | null };

export type RemoveClientCompanyModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveClientCompanyModelByIdMutation = { __typename?: 'mutation_root', delete_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number } | null };

export type RemoveClientCompanyModelMutationVariables = Exact<{
  where: ClientCompany_Bool_Exp;
}>;


export type RemoveClientCompanyModelMutation = { __typename?: 'mutation_root', delete_ClientCompany?: { __typename?: 'ClientCompany_mutation_response', affected_rows: number } | null };

export type QueryGatewayByIdQueryVariables = Exact<{
  gatewayId: Scalars['uuid'];
}>;


export type QueryGatewayByIdQuery = { __typename?: 'query_root', Gateway_by_pk?: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> } | null };

export type QueryGatewayObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Gateway_Select_Column> | Gateway_Select_Column>;
  where?: InputMaybe<Gateway_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By> | Gateway_Order_By>;
}>;


export type QueryGatewayObjectsQuery = { __typename?: 'query_root', Gateway: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> };

export type SubscribeToGatewayByIdSubscriptionVariables = Exact<{
  gatewayId: Scalars['uuid'];
}>;


export type SubscribeToGatewayByIdSubscription = { __typename?: 'subscription_root', Gateway_by_pk?: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> } | null };

export type SubscribeToGatewayObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Gateway_Select_Column> | Gateway_Select_Column>;
  where?: InputMaybe<Gateway_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gateway_Order_By> | Gateway_Order_By>;
}>;


export type SubscribeToGatewayObjectsSubscription = { __typename?: 'subscription_root', Gateway: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> };

export type InsertGatewayMutationVariables = Exact<{
  objects: Array<Gateway_Insert_Input> | Gateway_Insert_Input;
}>;


export type InsertGatewayMutation = { __typename?: 'mutation_root', insert_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> } | null };

export type InsertGatewayWithOnConflictMutationVariables = Exact<{
  objects: Array<Gateway_Insert_Input> | Gateway_Insert_Input;
  onConflict?: InputMaybe<Gateway_On_Conflict>;
}>;


export type InsertGatewayWithOnConflictMutation = { __typename?: 'mutation_root', insert_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> } | null };

export type UpdateGatewayByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Gateway_Set_Input>;
}>;


export type UpdateGatewayByIdMutation = { __typename?: 'mutation_root', update_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> } | null };

export type UpdateGatewayMutationVariables = Exact<{
  set?: InputMaybe<Gateway_Set_Input>;
  where: Gateway_Bool_Exp;
}>;


export type UpdateGatewayMutation = { __typename?: 'mutation_root', update_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }> } | null };

export type RemoveGatewayModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveGatewayModelByIdMutation = { __typename?: 'mutation_root', delete_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number } | null };

export type RemoveGatewayModelMutationVariables = Exact<{
  where: Gateway_Bool_Exp;
}>;


export type RemoveGatewayModelMutation = { __typename?: 'mutation_root', delete_Gateway?: { __typename?: 'Gateway_mutation_response', affected_rows: number } | null };

export type QueryPartnerByIdQueryVariables = Exact<{
  partnerId: Scalars['uuid'];
}>;


export type QueryPartnerByIdQuery = { __typename?: 'query_root', Partner_by_pk?: { __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> } | null };

export type QueryPartnerObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Partner_Select_Column> | Partner_Select_Column>;
  where?: InputMaybe<Partner_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By> | Partner_Order_By>;
}>;


export type QueryPartnerObjectsQuery = { __typename?: 'query_root', Partner: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> };

export type SubscribeToPartnerByIdSubscriptionVariables = Exact<{
  partnerId: Scalars['uuid'];
}>;


export type SubscribeToPartnerByIdSubscription = { __typename?: 'subscription_root', Partner_by_pk?: { __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> } | null };

export type SubscribeToPartnerObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Partner_Select_Column> | Partner_Select_Column>;
  where?: InputMaybe<Partner_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Partner_Order_By> | Partner_Order_By>;
}>;


export type SubscribeToPartnerObjectsSubscription = { __typename?: 'subscription_root', Partner: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> };

export type InsertPartnerMutationVariables = Exact<{
  objects: Array<Partner_Insert_Input> | Partner_Insert_Input;
}>;


export type InsertPartnerMutation = { __typename?: 'mutation_root', insert_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> } | null };

export type InsertPartnerWithOnConflictMutationVariables = Exact<{
  objects: Array<Partner_Insert_Input> | Partner_Insert_Input;
  onConflict?: InputMaybe<Partner_On_Conflict>;
}>;


export type InsertPartnerWithOnConflictMutation = { __typename?: 'mutation_root', insert_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> } | null };

export type UpdatePartnerByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Partner_Set_Input>;
}>;


export type UpdatePartnerByIdMutation = { __typename?: 'mutation_root', update_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> } | null };

export type UpdatePartnerMutationVariables = Exact<{
  set?: InputMaybe<Partner_Set_Input>;
  where: Partner_Bool_Exp;
}>;


export type UpdatePartnerMutation = { __typename?: 'mutation_root', update_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Partner', id: any, name?: string | null, billingContact?: string | null, billingEmail?: string | null, billingPhone?: string | null, billingExt?: string | null, billingAddress?: string | null, billingAddress1?: string | null, billingAddress2?: string | null, billingCity?: string | null, billingState?: string | null, billingCountry?: string | null, billingPostalCode?: string | null, primaryLanguage?: string | null, Users: Array<{ __typename?: 'User', id: any, email: string, emailAlert: boolean }> }> } | null };

export type RemovePartnerModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemovePartnerModelByIdMutation = { __typename?: 'mutation_root', delete_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number } | null };

export type RemovePartnerModelMutationVariables = Exact<{
  where: Partner_Bool_Exp;
}>;


export type RemovePartnerModelMutation = { __typename?: 'mutation_root', delete_Partner?: { __typename?: 'Partner_mutation_response', affected_rows: number } | null };

export type QueryQuicklinkByIdQueryVariables = Exact<{
  quicklinkId: Scalars['uuid'];
}>;


export type QueryQuicklinkByIdQuery = { __typename?: 'query_root', Quicklink_by_pk?: { __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } } | null };

export type QueryQuicklinkObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column> | Quicklink_Select_Column>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By> | Quicklink_Order_By>;
}>;


export type QueryQuicklinkObjectsQuery = { __typename?: 'query_root', Quicklink: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> };

export type SubscribeToQuicklinkByIdSubscriptionVariables = Exact<{
  quicklinkId: Scalars['uuid'];
}>;


export type SubscribeToQuicklinkByIdSubscription = { __typename?: 'subscription_root', Quicklink_by_pk?: { __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } } | null };

export type SubscribeToQuicklinkObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Quicklink_Select_Column> | Quicklink_Select_Column>;
  where?: InputMaybe<Quicklink_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quicklink_Order_By> | Quicklink_Order_By>;
}>;


export type SubscribeToQuicklinkObjectsSubscription = { __typename?: 'subscription_root', Quicklink: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> };

export type InsertQuicklinkMutationVariables = Exact<{
  objects: Array<Quicklink_Insert_Input> | Quicklink_Insert_Input;
}>;


export type InsertQuicklinkMutation = { __typename?: 'mutation_root', insert_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> } | null };

export type InsertQuicklinkWithOnConflictMutationVariables = Exact<{
  objects: Array<Quicklink_Insert_Input> | Quicklink_Insert_Input;
  onConflict?: InputMaybe<Quicklink_On_Conflict>;
}>;


export type InsertQuicklinkWithOnConflictMutation = { __typename?: 'mutation_root', insert_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> } | null };

export type UpdateQuicklinkByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Quicklink_Set_Input>;
}>;


export type UpdateQuicklinkByIdMutation = { __typename?: 'mutation_root', update_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> } | null };

export type UpdateQuicklinkMutationVariables = Exact<{
  set?: InputMaybe<Quicklink_Set_Input>;
  where: Quicklink_Bool_Exp;
}>;


export type UpdateQuicklinkMutation = { __typename?: 'mutation_root', update_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Quicklink', id: any, description?: string | null, link?: string | null, clientCompanyId: any, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null } }> } | null };

export type RemoveQuicklinkModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveQuicklinkModelByIdMutation = { __typename?: 'mutation_root', delete_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number } | null };

export type RemoveQuicklinkModelMutationVariables = Exact<{
  where: Quicklink_Bool_Exp;
}>;


export type RemoveQuicklinkModelMutation = { __typename?: 'mutation_root', delete_Quicklink?: { __typename?: 'Quicklink_mutation_response', affected_rows: number } | null };

export type QueryFirmwareByIdQueryVariables = Exact<{
  firmwareId: Scalars['uuid'];
}>;


export type QueryFirmwareByIdQuery = { __typename?: 'query_root', Firmware_by_pk?: { __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string } | null };

export type QueryFirmwareObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Firmware_Select_Column> | Firmware_Select_Column>;
  where?: InputMaybe<Firmware_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By> | Firmware_Order_By>;
}>;


export type QueryFirmwareObjectsQuery = { __typename?: 'query_root', Firmware: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> };

export type SubscribeToFirmwareByIdSubscriptionVariables = Exact<{
  firmwareId: Scalars['uuid'];
}>;


export type SubscribeToFirmwareByIdSubscription = { __typename?: 'subscription_root', Firmware_by_pk?: { __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string } | null };

export type SubscribeToFirmwareObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Firmware_Select_Column> | Firmware_Select_Column>;
  where?: InputMaybe<Firmware_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Firmware_Order_By> | Firmware_Order_By>;
}>;


export type SubscribeToFirmwareObjectsSubscription = { __typename?: 'subscription_root', Firmware: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> };

export type InsertFirmwareMutationVariables = Exact<{
  objects: Array<Firmware_Insert_Input> | Firmware_Insert_Input;
}>;


export type InsertFirmwareMutation = { __typename?: 'mutation_root', insert_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> } | null };

export type InsertFirmwareWithOnConflictMutationVariables = Exact<{
  objects: Array<Firmware_Insert_Input> | Firmware_Insert_Input;
  onConflict?: InputMaybe<Firmware_On_Conflict>;
}>;


export type InsertFirmwareWithOnConflictMutation = { __typename?: 'mutation_root', insert_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> } | null };

export type UpdateFirmwareByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Firmware_Set_Input>;
}>;


export type UpdateFirmwareByIdMutation = { __typename?: 'mutation_root', update_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> } | null };

export type UpdateFirmwareMutationVariables = Exact<{
  set?: InputMaybe<Firmware_Set_Input>;
  where: Firmware_Bool_Exp;
}>;


export type UpdateFirmwareMutation = { __typename?: 'mutation_root', update_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Firmware', id: any, URI: string, category: any, hash: string, isActive?: boolean | null, track: number, version: string }> } | null };

export type RemoveFirmwareModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveFirmwareModelByIdMutation = { __typename?: 'mutation_root', delete_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number } | null };

export type RemoveFirmwareModelMutationVariables = Exact<{
  where: Firmware_Bool_Exp;
}>;


export type RemoveFirmwareModelMutation = { __typename?: 'mutation_root', delete_Firmware?: { __typename?: 'Firmware_mutation_response', affected_rows: number } | null };

export type QueryGatewayBridgeByIdQueryVariables = Exact<{
  gatewayBridgeId: Scalars['uuid'];
}>;


export type QueryGatewayBridgeByIdQuery = { __typename?: 'query_root', GatewayBridge_by_pk?: { __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null } | null };

export type QueryGatewayBridgeObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column> | GatewayBridge_Select_Column>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By> | GatewayBridge_Order_By>;
}>;


export type QueryGatewayBridgeObjectsQuery = { __typename?: 'query_root', GatewayBridge: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> };

export type SubscribeToGatewayBridgeByIdSubscriptionVariables = Exact<{
  gatewayBridgeId: Scalars['uuid'];
}>;


export type SubscribeToGatewayBridgeByIdSubscription = { __typename?: 'subscription_root', GatewayBridge_by_pk?: { __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null } | null };

export type SubscribeToGatewayBridgeObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<GatewayBridge_Select_Column> | GatewayBridge_Select_Column>;
  where?: InputMaybe<GatewayBridge_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewayBridge_Order_By> | GatewayBridge_Order_By>;
}>;


export type SubscribeToGatewayBridgeObjectsSubscription = { __typename?: 'subscription_root', GatewayBridge: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> };

export type InsertGatewayBridgeMutationVariables = Exact<{
  objects: Array<GatewayBridge_Insert_Input> | GatewayBridge_Insert_Input;
}>;


export type InsertGatewayBridgeMutation = { __typename?: 'mutation_root', insert_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> } | null };

export type InsertGatewayBridgeWithOnConflictMutationVariables = Exact<{
  objects: Array<GatewayBridge_Insert_Input> | GatewayBridge_Insert_Input;
  onConflict?: InputMaybe<GatewayBridge_On_Conflict>;
}>;


export type InsertGatewayBridgeWithOnConflictMutation = { __typename?: 'mutation_root', insert_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> } | null };

export type UpdateGatewayBridgeByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<GatewayBridge_Set_Input>;
}>;


export type UpdateGatewayBridgeByIdMutation = { __typename?: 'mutation_root', update_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> } | null };

export type UpdateGatewayBridgeMutationVariables = Exact<{
  set?: InputMaybe<GatewayBridge_Set_Input>;
  where: GatewayBridge_Bool_Exp;
}>;


export type UpdateGatewayBridgeMutation = { __typename?: 'mutation_root', update_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewayBridge', id: any, gatewayId: any, bridgeType: any, ipAddress?: any | null }> } | null };

export type RemoveGatewayBridgeModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveGatewayBridgeModelByIdMutation = { __typename?: 'mutation_root', delete_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number } | null };

export type RemoveGatewayBridgeModelMutationVariables = Exact<{
  where: GatewayBridge_Bool_Exp;
}>;


export type RemoveGatewayBridgeModelMutation = { __typename?: 'mutation_root', delete_GatewayBridge?: { __typename?: 'GatewayBridge_mutation_response', affected_rows: number } | null };

export type QueryGatewaySubnetByIdQueryVariables = Exact<{
  gatewaySubnetId: Scalars['uuid'];
}>;


export type QueryGatewaySubnetByIdQuery = { __typename?: 'query_root', GatewaySubnet_by_pk?: { __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null } | null };

export type QueryGatewaySubnetObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column> | GatewaySubnet_Select_Column>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By> | GatewaySubnet_Order_By>;
}>;


export type QueryGatewaySubnetObjectsQuery = { __typename?: 'query_root', GatewaySubnet: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> };

export type SubscribeToGatewaySubnetByIdSubscriptionVariables = Exact<{
  gatewaySubnetId: Scalars['uuid'];
}>;


export type SubscribeToGatewaySubnetByIdSubscription = { __typename?: 'subscription_root', GatewaySubnet_by_pk?: { __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null } | null };

export type SubscribeToGatewaySubnetObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<GatewaySubnet_Select_Column> | GatewaySubnet_Select_Column>;
  where?: InputMaybe<GatewaySubnet_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<GatewaySubnet_Order_By> | GatewaySubnet_Order_By>;
}>;


export type SubscribeToGatewaySubnetObjectsSubscription = { __typename?: 'subscription_root', GatewaySubnet: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> };

export type InsertGatewaySubnetMutationVariables = Exact<{
  objects: Array<GatewaySubnet_Insert_Input> | GatewaySubnet_Insert_Input;
}>;


export type InsertGatewaySubnetMutation = { __typename?: 'mutation_root', insert_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> } | null };

export type InsertGatewaySubnetWithOnConflictMutationVariables = Exact<{
  objects: Array<GatewaySubnet_Insert_Input> | GatewaySubnet_Insert_Input;
  onConflict?: InputMaybe<GatewaySubnet_On_Conflict>;
}>;


export type InsertGatewaySubnetWithOnConflictMutation = { __typename?: 'mutation_root', insert_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> } | null };

export type UpdateGatewaySubnetByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<GatewaySubnet_Set_Input>;
}>;


export type UpdateGatewaySubnetByIdMutation = { __typename?: 'mutation_root', update_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> } | null };

export type UpdateGatewaySubnetMutationVariables = Exact<{
  set?: InputMaybe<GatewaySubnet_Set_Input>;
  where: GatewaySubnet_Bool_Exp;
}>;


export type UpdateGatewaySubnetMutation = { __typename?: 'mutation_root', update_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'GatewaySubnet', id: any, gatewayId: any, cidr?: string | null, address?: string | null }> } | null };

export type RemoveGatewaySubnetModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveGatewaySubnetModelByIdMutation = { __typename?: 'mutation_root', delete_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number } | null };

export type RemoveGatewaySubnetModelMutationVariables = Exact<{
  where: GatewaySubnet_Bool_Exp;
}>;


export type RemoveGatewaySubnetModelMutation = { __typename?: 'mutation_root', delete_GatewaySubnet?: { __typename?: 'GatewaySubnet_mutation_response', affected_rows: number } | null };

export type QueryLanNodeByIdQueryVariables = Exact<{
  lanNodeId: Scalars['uuid'];
}>;


export type QueryLanNodeByIdQuery = { __typename?: 'query_root', LanNode_by_pk?: { __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any } | null };

export type QueryLanNodeObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<LanNode_Select_Column> | LanNode_Select_Column>;
  where?: InputMaybe<LanNode_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By> | LanNode_Order_By>;
}>;


export type QueryLanNodeObjectsQuery = { __typename?: 'query_root', LanNode: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> };

export type SubscribeToLanNodeByIdSubscriptionVariables = Exact<{
  lanNodeId: Scalars['uuid'];
}>;


export type SubscribeToLanNodeByIdSubscription = { __typename?: 'subscription_root', LanNode_by_pk?: { __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any } | null };

export type SubscribeToLanNodeObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<LanNode_Select_Column> | LanNode_Select_Column>;
  where?: InputMaybe<LanNode_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LanNode_Order_By> | LanNode_Order_By>;
}>;


export type SubscribeToLanNodeObjectsSubscription = { __typename?: 'subscription_root', LanNode: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> };

export type InsertLanNodeMutationVariables = Exact<{
  objects: Array<LanNode_Insert_Input> | LanNode_Insert_Input;
}>;


export type InsertLanNodeMutation = { __typename?: 'mutation_root', insert_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> } | null };

export type InsertLanNodeWithOnConflictMutationVariables = Exact<{
  objects: Array<LanNode_Insert_Input> | LanNode_Insert_Input;
  onConflict?: InputMaybe<LanNode_On_Conflict>;
}>;


export type InsertLanNodeWithOnConflictMutation = { __typename?: 'mutation_root', insert_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> } | null };

export type UpdateLanNodeByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<LanNode_Set_Input>;
}>;


export type UpdateLanNodeByIdMutation = { __typename?: 'mutation_root', update_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> } | null };

export type UpdateLanNodeMutationVariables = Exact<{
  set?: InputMaybe<LanNode_Set_Input>;
  where: LanNode_Bool_Exp;
}>;


export type UpdateLanNodeMutation = { __typename?: 'mutation_root', update_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LanNode', id: any, ip4Address?: string | null, isPublic?: boolean | null, siteLanId: any, publicIpId: any }> } | null };

export type RemoveLanNodeModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveLanNodeModelByIdMutation = { __typename?: 'mutation_root', delete_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number } | null };

export type RemoveLanNodeModelMutationVariables = Exact<{
  where: LanNode_Bool_Exp;
}>;


export type RemoveLanNodeModelMutation = { __typename?: 'mutation_root', delete_LanNode?: { __typename?: 'LanNode_mutation_response', affected_rows: number } | null };

export type QueryLinkByIdQueryVariables = Exact<{
  linkId: Scalars['uuid'];
}>;


export type QueryLinkByIdQuery = { __typename?: 'query_root', Link_by_pk?: { __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null } | null };

export type QueryLinkObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Link_Select_Column> | Link_Select_Column>;
  where?: InputMaybe<Link_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By> | Link_Order_By>;
}>;


export type QueryLinkObjectsQuery = { __typename?: 'query_root', Link: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> };

export type SubscribeToLinkByIdSubscriptionVariables = Exact<{
  linkId: Scalars['uuid'];
}>;


export type SubscribeToLinkByIdSubscription = { __typename?: 'subscription_root', Link_by_pk?: { __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null } | null };

export type SubscribeToLinkObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Link_Select_Column> | Link_Select_Column>;
  where?: InputMaybe<Link_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Link_Order_By> | Link_Order_By>;
}>;


export type SubscribeToLinkObjectsSubscription = { __typename?: 'subscription_root', Link: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> };

export type InsertLinkMutationVariables = Exact<{
  objects: Array<Link_Insert_Input> | Link_Insert_Input;
}>;


export type InsertLinkMutation = { __typename?: 'mutation_root', insert_Link?: { __typename?: 'Link_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> } | null };

export type InsertLinkWithOnConflictMutationVariables = Exact<{
  objects: Array<Link_Insert_Input> | Link_Insert_Input;
  onConflict?: InputMaybe<Link_On_Conflict>;
}>;


export type InsertLinkWithOnConflictMutation = { __typename?: 'mutation_root', insert_Link?: { __typename?: 'Link_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> } | null };

export type UpdateLinkByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Link_Set_Input>;
}>;


export type UpdateLinkByIdMutation = { __typename?: 'mutation_root', update_Link?: { __typename?: 'Link_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> } | null };

export type UpdateLinkMutationVariables = Exact<{
  set?: InputMaybe<Link_Set_Input>;
  where: Link_Bool_Exp;
}>;


export type UpdateLinkMutation = { __typename?: 'mutation_root', update_Link?: { __typename?: 'Link_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Link', id: any, carrierName?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUpdated?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, isCapEnabled?: boolean | null, isCapped?: boolean | null, isDHCP?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMacOverride?: boolean | null, isMetered?: boolean | null, isPPPoE?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, isWWAN?: boolean | null, macAddress?: string | null, metric?: number | null, modemAPN?: string | null, name?: string | null, notes?: string | null, pppoePassword?: string | null, pppoeUsername?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, staticIp?: string | null, tunnelId: any, type?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, vlanId?: number | null }> } | null };

export type RemoveLinkModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveLinkModelByIdMutation = { __typename?: 'mutation_root', delete_Link?: { __typename?: 'Link_mutation_response', affected_rows: number } | null };

export type RemoveLinkModelMutationVariables = Exact<{
  where: Link_Bool_Exp;
}>;


export type RemoveLinkModelMutation = { __typename?: 'mutation_root', delete_Link?: { __typename?: 'Link_mutation_response', affected_rows: number } | null };

export type QueryLinkTypeByIdQueryVariables = Exact<{
  linkTypeId: Scalars['uuid'];
}>;


export type QueryLinkTypeByIdQuery = { __typename?: 'query_root', LinkType_by_pk?: { __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null } | null };

export type QueryLinkTypeObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<LinkType_Select_Column> | LinkType_Select_Column>;
  where?: InputMaybe<LinkType_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By> | LinkType_Order_By>;
}>;


export type QueryLinkTypeObjectsQuery = { __typename?: 'query_root', LinkType: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> };

export type SubscribeToLinkTypeByIdSubscriptionVariables = Exact<{
  linkTypeId: Scalars['uuid'];
}>;


export type SubscribeToLinkTypeByIdSubscription = { __typename?: 'subscription_root', LinkType_by_pk?: { __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null } | null };

export type SubscribeToLinkTypeObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<LinkType_Select_Column> | LinkType_Select_Column>;
  where?: InputMaybe<LinkType_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<LinkType_Order_By> | LinkType_Order_By>;
}>;


export type SubscribeToLinkTypeObjectsSubscription = { __typename?: 'subscription_root', LinkType: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> };

export type InsertLinkTypeMutationVariables = Exact<{
  objects: Array<LinkType_Insert_Input> | LinkType_Insert_Input;
}>;


export type InsertLinkTypeMutation = { __typename?: 'mutation_root', insert_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> } | null };

export type InsertLinkTypeWithOnConflictMutationVariables = Exact<{
  objects: Array<LinkType_Insert_Input> | LinkType_Insert_Input;
  onConflict?: InputMaybe<LinkType_On_Conflict>;
}>;


export type InsertLinkTypeWithOnConflictMutation = { __typename?: 'mutation_root', insert_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> } | null };

export type UpdateLinkTypeByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<LinkType_Set_Input>;
}>;


export type UpdateLinkTypeByIdMutation = { __typename?: 'mutation_root', update_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> } | null };

export type UpdateLinkTypeMutationVariables = Exact<{
  set?: InputMaybe<LinkType_Set_Input>;
  where: LinkType_Bool_Exp;
}>;


export type UpdateLinkTypeMutation = { __typename?: 'mutation_root', update_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'LinkType', id: any, name?: string | null, isActive?: boolean | null, isAPN?: boolean | null }> } | null };

export type RemoveLinkTypeModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveLinkTypeModelByIdMutation = { __typename?: 'mutation_root', delete_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number } | null };

export type RemoveLinkTypeModelMutationVariables = Exact<{
  where: LinkType_Bool_Exp;
}>;


export type RemoveLinkTypeModelMutation = { __typename?: 'mutation_root', delete_LinkType?: { __typename?: 'LinkType_mutation_response', affected_rows: number } | null };

export type QueryMeshWanByIdQueryVariables = Exact<{
  meshWanId: Scalars['uuid'];
}>;


export type QueryMeshWanByIdQuery = { __typename?: 'query_root', MeshWan_by_pk?: { __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null } | null };

export type QueryMeshWanObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column> | MeshWan_Select_Column>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By> | MeshWan_Order_By>;
}>;


export type QueryMeshWanObjectsQuery = { __typename?: 'query_root', MeshWan: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> };

export type SubscribeToMeshWanByIdSubscriptionVariables = Exact<{
  meshWanId: Scalars['uuid'];
}>;


export type SubscribeToMeshWanByIdSubscription = { __typename?: 'subscription_root', MeshWan_by_pk?: { __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null } | null };

export type SubscribeToMeshWanObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<MeshWan_Select_Column> | MeshWan_Select_Column>;
  where?: InputMaybe<MeshWan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MeshWan_Order_By> | MeshWan_Order_By>;
}>;


export type SubscribeToMeshWanObjectsSubscription = { __typename?: 'subscription_root', MeshWan: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> };

export type InsertMeshWanMutationVariables = Exact<{
  objects: Array<MeshWan_Insert_Input> | MeshWan_Insert_Input;
}>;


export type InsertMeshWanMutation = { __typename?: 'mutation_root', insert_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> } | null };

export type InsertMeshWanWithOnConflictMutationVariables = Exact<{
  objects: Array<MeshWan_Insert_Input> | MeshWan_Insert_Input;
  onConflict?: InputMaybe<MeshWan_On_Conflict>;
}>;


export type InsertMeshWanWithOnConflictMutation = { __typename?: 'mutation_root', insert_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> } | null };

export type UpdateMeshWanByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<MeshWan_Set_Input>;
}>;


export type UpdateMeshWanByIdMutation = { __typename?: 'mutation_root', update_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> } | null };

export type UpdateMeshWanMutationVariables = Exact<{
  set?: InputMaybe<MeshWan_Set_Input>;
  where: MeshWan_Bool_Exp;
}>;


export type UpdateMeshWanMutation = { __typename?: 'mutation_root', update_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'MeshWan', id: any, name?: string | null, description?: string | null }> } | null };

export type RemoveMeshWanModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveMeshWanModelByIdMutation = { __typename?: 'mutation_root', delete_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number } | null };

export type RemoveMeshWanModelMutationVariables = Exact<{
  where: MeshWan_Bool_Exp;
}>;


export type RemoveMeshWanModelMutation = { __typename?: 'mutation_root', delete_MeshWan?: { __typename?: 'MeshWan_mutation_response', affected_rows: number } | null };

export type QueryMonitorByIdQueryVariables = Exact<{
  monitorId: Scalars['uuid'];
}>;


export type QueryMonitorByIdQuery = { __typename?: 'query_root', Monitor_by_pk?: { __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null } | null };

export type QueryMonitorObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Monitor_Select_Column> | Monitor_Select_Column>;
  where?: InputMaybe<Monitor_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By> | Monitor_Order_By>;
}>;


export type QueryMonitorObjectsQuery = { __typename?: 'query_root', Monitor: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> };

export type SubscribeToMonitorByIdSubscriptionVariables = Exact<{
  monitorId: Scalars['uuid'];
}>;


export type SubscribeToMonitorByIdSubscription = { __typename?: 'subscription_root', Monitor_by_pk?: { __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null } | null };

export type SubscribeToMonitorObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Monitor_Select_Column> | Monitor_Select_Column>;
  where?: InputMaybe<Monitor_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Monitor_Order_By> | Monitor_Order_By>;
}>;


export type SubscribeToMonitorObjectsSubscription = { __typename?: 'subscription_root', Monitor: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> };

export type InsertMonitorMutationVariables = Exact<{
  objects: Array<Monitor_Insert_Input> | Monitor_Insert_Input;
}>;


export type InsertMonitorMutation = { __typename?: 'mutation_root', insert_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> } | null };

export type InsertMonitorWithOnConflictMutationVariables = Exact<{
  objects: Array<Monitor_Insert_Input> | Monitor_Insert_Input;
  onConflict?: InputMaybe<Monitor_On_Conflict>;
}>;


export type InsertMonitorWithOnConflictMutation = { __typename?: 'mutation_root', insert_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> } | null };

export type UpdateMonitorByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Monitor_Set_Input>;
}>;


export type UpdateMonitorByIdMutation = { __typename?: 'mutation_root', update_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> } | null };

export type UpdateMonitorMutationVariables = Exact<{
  set?: InputMaybe<Monitor_Set_Input>;
  where: Monitor_Bool_Exp;
}>;


export type UpdateMonitorMutation = { __typename?: 'mutation_root', update_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Monitor', id: any, isActive?: boolean | null, isDefault?: boolean | null, logURI?: string | null, metricsURI?: string | null, name?: string | null, partnerId: any, password?: string | null, username?: string | null }> } | null };

export type RemoveMonitorModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveMonitorModelByIdMutation = { __typename?: 'mutation_root', delete_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number } | null };

export type RemoveMonitorModelMutationVariables = Exact<{
  where: Monitor_Bool_Exp;
}>;


export type RemoveMonitorModelMutation = { __typename?: 'mutation_root', delete_Monitor?: { __typename?: 'Monitor_mutation_response', affected_rows: number } | null };

export type QueryProfileByIdQueryVariables = Exact<{
  profileId: Scalars['uuid'];
}>;


export type QueryProfileByIdQuery = { __typename?: 'query_root', Profile_by_pk?: { __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null } | null };

export type QueryProfileObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Profile_Select_Column> | Profile_Select_Column>;
  where?: InputMaybe<Profile_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By> | Profile_Order_By>;
}>;


export type QueryProfileObjectsQuery = { __typename?: 'query_root', Profile: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> };

export type SubscribeToProfileByIdSubscriptionVariables = Exact<{
  profileId: Scalars['uuid'];
}>;


export type SubscribeToProfileByIdSubscription = { __typename?: 'subscription_root', Profile_by_pk?: { __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null } | null };

export type SubscribeToProfileObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Profile_Select_Column> | Profile_Select_Column>;
  where?: InputMaybe<Profile_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By> | Profile_Order_By>;
}>;


export type SubscribeToProfileObjectsSubscription = { __typename?: 'subscription_root', Profile: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> };

export type InsertProfileMutationVariables = Exact<{
  objects: Array<Profile_Insert_Input> | Profile_Insert_Input;
}>;


export type InsertProfileMutation = { __typename?: 'mutation_root', insert_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> } | null };

export type InsertProfileWithOnConflictMutationVariables = Exact<{
  objects: Array<Profile_Insert_Input> | Profile_Insert_Input;
  onConflict?: InputMaybe<Profile_On_Conflict>;
}>;


export type InsertProfileWithOnConflictMutation = { __typename?: 'mutation_root', insert_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> } | null };

export type UpdateProfileByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Profile_Set_Input>;
}>;


export type UpdateProfileByIdMutation = { __typename?: 'mutation_root', update_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> } | null };

export type UpdateProfileMutationVariables = Exact<{
  set?: InputMaybe<Profile_Set_Input>;
  where: Profile_Bool_Exp;
}>;


export type UpdateProfileMutation = { __typename?: 'mutation_root', update_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Profile', id: any, description?: string | null, isUniversal?: boolean | null, name?: string | null, partnerId: any, url?: string | null }> } | null };

export type RemoveProfileModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveProfileModelByIdMutation = { __typename?: 'mutation_root', delete_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number } | null };

export type RemoveProfileModelMutationVariables = Exact<{
  where: Profile_Bool_Exp;
}>;


export type RemoveProfileModelMutation = { __typename?: 'mutation_root', delete_Profile?: { __typename?: 'Profile_mutation_response', affected_rows: number } | null };

export type QueryPublicIpByIdQueryVariables = Exact<{
  publicIpId: Scalars['uuid'];
}>;


export type QueryPublicIpByIdQuery = { __typename?: 'query_root', PublicIp_by_pk?: { __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any } | null };

export type QueryPublicIpObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column> | PublicIp_Select_Column>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By> | PublicIp_Order_By>;
}>;


export type QueryPublicIpObjectsQuery = { __typename?: 'query_root', PublicIp: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> };

export type SubscribeToPublicIpByIdSubscriptionVariables = Exact<{
  publicIpId: Scalars['uuid'];
}>;


export type SubscribeToPublicIpByIdSubscription = { __typename?: 'subscription_root', PublicIp_by_pk?: { __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any } | null };

export type SubscribeToPublicIpObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<PublicIp_Select_Column> | PublicIp_Select_Column>;
  where?: InputMaybe<PublicIp_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PublicIp_Order_By> | PublicIp_Order_By>;
}>;


export type SubscribeToPublicIpObjectsSubscription = { __typename?: 'subscription_root', PublicIp: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> };

export type InsertPublicIpMutationVariables = Exact<{
  objects: Array<PublicIp_Insert_Input> | PublicIp_Insert_Input;
}>;


export type InsertPublicIpMutation = { __typename?: 'mutation_root', insert_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type InsertPublicIpWithOnConflictMutationVariables = Exact<{
  objects: Array<PublicIp_Insert_Input> | PublicIp_Insert_Input;
  onConflict?: InputMaybe<PublicIp_On_Conflict>;
}>;


export type InsertPublicIpWithOnConflictMutation = { __typename?: 'mutation_root', insert_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type UpdatePublicIpByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<PublicIp_Set_Input>;
}>;


export type UpdatePublicIpByIdMutation = { __typename?: 'mutation_root', update_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type UpdatePublicIpMutationVariables = Exact<{
  set?: InputMaybe<PublicIp_Set_Input>;
  where: PublicIp_Bool_Exp;
}>;


export type UpdatePublicIpMutation = { __typename?: 'mutation_root', update_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type RemovePublicIpModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemovePublicIpModelByIdMutation = { __typename?: 'mutation_root', delete_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number } | null };

export type RemovePublicIpModelMutationVariables = Exact<{
  where: PublicIp_Bool_Exp;
}>;


export type RemovePublicIpModelMutation = { __typename?: 'mutation_root', delete_PublicIp?: { __typename?: 'PublicIp_mutation_response', affected_rows: number } | null };

export type QueryServerByIdQueryVariables = Exact<{
  serverId: Scalars['uuid'];
}>;


export type QueryServerByIdQuery = { __typename?: 'query_root', Server_by_pk?: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type QueryServerObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Server_Select_Column> | Server_Select_Column>;
  where?: InputMaybe<Server_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By> | Server_Order_By>;
}>;


export type QueryServerObjectsQuery = { __typename?: 'query_root', Server: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> };

export type SubscribeToServerByIdSubscriptionVariables = Exact<{
  serverId: Scalars['uuid'];
}>;


export type SubscribeToServerByIdSubscription = { __typename?: 'subscription_root', Server_by_pk?: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> } | null };

export type SubscribeToServerObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Server_Select_Column> | Server_Select_Column>;
  where?: InputMaybe<Server_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Server_Order_By> | Server_Order_By>;
}>;


export type SubscribeToServerObjectsSubscription = { __typename?: 'subscription_root', Server: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> };

export type InsertServerMutationVariables = Exact<{
  objects: Array<Server_Insert_Input> | Server_Insert_Input;
}>;


export type InsertServerMutation = { __typename?: 'mutation_root', insert_Server?: { __typename?: 'Server_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> } | null };

export type InsertServerWithOnConflictMutationVariables = Exact<{
  objects: Array<Server_Insert_Input> | Server_Insert_Input;
  onConflict?: InputMaybe<Server_On_Conflict>;
}>;


export type InsertServerWithOnConflictMutation = { __typename?: 'mutation_root', insert_Server?: { __typename?: 'Server_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> } | null };

export type UpdateServerByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Server_Set_Input>;
}>;


export type UpdateServerByIdMutation = { __typename?: 'mutation_root', update_Server?: { __typename?: 'Server_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> } | null };

export type UpdateServerMutationVariables = Exact<{
  set?: InputMaybe<Server_Set_Input>;
  where: Server_Bool_Exp;
}>;


export type UpdateServerMutation = { __typename?: 'mutation_root', update_Server?: { __typename?: 'Server_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, monitorEndpoint?: string | null, monitorId?: any | null, name?: string | null, osVersion?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, Gateway: { __typename?: 'Gateway', id: any, name?: string | null, description?: string | null, region?: string | null, country?: string | null, timezone?: string | null, state?: string | null, isVps?: boolean | null, vpsProvider?: string | null, Servers: Array<{ __typename?: 'Server', id: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null, name?: string | null, osVersion?: string | null, gatewayId: any, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }>, Tunnels: Array<{ __typename?: 'Tunnel', id: any }> }> }, PublicIps: Array<{ __typename?: 'PublicIp', id: any, address?: string | null, ip4Cidr?: string | null, isV6?: boolean | null, serverId: any }> }> } | null };

export type RemoveServerModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveServerModelByIdMutation = { __typename?: 'mutation_root', delete_Server?: { __typename?: 'Server_mutation_response', affected_rows: number } | null };

export type RemoveServerModelMutationVariables = Exact<{
  where: Server_Bool_Exp;
}>;


export type RemoveServerModelMutation = { __typename?: 'mutation_root', delete_Server?: { __typename?: 'Server_mutation_response', affected_rows: number } | null };

export type QueryServerBridgeObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column> | ServerBridge_Select_Column>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By> | ServerBridge_Order_By>;
}>;


export type QueryServerBridgeObjectsQuery = { __typename?: 'query_root', ServerBridge: Array<{ __typename?: 'ServerBridge', gatewayBridgeId: any, serverId: any }> };

export type SubscribeToServerBridgeObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<ServerBridge_Select_Column> | ServerBridge_Select_Column>;
  where?: InputMaybe<ServerBridge_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ServerBridge_Order_By> | ServerBridge_Order_By>;
}>;


export type SubscribeToServerBridgeObjectsSubscription = { __typename?: 'subscription_root', ServerBridge: Array<{ __typename?: 'ServerBridge', gatewayBridgeId: any, serverId: any }> };

export type QuerySiteByIdQueryVariables = Exact<{
  siteId: Scalars['uuid'];
}>;


export type QuerySiteByIdQuery = { __typename?: 'query_root', Site_by_pk?: { __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null } | null };

export type QuerySiteObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Site_Select_Column> | Site_Select_Column>;
  where?: InputMaybe<Site_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By> | Site_Order_By>;
}>;


export type QuerySiteObjectsQuery = { __typename?: 'query_root', Site: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> };

export type SubscribeToSiteByIdSubscriptionVariables = Exact<{
  siteId: Scalars['uuid'];
}>;


export type SubscribeToSiteByIdSubscription = { __typename?: 'subscription_root', Site_by_pk?: { __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null } | null };

export type SubscribeToSiteObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Site_Select_Column> | Site_Select_Column>;
  where?: InputMaybe<Site_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By> | Site_Order_By>;
}>;


export type SubscribeToSiteObjectsSubscription = { __typename?: 'subscription_root', Site: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> };

export type InsertSiteMutationVariables = Exact<{
  objects: Array<Site_Insert_Input> | Site_Insert_Input;
}>;


export type InsertSiteMutation = { __typename?: 'mutation_root', insert_Site?: { __typename?: 'Site_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> } | null };

export type InsertSiteWithOnConflictMutationVariables = Exact<{
  objects: Array<Site_Insert_Input> | Site_Insert_Input;
  onConflict?: InputMaybe<Site_On_Conflict>;
}>;


export type InsertSiteWithOnConflictMutation = { __typename?: 'mutation_root', insert_Site?: { __typename?: 'Site_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> } | null };

export type UpdateSiteByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Site_Set_Input>;
}>;


export type UpdateSiteByIdMutation = { __typename?: 'mutation_root', update_Site?: { __typename?: 'Site_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> } | null };

export type UpdateSiteMutationVariables = Exact<{
  set?: InputMaybe<Site_Set_Input>;
  where: Site_Bool_Exp;
}>;


export type UpdateSiteMutation = { __typename?: 'mutation_root', update_Site?: { __typename?: 'Site_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Site', id: any, accessibleIps?: string | null, address1?: string | null, address2?: string | null, city?: string | null, clientCompanyId: any, country?: string | null, ipAccessLevel: string, isServerless: boolean, meshWanId?: any | null, monitorEndpoint?: string | null, monitorId?: any | null, osVersion?: string | null, postalCode?: string | null, rebootRequest?: any | null, softwareVersion?: string | null, state?: string | null, wanId?: any | null, ClientCompany: { __typename?: 'ClientCompany', id: any, name?: string | null, industry?: string | null, notes?: string | null, Quicklinks: Array<{ __typename?: 'Quicklink', id: any, link?: string | null, description?: string | null }> }, Tunnels: Array<{ __typename?: 'Tunnel', id: any, isPrimary: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, shouldReorderBuffer: boolean, reorderBufferTime?: number | null, status?: string | null, timeout?: string | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null, serverId: any, autoMTU: boolean, portRangeStart: any, portRangeEnd: any, lbAlgo?: string | null, flowlet?: boolean | null, Server: { __typename?: 'Server', id: any, gatewayId: any, ip4Address?: string | null, ip4Cidr?: string | null, ip4Router?: string | null }, Links: Array<{ __typename?: 'Link', id: any, type?: string | null, carrierName?: string | null, isDHCP?: boolean | null, staticIp?: string | null, staticDnsIp?: string | null, staticGatewayIp?: string | null, cpeBindIp: string, dataLimit?: any | null, dataLimitReset?: any | null, dataLimitUsed?: any | null, downloadThroughput?: any | null, downloadThroughputCap?: any | null, interfaceName?: string | null, isCapped?: boolean | null, isCapEnabled?: boolean | null, isEnabled?: boolean | null, isEncrypted?: boolean | null, isMetered?: boolean | null, isPassthrough?: boolean | null, isStandby?: boolean | null, name?: string | null, notes?: string | null, serverBindIp?: string | null, serverPort?: number | null, state?: string | null, uploadThroughput?: any | null, uploadThroughputCap?: any | null, modemAPN?: string | null, isPPPoE?: boolean | null, isWWAN?: boolean | null, pppoeUsername?: string | null, pppoePassword?: string | null }> }>, SiteLans: Array<{ __typename?: 'SiteLan', id: any, lanSegmentIp4?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer2?: string | null, dnsServer1?: string | null, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, isDMZ: boolean, ip4DMZ?: string | null, isAP: boolean, interfaceName: string, apMode: any, apSSID?: string | null, apCountryCode?: string | null, apChannel?: number | null, apPassword?: string | null, ap5SSID?: string | null, ap5Channel?: number | null, ap5Password?: string | null }>, SiteRoutes: Array<{ __typename?: 'SiteRoute', id: any, subnet?: any | null, routerIP?: any | null, routerInterface?: string | null, metric?: number | null, isActive?: boolean | null, isInbound?: boolean | null }>, SiteContacts: Array<{ __typename?: 'SiteContact', id: any, label?: string | null, lastName?: string | null, phone?: string | null, ext?: string | null, email?: string | null, emailAlert: boolean, firstName?: string | null }>, Wan?: { __typename?: 'Wan', id: any, name: string } | null }> } | null };

export type RemoveSiteModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveSiteModelByIdMutation = { __typename?: 'mutation_root', delete_Site?: { __typename?: 'Site_mutation_response', affected_rows: number } | null };

export type RemoveSiteModelMutationVariables = Exact<{
  where: Site_Bool_Exp;
}>;


export type RemoveSiteModelMutation = { __typename?: 'mutation_root', delete_Site?: { __typename?: 'Site_mutation_response', affected_rows: number } | null };

export type QuerySiteContactByIdQueryVariables = Exact<{
  siteContactId: Scalars['uuid'];
}>;


export type QuerySiteContactByIdQuery = { __typename?: 'query_root', SiteContact_by_pk?: { __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any } | null };

export type QuerySiteContactObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column> | SiteContact_Select_Column>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By> | SiteContact_Order_By>;
}>;


export type QuerySiteContactObjectsQuery = { __typename?: 'query_root', SiteContact: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> };

export type SubscribeToSiteContactByIdSubscriptionVariables = Exact<{
  siteContactId: Scalars['uuid'];
}>;


export type SubscribeToSiteContactByIdSubscription = { __typename?: 'subscription_root', SiteContact_by_pk?: { __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any } | null };

export type SubscribeToSiteContactObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteContact_Select_Column> | SiteContact_Select_Column>;
  where?: InputMaybe<SiteContact_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteContact_Order_By> | SiteContact_Order_By>;
}>;


export type SubscribeToSiteContactObjectsSubscription = { __typename?: 'subscription_root', SiteContact: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> };

export type InsertSiteContactMutationVariables = Exact<{
  objects: Array<SiteContact_Insert_Input> | SiteContact_Insert_Input;
}>;


export type InsertSiteContactMutation = { __typename?: 'mutation_root', insert_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> } | null };

export type InsertSiteContactWithOnConflictMutationVariables = Exact<{
  objects: Array<SiteContact_Insert_Input> | SiteContact_Insert_Input;
  onConflict?: InputMaybe<SiteContact_On_Conflict>;
}>;


export type InsertSiteContactWithOnConflictMutation = { __typename?: 'mutation_root', insert_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> } | null };

export type UpdateSiteContactByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<SiteContact_Set_Input>;
}>;


export type UpdateSiteContactByIdMutation = { __typename?: 'mutation_root', update_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> } | null };

export type UpdateSiteContactMutationVariables = Exact<{
  set?: InputMaybe<SiteContact_Set_Input>;
  where: SiteContact_Bool_Exp;
}>;


export type UpdateSiteContactMutation = { __typename?: 'mutation_root', update_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteContact', id: any, email?: string | null, emailAlert: boolean, ext?: string | null, firstName?: string | null, label?: string | null, lastName?: string | null, phone?: string | null, siteId: any }> } | null };

export type RemoveSiteContactModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveSiteContactModelByIdMutation = { __typename?: 'mutation_root', delete_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number } | null };

export type RemoveSiteContactModelMutationVariables = Exact<{
  where: SiteContact_Bool_Exp;
}>;


export type RemoveSiteContactModelMutation = { __typename?: 'mutation_root', delete_SiteContact?: { __typename?: 'SiteContact_mutation_response', affected_rows: number } | null };

export type QuerySiteLanByIdQueryVariables = Exact<{
  siteLanId: Scalars['uuid'];
}>;


export type QuerySiteLanByIdQuery = { __typename?: 'query_root', SiteLan_by_pk?: { __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null } | null };

export type QuerySiteLanObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column> | SiteLan_Select_Column>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By> | SiteLan_Order_By>;
}>;


export type QuerySiteLanObjectsQuery = { __typename?: 'query_root', SiteLan: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> };

export type SubscribeToSiteLanByIdSubscriptionVariables = Exact<{
  siteLanId: Scalars['uuid'];
}>;


export type SubscribeToSiteLanByIdSubscription = { __typename?: 'subscription_root', SiteLan_by_pk?: { __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null } | null };

export type SubscribeToSiteLanObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteLan_Select_Column> | SiteLan_Select_Column>;
  where?: InputMaybe<SiteLan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteLan_Order_By> | SiteLan_Order_By>;
}>;


export type SubscribeToSiteLanObjectsSubscription = { __typename?: 'subscription_root', SiteLan: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> };

export type InsertSiteLanMutationVariables = Exact<{
  objects: Array<SiteLan_Insert_Input> | SiteLan_Insert_Input;
}>;


export type InsertSiteLanMutation = { __typename?: 'mutation_root', insert_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> } | null };

export type InsertSiteLanWithOnConflictMutationVariables = Exact<{
  objects: Array<SiteLan_Insert_Input> | SiteLan_Insert_Input;
  onConflict?: InputMaybe<SiteLan_On_Conflict>;
}>;


export type InsertSiteLanWithOnConflictMutation = { __typename?: 'mutation_root', insert_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> } | null };

export type UpdateSiteLanByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<SiteLan_Set_Input>;
}>;


export type UpdateSiteLanByIdMutation = { __typename?: 'mutation_root', update_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> } | null };

export type UpdateSiteLanMutationVariables = Exact<{
  set?: InputMaybe<SiteLan_Set_Input>;
  where: SiteLan_Bool_Exp;
}>;


export type UpdateSiteLanMutation = { __typename?: 'mutation_root', update_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteLan', id: any, ap5Channel?: number | null, ap5Password?: string | null, ap5SSID?: string | null, apChannel?: number | null, apCountryCode?: string | null, apMode: any, apPassword?: string | null, apSSID?: string | null, dhcpDefaultLease?: string | null, dhcpMaxLease?: string | null, dhcpRangeEnd?: string | null, dhcpRangeStart?: string | null, dnsServer1?: string | null, dnsServer2?: string | null, interfaceName: string, ip4DMZ?: string | null, isAP: boolean, isDMZ: boolean, isDhcpRequired?: boolean | null, lanCidrIp4?: string | null, lanSegmentIp4?: string | null, siteId: any, vlanId?: number | null }> } | null };

export type RemoveSiteLanModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveSiteLanModelByIdMutation = { __typename?: 'mutation_root', delete_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number } | null };

export type RemoveSiteLanModelMutationVariables = Exact<{
  where: SiteLan_Bool_Exp;
}>;


export type RemoveSiteLanModelMutation = { __typename?: 'mutation_root', delete_SiteLan?: { __typename?: 'SiteLan_mutation_response', affected_rows: number } | null };

export type QuerySiteRouteByIdQueryVariables = Exact<{
  siteRouteId: Scalars['uuid'];
}>;


export type QuerySiteRouteByIdQuery = { __typename?: 'query_root', SiteRoute_by_pk?: { __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null } | null };

export type QuerySiteRouteObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column> | SiteRoute_Select_Column>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By> | SiteRoute_Order_By>;
}>;


export type QuerySiteRouteObjectsQuery = { __typename?: 'query_root', SiteRoute: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> };

export type SubscribeToSiteRouteByIdSubscriptionVariables = Exact<{
  siteRouteId: Scalars['uuid'];
}>;


export type SubscribeToSiteRouteByIdSubscription = { __typename?: 'subscription_root', SiteRoute_by_pk?: { __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null } | null };

export type SubscribeToSiteRouteObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<SiteRoute_Select_Column> | SiteRoute_Select_Column>;
  where?: InputMaybe<SiteRoute_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SiteRoute_Order_By> | SiteRoute_Order_By>;
}>;


export type SubscribeToSiteRouteObjectsSubscription = { __typename?: 'subscription_root', SiteRoute: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> };

export type InsertSiteRouteMutationVariables = Exact<{
  objects: Array<SiteRoute_Insert_Input> | SiteRoute_Insert_Input;
}>;


export type InsertSiteRouteMutation = { __typename?: 'mutation_root', insert_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> } | null };

export type InsertSiteRouteWithOnConflictMutationVariables = Exact<{
  objects: Array<SiteRoute_Insert_Input> | SiteRoute_Insert_Input;
  onConflict?: InputMaybe<SiteRoute_On_Conflict>;
}>;


export type InsertSiteRouteWithOnConflictMutation = { __typename?: 'mutation_root', insert_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> } | null };

export type UpdateSiteRouteByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<SiteRoute_Set_Input>;
}>;


export type UpdateSiteRouteByIdMutation = { __typename?: 'mutation_root', update_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> } | null };

export type UpdateSiteRouteMutationVariables = Exact<{
  set?: InputMaybe<SiteRoute_Set_Input>;
  where: SiteRoute_Bool_Exp;
}>;


export type UpdateSiteRouteMutation = { __typename?: 'mutation_root', update_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'SiteRoute', id: any, isActive?: boolean | null, isInbound?: boolean | null, metric?: number | null, routerIP?: any | null, routerInterface?: string | null, siteId: any, subnet?: any | null }> } | null };

export type RemoveSiteRouteModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveSiteRouteModelByIdMutation = { __typename?: 'mutation_root', delete_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number } | null };

export type RemoveSiteRouteModelMutationVariables = Exact<{
  where: SiteRoute_Bool_Exp;
}>;


export type RemoveSiteRouteModelMutation = { __typename?: 'mutation_root', delete_SiteRoute?: { __typename?: 'SiteRoute_mutation_response', affected_rows: number } | null };

export type QueryTunnelByIdQueryVariables = Exact<{
  tunnelId: Scalars['uuid'];
}>;


export type QueryTunnelByIdQuery = { __typename?: 'query_root', Tunnel_by_pk?: { __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null } | null };

export type QueryTunnelObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column> | Tunnel_Select_Column>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By> | Tunnel_Order_By>;
}>;


export type QueryTunnelObjectsQuery = { __typename?: 'query_root', Tunnel: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> };

export type SubscribeToTunnelByIdSubscriptionVariables = Exact<{
  tunnelId: Scalars['uuid'];
}>;


export type SubscribeToTunnelByIdSubscription = { __typename?: 'subscription_root', Tunnel_by_pk?: { __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null } | null };

export type SubscribeToTunnelObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Tunnel_Select_Column> | Tunnel_Select_Column>;
  where?: InputMaybe<Tunnel_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tunnel_Order_By> | Tunnel_Order_By>;
}>;


export type SubscribeToTunnelObjectsSubscription = { __typename?: 'subscription_root', Tunnel: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> };

export type InsertTunnelMutationVariables = Exact<{
  objects: Array<Tunnel_Insert_Input> | Tunnel_Insert_Input;
}>;


export type InsertTunnelMutation = { __typename?: 'mutation_root', insert_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> } | null };

export type InsertTunnelWithOnConflictMutationVariables = Exact<{
  objects: Array<Tunnel_Insert_Input> | Tunnel_Insert_Input;
  onConflict?: InputMaybe<Tunnel_On_Conflict>;
}>;


export type InsertTunnelWithOnConflictMutation = { __typename?: 'mutation_root', insert_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> } | null };

export type UpdateTunnelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Tunnel_Set_Input>;
}>;


export type UpdateTunnelByIdMutation = { __typename?: 'mutation_root', update_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> } | null };

export type UpdateTunnelMutationVariables = Exact<{
  set?: InputMaybe<Tunnel_Set_Input>;
  where: Tunnel_Bool_Exp;
}>;


export type UpdateTunnelMutation = { __typename?: 'mutation_root', update_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Tunnel', id: any, autoMTU: boolean, cidr?: string | null, downloadCap?: string | null, hasTrafficManagement?: boolean | null, interfaceName?: string | null, isCapEnabled?: boolean | null, isClearTextData: boolean, isPrimary: boolean, isQOSEnabled?: boolean | null, lossTolerance?: string | null, mtu?: string | null, portRangeEnd: any, portRangeStart: any, lbAlgo?: string | null, flowlet?: boolean | null, reorderBufferTime?: number | null, serverId: any, shouldReorderBuffer: boolean, siteId: any, status?: string | null, timeout?: string | null, tunnelAddressPairSeed?: number | null, tunnelPassword?: string | null, tuntap?: string | null, uploadCap?: string | null }> } | null };

export type RemoveTunnelModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveTunnelModelByIdMutation = { __typename?: 'mutation_root', delete_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number } | null };

export type RemoveTunnelModelMutationVariables = Exact<{
  where: Tunnel_Bool_Exp;
}>;


export type RemoveTunnelModelMutation = { __typename?: 'mutation_root', delete_Tunnel?: { __typename?: 'Tunnel_mutation_response', affected_rows: number } | null };

export type QueryTunnelProfileByIdQueryVariables = Exact<{
  tunnelProfileId: Scalars['uuid'];
}>;


export type QueryTunnelProfileByIdQuery = { __typename?: 'query_root', TunnelProfile_by_pk?: { __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any } | null };

export type QueryTunnelProfileObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column> | TunnelProfile_Select_Column>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By> | TunnelProfile_Order_By>;
}>;


export type QueryTunnelProfileObjectsQuery = { __typename?: 'query_root', TunnelProfile: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> };

export type SubscribeToTunnelProfileByIdSubscriptionVariables = Exact<{
  tunnelProfileId: Scalars['uuid'];
}>;


export type SubscribeToTunnelProfileByIdSubscription = { __typename?: 'subscription_root', TunnelProfile_by_pk?: { __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any } | null };

export type SubscribeToTunnelProfileObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<TunnelProfile_Select_Column> | TunnelProfile_Select_Column>;
  where?: InputMaybe<TunnelProfile_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TunnelProfile_Order_By> | TunnelProfile_Order_By>;
}>;


export type SubscribeToTunnelProfileObjectsSubscription = { __typename?: 'subscription_root', TunnelProfile: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> };

export type InsertTunnelProfileMutationVariables = Exact<{
  objects: Array<TunnelProfile_Insert_Input> | TunnelProfile_Insert_Input;
}>;


export type InsertTunnelProfileMutation = { __typename?: 'mutation_root', insert_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> } | null };

export type InsertTunnelProfileWithOnConflictMutationVariables = Exact<{
  objects: Array<TunnelProfile_Insert_Input> | TunnelProfile_Insert_Input;
  onConflict?: InputMaybe<TunnelProfile_On_Conflict>;
}>;


export type InsertTunnelProfileWithOnConflictMutation = { __typename?: 'mutation_root', insert_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> } | null };

export type UpdateTunnelProfileByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<TunnelProfile_Set_Input>;
}>;


export type UpdateTunnelProfileByIdMutation = { __typename?: 'mutation_root', update_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> } | null };

export type UpdateTunnelProfileMutationVariables = Exact<{
  set?: InputMaybe<TunnelProfile_Set_Input>;
  where: TunnelProfile_Bool_Exp;
}>;


export type UpdateTunnelProfileMutation = { __typename?: 'mutation_root', update_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'TunnelProfile', id: any, profileId: any, tunnelId: any }> } | null };

export type RemoveTunnelProfileModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveTunnelProfileModelByIdMutation = { __typename?: 'mutation_root', delete_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number } | null };

export type RemoveTunnelProfileModelMutationVariables = Exact<{
  where: TunnelProfile_Bool_Exp;
}>;


export type RemoveTunnelProfileModelMutation = { __typename?: 'mutation_root', delete_TunnelProfile?: { __typename?: 'TunnelProfile_mutation_response', affected_rows: number } | null };

export type QueryUserByIdQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type QueryUserByIdQuery = { __typename?: 'query_root', User_by_pk?: { __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any } | null };

export type QueryUserObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<User_Select_Column> | User_Select_Column>;
  where?: InputMaybe<User_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By> | User_Order_By>;
}>;


export type QueryUserObjectsQuery = { __typename?: 'query_root', User: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> };

export type SubscribeToUserByIdSubscriptionVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type SubscribeToUserByIdSubscription = { __typename?: 'subscription_root', User_by_pk?: { __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any } | null };

export type SubscribeToUserObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<User_Select_Column> | User_Select_Column>;
  where?: InputMaybe<User_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By> | User_Order_By>;
}>;


export type SubscribeToUserObjectsSubscription = { __typename?: 'subscription_root', User: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> };

export type InsertUserMutationVariables = Exact<{
  objects: Array<User_Insert_Input> | User_Insert_Input;
}>;


export type InsertUserMutation = { __typename?: 'mutation_root', insert_User?: { __typename?: 'User_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> } | null };

export type InsertUserWithOnConflictMutationVariables = Exact<{
  objects: Array<User_Insert_Input> | User_Insert_Input;
  onConflict?: InputMaybe<User_On_Conflict>;
}>;


export type InsertUserWithOnConflictMutation = { __typename?: 'mutation_root', insert_User?: { __typename?: 'User_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> } | null };

export type UpdateUserByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<User_Set_Input>;
}>;


export type UpdateUserByIdMutation = { __typename?: 'mutation_root', update_User?: { __typename?: 'User_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> } | null };

export type UpdateUserMutationVariables = Exact<{
  set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_User?: { __typename?: 'User_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'User', id: any, accountStatus?: string | null, email: string, emailAlert: boolean, firstName?: string | null, fromUserId?: string | null, isInvited?: boolean | null, lastName?: string | null, login_at?: any | null, partnerId: any, phone?: string | null, userRoleId: any }> } | null };

export type RemoveUserModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveUserModelByIdMutation = { __typename?: 'mutation_root', delete_User?: { __typename?: 'User_mutation_response', affected_rows: number } | null };

export type RemoveUserModelMutationVariables = Exact<{
  where: User_Bool_Exp;
}>;


export type RemoveUserModelMutation = { __typename?: 'mutation_root', delete_User?: { __typename?: 'User_mutation_response', affected_rows: number } | null };

export type QueryUserHistoryByIdQueryVariables = Exact<{
  userHistoryId: Scalars['uuid'];
}>;


export type QueryUserHistoryByIdQuery = { __typename?: 'query_root', UserHistory_by_pk?: { __typename?: 'UserHistory', id: any, status?: string | null, userId: any } | null };

export type QueryUserHistoryObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column> | UserHistory_Select_Column>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By> | UserHistory_Order_By>;
}>;


export type QueryUserHistoryObjectsQuery = { __typename?: 'query_root', UserHistory: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> };

export type SubscribeToUserHistoryByIdSubscriptionVariables = Exact<{
  userHistoryId: Scalars['uuid'];
}>;


export type SubscribeToUserHistoryByIdSubscription = { __typename?: 'subscription_root', UserHistory_by_pk?: { __typename?: 'UserHistory', id: any, status?: string | null, userId: any } | null };

export type SubscribeToUserHistoryObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<UserHistory_Select_Column> | UserHistory_Select_Column>;
  where?: InputMaybe<UserHistory_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserHistory_Order_By> | UserHistory_Order_By>;
}>;


export type SubscribeToUserHistoryObjectsSubscription = { __typename?: 'subscription_root', UserHistory: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> };

export type InsertUserHistoryMutationVariables = Exact<{
  objects: Array<UserHistory_Insert_Input> | UserHistory_Insert_Input;
}>;


export type InsertUserHistoryMutation = { __typename?: 'mutation_root', insert_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> } | null };

export type InsertUserHistoryWithOnConflictMutationVariables = Exact<{
  objects: Array<UserHistory_Insert_Input> | UserHistory_Insert_Input;
  onConflict?: InputMaybe<UserHistory_On_Conflict>;
}>;


export type InsertUserHistoryWithOnConflictMutation = { __typename?: 'mutation_root', insert_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> } | null };

export type UpdateUserHistoryByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<UserHistory_Set_Input>;
}>;


export type UpdateUserHistoryByIdMutation = { __typename?: 'mutation_root', update_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> } | null };

export type UpdateUserHistoryMutationVariables = Exact<{
  set?: InputMaybe<UserHistory_Set_Input>;
  where: UserHistory_Bool_Exp;
}>;


export type UpdateUserHistoryMutation = { __typename?: 'mutation_root', update_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserHistory', id: any, status?: string | null, userId: any }> } | null };

export type RemoveUserHistoryModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveUserHistoryModelByIdMutation = { __typename?: 'mutation_root', delete_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number } | null };

export type RemoveUserHistoryModelMutationVariables = Exact<{
  where: UserHistory_Bool_Exp;
}>;


export type RemoveUserHistoryModelMutation = { __typename?: 'mutation_root', delete_UserHistory?: { __typename?: 'UserHistory_mutation_response', affected_rows: number } | null };

export type QueryUserRoleByIdQueryVariables = Exact<{
  userRoleId: Scalars['uuid'];
}>;


export type QueryUserRoleByIdQuery = { __typename?: 'query_root', UserRole_by_pk?: { __typename?: 'UserRole', id: any, roleName?: string | null } | null };

export type QueryUserRoleObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<UserRole_Select_Column> | UserRole_Select_Column>;
  where?: InputMaybe<UserRole_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By> | UserRole_Order_By>;
}>;


export type QueryUserRoleObjectsQuery = { __typename?: 'query_root', UserRole: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> };

export type SubscribeToUserRoleByIdSubscriptionVariables = Exact<{
  userRoleId: Scalars['uuid'];
}>;


export type SubscribeToUserRoleByIdSubscription = { __typename?: 'subscription_root', UserRole_by_pk?: { __typename?: 'UserRole', id: any, roleName?: string | null } | null };

export type SubscribeToUserRoleObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<UserRole_Select_Column> | UserRole_Select_Column>;
  where?: InputMaybe<UserRole_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRole_Order_By> | UserRole_Order_By>;
}>;


export type SubscribeToUserRoleObjectsSubscription = { __typename?: 'subscription_root', UserRole: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> };

export type InsertUserRoleMutationVariables = Exact<{
  objects: Array<UserRole_Insert_Input> | UserRole_Insert_Input;
}>;


export type InsertUserRoleMutation = { __typename?: 'mutation_root', insert_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> } | null };

export type InsertUserRoleWithOnConflictMutationVariables = Exact<{
  objects: Array<UserRole_Insert_Input> | UserRole_Insert_Input;
  onConflict?: InputMaybe<UserRole_On_Conflict>;
}>;


export type InsertUserRoleWithOnConflictMutation = { __typename?: 'mutation_root', insert_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> } | null };

export type UpdateUserRoleByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<UserRole_Set_Input>;
}>;


export type UpdateUserRoleByIdMutation = { __typename?: 'mutation_root', update_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> } | null };

export type UpdateUserRoleMutationVariables = Exact<{
  set?: InputMaybe<UserRole_Set_Input>;
  where: UserRole_Bool_Exp;
}>;


export type UpdateUserRoleMutation = { __typename?: 'mutation_root', update_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'UserRole', id: any, roleName?: string | null }> } | null };

export type RemoveUserRoleModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveUserRoleModelByIdMutation = { __typename?: 'mutation_root', delete_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number } | null };

export type RemoveUserRoleModelMutationVariables = Exact<{
  where: UserRole_Bool_Exp;
}>;


export type RemoveUserRoleModelMutation = { __typename?: 'mutation_root', delete_UserRole?: { __typename?: 'UserRole_mutation_response', affected_rows: number } | null };

export type QueryWanByIdQueryVariables = Exact<{
  wanId: Scalars['uuid'];
}>;


export type QueryWanByIdQuery = { __typename?: 'query_root', Wan_by_pk?: { __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null } | null };

export type QueryWanObjectsQueryVariables = Exact<{
  distinct_on?: InputMaybe<Array<Wan_Select_Column> | Wan_Select_Column>;
  where?: InputMaybe<Wan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By> | Wan_Order_By>;
}>;


export type QueryWanObjectsQuery = { __typename?: 'query_root', Wan: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> };

export type SubscribeToWanByIdSubscriptionVariables = Exact<{
  wanId: Scalars['uuid'];
}>;


export type SubscribeToWanByIdSubscription = { __typename?: 'subscription_root', Wan_by_pk?: { __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null } | null };

export type SubscribeToWanObjectsSubscriptionVariables = Exact<{
  distinct_on?: InputMaybe<Array<Wan_Select_Column> | Wan_Select_Column>;
  where?: InputMaybe<Wan_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Wan_Order_By> | Wan_Order_By>;
}>;


export type SubscribeToWanObjectsSubscription = { __typename?: 'subscription_root', Wan: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> };

export type InsertWanMutationVariables = Exact<{
  objects: Array<Wan_Insert_Input> | Wan_Insert_Input;
}>;


export type InsertWanMutation = { __typename?: 'mutation_root', insert_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> } | null };

export type InsertWanWithOnConflictMutationVariables = Exact<{
  objects: Array<Wan_Insert_Input> | Wan_Insert_Input;
  onConflict?: InputMaybe<Wan_On_Conflict>;
}>;


export type InsertWanWithOnConflictMutation = { __typename?: 'mutation_root', insert_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> } | null };

export type UpdateWanByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  set?: InputMaybe<Wan_Set_Input>;
}>;


export type UpdateWanByIdMutation = { __typename?: 'mutation_root', update_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> } | null };

export type UpdateWanMutationVariables = Exact<{
  set?: InputMaybe<Wan_Set_Input>;
  where: Wan_Bool_Exp;
}>;


export type UpdateWanMutation = { __typename?: 'mutation_root', update_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Wan', id: any, activeGatewayId: any, activeServerId: any, description?: string | null, isEncrypted: boolean, name: string, partnerId: any, standbyGatewayId?: any | null, standbyServerId?: any | null }> } | null };

export type RemoveWanModelByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type RemoveWanModelByIdMutation = { __typename?: 'mutation_root', delete_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number } | null };

export type RemoveWanModelMutationVariables = Exact<{
  where: Wan_Bool_Exp;
}>;


export type RemoveWanModelMutation = { __typename?: 'mutation_root', delete_Wan?: { __typename?: 'Wan_mutation_response', affected_rows: number } | null };

export const CarrierFragmentDoc = gql`
    fragment Carrier on Carrier {
  id
  name
  partnerId
}
    `;
export const ClientCompanyFragmentDoc = gql`
    fragment ClientCompany on ClientCompany {
  id
  name
  industry
  notes
  Quicklinks {
    id
    link
    description
  }
}
    `;
export const GatewayFragmentDoc = gql`
    fragment Gateway on Gateway {
  id
  name
  description
  region
  country
  timezone
  state
  isVps
  vpsProvider
  Servers {
    id
    ip4Address
    ip4Cidr
    ip4Router
    name
    osVersion
    gatewayId
    PublicIps {
      id
      address
      ip4Cidr
      isV6
      serverId
    }
    Tunnels {
      id
    }
  }
}
    `;
export const PartnerFragmentDoc = gql`
    fragment Partner on Partner {
  id
  name
  billingContact
  billingEmail
  billingPhone
  billingExt
  billingAddress
  billingAddress1
  billingAddress2
  billingCity
  billingState
  billingCountry
  billingPostalCode
  primaryLanguage
  Users {
    id
    email
    emailAlert
  }
}
    `;
export const QuicklinkFragmentDoc = gql`
    fragment Quicklink on Quicklink {
  id
  description
  link
  clientCompanyId
  ClientCompany {
    id
    name
    industry
    notes
  }
}
    `;
export const FirmwareFragmentDoc = gql`
    fragment Firmware on Firmware {
  id
  URI
  category
  hash
  isActive
  track
  version
}
    `;
export const GatewayBridgeFragmentDoc = gql`
    fragment GatewayBridge on GatewayBridge {
  id
  gatewayId
  bridgeType
  ipAddress
}
    `;
export const GatewaySubnetFragmentDoc = gql`
    fragment GatewaySubnet on GatewaySubnet {
  id
  gatewayId
  cidr
  address
}
    `;
export const LanNodeFragmentDoc = gql`
    fragment LanNode on LanNode {
  id
  ip4Address
  isPublic
  siteLanId
  publicIpId
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on Link {
  id
  carrierName
  cpeBindIp
  dataLimit
  dataLimitReset
  dataLimitUpdated
  dataLimitUsed
  downloadThroughput
  downloadThroughputCap
  interfaceName
  ip4Cidr
  ip4Router
  isCapEnabled
  isCapped
  isDHCP
  isEnabled
  isEncrypted
  isMacOverride
  isMetered
  isPPPoE
  isPassthrough
  isStandby
  isWWAN
  macAddress
  metric
  modemAPN
  name
  notes
  pppoePassword
  pppoeUsername
  serverBindIp
  serverPort
  state
  staticDnsIp
  staticGatewayIp
  staticIp
  tunnelId
  type
  uploadThroughput
  uploadThroughputCap
  vlanId
}
    `;
export const LinkTypeFragmentDoc = gql`
    fragment LinkType on LinkType {
  id
  name
  isActive
  isAPN
}
    `;
export const MeshWanFragmentDoc = gql`
    fragment MeshWan on MeshWan {
  id
  name
  description
}
    `;
export const MonitorFragmentDoc = gql`
    fragment Monitor on Monitor {
  id
  isActive
  isDefault
  logURI
  metricsURI
  name
  partnerId
  password
  username
}
    `;
export const ProfileFragmentDoc = gql`
    fragment Profile on Profile {
  id
  description
  isUniversal
  name
  partnerId
  url
}
    `;
export const PublicIpFragmentDoc = gql`
    fragment PublicIp on PublicIp {
  id
  address
  ip4Cidr
  isV6
  serverId
}
    `;
export const ServerFragmentDoc = gql`
    fragment Server on Server {
  id
  gatewayId
  ip4Address
  ip4Cidr
  ip4Router
  monitorEndpoint
  monitorId
  name
  osVersion
  rebootRequest
  softwareVersion
  Tunnels {
    id
  }
  Gateway {
    id
    name
    description
    region
    country
    timezone
    state
    isVps
    vpsProvider
    Servers {
      id
      ip4Address
      ip4Cidr
      ip4Router
      name
      osVersion
      gatewayId
      PublicIps {
        id
        address
        ip4Cidr
        isV6
        serverId
      }
      Tunnels {
        id
      }
    }
  }
  PublicIps {
    id
    address
    ip4Cidr
    isV6
    serverId
  }
}
    `;
export const ServerBridgeFragmentDoc = gql`
    fragment ServerBridge on ServerBridge {
  gatewayBridgeId
  serverId
}
    `;
export const SiteFragmentDoc = gql`
    fragment Site on Site {
  id
  name
  accessibleIps
  address1
  address2
  city
  clientCompanyId
  country
  ipAccessLevel
  isServerless
  meshWanId
  monitorEndpoint
  monitorId
  osVersion
  postalCode
  rebootRequest
  softwareVersion
  state
  wanId
  ClientCompany {
    id
    name
    industry
    notes
    Quicklinks {
      id
      link
      description
    }
  }
  Tunnels(order_by: {isPrimary: desc}) {
    id
    isPrimary
    isActive
    cidr
    downloadCap
    hasTrafficManagement
    interfaceName
    isCapEnabled
    isClearTextData
    isQOSEnabled
    lossTolerance
    mtu
    shouldReorderBuffer
    reorderBufferTime
    status
    timeout
    tunnelPassword
    tuntap
    uploadCap
    serverId
    autoMTU
    portRangeStart
    portRangeEnd
    lbAlgo
    flowlet
    Server {
      id
      gatewayId
      ip4Address
      ip4Cidr
      ip4Router
    }
    Links {
      id
      type
      carrierName
      isDHCP
      staticIp
      staticDnsIp
      staticGatewayIp
      cpeBindIp
      dataLimit
      dataLimitReset
      dataLimitUsed
      downloadThroughput
      downloadThroughputCap
      interfaceName
      isCapped
      isCapEnabled
      isEnabled
      isEncrypted
      isMetered
      isPassthrough
      isStandby
      name
      notes
      serverBindIp
      serverPort
      state
      uploadThroughput
      uploadThroughputCap
      modemAPN
      isPPPoE
      isWWAN
      pppoeUsername
      pppoePassword
      vlanId
    }
  }
  SiteLans {
    id
    lanSegmentIp4
    dhcpDefaultLease
    dhcpMaxLease
    dhcpRangeEnd
    dhcpRangeStart
    dnsServer2
    dnsServer1
    isDhcpRequired
    lanCidrIp4
    isDMZ
    ip4DMZ
    isAP
    interfaceName
    vlanId
    apMode
    apSSID
    apCountryCode
    apChannel
    apPassword
    ap5SSID
    ap5Channel
    ap5Password
  }
  SiteRoutes {
    id
    subnet
    routerIP
    routerInterface
    metric
    isActive
    isInbound
  }
  SiteContacts {
    id
    label
    lastName
    phone
    ext
    email
    emailAlert
    firstName
  }
  Wan {
    id
    name
  }
}
    `;
export const SiteContactFragmentDoc = gql`
    fragment SiteContact on SiteContact {
  id
  email
  emailAlert
  ext
  firstName
  label
  lastName
  phone
  siteId
}
    `;
export const SiteLanFragmentDoc = gql`
    fragment SiteLan on SiteLan {
  id
  ap5Channel
  ap5Password
  ap5SSID
  apChannel
  apCountryCode
  apMode
  apPassword
  apSSID
  dhcpDefaultLease
  dhcpMaxLease
  dhcpRangeEnd
  dhcpRangeStart
  dnsServer1
  dnsServer2
  interfaceName
  ip4DMZ
  isAP
  isDMZ
  isDhcpRequired
  lanCidrIp4
  lanSegmentIp4
  siteId
  vlanId
}
    `;
export const SiteRouteFragmentDoc = gql`
    fragment SiteRoute on SiteRoute {
  id
  isActive
  isInbound
  metric
  routerIP
  routerInterface
  siteId
  subnet
}
    `;
export const TunnelFragmentDoc = gql`
    fragment Tunnel on Tunnel {
  id
  autoMTU
  cidr
  downloadCap
  hasTrafficManagement
  interfaceName
  isCapEnabled
  isClearTextData
  isPrimary
  isQOSEnabled
  lossTolerance
  mtu
  portRangeEnd
  portRangeStart
  lbAlgo
  flowlet
  reorderBufferTime
  serverId
  shouldReorderBuffer
  siteId
  status
  timeout
  tunnelAddressPairSeed
  tunnelPassword
  tuntap
  uploadCap
}
    `;
export const TunnelProfileFragmentDoc = gql`
    fragment TunnelProfile on TunnelProfile {
  id
  profileId
  tunnelId
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  accountStatus
  email
  emailAlert
  firstName
  fromUserId
  isInvited
  lastName
  login_at
  partnerId
  phone
  userRoleId
}
    `;
export const UserHistoryFragmentDoc = gql`
    fragment UserHistory on UserHistory {
  id
  status
  userId
}
    `;
export const UserRoleFragmentDoc = gql`
    fragment UserRole on UserRole {
  id
  roleName
}
    `;
export const WanFragmentDoc = gql`
    fragment Wan on Wan {
  id
  activeGatewayId
  activeServerId
  description
  isEncrypted
  name
  partnerId
  standbyGatewayId
  standbyServerId
}
    `;
export const QueryCarrierByIdDocument = gql`
    query queryCarrierById($carrierId: uuid!) {
  Carrier_by_pk(id: $carrierId) {
    ...Carrier
  }
}
    ${CarrierFragmentDoc}`;
export type QueryCarrierByIdQueryResult = Apollo.QueryResult<QueryCarrierByIdQuery, QueryCarrierByIdQueryVariables>;
export const QueryCarrierObjectsDocument = gql`
    query queryCarrierObjects($distinct_on: [Carrier_select_column!], $where: Carrier_bool_exp, $limit: Int, $offset: Int, $order_by: [Carrier_order_by!]) {
  Carrier(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Carrier
  }
}
    ${CarrierFragmentDoc}`;
export type QueryCarrierObjectsQueryResult = Apollo.QueryResult<QueryCarrierObjectsQuery, QueryCarrierObjectsQueryVariables>;
export const SubscribeToCarrierByIdDocument = gql`
    subscription subscribeToCarrierById($carrierId: uuid!) {
  Carrier_by_pk(id: $carrierId) {
    ...Carrier
  }
}
    ${CarrierFragmentDoc}`;
export type SubscribeToCarrierByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToCarrierByIdSubscription>;
export const SubscribeToCarrierObjectsDocument = gql`
    subscription subscribeToCarrierObjects($distinct_on: [Carrier_select_column!], $where: Carrier_bool_exp, $limit: Int, $offset: Int, $order_by: [Carrier_order_by!]) {
  Carrier(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Carrier
  }
}
    ${CarrierFragmentDoc}`;
export type SubscribeToCarrierObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToCarrierObjectsSubscription>;
export const InsertCarrierDocument = gql`
    mutation insertCarrier($objects: [Carrier_insert_input!]!) {
  insert_Carrier(objects: $objects) {
    affected_rows
    returning {
      ...Carrier
    }
  }
}
    ${CarrierFragmentDoc}`;
export type InsertCarrierMutationFn = Apollo.MutationFunction<InsertCarrierMutation, InsertCarrierMutationVariables>;
export type InsertCarrierMutationResult = Apollo.MutationResult<InsertCarrierMutation>;
export type InsertCarrierMutationOptions = Apollo.BaseMutationOptions<InsertCarrierMutation, InsertCarrierMutationVariables>;
export const InsertCarrierWithOnConflictDocument = gql`
    mutation insertCarrierWithOnConflict($objects: [Carrier_insert_input!]!, $onConflict: Carrier_on_conflict) {
  insert_Carrier(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Carrier
    }
  }
}
    ${CarrierFragmentDoc}`;
export type InsertCarrierWithOnConflictMutationFn = Apollo.MutationFunction<InsertCarrierWithOnConflictMutation, InsertCarrierWithOnConflictMutationVariables>;
export type InsertCarrierWithOnConflictMutationResult = Apollo.MutationResult<InsertCarrierWithOnConflictMutation>;
export type InsertCarrierWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertCarrierWithOnConflictMutation, InsertCarrierWithOnConflictMutationVariables>;
export const UpdateCarrierByIdDocument = gql`
    mutation updateCarrierById($id: uuid, $set: Carrier_set_input) {
  update_Carrier(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Carrier
    }
  }
}
    ${CarrierFragmentDoc}`;
export type UpdateCarrierByIdMutationFn = Apollo.MutationFunction<UpdateCarrierByIdMutation, UpdateCarrierByIdMutationVariables>;
export type UpdateCarrierByIdMutationResult = Apollo.MutationResult<UpdateCarrierByIdMutation>;
export type UpdateCarrierByIdMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierByIdMutation, UpdateCarrierByIdMutationVariables>;
export const UpdateCarrierDocument = gql`
    mutation updateCarrier($set: Carrier_set_input, $where: Carrier_bool_exp!) {
  update_Carrier(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Carrier
    }
  }
}
    ${CarrierFragmentDoc}`;
export type UpdateCarrierMutationFn = Apollo.MutationFunction<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export type UpdateCarrierMutationResult = Apollo.MutationResult<UpdateCarrierMutation>;
export type UpdateCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export const RemoveCarrierModelByIdDocument = gql`
    mutation removeCarrierModelById($id: uuid) {
  delete_Carrier(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveCarrierModelByIdMutationFn = Apollo.MutationFunction<RemoveCarrierModelByIdMutation, RemoveCarrierModelByIdMutationVariables>;
export type RemoveCarrierModelByIdMutationResult = Apollo.MutationResult<RemoveCarrierModelByIdMutation>;
export type RemoveCarrierModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveCarrierModelByIdMutation, RemoveCarrierModelByIdMutationVariables>;
export const RemoveCarrierModelDocument = gql`
    mutation removeCarrierModel($where: Carrier_bool_exp!) {
  delete_Carrier(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveCarrierModelMutationFn = Apollo.MutationFunction<RemoveCarrierModelMutation, RemoveCarrierModelMutationVariables>;
export type RemoveCarrierModelMutationResult = Apollo.MutationResult<RemoveCarrierModelMutation>;
export type RemoveCarrierModelMutationOptions = Apollo.BaseMutationOptions<RemoveCarrierModelMutation, RemoveCarrierModelMutationVariables>;
export const QueryClientCompanyByIdDocument = gql`
    query queryClientCompanyById($clientCompanyId: uuid!) {
  ClientCompany_by_pk(id: $clientCompanyId) {
    ...ClientCompany
  }
}
    ${ClientCompanyFragmentDoc}`;
export type QueryClientCompanyByIdQueryResult = Apollo.QueryResult<QueryClientCompanyByIdQuery, QueryClientCompanyByIdQueryVariables>;
export const QueryClientCompanyObjectsDocument = gql`
    query queryClientCompanyObjects($distinct_on: [ClientCompany_select_column!], $where: ClientCompany_bool_exp, $limit: Int, $offset: Int, $order_by: [ClientCompany_order_by!]) {
  ClientCompany(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ClientCompany
  }
}
    ${ClientCompanyFragmentDoc}`;
export type QueryClientCompanyObjectsQueryResult = Apollo.QueryResult<QueryClientCompanyObjectsQuery, QueryClientCompanyObjectsQueryVariables>;
export const SubscribeToClientCompanyByIdDocument = gql`
    subscription subscribeToClientCompanyById($clientCompanyId: uuid!) {
  ClientCompany_by_pk(id: $clientCompanyId) {
    ...ClientCompany
  }
}
    ${ClientCompanyFragmentDoc}`;
export type SubscribeToClientCompanyByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClientCompanyByIdSubscription>;
export const SubscribeToClientCompanyObjectsDocument = gql`
    subscription subscribeToClientCompanyObjects($distinct_on: [ClientCompany_select_column!], $where: ClientCompany_bool_exp, $limit: Int, $offset: Int, $order_by: [ClientCompany_order_by!]) {
  ClientCompany(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ClientCompany
  }
}
    ${ClientCompanyFragmentDoc}`;
export type SubscribeToClientCompanyObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToClientCompanyObjectsSubscription>;
export const InsertClientCompanyDocument = gql`
    mutation insertClientCompany($objects: [ClientCompany_insert_input!]!) {
  insert_ClientCompany(objects: $objects) {
    affected_rows
    returning {
      ...ClientCompany
    }
  }
}
    ${ClientCompanyFragmentDoc}`;
export type InsertClientCompanyMutationFn = Apollo.MutationFunction<InsertClientCompanyMutation, InsertClientCompanyMutationVariables>;
export type InsertClientCompanyMutationResult = Apollo.MutationResult<InsertClientCompanyMutation>;
export type InsertClientCompanyMutationOptions = Apollo.BaseMutationOptions<InsertClientCompanyMutation, InsertClientCompanyMutationVariables>;
export const InsertClientCompanyWithOnConflictDocument = gql`
    mutation insertClientCompanyWithOnConflict($objects: [ClientCompany_insert_input!]!, $onConflict: ClientCompany_on_conflict) {
  insert_ClientCompany(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...ClientCompany
    }
  }
}
    ${ClientCompanyFragmentDoc}`;
export type InsertClientCompanyWithOnConflictMutationFn = Apollo.MutationFunction<InsertClientCompanyWithOnConflictMutation, InsertClientCompanyWithOnConflictMutationVariables>;
export type InsertClientCompanyWithOnConflictMutationResult = Apollo.MutationResult<InsertClientCompanyWithOnConflictMutation>;
export type InsertClientCompanyWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertClientCompanyWithOnConflictMutation, InsertClientCompanyWithOnConflictMutationVariables>;
export const UpdateClientCompanyByIdDocument = gql`
    mutation updateClientCompanyById($id: uuid, $set: ClientCompany_set_input) {
  update_ClientCompany(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...ClientCompany
    }
  }
}
    ${ClientCompanyFragmentDoc}`;
export type UpdateClientCompanyByIdMutationFn = Apollo.MutationFunction<UpdateClientCompanyByIdMutation, UpdateClientCompanyByIdMutationVariables>;
export type UpdateClientCompanyByIdMutationResult = Apollo.MutationResult<UpdateClientCompanyByIdMutation>;
export type UpdateClientCompanyByIdMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyByIdMutation, UpdateClientCompanyByIdMutationVariables>;
export const UpdateClientCompanyDocument = gql`
    mutation updateClientCompany($set: ClientCompany_set_input, $where: ClientCompany_bool_exp!) {
  update_ClientCompany(_set: $set, where: $where) {
    affected_rows
    returning {
      ...ClientCompany
    }
  }
}
    ${ClientCompanyFragmentDoc}`;
export type UpdateClientCompanyMutationFn = Apollo.MutationFunction<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;
export type UpdateClientCompanyMutationResult = Apollo.MutationResult<UpdateClientCompanyMutation>;
export type UpdateClientCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;
export const RemoveClientCompanyModelByIdDocument = gql`
    mutation removeClientCompanyModelById($id: uuid) {
  delete_ClientCompany(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveClientCompanyModelByIdMutationFn = Apollo.MutationFunction<RemoveClientCompanyModelByIdMutation, RemoveClientCompanyModelByIdMutationVariables>;
export type RemoveClientCompanyModelByIdMutationResult = Apollo.MutationResult<RemoveClientCompanyModelByIdMutation>;
export type RemoveClientCompanyModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveClientCompanyModelByIdMutation, RemoveClientCompanyModelByIdMutationVariables>;
export const RemoveClientCompanyModelDocument = gql`
    mutation removeClientCompanyModel($where: ClientCompany_bool_exp!) {
  delete_ClientCompany(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveClientCompanyModelMutationFn = Apollo.MutationFunction<RemoveClientCompanyModelMutation, RemoveClientCompanyModelMutationVariables>;
export type RemoveClientCompanyModelMutationResult = Apollo.MutationResult<RemoveClientCompanyModelMutation>;
export type RemoveClientCompanyModelMutationOptions = Apollo.BaseMutationOptions<RemoveClientCompanyModelMutation, RemoveClientCompanyModelMutationVariables>;
export const QueryGatewayByIdDocument = gql`
    query queryGatewayById($gatewayId: uuid!) {
  Gateway_by_pk(id: $gatewayId) {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;
export type QueryGatewayByIdQueryResult = Apollo.QueryResult<QueryGatewayByIdQuery, QueryGatewayByIdQueryVariables>;
export const QueryGatewayObjectsDocument = gql`
    query queryGatewayObjects($distinct_on: [Gateway_select_column!], $where: Gateway_bool_exp, $limit: Int, $offset: Int, $order_by: [Gateway_order_by!]) {
  Gateway(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;
export type QueryGatewayObjectsQueryResult = Apollo.QueryResult<QueryGatewayObjectsQuery, QueryGatewayObjectsQueryVariables>;
export const SubscribeToGatewayByIdDocument = gql`
    subscription subscribeToGatewayById($gatewayId: uuid!) {
  Gateway_by_pk(id: $gatewayId) {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;
export type SubscribeToGatewayByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewayByIdSubscription>;
export const SubscribeToGatewayObjectsDocument = gql`
    subscription subscribeToGatewayObjects($distinct_on: [Gateway_select_column!], $where: Gateway_bool_exp, $limit: Int, $offset: Int, $order_by: [Gateway_order_by!]) {
  Gateway(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Gateway
  }
}
    ${GatewayFragmentDoc}`;
export type SubscribeToGatewayObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewayObjectsSubscription>;
export const InsertGatewayDocument = gql`
    mutation insertGateway($objects: [Gateway_insert_input!]!) {
  insert_Gateway(objects: $objects) {
    affected_rows
    returning {
      ...Gateway
    }
  }
}
    ${GatewayFragmentDoc}`;
export type InsertGatewayMutationFn = Apollo.MutationFunction<InsertGatewayMutation, InsertGatewayMutationVariables>;
export type InsertGatewayMutationResult = Apollo.MutationResult<InsertGatewayMutation>;
export type InsertGatewayMutationOptions = Apollo.BaseMutationOptions<InsertGatewayMutation, InsertGatewayMutationVariables>;
export const InsertGatewayWithOnConflictDocument = gql`
    mutation insertGatewayWithOnConflict($objects: [Gateway_insert_input!]!, $onConflict: Gateway_on_conflict) {
  insert_Gateway(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Gateway
    }
  }
}
    ${GatewayFragmentDoc}`;
export type InsertGatewayWithOnConflictMutationFn = Apollo.MutationFunction<InsertGatewayWithOnConflictMutation, InsertGatewayWithOnConflictMutationVariables>;
export type InsertGatewayWithOnConflictMutationResult = Apollo.MutationResult<InsertGatewayWithOnConflictMutation>;
export type InsertGatewayWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertGatewayWithOnConflictMutation, InsertGatewayWithOnConflictMutationVariables>;
export const UpdateGatewayByIdDocument = gql`
    mutation updateGatewayById($id: uuid, $set: Gateway_set_input) {
  update_Gateway(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Gateway
    }
  }
}
    ${GatewayFragmentDoc}`;
export type UpdateGatewayByIdMutationFn = Apollo.MutationFunction<UpdateGatewayByIdMutation, UpdateGatewayByIdMutationVariables>;
export type UpdateGatewayByIdMutationResult = Apollo.MutationResult<UpdateGatewayByIdMutation>;
export type UpdateGatewayByIdMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayByIdMutation, UpdateGatewayByIdMutationVariables>;
export const UpdateGatewayDocument = gql`
    mutation updateGateway($set: Gateway_set_input, $where: Gateway_bool_exp!) {
  update_Gateway(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Gateway
    }
  }
}
    ${GatewayFragmentDoc}`;
export type UpdateGatewayMutationFn = Apollo.MutationFunction<UpdateGatewayMutation, UpdateGatewayMutationVariables>;
export type UpdateGatewayMutationResult = Apollo.MutationResult<UpdateGatewayMutation>;
export type UpdateGatewayMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayMutation, UpdateGatewayMutationVariables>;
export const RemoveGatewayModelByIdDocument = gql`
    mutation removeGatewayModelById($id: uuid) {
  delete_Gateway(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveGatewayModelByIdMutationFn = Apollo.MutationFunction<RemoveGatewayModelByIdMutation, RemoveGatewayModelByIdMutationVariables>;
export type RemoveGatewayModelByIdMutationResult = Apollo.MutationResult<RemoveGatewayModelByIdMutation>;
export type RemoveGatewayModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveGatewayModelByIdMutation, RemoveGatewayModelByIdMutationVariables>;
export const RemoveGatewayModelDocument = gql`
    mutation removeGatewayModel($where: Gateway_bool_exp!) {
  delete_Gateway(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveGatewayModelMutationFn = Apollo.MutationFunction<RemoveGatewayModelMutation, RemoveGatewayModelMutationVariables>;
export type RemoveGatewayModelMutationResult = Apollo.MutationResult<RemoveGatewayModelMutation>;
export type RemoveGatewayModelMutationOptions = Apollo.BaseMutationOptions<RemoveGatewayModelMutation, RemoveGatewayModelMutationVariables>;
export const QueryPartnerByIdDocument = gql`
    query queryPartnerById($partnerId: uuid!) {
  Partner_by_pk(id: $partnerId) {
    ...Partner
  }
}
    ${PartnerFragmentDoc}`;
export type QueryPartnerByIdQueryResult = Apollo.QueryResult<QueryPartnerByIdQuery, QueryPartnerByIdQueryVariables>;
export const QueryPartnerObjectsDocument = gql`
    query queryPartnerObjects($distinct_on: [Partner_select_column!], $where: Partner_bool_exp, $limit: Int, $offset: Int, $order_by: [Partner_order_by!]) {
  Partner(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Partner
  }
}
    ${PartnerFragmentDoc}`;
export type QueryPartnerObjectsQueryResult = Apollo.QueryResult<QueryPartnerObjectsQuery, QueryPartnerObjectsQueryVariables>;
export const SubscribeToPartnerByIdDocument = gql`
    subscription subscribeToPartnerById($partnerId: uuid!) {
  Partner_by_pk(id: $partnerId) {
    ...Partner
  }
}
    ${PartnerFragmentDoc}`;
export type SubscribeToPartnerByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPartnerByIdSubscription>;
export const SubscribeToPartnerObjectsDocument = gql`
    subscription subscribeToPartnerObjects($distinct_on: [Partner_select_column!], $where: Partner_bool_exp, $limit: Int, $offset: Int, $order_by: [Partner_order_by!]) {
  Partner(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Partner
  }
}
    ${PartnerFragmentDoc}`;
export type SubscribeToPartnerObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPartnerObjectsSubscription>;
export const InsertPartnerDocument = gql`
    mutation insertPartner($objects: [Partner_insert_input!]!) {
  insert_Partner(objects: $objects) {
    affected_rows
    returning {
      ...Partner
    }
  }
}
    ${PartnerFragmentDoc}`;
export type InsertPartnerMutationFn = Apollo.MutationFunction<InsertPartnerMutation, InsertPartnerMutationVariables>;
export type InsertPartnerMutationResult = Apollo.MutationResult<InsertPartnerMutation>;
export type InsertPartnerMutationOptions = Apollo.BaseMutationOptions<InsertPartnerMutation, InsertPartnerMutationVariables>;
export const InsertPartnerWithOnConflictDocument = gql`
    mutation insertPartnerWithOnConflict($objects: [Partner_insert_input!]!, $onConflict: Partner_on_conflict) {
  insert_Partner(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Partner
    }
  }
}
    ${PartnerFragmentDoc}`;
export type InsertPartnerWithOnConflictMutationFn = Apollo.MutationFunction<InsertPartnerWithOnConflictMutation, InsertPartnerWithOnConflictMutationVariables>;
export type InsertPartnerWithOnConflictMutationResult = Apollo.MutationResult<InsertPartnerWithOnConflictMutation>;
export type InsertPartnerWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertPartnerWithOnConflictMutation, InsertPartnerWithOnConflictMutationVariables>;
export const UpdatePartnerByIdDocument = gql`
    mutation updatePartnerById($id: uuid, $set: Partner_set_input) {
  update_Partner(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Partner
    }
  }
}
    ${PartnerFragmentDoc}`;
export type UpdatePartnerByIdMutationFn = Apollo.MutationFunction<UpdatePartnerByIdMutation, UpdatePartnerByIdMutationVariables>;
export type UpdatePartnerByIdMutationResult = Apollo.MutationResult<UpdatePartnerByIdMutation>;
export type UpdatePartnerByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerByIdMutation, UpdatePartnerByIdMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation updatePartner($set: Partner_set_input, $where: Partner_bool_exp!) {
  update_Partner(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Partner
    }
  }
}
    ${PartnerFragmentDoc}`;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const RemovePartnerModelByIdDocument = gql`
    mutation removePartnerModelById($id: uuid) {
  delete_Partner(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemovePartnerModelByIdMutationFn = Apollo.MutationFunction<RemovePartnerModelByIdMutation, RemovePartnerModelByIdMutationVariables>;
export type RemovePartnerModelByIdMutationResult = Apollo.MutationResult<RemovePartnerModelByIdMutation>;
export type RemovePartnerModelByIdMutationOptions = Apollo.BaseMutationOptions<RemovePartnerModelByIdMutation, RemovePartnerModelByIdMutationVariables>;
export const RemovePartnerModelDocument = gql`
    mutation removePartnerModel($where: Partner_bool_exp!) {
  delete_Partner(where: $where) {
    affected_rows
  }
}
    `;
export type RemovePartnerModelMutationFn = Apollo.MutationFunction<RemovePartnerModelMutation, RemovePartnerModelMutationVariables>;
export type RemovePartnerModelMutationResult = Apollo.MutationResult<RemovePartnerModelMutation>;
export type RemovePartnerModelMutationOptions = Apollo.BaseMutationOptions<RemovePartnerModelMutation, RemovePartnerModelMutationVariables>;
export const QueryQuicklinkByIdDocument = gql`
    query queryQuicklinkById($quicklinkId: uuid!) {
  Quicklink_by_pk(id: $quicklinkId) {
    ...Quicklink
  }
}
    ${QuicklinkFragmentDoc}`;
export type QueryQuicklinkByIdQueryResult = Apollo.QueryResult<QueryQuicklinkByIdQuery, QueryQuicklinkByIdQueryVariables>;
export const QueryQuicklinkObjectsDocument = gql`
    query queryQuicklinkObjects($distinct_on: [Quicklink_select_column!], $where: Quicklink_bool_exp, $limit: Int, $offset: Int, $order_by: [Quicklink_order_by!]) {
  Quicklink(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Quicklink
  }
}
    ${QuicklinkFragmentDoc}`;
export type QueryQuicklinkObjectsQueryResult = Apollo.QueryResult<QueryQuicklinkObjectsQuery, QueryQuicklinkObjectsQueryVariables>;
export const SubscribeToQuicklinkByIdDocument = gql`
    subscription subscribeToQuicklinkById($quicklinkId: uuid!) {
  Quicklink_by_pk(id: $quicklinkId) {
    ...Quicklink
  }
}
    ${QuicklinkFragmentDoc}`;
export type SubscribeToQuicklinkByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToQuicklinkByIdSubscription>;
export const SubscribeToQuicklinkObjectsDocument = gql`
    subscription subscribeToQuicklinkObjects($distinct_on: [Quicklink_select_column!], $where: Quicklink_bool_exp, $limit: Int, $offset: Int, $order_by: [Quicklink_order_by!]) {
  Quicklink(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Quicklink
  }
}
    ${QuicklinkFragmentDoc}`;
export type SubscribeToQuicklinkObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToQuicklinkObjectsSubscription>;
export const InsertQuicklinkDocument = gql`
    mutation insertQuicklink($objects: [Quicklink_insert_input!]!) {
  insert_Quicklink(objects: $objects) {
    affected_rows
    returning {
      ...Quicklink
    }
  }
}
    ${QuicklinkFragmentDoc}`;
export type InsertQuicklinkMutationFn = Apollo.MutationFunction<InsertQuicklinkMutation, InsertQuicklinkMutationVariables>;
export type InsertQuicklinkMutationResult = Apollo.MutationResult<InsertQuicklinkMutation>;
export type InsertQuicklinkMutationOptions = Apollo.BaseMutationOptions<InsertQuicklinkMutation, InsertQuicklinkMutationVariables>;
export const InsertQuicklinkWithOnConflictDocument = gql`
    mutation insertQuicklinkWithOnConflict($objects: [Quicklink_insert_input!]!, $onConflict: Quicklink_on_conflict) {
  insert_Quicklink(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Quicklink
    }
  }
}
    ${QuicklinkFragmentDoc}`;
export type InsertQuicklinkWithOnConflictMutationFn = Apollo.MutationFunction<InsertQuicklinkWithOnConflictMutation, InsertQuicklinkWithOnConflictMutationVariables>;
export type InsertQuicklinkWithOnConflictMutationResult = Apollo.MutationResult<InsertQuicklinkWithOnConflictMutation>;
export type InsertQuicklinkWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertQuicklinkWithOnConflictMutation, InsertQuicklinkWithOnConflictMutationVariables>;
export const UpdateQuicklinkByIdDocument = gql`
    mutation updateQuicklinkById($id: uuid, $set: Quicklink_set_input) {
  update_Quicklink(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Quicklink
    }
  }
}
    ${QuicklinkFragmentDoc}`;
export type UpdateQuicklinkByIdMutationFn = Apollo.MutationFunction<UpdateQuicklinkByIdMutation, UpdateQuicklinkByIdMutationVariables>;
export type UpdateQuicklinkByIdMutationResult = Apollo.MutationResult<UpdateQuicklinkByIdMutation>;
export type UpdateQuicklinkByIdMutationOptions = Apollo.BaseMutationOptions<UpdateQuicklinkByIdMutation, UpdateQuicklinkByIdMutationVariables>;
export const UpdateQuicklinkDocument = gql`
    mutation updateQuicklink($set: Quicklink_set_input, $where: Quicklink_bool_exp!) {
  update_Quicklink(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Quicklink
    }
  }
}
    ${QuicklinkFragmentDoc}`;
export type UpdateQuicklinkMutationFn = Apollo.MutationFunction<UpdateQuicklinkMutation, UpdateQuicklinkMutationVariables>;
export type UpdateQuicklinkMutationResult = Apollo.MutationResult<UpdateQuicklinkMutation>;
export type UpdateQuicklinkMutationOptions = Apollo.BaseMutationOptions<UpdateQuicklinkMutation, UpdateQuicklinkMutationVariables>;
export const RemoveQuicklinkModelByIdDocument = gql`
    mutation removeQuicklinkModelById($id: uuid) {
  delete_Quicklink(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveQuicklinkModelByIdMutationFn = Apollo.MutationFunction<RemoveQuicklinkModelByIdMutation, RemoveQuicklinkModelByIdMutationVariables>;
export type RemoveQuicklinkModelByIdMutationResult = Apollo.MutationResult<RemoveQuicklinkModelByIdMutation>;
export type RemoveQuicklinkModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveQuicklinkModelByIdMutation, RemoveQuicklinkModelByIdMutationVariables>;
export const RemoveQuicklinkModelDocument = gql`
    mutation removeQuicklinkModel($where: Quicklink_bool_exp!) {
  delete_Quicklink(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveQuicklinkModelMutationFn = Apollo.MutationFunction<RemoveQuicklinkModelMutation, RemoveQuicklinkModelMutationVariables>;
export type RemoveQuicklinkModelMutationResult = Apollo.MutationResult<RemoveQuicklinkModelMutation>;
export type RemoveQuicklinkModelMutationOptions = Apollo.BaseMutationOptions<RemoveQuicklinkModelMutation, RemoveQuicklinkModelMutationVariables>;
export const QueryFirmwareByIdDocument = gql`
    query queryFirmwareById($firmwareId: uuid!) {
  Firmware_by_pk(id: $firmwareId) {
    ...Firmware
  }
}
    ${FirmwareFragmentDoc}`;
export type QueryFirmwareByIdQueryResult = Apollo.QueryResult<QueryFirmwareByIdQuery, QueryFirmwareByIdQueryVariables>;
export const QueryFirmwareObjectsDocument = gql`
    query queryFirmwareObjects($distinct_on: [Firmware_select_column!], $where: Firmware_bool_exp, $limit: Int, $offset: Int, $order_by: [Firmware_order_by!]) {
  Firmware(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Firmware
  }
}
    ${FirmwareFragmentDoc}`;
export type QueryFirmwareObjectsQueryResult = Apollo.QueryResult<QueryFirmwareObjectsQuery, QueryFirmwareObjectsQueryVariables>;
export const SubscribeToFirmwareByIdDocument = gql`
    subscription subscribeToFirmwareById($firmwareId: uuid!) {
  Firmware_by_pk(id: $firmwareId) {
    ...Firmware
  }
}
    ${FirmwareFragmentDoc}`;
export type SubscribeToFirmwareByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFirmwareByIdSubscription>;
export const SubscribeToFirmwareObjectsDocument = gql`
    subscription subscribeToFirmwareObjects($distinct_on: [Firmware_select_column!], $where: Firmware_bool_exp, $limit: Int, $offset: Int, $order_by: [Firmware_order_by!]) {
  Firmware(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Firmware
  }
}
    ${FirmwareFragmentDoc}`;
export type SubscribeToFirmwareObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFirmwareObjectsSubscription>;
export const InsertFirmwareDocument = gql`
    mutation insertFirmware($objects: [Firmware_insert_input!]!) {
  insert_Firmware(objects: $objects) {
    affected_rows
    returning {
      ...Firmware
    }
  }
}
    ${FirmwareFragmentDoc}`;
export type InsertFirmwareMutationFn = Apollo.MutationFunction<InsertFirmwareMutation, InsertFirmwareMutationVariables>;
export type InsertFirmwareMutationResult = Apollo.MutationResult<InsertFirmwareMutation>;
export type InsertFirmwareMutationOptions = Apollo.BaseMutationOptions<InsertFirmwareMutation, InsertFirmwareMutationVariables>;
export const InsertFirmwareWithOnConflictDocument = gql`
    mutation insertFirmwareWithOnConflict($objects: [Firmware_insert_input!]!, $onConflict: Firmware_on_conflict) {
  insert_Firmware(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Firmware
    }
  }
}
    ${FirmwareFragmentDoc}`;
export type InsertFirmwareWithOnConflictMutationFn = Apollo.MutationFunction<InsertFirmwareWithOnConflictMutation, InsertFirmwareWithOnConflictMutationVariables>;
export type InsertFirmwareWithOnConflictMutationResult = Apollo.MutationResult<InsertFirmwareWithOnConflictMutation>;
export type InsertFirmwareWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertFirmwareWithOnConflictMutation, InsertFirmwareWithOnConflictMutationVariables>;
export const UpdateFirmwareByIdDocument = gql`
    mutation updateFirmwareById($id: uuid, $set: Firmware_set_input) {
  update_Firmware(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Firmware
    }
  }
}
    ${FirmwareFragmentDoc}`;
export type UpdateFirmwareByIdMutationFn = Apollo.MutationFunction<UpdateFirmwareByIdMutation, UpdateFirmwareByIdMutationVariables>;
export type UpdateFirmwareByIdMutationResult = Apollo.MutationResult<UpdateFirmwareByIdMutation>;
export type UpdateFirmwareByIdMutationOptions = Apollo.BaseMutationOptions<UpdateFirmwareByIdMutation, UpdateFirmwareByIdMutationVariables>;
export const UpdateFirmwareDocument = gql`
    mutation updateFirmware($set: Firmware_set_input, $where: Firmware_bool_exp!) {
  update_Firmware(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Firmware
    }
  }
}
    ${FirmwareFragmentDoc}`;
export type UpdateFirmwareMutationFn = Apollo.MutationFunction<UpdateFirmwareMutation, UpdateFirmwareMutationVariables>;
export type UpdateFirmwareMutationResult = Apollo.MutationResult<UpdateFirmwareMutation>;
export type UpdateFirmwareMutationOptions = Apollo.BaseMutationOptions<UpdateFirmwareMutation, UpdateFirmwareMutationVariables>;
export const RemoveFirmwareModelByIdDocument = gql`
    mutation removeFirmwareModelById($id: uuid) {
  delete_Firmware(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveFirmwareModelByIdMutationFn = Apollo.MutationFunction<RemoveFirmwareModelByIdMutation, RemoveFirmwareModelByIdMutationVariables>;
export type RemoveFirmwareModelByIdMutationResult = Apollo.MutationResult<RemoveFirmwareModelByIdMutation>;
export type RemoveFirmwareModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveFirmwareModelByIdMutation, RemoveFirmwareModelByIdMutationVariables>;
export const RemoveFirmwareModelDocument = gql`
    mutation removeFirmwareModel($where: Firmware_bool_exp!) {
  delete_Firmware(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveFirmwareModelMutationFn = Apollo.MutationFunction<RemoveFirmwareModelMutation, RemoveFirmwareModelMutationVariables>;
export type RemoveFirmwareModelMutationResult = Apollo.MutationResult<RemoveFirmwareModelMutation>;
export type RemoveFirmwareModelMutationOptions = Apollo.BaseMutationOptions<RemoveFirmwareModelMutation, RemoveFirmwareModelMutationVariables>;
export const QueryGatewayBridgeByIdDocument = gql`
    query queryGatewayBridgeById($gatewayBridgeId: uuid!) {
  GatewayBridge_by_pk(id: $gatewayBridgeId) {
    ...GatewayBridge
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type QueryGatewayBridgeByIdQueryResult = Apollo.QueryResult<QueryGatewayBridgeByIdQuery, QueryGatewayBridgeByIdQueryVariables>;
export const QueryGatewayBridgeObjectsDocument = gql`
    query queryGatewayBridgeObjects($distinct_on: [GatewayBridge_select_column!], $where: GatewayBridge_bool_exp, $limit: Int, $offset: Int, $order_by: [GatewayBridge_order_by!]) {
  GatewayBridge(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...GatewayBridge
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type QueryGatewayBridgeObjectsQueryResult = Apollo.QueryResult<QueryGatewayBridgeObjectsQuery, QueryGatewayBridgeObjectsQueryVariables>;
export const SubscribeToGatewayBridgeByIdDocument = gql`
    subscription subscribeToGatewayBridgeById($gatewayBridgeId: uuid!) {
  GatewayBridge_by_pk(id: $gatewayBridgeId) {
    ...GatewayBridge
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type SubscribeToGatewayBridgeByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewayBridgeByIdSubscription>;
export const SubscribeToGatewayBridgeObjectsDocument = gql`
    subscription subscribeToGatewayBridgeObjects($distinct_on: [GatewayBridge_select_column!], $where: GatewayBridge_bool_exp, $limit: Int, $offset: Int, $order_by: [GatewayBridge_order_by!]) {
  GatewayBridge(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...GatewayBridge
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type SubscribeToGatewayBridgeObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewayBridgeObjectsSubscription>;
export const InsertGatewayBridgeDocument = gql`
    mutation insertGatewayBridge($objects: [GatewayBridge_insert_input!]!) {
  insert_GatewayBridge(objects: $objects) {
    affected_rows
    returning {
      ...GatewayBridge
    }
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type InsertGatewayBridgeMutationFn = Apollo.MutationFunction<InsertGatewayBridgeMutation, InsertGatewayBridgeMutationVariables>;
export type InsertGatewayBridgeMutationResult = Apollo.MutationResult<InsertGatewayBridgeMutation>;
export type InsertGatewayBridgeMutationOptions = Apollo.BaseMutationOptions<InsertGatewayBridgeMutation, InsertGatewayBridgeMutationVariables>;
export const InsertGatewayBridgeWithOnConflictDocument = gql`
    mutation insertGatewayBridgeWithOnConflict($objects: [GatewayBridge_insert_input!]!, $onConflict: GatewayBridge_on_conflict) {
  insert_GatewayBridge(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...GatewayBridge
    }
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type InsertGatewayBridgeWithOnConflictMutationFn = Apollo.MutationFunction<InsertGatewayBridgeWithOnConflictMutation, InsertGatewayBridgeWithOnConflictMutationVariables>;
export type InsertGatewayBridgeWithOnConflictMutationResult = Apollo.MutationResult<InsertGatewayBridgeWithOnConflictMutation>;
export type InsertGatewayBridgeWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertGatewayBridgeWithOnConflictMutation, InsertGatewayBridgeWithOnConflictMutationVariables>;
export const UpdateGatewayBridgeByIdDocument = gql`
    mutation updateGatewayBridgeById($id: uuid, $set: GatewayBridge_set_input) {
  update_GatewayBridge(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...GatewayBridge
    }
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type UpdateGatewayBridgeByIdMutationFn = Apollo.MutationFunction<UpdateGatewayBridgeByIdMutation, UpdateGatewayBridgeByIdMutationVariables>;
export type UpdateGatewayBridgeByIdMutationResult = Apollo.MutationResult<UpdateGatewayBridgeByIdMutation>;
export type UpdateGatewayBridgeByIdMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayBridgeByIdMutation, UpdateGatewayBridgeByIdMutationVariables>;
export const UpdateGatewayBridgeDocument = gql`
    mutation updateGatewayBridge($set: GatewayBridge_set_input, $where: GatewayBridge_bool_exp!) {
  update_GatewayBridge(_set: $set, where: $where) {
    affected_rows
    returning {
      ...GatewayBridge
    }
  }
}
    ${GatewayBridgeFragmentDoc}`;
export type UpdateGatewayBridgeMutationFn = Apollo.MutationFunction<UpdateGatewayBridgeMutation, UpdateGatewayBridgeMutationVariables>;
export type UpdateGatewayBridgeMutationResult = Apollo.MutationResult<UpdateGatewayBridgeMutation>;
export type UpdateGatewayBridgeMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayBridgeMutation, UpdateGatewayBridgeMutationVariables>;
export const RemoveGatewayBridgeModelByIdDocument = gql`
    mutation removeGatewayBridgeModelById($id: uuid) {
  delete_GatewayBridge(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveGatewayBridgeModelByIdMutationFn = Apollo.MutationFunction<RemoveGatewayBridgeModelByIdMutation, RemoveGatewayBridgeModelByIdMutationVariables>;
export type RemoveGatewayBridgeModelByIdMutationResult = Apollo.MutationResult<RemoveGatewayBridgeModelByIdMutation>;
export type RemoveGatewayBridgeModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveGatewayBridgeModelByIdMutation, RemoveGatewayBridgeModelByIdMutationVariables>;
export const RemoveGatewayBridgeModelDocument = gql`
    mutation removeGatewayBridgeModel($where: GatewayBridge_bool_exp!) {
  delete_GatewayBridge(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveGatewayBridgeModelMutationFn = Apollo.MutationFunction<RemoveGatewayBridgeModelMutation, RemoveGatewayBridgeModelMutationVariables>;
export type RemoveGatewayBridgeModelMutationResult = Apollo.MutationResult<RemoveGatewayBridgeModelMutation>;
export type RemoveGatewayBridgeModelMutationOptions = Apollo.BaseMutationOptions<RemoveGatewayBridgeModelMutation, RemoveGatewayBridgeModelMutationVariables>;
export const QueryGatewaySubnetByIdDocument = gql`
    query queryGatewaySubnetById($gatewaySubnetId: uuid!) {
  GatewaySubnet_by_pk(id: $gatewaySubnetId) {
    ...GatewaySubnet
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type QueryGatewaySubnetByIdQueryResult = Apollo.QueryResult<QueryGatewaySubnetByIdQuery, QueryGatewaySubnetByIdQueryVariables>;
export const QueryGatewaySubnetObjectsDocument = gql`
    query queryGatewaySubnetObjects($distinct_on: [GatewaySubnet_select_column!], $where: GatewaySubnet_bool_exp, $limit: Int, $offset: Int, $order_by: [GatewaySubnet_order_by!]) {
  GatewaySubnet(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...GatewaySubnet
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type QueryGatewaySubnetObjectsQueryResult = Apollo.QueryResult<QueryGatewaySubnetObjectsQuery, QueryGatewaySubnetObjectsQueryVariables>;
export const SubscribeToGatewaySubnetByIdDocument = gql`
    subscription subscribeToGatewaySubnetById($gatewaySubnetId: uuid!) {
  GatewaySubnet_by_pk(id: $gatewaySubnetId) {
    ...GatewaySubnet
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type SubscribeToGatewaySubnetByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewaySubnetByIdSubscription>;
export const SubscribeToGatewaySubnetObjectsDocument = gql`
    subscription subscribeToGatewaySubnetObjects($distinct_on: [GatewaySubnet_select_column!], $where: GatewaySubnet_bool_exp, $limit: Int, $offset: Int, $order_by: [GatewaySubnet_order_by!]) {
  GatewaySubnet(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...GatewaySubnet
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type SubscribeToGatewaySubnetObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToGatewaySubnetObjectsSubscription>;
export const InsertGatewaySubnetDocument = gql`
    mutation insertGatewaySubnet($objects: [GatewaySubnet_insert_input!]!) {
  insert_GatewaySubnet(objects: $objects) {
    affected_rows
    returning {
      ...GatewaySubnet
    }
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type InsertGatewaySubnetMutationFn = Apollo.MutationFunction<InsertGatewaySubnetMutation, InsertGatewaySubnetMutationVariables>;
export type InsertGatewaySubnetMutationResult = Apollo.MutationResult<InsertGatewaySubnetMutation>;
export type InsertGatewaySubnetMutationOptions = Apollo.BaseMutationOptions<InsertGatewaySubnetMutation, InsertGatewaySubnetMutationVariables>;
export const InsertGatewaySubnetWithOnConflictDocument = gql`
    mutation insertGatewaySubnetWithOnConflict($objects: [GatewaySubnet_insert_input!]!, $onConflict: GatewaySubnet_on_conflict) {
  insert_GatewaySubnet(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...GatewaySubnet
    }
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type InsertGatewaySubnetWithOnConflictMutationFn = Apollo.MutationFunction<InsertGatewaySubnetWithOnConflictMutation, InsertGatewaySubnetWithOnConflictMutationVariables>;
export type InsertGatewaySubnetWithOnConflictMutationResult = Apollo.MutationResult<InsertGatewaySubnetWithOnConflictMutation>;
export type InsertGatewaySubnetWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertGatewaySubnetWithOnConflictMutation, InsertGatewaySubnetWithOnConflictMutationVariables>;
export const UpdateGatewaySubnetByIdDocument = gql`
    mutation updateGatewaySubnetById($id: uuid, $set: GatewaySubnet_set_input) {
  update_GatewaySubnet(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...GatewaySubnet
    }
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type UpdateGatewaySubnetByIdMutationFn = Apollo.MutationFunction<UpdateGatewaySubnetByIdMutation, UpdateGatewaySubnetByIdMutationVariables>;
export type UpdateGatewaySubnetByIdMutationResult = Apollo.MutationResult<UpdateGatewaySubnetByIdMutation>;
export type UpdateGatewaySubnetByIdMutationOptions = Apollo.BaseMutationOptions<UpdateGatewaySubnetByIdMutation, UpdateGatewaySubnetByIdMutationVariables>;
export const UpdateGatewaySubnetDocument = gql`
    mutation updateGatewaySubnet($set: GatewaySubnet_set_input, $where: GatewaySubnet_bool_exp!) {
  update_GatewaySubnet(_set: $set, where: $where) {
    affected_rows
    returning {
      ...GatewaySubnet
    }
  }
}
    ${GatewaySubnetFragmentDoc}`;
export type UpdateGatewaySubnetMutationFn = Apollo.MutationFunction<UpdateGatewaySubnetMutation, UpdateGatewaySubnetMutationVariables>;
export type UpdateGatewaySubnetMutationResult = Apollo.MutationResult<UpdateGatewaySubnetMutation>;
export type UpdateGatewaySubnetMutationOptions = Apollo.BaseMutationOptions<UpdateGatewaySubnetMutation, UpdateGatewaySubnetMutationVariables>;
export const RemoveGatewaySubnetModelByIdDocument = gql`
    mutation removeGatewaySubnetModelById($id: uuid) {
  delete_GatewaySubnet(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveGatewaySubnetModelByIdMutationFn = Apollo.MutationFunction<RemoveGatewaySubnetModelByIdMutation, RemoveGatewaySubnetModelByIdMutationVariables>;
export type RemoveGatewaySubnetModelByIdMutationResult = Apollo.MutationResult<RemoveGatewaySubnetModelByIdMutation>;
export type RemoveGatewaySubnetModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveGatewaySubnetModelByIdMutation, RemoveGatewaySubnetModelByIdMutationVariables>;
export const RemoveGatewaySubnetModelDocument = gql`
    mutation removeGatewaySubnetModel($where: GatewaySubnet_bool_exp!) {
  delete_GatewaySubnet(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveGatewaySubnetModelMutationFn = Apollo.MutationFunction<RemoveGatewaySubnetModelMutation, RemoveGatewaySubnetModelMutationVariables>;
export type RemoveGatewaySubnetModelMutationResult = Apollo.MutationResult<RemoveGatewaySubnetModelMutation>;
export type RemoveGatewaySubnetModelMutationOptions = Apollo.BaseMutationOptions<RemoveGatewaySubnetModelMutation, RemoveGatewaySubnetModelMutationVariables>;
export const QueryLanNodeByIdDocument = gql`
    query queryLanNodeById($lanNodeId: uuid!) {
  LanNode_by_pk(id: $lanNodeId) {
    ...LanNode
  }
}
    ${LanNodeFragmentDoc}`;
export type QueryLanNodeByIdQueryResult = Apollo.QueryResult<QueryLanNodeByIdQuery, QueryLanNodeByIdQueryVariables>;
export const QueryLanNodeObjectsDocument = gql`
    query queryLanNodeObjects($distinct_on: [LanNode_select_column!], $where: LanNode_bool_exp, $limit: Int, $offset: Int, $order_by: [LanNode_order_by!]) {
  LanNode(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...LanNode
  }
}
    ${LanNodeFragmentDoc}`;
export type QueryLanNodeObjectsQueryResult = Apollo.QueryResult<QueryLanNodeObjectsQuery, QueryLanNodeObjectsQueryVariables>;
export const SubscribeToLanNodeByIdDocument = gql`
    subscription subscribeToLanNodeById($lanNodeId: uuid!) {
  LanNode_by_pk(id: $lanNodeId) {
    ...LanNode
  }
}
    ${LanNodeFragmentDoc}`;
export type SubscribeToLanNodeByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLanNodeByIdSubscription>;
export const SubscribeToLanNodeObjectsDocument = gql`
    subscription subscribeToLanNodeObjects($distinct_on: [LanNode_select_column!], $where: LanNode_bool_exp, $limit: Int, $offset: Int, $order_by: [LanNode_order_by!]) {
  LanNode(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...LanNode
  }
}
    ${LanNodeFragmentDoc}`;
export type SubscribeToLanNodeObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLanNodeObjectsSubscription>;
export const InsertLanNodeDocument = gql`
    mutation insertLanNode($objects: [LanNode_insert_input!]!) {
  insert_LanNode(objects: $objects) {
    affected_rows
    returning {
      ...LanNode
    }
  }
}
    ${LanNodeFragmentDoc}`;
export type InsertLanNodeMutationFn = Apollo.MutationFunction<InsertLanNodeMutation, InsertLanNodeMutationVariables>;
export type InsertLanNodeMutationResult = Apollo.MutationResult<InsertLanNodeMutation>;
export type InsertLanNodeMutationOptions = Apollo.BaseMutationOptions<InsertLanNodeMutation, InsertLanNodeMutationVariables>;
export const InsertLanNodeWithOnConflictDocument = gql`
    mutation insertLanNodeWithOnConflict($objects: [LanNode_insert_input!]!, $onConflict: LanNode_on_conflict) {
  insert_LanNode(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...LanNode
    }
  }
}
    ${LanNodeFragmentDoc}`;
export type InsertLanNodeWithOnConflictMutationFn = Apollo.MutationFunction<InsertLanNodeWithOnConflictMutation, InsertLanNodeWithOnConflictMutationVariables>;
export type InsertLanNodeWithOnConflictMutationResult = Apollo.MutationResult<InsertLanNodeWithOnConflictMutation>;
export type InsertLanNodeWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertLanNodeWithOnConflictMutation, InsertLanNodeWithOnConflictMutationVariables>;
export const UpdateLanNodeByIdDocument = gql`
    mutation updateLanNodeById($id: uuid, $set: LanNode_set_input) {
  update_LanNode(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...LanNode
    }
  }
}
    ${LanNodeFragmentDoc}`;
export type UpdateLanNodeByIdMutationFn = Apollo.MutationFunction<UpdateLanNodeByIdMutation, UpdateLanNodeByIdMutationVariables>;
export type UpdateLanNodeByIdMutationResult = Apollo.MutationResult<UpdateLanNodeByIdMutation>;
export type UpdateLanNodeByIdMutationOptions = Apollo.BaseMutationOptions<UpdateLanNodeByIdMutation, UpdateLanNodeByIdMutationVariables>;
export const UpdateLanNodeDocument = gql`
    mutation updateLanNode($set: LanNode_set_input, $where: LanNode_bool_exp!) {
  update_LanNode(_set: $set, where: $where) {
    affected_rows
    returning {
      ...LanNode
    }
  }
}
    ${LanNodeFragmentDoc}`;
export type UpdateLanNodeMutationFn = Apollo.MutationFunction<UpdateLanNodeMutation, UpdateLanNodeMutationVariables>;
export type UpdateLanNodeMutationResult = Apollo.MutationResult<UpdateLanNodeMutation>;
export type UpdateLanNodeMutationOptions = Apollo.BaseMutationOptions<UpdateLanNodeMutation, UpdateLanNodeMutationVariables>;
export const RemoveLanNodeModelByIdDocument = gql`
    mutation removeLanNodeModelById($id: uuid) {
  delete_LanNode(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveLanNodeModelByIdMutationFn = Apollo.MutationFunction<RemoveLanNodeModelByIdMutation, RemoveLanNodeModelByIdMutationVariables>;
export type RemoveLanNodeModelByIdMutationResult = Apollo.MutationResult<RemoveLanNodeModelByIdMutation>;
export type RemoveLanNodeModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveLanNodeModelByIdMutation, RemoveLanNodeModelByIdMutationVariables>;
export const RemoveLanNodeModelDocument = gql`
    mutation removeLanNodeModel($where: LanNode_bool_exp!) {
  delete_LanNode(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveLanNodeModelMutationFn = Apollo.MutationFunction<RemoveLanNodeModelMutation, RemoveLanNodeModelMutationVariables>;
export type RemoveLanNodeModelMutationResult = Apollo.MutationResult<RemoveLanNodeModelMutation>;
export type RemoveLanNodeModelMutationOptions = Apollo.BaseMutationOptions<RemoveLanNodeModelMutation, RemoveLanNodeModelMutationVariables>;
export const QueryLinkByIdDocument = gql`
    query queryLinkById($linkId: uuid!) {
  Link_by_pk(id: $linkId) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type QueryLinkByIdQueryResult = Apollo.QueryResult<QueryLinkByIdQuery, QueryLinkByIdQueryVariables>;
export const QueryLinkObjectsDocument = gql`
    query queryLinkObjects($distinct_on: [Link_select_column!], $where: Link_bool_exp, $limit: Int, $offset: Int, $order_by: [Link_order_by!]) {
  Link(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type QueryLinkObjectsQueryResult = Apollo.QueryResult<QueryLinkObjectsQuery, QueryLinkObjectsQueryVariables>;
export const SubscribeToLinkByIdDocument = gql`
    subscription subscribeToLinkById($linkId: uuid!) {
  Link_by_pk(id: $linkId) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type SubscribeToLinkByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLinkByIdSubscription>;
export const SubscribeToLinkObjectsDocument = gql`
    subscription subscribeToLinkObjects($distinct_on: [Link_select_column!], $where: Link_bool_exp, $limit: Int, $offset: Int, $order_by: [Link_order_by!]) {
  Link(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Link
  }
}
    ${LinkFragmentDoc}`;
export type SubscribeToLinkObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLinkObjectsSubscription>;
export const InsertLinkDocument = gql`
    mutation insertLink($objects: [Link_insert_input!]!) {
  insert_Link(objects: $objects) {
    affected_rows
    returning {
      ...Link
    }
  }
}
    ${LinkFragmentDoc}`;
export type InsertLinkMutationFn = Apollo.MutationFunction<InsertLinkMutation, InsertLinkMutationVariables>;
export type InsertLinkMutationResult = Apollo.MutationResult<InsertLinkMutation>;
export type InsertLinkMutationOptions = Apollo.BaseMutationOptions<InsertLinkMutation, InsertLinkMutationVariables>;
export const InsertLinkWithOnConflictDocument = gql`
    mutation insertLinkWithOnConflict($objects: [Link_insert_input!]!, $onConflict: Link_on_conflict) {
  insert_Link(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Link
    }
  }
}
    ${LinkFragmentDoc}`;
export type InsertLinkWithOnConflictMutationFn = Apollo.MutationFunction<InsertLinkWithOnConflictMutation, InsertLinkWithOnConflictMutationVariables>;
export type InsertLinkWithOnConflictMutationResult = Apollo.MutationResult<InsertLinkWithOnConflictMutation>;
export type InsertLinkWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertLinkWithOnConflictMutation, InsertLinkWithOnConflictMutationVariables>;
export const UpdateLinkByIdDocument = gql`
    mutation updateLinkById($id: uuid, $set: Link_set_input) {
  update_Link(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Link
    }
  }
}
    ${LinkFragmentDoc}`;
export type UpdateLinkByIdMutationFn = Apollo.MutationFunction<UpdateLinkByIdMutation, UpdateLinkByIdMutationVariables>;
export type UpdateLinkByIdMutationResult = Apollo.MutationResult<UpdateLinkByIdMutation>;
export type UpdateLinkByIdMutationOptions = Apollo.BaseMutationOptions<UpdateLinkByIdMutation, UpdateLinkByIdMutationVariables>;
export const UpdateLinkDocument = gql`
    mutation updateLink($set: Link_set_input, $where: Link_bool_exp!) {
  update_Link(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Link
    }
  }
}
    ${LinkFragmentDoc}`;
export type UpdateLinkMutationFn = Apollo.MutationFunction<UpdateLinkMutation, UpdateLinkMutationVariables>;
export type UpdateLinkMutationResult = Apollo.MutationResult<UpdateLinkMutation>;
export type UpdateLinkMutationOptions = Apollo.BaseMutationOptions<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const RemoveLinkModelByIdDocument = gql`
    mutation removeLinkModelById($id: uuid) {
  delete_Link(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveLinkModelByIdMutationFn = Apollo.MutationFunction<RemoveLinkModelByIdMutation, RemoveLinkModelByIdMutationVariables>;
export type RemoveLinkModelByIdMutationResult = Apollo.MutationResult<RemoveLinkModelByIdMutation>;
export type RemoveLinkModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveLinkModelByIdMutation, RemoveLinkModelByIdMutationVariables>;
export const RemoveLinkModelDocument = gql`
    mutation removeLinkModel($where: Link_bool_exp!) {
  delete_Link(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveLinkModelMutationFn = Apollo.MutationFunction<RemoveLinkModelMutation, RemoveLinkModelMutationVariables>;
export type RemoveLinkModelMutationResult = Apollo.MutationResult<RemoveLinkModelMutation>;
export type RemoveLinkModelMutationOptions = Apollo.BaseMutationOptions<RemoveLinkModelMutation, RemoveLinkModelMutationVariables>;
export const QueryLinkTypeByIdDocument = gql`
    query queryLinkTypeById($linkTypeId: uuid!) {
  LinkType_by_pk(id: $linkTypeId) {
    ...LinkType
  }
}
    ${LinkTypeFragmentDoc}`;
export type QueryLinkTypeByIdQueryResult = Apollo.QueryResult<QueryLinkTypeByIdQuery, QueryLinkTypeByIdQueryVariables>;
export const QueryLinkTypeObjectsDocument = gql`
    query queryLinkTypeObjects($distinct_on: [LinkType_select_column!], $where: LinkType_bool_exp, $limit: Int, $offset: Int, $order_by: [LinkType_order_by!]) {
  LinkType(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...LinkType
  }
}
    ${LinkTypeFragmentDoc}`;
export type QueryLinkTypeObjectsQueryResult = Apollo.QueryResult<QueryLinkTypeObjectsQuery, QueryLinkTypeObjectsQueryVariables>;
export const SubscribeToLinkTypeByIdDocument = gql`
    subscription subscribeToLinkTypeById($linkTypeId: uuid!) {
  LinkType_by_pk(id: $linkTypeId) {
    ...LinkType
  }
}
    ${LinkTypeFragmentDoc}`;
export type SubscribeToLinkTypeByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLinkTypeByIdSubscription>;
export const SubscribeToLinkTypeObjectsDocument = gql`
    subscription subscribeToLinkTypeObjects($distinct_on: [LinkType_select_column!], $where: LinkType_bool_exp, $limit: Int, $offset: Int, $order_by: [LinkType_order_by!]) {
  LinkType(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...LinkType
  }
}
    ${LinkTypeFragmentDoc}`;
export type SubscribeToLinkTypeObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLinkTypeObjectsSubscription>;
export const InsertLinkTypeDocument = gql`
    mutation insertLinkType($objects: [LinkType_insert_input!]!) {
  insert_LinkType(objects: $objects) {
    affected_rows
    returning {
      ...LinkType
    }
  }
}
    ${LinkTypeFragmentDoc}`;
export type InsertLinkTypeMutationFn = Apollo.MutationFunction<InsertLinkTypeMutation, InsertLinkTypeMutationVariables>;
export type InsertLinkTypeMutationResult = Apollo.MutationResult<InsertLinkTypeMutation>;
export type InsertLinkTypeMutationOptions = Apollo.BaseMutationOptions<InsertLinkTypeMutation, InsertLinkTypeMutationVariables>;
export const InsertLinkTypeWithOnConflictDocument = gql`
    mutation insertLinkTypeWithOnConflict($objects: [LinkType_insert_input!]!, $onConflict: LinkType_on_conflict) {
  insert_LinkType(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...LinkType
    }
  }
}
    ${LinkTypeFragmentDoc}`;
export type InsertLinkTypeWithOnConflictMutationFn = Apollo.MutationFunction<InsertLinkTypeWithOnConflictMutation, InsertLinkTypeWithOnConflictMutationVariables>;
export type InsertLinkTypeWithOnConflictMutationResult = Apollo.MutationResult<InsertLinkTypeWithOnConflictMutation>;
export type InsertLinkTypeWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertLinkTypeWithOnConflictMutation, InsertLinkTypeWithOnConflictMutationVariables>;
export const UpdateLinkTypeByIdDocument = gql`
    mutation updateLinkTypeById($id: uuid, $set: LinkType_set_input) {
  update_LinkType(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...LinkType
    }
  }
}
    ${LinkTypeFragmentDoc}`;
export type UpdateLinkTypeByIdMutationFn = Apollo.MutationFunction<UpdateLinkTypeByIdMutation, UpdateLinkTypeByIdMutationVariables>;
export type UpdateLinkTypeByIdMutationResult = Apollo.MutationResult<UpdateLinkTypeByIdMutation>;
export type UpdateLinkTypeByIdMutationOptions = Apollo.BaseMutationOptions<UpdateLinkTypeByIdMutation, UpdateLinkTypeByIdMutationVariables>;
export const UpdateLinkTypeDocument = gql`
    mutation updateLinkType($set: LinkType_set_input, $where: LinkType_bool_exp!) {
  update_LinkType(_set: $set, where: $where) {
    affected_rows
    returning {
      ...LinkType
    }
  }
}
    ${LinkTypeFragmentDoc}`;
export type UpdateLinkTypeMutationFn = Apollo.MutationFunction<UpdateLinkTypeMutation, UpdateLinkTypeMutationVariables>;
export type UpdateLinkTypeMutationResult = Apollo.MutationResult<UpdateLinkTypeMutation>;
export type UpdateLinkTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLinkTypeMutation, UpdateLinkTypeMutationVariables>;
export const RemoveLinkTypeModelByIdDocument = gql`
    mutation removeLinkTypeModelById($id: uuid) {
  delete_LinkType(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveLinkTypeModelByIdMutationFn = Apollo.MutationFunction<RemoveLinkTypeModelByIdMutation, RemoveLinkTypeModelByIdMutationVariables>;
export type RemoveLinkTypeModelByIdMutationResult = Apollo.MutationResult<RemoveLinkTypeModelByIdMutation>;
export type RemoveLinkTypeModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveLinkTypeModelByIdMutation, RemoveLinkTypeModelByIdMutationVariables>;
export const RemoveLinkTypeModelDocument = gql`
    mutation removeLinkTypeModel($where: LinkType_bool_exp!) {
  delete_LinkType(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveLinkTypeModelMutationFn = Apollo.MutationFunction<RemoveLinkTypeModelMutation, RemoveLinkTypeModelMutationVariables>;
export type RemoveLinkTypeModelMutationResult = Apollo.MutationResult<RemoveLinkTypeModelMutation>;
export type RemoveLinkTypeModelMutationOptions = Apollo.BaseMutationOptions<RemoveLinkTypeModelMutation, RemoveLinkTypeModelMutationVariables>;
export const QueryMeshWanByIdDocument = gql`
    query queryMeshWanById($meshWanId: uuid!) {
  MeshWan_by_pk(id: $meshWanId) {
    ...MeshWan
  }
}
    ${MeshWanFragmentDoc}`;
export type QueryMeshWanByIdQueryResult = Apollo.QueryResult<QueryMeshWanByIdQuery, QueryMeshWanByIdQueryVariables>;
export const QueryMeshWanObjectsDocument = gql`
    query queryMeshWanObjects($distinct_on: [MeshWan_select_column!], $where: MeshWan_bool_exp, $limit: Int, $offset: Int, $order_by: [MeshWan_order_by!]) {
  MeshWan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...MeshWan
  }
}
    ${MeshWanFragmentDoc}`;
export type QueryMeshWanObjectsQueryResult = Apollo.QueryResult<QueryMeshWanObjectsQuery, QueryMeshWanObjectsQueryVariables>;
export const SubscribeToMeshWanByIdDocument = gql`
    subscription subscribeToMeshWanById($meshWanId: uuid!) {
  MeshWan_by_pk(id: $meshWanId) {
    ...MeshWan
  }
}
    ${MeshWanFragmentDoc}`;
export type SubscribeToMeshWanByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMeshWanByIdSubscription>;
export const SubscribeToMeshWanObjectsDocument = gql`
    subscription subscribeToMeshWanObjects($distinct_on: [MeshWan_select_column!], $where: MeshWan_bool_exp, $limit: Int, $offset: Int, $order_by: [MeshWan_order_by!]) {
  MeshWan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...MeshWan
  }
}
    ${MeshWanFragmentDoc}`;
export type SubscribeToMeshWanObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMeshWanObjectsSubscription>;
export const InsertMeshWanDocument = gql`
    mutation insertMeshWan($objects: [MeshWan_insert_input!]!) {
  insert_MeshWan(objects: $objects) {
    affected_rows
    returning {
      ...MeshWan
    }
  }
}
    ${MeshWanFragmentDoc}`;
export type InsertMeshWanMutationFn = Apollo.MutationFunction<InsertMeshWanMutation, InsertMeshWanMutationVariables>;
export type InsertMeshWanMutationResult = Apollo.MutationResult<InsertMeshWanMutation>;
export type InsertMeshWanMutationOptions = Apollo.BaseMutationOptions<InsertMeshWanMutation, InsertMeshWanMutationVariables>;
export const InsertMeshWanWithOnConflictDocument = gql`
    mutation insertMeshWanWithOnConflict($objects: [MeshWan_insert_input!]!, $onConflict: MeshWan_on_conflict) {
  insert_MeshWan(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...MeshWan
    }
  }
}
    ${MeshWanFragmentDoc}`;
export type InsertMeshWanWithOnConflictMutationFn = Apollo.MutationFunction<InsertMeshWanWithOnConflictMutation, InsertMeshWanWithOnConflictMutationVariables>;
export type InsertMeshWanWithOnConflictMutationResult = Apollo.MutationResult<InsertMeshWanWithOnConflictMutation>;
export type InsertMeshWanWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertMeshWanWithOnConflictMutation, InsertMeshWanWithOnConflictMutationVariables>;
export const UpdateMeshWanByIdDocument = gql`
    mutation updateMeshWanById($id: uuid, $set: MeshWan_set_input) {
  update_MeshWan(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...MeshWan
    }
  }
}
    ${MeshWanFragmentDoc}`;
export type UpdateMeshWanByIdMutationFn = Apollo.MutationFunction<UpdateMeshWanByIdMutation, UpdateMeshWanByIdMutationVariables>;
export type UpdateMeshWanByIdMutationResult = Apollo.MutationResult<UpdateMeshWanByIdMutation>;
export type UpdateMeshWanByIdMutationOptions = Apollo.BaseMutationOptions<UpdateMeshWanByIdMutation, UpdateMeshWanByIdMutationVariables>;
export const UpdateMeshWanDocument = gql`
    mutation updateMeshWan($set: MeshWan_set_input, $where: MeshWan_bool_exp!) {
  update_MeshWan(_set: $set, where: $where) {
    affected_rows
    returning {
      ...MeshWan
    }
  }
}
    ${MeshWanFragmentDoc}`;
export type UpdateMeshWanMutationFn = Apollo.MutationFunction<UpdateMeshWanMutation, UpdateMeshWanMutationVariables>;
export type UpdateMeshWanMutationResult = Apollo.MutationResult<UpdateMeshWanMutation>;
export type UpdateMeshWanMutationOptions = Apollo.BaseMutationOptions<UpdateMeshWanMutation, UpdateMeshWanMutationVariables>;
export const RemoveMeshWanModelByIdDocument = gql`
    mutation removeMeshWanModelById($id: uuid) {
  delete_MeshWan(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveMeshWanModelByIdMutationFn = Apollo.MutationFunction<RemoveMeshWanModelByIdMutation, RemoveMeshWanModelByIdMutationVariables>;
export type RemoveMeshWanModelByIdMutationResult = Apollo.MutationResult<RemoveMeshWanModelByIdMutation>;
export type RemoveMeshWanModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveMeshWanModelByIdMutation, RemoveMeshWanModelByIdMutationVariables>;
export const RemoveMeshWanModelDocument = gql`
    mutation removeMeshWanModel($where: MeshWan_bool_exp!) {
  delete_MeshWan(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveMeshWanModelMutationFn = Apollo.MutationFunction<RemoveMeshWanModelMutation, RemoveMeshWanModelMutationVariables>;
export type RemoveMeshWanModelMutationResult = Apollo.MutationResult<RemoveMeshWanModelMutation>;
export type RemoveMeshWanModelMutationOptions = Apollo.BaseMutationOptions<RemoveMeshWanModelMutation, RemoveMeshWanModelMutationVariables>;
export const QueryMonitorByIdDocument = gql`
    query queryMonitorById($monitorId: uuid!) {
  Monitor_by_pk(id: $monitorId) {
    ...Monitor
  }
}
    ${MonitorFragmentDoc}`;
export type QueryMonitorByIdQueryResult = Apollo.QueryResult<QueryMonitorByIdQuery, QueryMonitorByIdQueryVariables>;
export const QueryMonitorObjectsDocument = gql`
    query queryMonitorObjects($distinct_on: [Monitor_select_column!], $where: Monitor_bool_exp, $limit: Int, $offset: Int, $order_by: [Monitor_order_by!]) {
  Monitor(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Monitor
  }
}
    ${MonitorFragmentDoc}`;
export type QueryMonitorObjectsQueryResult = Apollo.QueryResult<QueryMonitorObjectsQuery, QueryMonitorObjectsQueryVariables>;
export const SubscribeToMonitorByIdDocument = gql`
    subscription subscribeToMonitorById($monitorId: uuid!) {
  Monitor_by_pk(id: $monitorId) {
    ...Monitor
  }
}
    ${MonitorFragmentDoc}`;
export type SubscribeToMonitorByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMonitorByIdSubscription>;
export const SubscribeToMonitorObjectsDocument = gql`
    subscription subscribeToMonitorObjects($distinct_on: [Monitor_select_column!], $where: Monitor_bool_exp, $limit: Int, $offset: Int, $order_by: [Monitor_order_by!]) {
  Monitor(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Monitor
  }
}
    ${MonitorFragmentDoc}`;
export type SubscribeToMonitorObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToMonitorObjectsSubscription>;
export const InsertMonitorDocument = gql`
    mutation insertMonitor($objects: [Monitor_insert_input!]!) {
  insert_Monitor(objects: $objects) {
    affected_rows
    returning {
      ...Monitor
    }
  }
}
    ${MonitorFragmentDoc}`;
export type InsertMonitorMutationFn = Apollo.MutationFunction<InsertMonitorMutation, InsertMonitorMutationVariables>;
export type InsertMonitorMutationResult = Apollo.MutationResult<InsertMonitorMutation>;
export type InsertMonitorMutationOptions = Apollo.BaseMutationOptions<InsertMonitorMutation, InsertMonitorMutationVariables>;
export const InsertMonitorWithOnConflictDocument = gql`
    mutation insertMonitorWithOnConflict($objects: [Monitor_insert_input!]!, $onConflict: Monitor_on_conflict) {
  insert_Monitor(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Monitor
    }
  }
}
    ${MonitorFragmentDoc}`;
export type InsertMonitorWithOnConflictMutationFn = Apollo.MutationFunction<InsertMonitorWithOnConflictMutation, InsertMonitorWithOnConflictMutationVariables>;
export type InsertMonitorWithOnConflictMutationResult = Apollo.MutationResult<InsertMonitorWithOnConflictMutation>;
export type InsertMonitorWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertMonitorWithOnConflictMutation, InsertMonitorWithOnConflictMutationVariables>;
export const UpdateMonitorByIdDocument = gql`
    mutation updateMonitorById($id: uuid, $set: Monitor_set_input) {
  update_Monitor(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Monitor
    }
  }
}
    ${MonitorFragmentDoc}`;
export type UpdateMonitorByIdMutationFn = Apollo.MutationFunction<UpdateMonitorByIdMutation, UpdateMonitorByIdMutationVariables>;
export type UpdateMonitorByIdMutationResult = Apollo.MutationResult<UpdateMonitorByIdMutation>;
export type UpdateMonitorByIdMutationOptions = Apollo.BaseMutationOptions<UpdateMonitorByIdMutation, UpdateMonitorByIdMutationVariables>;
export const UpdateMonitorDocument = gql`
    mutation updateMonitor($set: Monitor_set_input, $where: Monitor_bool_exp!) {
  update_Monitor(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Monitor
    }
  }
}
    ${MonitorFragmentDoc}`;
export type UpdateMonitorMutationFn = Apollo.MutationFunction<UpdateMonitorMutation, UpdateMonitorMutationVariables>;
export type UpdateMonitorMutationResult = Apollo.MutationResult<UpdateMonitorMutation>;
export type UpdateMonitorMutationOptions = Apollo.BaseMutationOptions<UpdateMonitorMutation, UpdateMonitorMutationVariables>;
export const RemoveMonitorModelByIdDocument = gql`
    mutation removeMonitorModelById($id: uuid) {
  delete_Monitor(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveMonitorModelByIdMutationFn = Apollo.MutationFunction<RemoveMonitorModelByIdMutation, RemoveMonitorModelByIdMutationVariables>;
export type RemoveMonitorModelByIdMutationResult = Apollo.MutationResult<RemoveMonitorModelByIdMutation>;
export type RemoveMonitorModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveMonitorModelByIdMutation, RemoveMonitorModelByIdMutationVariables>;
export const RemoveMonitorModelDocument = gql`
    mutation removeMonitorModel($where: Monitor_bool_exp!) {
  delete_Monitor(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveMonitorModelMutationFn = Apollo.MutationFunction<RemoveMonitorModelMutation, RemoveMonitorModelMutationVariables>;
export type RemoveMonitorModelMutationResult = Apollo.MutationResult<RemoveMonitorModelMutation>;
export type RemoveMonitorModelMutationOptions = Apollo.BaseMutationOptions<RemoveMonitorModelMutation, RemoveMonitorModelMutationVariables>;
export const QueryProfileByIdDocument = gql`
    query queryProfileById($profileId: uuid!) {
  Profile_by_pk(id: $profileId) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type QueryProfileByIdQueryResult = Apollo.QueryResult<QueryProfileByIdQuery, QueryProfileByIdQueryVariables>;
export const QueryProfileObjectsDocument = gql`
    query queryProfileObjects($distinct_on: [Profile_select_column!], $where: Profile_bool_exp, $limit: Int, $offset: Int, $order_by: [Profile_order_by!]) {
  Profile(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type QueryProfileObjectsQueryResult = Apollo.QueryResult<QueryProfileObjectsQuery, QueryProfileObjectsQueryVariables>;
export const SubscribeToProfileByIdDocument = gql`
    subscription subscribeToProfileById($profileId: uuid!) {
  Profile_by_pk(id: $profileId) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type SubscribeToProfileByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToProfileByIdSubscription>;
export const SubscribeToProfileObjectsDocument = gql`
    subscription subscribeToProfileObjects($distinct_on: [Profile_select_column!], $where: Profile_bool_exp, $limit: Int, $offset: Int, $order_by: [Profile_order_by!]) {
  Profile(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Profile
  }
}
    ${ProfileFragmentDoc}`;
export type SubscribeToProfileObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToProfileObjectsSubscription>;
export const InsertProfileDocument = gql`
    mutation insertProfile($objects: [Profile_insert_input!]!) {
  insert_Profile(objects: $objects) {
    affected_rows
    returning {
      ...Profile
    }
  }
}
    ${ProfileFragmentDoc}`;
export type InsertProfileMutationFn = Apollo.MutationFunction<InsertProfileMutation, InsertProfileMutationVariables>;
export type InsertProfileMutationResult = Apollo.MutationResult<InsertProfileMutation>;
export type InsertProfileMutationOptions = Apollo.BaseMutationOptions<InsertProfileMutation, InsertProfileMutationVariables>;
export const InsertProfileWithOnConflictDocument = gql`
    mutation insertProfileWithOnConflict($objects: [Profile_insert_input!]!, $onConflict: Profile_on_conflict) {
  insert_Profile(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Profile
    }
  }
}
    ${ProfileFragmentDoc}`;
export type InsertProfileWithOnConflictMutationFn = Apollo.MutationFunction<InsertProfileWithOnConflictMutation, InsertProfileWithOnConflictMutationVariables>;
export type InsertProfileWithOnConflictMutationResult = Apollo.MutationResult<InsertProfileWithOnConflictMutation>;
export type InsertProfileWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertProfileWithOnConflictMutation, InsertProfileWithOnConflictMutationVariables>;
export const UpdateProfileByIdDocument = gql`
    mutation updateProfileById($id: uuid, $set: Profile_set_input) {
  update_Profile(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Profile
    }
  }
}
    ${ProfileFragmentDoc}`;
export type UpdateProfileByIdMutationFn = Apollo.MutationFunction<UpdateProfileByIdMutation, UpdateProfileByIdMutationVariables>;
export type UpdateProfileByIdMutationResult = Apollo.MutationResult<UpdateProfileByIdMutation>;
export type UpdateProfileByIdMutationOptions = Apollo.BaseMutationOptions<UpdateProfileByIdMutation, UpdateProfileByIdMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($set: Profile_set_input, $where: Profile_bool_exp!) {
  update_Profile(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Profile
    }
  }
}
    ${ProfileFragmentDoc}`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const RemoveProfileModelByIdDocument = gql`
    mutation removeProfileModelById($id: uuid) {
  delete_Profile(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveProfileModelByIdMutationFn = Apollo.MutationFunction<RemoveProfileModelByIdMutation, RemoveProfileModelByIdMutationVariables>;
export type RemoveProfileModelByIdMutationResult = Apollo.MutationResult<RemoveProfileModelByIdMutation>;
export type RemoveProfileModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveProfileModelByIdMutation, RemoveProfileModelByIdMutationVariables>;
export const RemoveProfileModelDocument = gql`
    mutation removeProfileModel($where: Profile_bool_exp!) {
  delete_Profile(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveProfileModelMutationFn = Apollo.MutationFunction<RemoveProfileModelMutation, RemoveProfileModelMutationVariables>;
export type RemoveProfileModelMutationResult = Apollo.MutationResult<RemoveProfileModelMutation>;
export type RemoveProfileModelMutationOptions = Apollo.BaseMutationOptions<RemoveProfileModelMutation, RemoveProfileModelMutationVariables>;
export const QueryPublicIpByIdDocument = gql`
    query queryPublicIpById($publicIpId: uuid!) {
  PublicIp_by_pk(id: $publicIpId) {
    ...PublicIp
  }
}
    ${PublicIpFragmentDoc}`;
export type QueryPublicIpByIdQueryResult = Apollo.QueryResult<QueryPublicIpByIdQuery, QueryPublicIpByIdQueryVariables>;
export const QueryPublicIpObjectsDocument = gql`
    query queryPublicIpObjects($distinct_on: [PublicIp_select_column!], $where: PublicIp_bool_exp, $limit: Int, $offset: Int, $order_by: [PublicIp_order_by!]) {
  PublicIp(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...PublicIp
  }
}
    ${PublicIpFragmentDoc}`;
export type QueryPublicIpObjectsQueryResult = Apollo.QueryResult<QueryPublicIpObjectsQuery, QueryPublicIpObjectsQueryVariables>;
export const SubscribeToPublicIpByIdDocument = gql`
    subscription subscribeToPublicIpById($publicIpId: uuid!) {
  PublicIp_by_pk(id: $publicIpId) {
    ...PublicIp
  }
}
    ${PublicIpFragmentDoc}`;
export type SubscribeToPublicIpByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPublicIpByIdSubscription>;
export const SubscribeToPublicIpObjectsDocument = gql`
    subscription subscribeToPublicIpObjects($distinct_on: [PublicIp_select_column!], $where: PublicIp_bool_exp, $limit: Int, $offset: Int, $order_by: [PublicIp_order_by!]) {
  PublicIp(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...PublicIp
  }
}
    ${PublicIpFragmentDoc}`;
export type SubscribeToPublicIpObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToPublicIpObjectsSubscription>;
export const InsertPublicIpDocument = gql`
    mutation insertPublicIp($objects: [PublicIp_insert_input!]!) {
  insert_PublicIp(objects: $objects) {
    affected_rows
    returning {
      ...PublicIp
    }
  }
}
    ${PublicIpFragmentDoc}`;
export type InsertPublicIpMutationFn = Apollo.MutationFunction<InsertPublicIpMutation, InsertPublicIpMutationVariables>;
export type InsertPublicIpMutationResult = Apollo.MutationResult<InsertPublicIpMutation>;
export type InsertPublicIpMutationOptions = Apollo.BaseMutationOptions<InsertPublicIpMutation, InsertPublicIpMutationVariables>;
export const InsertPublicIpWithOnConflictDocument = gql`
    mutation insertPublicIpWithOnConflict($objects: [PublicIp_insert_input!]!, $onConflict: PublicIp_on_conflict) {
  insert_PublicIp(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...PublicIp
    }
  }
}
    ${PublicIpFragmentDoc}`;
export type InsertPublicIpWithOnConflictMutationFn = Apollo.MutationFunction<InsertPublicIpWithOnConflictMutation, InsertPublicIpWithOnConflictMutationVariables>;
export type InsertPublicIpWithOnConflictMutationResult = Apollo.MutationResult<InsertPublicIpWithOnConflictMutation>;
export type InsertPublicIpWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertPublicIpWithOnConflictMutation, InsertPublicIpWithOnConflictMutationVariables>;
export const UpdatePublicIpByIdDocument = gql`
    mutation updatePublicIpById($id: uuid, $set: PublicIp_set_input) {
  update_PublicIp(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...PublicIp
    }
  }
}
    ${PublicIpFragmentDoc}`;
export type UpdatePublicIpByIdMutationFn = Apollo.MutationFunction<UpdatePublicIpByIdMutation, UpdatePublicIpByIdMutationVariables>;
export type UpdatePublicIpByIdMutationResult = Apollo.MutationResult<UpdatePublicIpByIdMutation>;
export type UpdatePublicIpByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePublicIpByIdMutation, UpdatePublicIpByIdMutationVariables>;
export const UpdatePublicIpDocument = gql`
    mutation updatePublicIp($set: PublicIp_set_input, $where: PublicIp_bool_exp!) {
  update_PublicIp(_set: $set, where: $where) {
    affected_rows
    returning {
      ...PublicIp
    }
  }
}
    ${PublicIpFragmentDoc}`;
export type UpdatePublicIpMutationFn = Apollo.MutationFunction<UpdatePublicIpMutation, UpdatePublicIpMutationVariables>;
export type UpdatePublicIpMutationResult = Apollo.MutationResult<UpdatePublicIpMutation>;
export type UpdatePublicIpMutationOptions = Apollo.BaseMutationOptions<UpdatePublicIpMutation, UpdatePublicIpMutationVariables>;
export const RemovePublicIpModelByIdDocument = gql`
    mutation removePublicIpModelById($id: uuid) {
  delete_PublicIp(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemovePublicIpModelByIdMutationFn = Apollo.MutationFunction<RemovePublicIpModelByIdMutation, RemovePublicIpModelByIdMutationVariables>;
export type RemovePublicIpModelByIdMutationResult = Apollo.MutationResult<RemovePublicIpModelByIdMutation>;
export type RemovePublicIpModelByIdMutationOptions = Apollo.BaseMutationOptions<RemovePublicIpModelByIdMutation, RemovePublicIpModelByIdMutationVariables>;
export const RemovePublicIpModelDocument = gql`
    mutation removePublicIpModel($where: PublicIp_bool_exp!) {
  delete_PublicIp(where: $where) {
    affected_rows
  }
}
    `;
export type RemovePublicIpModelMutationFn = Apollo.MutationFunction<RemovePublicIpModelMutation, RemovePublicIpModelMutationVariables>;
export type RemovePublicIpModelMutationResult = Apollo.MutationResult<RemovePublicIpModelMutation>;
export type RemovePublicIpModelMutationOptions = Apollo.BaseMutationOptions<RemovePublicIpModelMutation, RemovePublicIpModelMutationVariables>;
export const QueryServerByIdDocument = gql`
    query queryServerById($serverId: uuid!) {
  Server_by_pk(id: $serverId) {
    ...Server
  }
}
    ${ServerFragmentDoc}`;
export type QueryServerByIdQueryResult = Apollo.QueryResult<QueryServerByIdQuery, QueryServerByIdQueryVariables>;
export const QueryServerObjectsDocument = gql`
    query queryServerObjects($distinct_on: [Server_select_column!], $where: Server_bool_exp, $limit: Int, $offset: Int, $order_by: [Server_order_by!]) {
  Server(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Server
  }
}
    ${ServerFragmentDoc}`;
export type QueryServerObjectsQueryResult = Apollo.QueryResult<QueryServerObjectsQuery, QueryServerObjectsQueryVariables>;
export const SubscribeToServerByIdDocument = gql`
    subscription subscribeToServerById($serverId: uuid!) {
  Server_by_pk(id: $serverId) {
    ...Server
  }
}
    ${ServerFragmentDoc}`;
export type SubscribeToServerByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToServerByIdSubscription>;
export const SubscribeToServerObjectsDocument = gql`
    subscription subscribeToServerObjects($distinct_on: [Server_select_column!], $where: Server_bool_exp, $limit: Int, $offset: Int, $order_by: [Server_order_by!]) {
  Server(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Server
  }
}
    ${ServerFragmentDoc}`;
export type SubscribeToServerObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToServerObjectsSubscription>;
export const InsertServerDocument = gql`
    mutation insertServer($objects: [Server_insert_input!]!) {
  insert_Server(objects: $objects) {
    affected_rows
    returning {
      ...Server
    }
  }
}
    ${ServerFragmentDoc}`;
export type InsertServerMutationFn = Apollo.MutationFunction<InsertServerMutation, InsertServerMutationVariables>;
export type InsertServerMutationResult = Apollo.MutationResult<InsertServerMutation>;
export type InsertServerMutationOptions = Apollo.BaseMutationOptions<InsertServerMutation, InsertServerMutationVariables>;
export const InsertServerWithOnConflictDocument = gql`
    mutation insertServerWithOnConflict($objects: [Server_insert_input!]!, $onConflict: Server_on_conflict) {
  insert_Server(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Server
    }
  }
}
    ${ServerFragmentDoc}`;
export type InsertServerWithOnConflictMutationFn = Apollo.MutationFunction<InsertServerWithOnConflictMutation, InsertServerWithOnConflictMutationVariables>;
export type InsertServerWithOnConflictMutationResult = Apollo.MutationResult<InsertServerWithOnConflictMutation>;
export type InsertServerWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertServerWithOnConflictMutation, InsertServerWithOnConflictMutationVariables>;
export const UpdateServerByIdDocument = gql`
    mutation updateServerById($id: uuid, $set: Server_set_input) {
  update_Server(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Server
    }
  }
}
    ${ServerFragmentDoc}`;
export type UpdateServerByIdMutationFn = Apollo.MutationFunction<UpdateServerByIdMutation, UpdateServerByIdMutationVariables>;
export type UpdateServerByIdMutationResult = Apollo.MutationResult<UpdateServerByIdMutation>;
export type UpdateServerByIdMutationOptions = Apollo.BaseMutationOptions<UpdateServerByIdMutation, UpdateServerByIdMutationVariables>;
export const UpdateServerDocument = gql`
    mutation updateServer($set: Server_set_input, $where: Server_bool_exp!) {
  update_Server(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Server
    }
  }
}
    ${ServerFragmentDoc}`;
export type UpdateServerMutationFn = Apollo.MutationFunction<UpdateServerMutation, UpdateServerMutationVariables>;
export type UpdateServerMutationResult = Apollo.MutationResult<UpdateServerMutation>;
export type UpdateServerMutationOptions = Apollo.BaseMutationOptions<UpdateServerMutation, UpdateServerMutationVariables>;
export const RemoveServerModelByIdDocument = gql`
    mutation removeServerModelById($id: uuid) {
  delete_Server(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveServerModelByIdMutationFn = Apollo.MutationFunction<RemoveServerModelByIdMutation, RemoveServerModelByIdMutationVariables>;
export type RemoveServerModelByIdMutationResult = Apollo.MutationResult<RemoveServerModelByIdMutation>;
export type RemoveServerModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveServerModelByIdMutation, RemoveServerModelByIdMutationVariables>;
export const RemoveServerModelDocument = gql`
    mutation removeServerModel($where: Server_bool_exp!) {
  delete_Server(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveServerModelMutationFn = Apollo.MutationFunction<RemoveServerModelMutation, RemoveServerModelMutationVariables>;
export type RemoveServerModelMutationResult = Apollo.MutationResult<RemoveServerModelMutation>;
export type RemoveServerModelMutationOptions = Apollo.BaseMutationOptions<RemoveServerModelMutation, RemoveServerModelMutationVariables>;
export const QueryServerBridgeObjectsDocument = gql`
    query queryServerBridgeObjects($distinct_on: [ServerBridge_select_column!], $where: ServerBridge_bool_exp, $limit: Int, $offset: Int, $order_by: [ServerBridge_order_by!]) {
  ServerBridge(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ServerBridge
  }
}
    ${ServerBridgeFragmentDoc}`;
export type QueryServerBridgeObjectsQueryResult = Apollo.QueryResult<QueryServerBridgeObjectsQuery, QueryServerBridgeObjectsQueryVariables>;
export const SubscribeToServerBridgeObjectsDocument = gql`
    subscription subscribeToServerBridgeObjects($distinct_on: [ServerBridge_select_column!], $where: ServerBridge_bool_exp, $limit: Int, $offset: Int, $order_by: [ServerBridge_order_by!]) {
  ServerBridge(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...ServerBridge
  }
}
    ${ServerBridgeFragmentDoc}`;
export type SubscribeToServerBridgeObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToServerBridgeObjectsSubscription>;
export const QuerySiteByIdDocument = gql`
    query querySiteById($siteId: uuid!) {
  Site_by_pk(id: $siteId) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type QuerySiteByIdQueryResult = Apollo.QueryResult<QuerySiteByIdQuery, QuerySiteByIdQueryVariables>;
export const QuerySiteObjectsDocument = gql`
    query querySiteObjects($distinct_on: [Site_select_column!], $where: Site_bool_exp, $limit: Int, $offset: Int, $order_by: [Site_order_by!]) {
  Site(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type QuerySiteObjectsQueryResult = Apollo.QueryResult<QuerySiteObjectsQuery, QuerySiteObjectsQueryVariables>;
export const SubscribeToSiteByIdDocument = gql`
    subscription subscribeToSiteById($siteId: uuid!) {
  Site_by_pk(id: $siteId) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type SubscribeToSiteByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteByIdSubscription>;
export const SubscribeToSiteObjectsDocument = gql`
    subscription subscribeToSiteObjects($distinct_on: [Site_select_column!], $where: Site_bool_exp, $limit: Int, $offset: Int, $order_by: [Site_order_by!]) {
  Site(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Site
  }
}
    ${SiteFragmentDoc}`;
export type SubscribeToSiteObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteObjectsSubscription>;
export const InsertSiteDocument = gql`
    mutation insertSite($objects: [Site_insert_input!]!) {
  insert_Site(objects: $objects) {
    affected_rows
    returning {
      ...Site
    }
  }
}
    ${SiteFragmentDoc}`;
export type InsertSiteMutationFn = Apollo.MutationFunction<InsertSiteMutation, InsertSiteMutationVariables>;
export type InsertSiteMutationResult = Apollo.MutationResult<InsertSiteMutation>;
export type InsertSiteMutationOptions = Apollo.BaseMutationOptions<InsertSiteMutation, InsertSiteMutationVariables>;
export const InsertSiteWithOnConflictDocument = gql`
    mutation insertSiteWithOnConflict($objects: [Site_insert_input!]!, $onConflict: Site_on_conflict) {
  insert_Site(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Site
    }
  }
}
    ${SiteFragmentDoc}`;
export type InsertSiteWithOnConflictMutationFn = Apollo.MutationFunction<InsertSiteWithOnConflictMutation, InsertSiteWithOnConflictMutationVariables>;
export type InsertSiteWithOnConflictMutationResult = Apollo.MutationResult<InsertSiteWithOnConflictMutation>;
export type InsertSiteWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertSiteWithOnConflictMutation, InsertSiteWithOnConflictMutationVariables>;
export const UpdateSiteByIdDocument = gql`
    mutation updateSiteById($id: uuid, $set: Site_set_input) {
  update_Site(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Site
    }
  }
}
    ${SiteFragmentDoc}`;
export type UpdateSiteByIdMutationFn = Apollo.MutationFunction<UpdateSiteByIdMutation, UpdateSiteByIdMutationVariables>;
export type UpdateSiteByIdMutationResult = Apollo.MutationResult<UpdateSiteByIdMutation>;
export type UpdateSiteByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSiteByIdMutation, UpdateSiteByIdMutationVariables>;
export const UpdateSiteDocument = gql`
    mutation updateSite($set: Site_set_input, $where: Site_bool_exp!) {
  update_Site(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Site
    }
  }
}
    ${SiteFragmentDoc}`;
export type UpdateSiteMutationFn = Apollo.MutationFunction<UpdateSiteMutation, UpdateSiteMutationVariables>;
export type UpdateSiteMutationResult = Apollo.MutationResult<UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const RemoveSiteModelByIdDocument = gql`
    mutation removeSiteModelById($id: uuid) {
  delete_Site(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveSiteModelByIdMutationFn = Apollo.MutationFunction<RemoveSiteModelByIdMutation, RemoveSiteModelByIdMutationVariables>;
export type RemoveSiteModelByIdMutationResult = Apollo.MutationResult<RemoveSiteModelByIdMutation>;
export type RemoveSiteModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveSiteModelByIdMutation, RemoveSiteModelByIdMutationVariables>;
export const RemoveSiteModelDocument = gql`
    mutation removeSiteModel($where: Site_bool_exp!) {
  delete_Site(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveSiteModelMutationFn = Apollo.MutationFunction<RemoveSiteModelMutation, RemoveSiteModelMutationVariables>;
export type RemoveSiteModelMutationResult = Apollo.MutationResult<RemoveSiteModelMutation>;
export type RemoveSiteModelMutationOptions = Apollo.BaseMutationOptions<RemoveSiteModelMutation, RemoveSiteModelMutationVariables>;
export const QuerySiteContactByIdDocument = gql`
    query querySiteContactById($siteContactId: uuid!) {
  SiteContact_by_pk(id: $siteContactId) {
    ...SiteContact
  }
}
    ${SiteContactFragmentDoc}`;
export type QuerySiteContactByIdQueryResult = Apollo.QueryResult<QuerySiteContactByIdQuery, QuerySiteContactByIdQueryVariables>;
export const QuerySiteContactObjectsDocument = gql`
    query querySiteContactObjects($distinct_on: [SiteContact_select_column!], $where: SiteContact_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteContact_order_by!]) {
  SiteContact(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteContact
  }
}
    ${SiteContactFragmentDoc}`;
export type QuerySiteContactObjectsQueryResult = Apollo.QueryResult<QuerySiteContactObjectsQuery, QuerySiteContactObjectsQueryVariables>;
export const SubscribeToSiteContactByIdDocument = gql`
    subscription subscribeToSiteContactById($siteContactId: uuid!) {
  SiteContact_by_pk(id: $siteContactId) {
    ...SiteContact
  }
}
    ${SiteContactFragmentDoc}`;
export type SubscribeToSiteContactByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteContactByIdSubscription>;
export const SubscribeToSiteContactObjectsDocument = gql`
    subscription subscribeToSiteContactObjects($distinct_on: [SiteContact_select_column!], $where: SiteContact_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteContact_order_by!]) {
  SiteContact(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteContact
  }
}
    ${SiteContactFragmentDoc}`;
export type SubscribeToSiteContactObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteContactObjectsSubscription>;
export const InsertSiteContactDocument = gql`
    mutation insertSiteContact($objects: [SiteContact_insert_input!]!) {
  insert_SiteContact(objects: $objects) {
    affected_rows
    returning {
      ...SiteContact
    }
  }
}
    ${SiteContactFragmentDoc}`;
export type InsertSiteContactMutationFn = Apollo.MutationFunction<InsertSiteContactMutation, InsertSiteContactMutationVariables>;
export type InsertSiteContactMutationResult = Apollo.MutationResult<InsertSiteContactMutation>;
export type InsertSiteContactMutationOptions = Apollo.BaseMutationOptions<InsertSiteContactMutation, InsertSiteContactMutationVariables>;
export const InsertSiteContactWithOnConflictDocument = gql`
    mutation insertSiteContactWithOnConflict($objects: [SiteContact_insert_input!]!, $onConflict: SiteContact_on_conflict) {
  insert_SiteContact(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...SiteContact
    }
  }
}
    ${SiteContactFragmentDoc}`;
export type InsertSiteContactWithOnConflictMutationFn = Apollo.MutationFunction<InsertSiteContactWithOnConflictMutation, InsertSiteContactWithOnConflictMutationVariables>;
export type InsertSiteContactWithOnConflictMutationResult = Apollo.MutationResult<InsertSiteContactWithOnConflictMutation>;
export type InsertSiteContactWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertSiteContactWithOnConflictMutation, InsertSiteContactWithOnConflictMutationVariables>;
export const UpdateSiteContactByIdDocument = gql`
    mutation updateSiteContactById($id: uuid, $set: SiteContact_set_input) {
  update_SiteContact(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...SiteContact
    }
  }
}
    ${SiteContactFragmentDoc}`;
export type UpdateSiteContactByIdMutationFn = Apollo.MutationFunction<UpdateSiteContactByIdMutation, UpdateSiteContactByIdMutationVariables>;
export type UpdateSiteContactByIdMutationResult = Apollo.MutationResult<UpdateSiteContactByIdMutation>;
export type UpdateSiteContactByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSiteContactByIdMutation, UpdateSiteContactByIdMutationVariables>;
export const UpdateSiteContactDocument = gql`
    mutation updateSiteContact($set: SiteContact_set_input, $where: SiteContact_bool_exp!) {
  update_SiteContact(_set: $set, where: $where) {
    affected_rows
    returning {
      ...SiteContact
    }
  }
}
    ${SiteContactFragmentDoc}`;
export type UpdateSiteContactMutationFn = Apollo.MutationFunction<UpdateSiteContactMutation, UpdateSiteContactMutationVariables>;
export type UpdateSiteContactMutationResult = Apollo.MutationResult<UpdateSiteContactMutation>;
export type UpdateSiteContactMutationOptions = Apollo.BaseMutationOptions<UpdateSiteContactMutation, UpdateSiteContactMutationVariables>;
export const RemoveSiteContactModelByIdDocument = gql`
    mutation removeSiteContactModelById($id: uuid) {
  delete_SiteContact(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveSiteContactModelByIdMutationFn = Apollo.MutationFunction<RemoveSiteContactModelByIdMutation, RemoveSiteContactModelByIdMutationVariables>;
export type RemoveSiteContactModelByIdMutationResult = Apollo.MutationResult<RemoveSiteContactModelByIdMutation>;
export type RemoveSiteContactModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveSiteContactModelByIdMutation, RemoveSiteContactModelByIdMutationVariables>;
export const RemoveSiteContactModelDocument = gql`
    mutation removeSiteContactModel($where: SiteContact_bool_exp!) {
  delete_SiteContact(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveSiteContactModelMutationFn = Apollo.MutationFunction<RemoveSiteContactModelMutation, RemoveSiteContactModelMutationVariables>;
export type RemoveSiteContactModelMutationResult = Apollo.MutationResult<RemoveSiteContactModelMutation>;
export type RemoveSiteContactModelMutationOptions = Apollo.BaseMutationOptions<RemoveSiteContactModelMutation, RemoveSiteContactModelMutationVariables>;
export const QuerySiteLanByIdDocument = gql`
    query querySiteLanById($siteLanId: uuid!) {
  SiteLan_by_pk(id: $siteLanId) {
    ...SiteLan
  }
}
    ${SiteLanFragmentDoc}`;
export type QuerySiteLanByIdQueryResult = Apollo.QueryResult<QuerySiteLanByIdQuery, QuerySiteLanByIdQueryVariables>;
export const QuerySiteLanObjectsDocument = gql`
    query querySiteLanObjects($distinct_on: [SiteLan_select_column!], $where: SiteLan_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteLan_order_by!]) {
  SiteLan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteLan
  }
}
    ${SiteLanFragmentDoc}`;
export type QuerySiteLanObjectsQueryResult = Apollo.QueryResult<QuerySiteLanObjectsQuery, QuerySiteLanObjectsQueryVariables>;
export const SubscribeToSiteLanByIdDocument = gql`
    subscription subscribeToSiteLanById($siteLanId: uuid!) {
  SiteLan_by_pk(id: $siteLanId) {
    ...SiteLan
  }
}
    ${SiteLanFragmentDoc}`;
export type SubscribeToSiteLanByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteLanByIdSubscription>;
export const SubscribeToSiteLanObjectsDocument = gql`
    subscription subscribeToSiteLanObjects($distinct_on: [SiteLan_select_column!], $where: SiteLan_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteLan_order_by!]) {
  SiteLan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteLan
  }
}
    ${SiteLanFragmentDoc}`;
export type SubscribeToSiteLanObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteLanObjectsSubscription>;
export const InsertSiteLanDocument = gql`
    mutation insertSiteLan($objects: [SiteLan_insert_input!]!) {
  insert_SiteLan(objects: $objects) {
    affected_rows
    returning {
      ...SiteLan
    }
  }
}
    ${SiteLanFragmentDoc}`;
export type InsertSiteLanMutationFn = Apollo.MutationFunction<InsertSiteLanMutation, InsertSiteLanMutationVariables>;
export type InsertSiteLanMutationResult = Apollo.MutationResult<InsertSiteLanMutation>;
export type InsertSiteLanMutationOptions = Apollo.BaseMutationOptions<InsertSiteLanMutation, InsertSiteLanMutationVariables>;
export const InsertSiteLanWithOnConflictDocument = gql`
    mutation insertSiteLanWithOnConflict($objects: [SiteLan_insert_input!]!, $onConflict: SiteLan_on_conflict) {
  insert_SiteLan(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...SiteLan
    }
  }
}
    ${SiteLanFragmentDoc}`;
export type InsertSiteLanWithOnConflictMutationFn = Apollo.MutationFunction<InsertSiteLanWithOnConflictMutation, InsertSiteLanWithOnConflictMutationVariables>;
export type InsertSiteLanWithOnConflictMutationResult = Apollo.MutationResult<InsertSiteLanWithOnConflictMutation>;
export type InsertSiteLanWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertSiteLanWithOnConflictMutation, InsertSiteLanWithOnConflictMutationVariables>;
export const UpdateSiteLanByIdDocument = gql`
    mutation updateSiteLanById($id: uuid, $set: SiteLan_set_input) {
  update_SiteLan(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...SiteLan
    }
  }
}
    ${SiteLanFragmentDoc}`;
export type UpdateSiteLanByIdMutationFn = Apollo.MutationFunction<UpdateSiteLanByIdMutation, UpdateSiteLanByIdMutationVariables>;
export type UpdateSiteLanByIdMutationResult = Apollo.MutationResult<UpdateSiteLanByIdMutation>;
export type UpdateSiteLanByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSiteLanByIdMutation, UpdateSiteLanByIdMutationVariables>;
export const UpdateSiteLanDocument = gql`
    mutation updateSiteLan($set: SiteLan_set_input, $where: SiteLan_bool_exp!) {
  update_SiteLan(_set: $set, where: $where) {
    affected_rows
    returning {
      ...SiteLan
    }
  }
}
    ${SiteLanFragmentDoc}`;
export type UpdateSiteLanMutationFn = Apollo.MutationFunction<UpdateSiteLanMutation, UpdateSiteLanMutationVariables>;
export type UpdateSiteLanMutationResult = Apollo.MutationResult<UpdateSiteLanMutation>;
export type UpdateSiteLanMutationOptions = Apollo.BaseMutationOptions<UpdateSiteLanMutation, UpdateSiteLanMutationVariables>;
export const RemoveSiteLanModelByIdDocument = gql`
    mutation removeSiteLanModelById($id: uuid) {
  delete_SiteLan(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveSiteLanModelByIdMutationFn = Apollo.MutationFunction<RemoveSiteLanModelByIdMutation, RemoveSiteLanModelByIdMutationVariables>;
export type RemoveSiteLanModelByIdMutationResult = Apollo.MutationResult<RemoveSiteLanModelByIdMutation>;
export type RemoveSiteLanModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveSiteLanModelByIdMutation, RemoveSiteLanModelByIdMutationVariables>;
export const RemoveSiteLanModelDocument = gql`
    mutation removeSiteLanModel($where: SiteLan_bool_exp!) {
  delete_SiteLan(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveSiteLanModelMutationFn = Apollo.MutationFunction<RemoveSiteLanModelMutation, RemoveSiteLanModelMutationVariables>;
export type RemoveSiteLanModelMutationResult = Apollo.MutationResult<RemoveSiteLanModelMutation>;
export type RemoveSiteLanModelMutationOptions = Apollo.BaseMutationOptions<RemoveSiteLanModelMutation, RemoveSiteLanModelMutationVariables>;
export const QuerySiteRouteByIdDocument = gql`
    query querySiteRouteById($siteRouteId: uuid!) {
  SiteRoute_by_pk(id: $siteRouteId) {
    ...SiteRoute
  }
}
    ${SiteRouteFragmentDoc}`;
export type QuerySiteRouteByIdQueryResult = Apollo.QueryResult<QuerySiteRouteByIdQuery, QuerySiteRouteByIdQueryVariables>;
export const QuerySiteRouteObjectsDocument = gql`
    query querySiteRouteObjects($distinct_on: [SiteRoute_select_column!], $where: SiteRoute_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteRoute_order_by!]) {
  SiteRoute(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteRoute
  }
}
    ${SiteRouteFragmentDoc}`;
export type QuerySiteRouteObjectsQueryResult = Apollo.QueryResult<QuerySiteRouteObjectsQuery, QuerySiteRouteObjectsQueryVariables>;
export const SubscribeToSiteRouteByIdDocument = gql`
    subscription subscribeToSiteRouteById($siteRouteId: uuid!) {
  SiteRoute_by_pk(id: $siteRouteId) {
    ...SiteRoute
  }
}
    ${SiteRouteFragmentDoc}`;
export type SubscribeToSiteRouteByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteRouteByIdSubscription>;
export const SubscribeToSiteRouteObjectsDocument = gql`
    subscription subscribeToSiteRouteObjects($distinct_on: [SiteRoute_select_column!], $where: SiteRoute_bool_exp, $limit: Int, $offset: Int, $order_by: [SiteRoute_order_by!]) {
  SiteRoute(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SiteRoute
  }
}
    ${SiteRouteFragmentDoc}`;
export type SubscribeToSiteRouteObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToSiteRouteObjectsSubscription>;
export const InsertSiteRouteDocument = gql`
    mutation insertSiteRoute($objects: [SiteRoute_insert_input!]!) {
  insert_SiteRoute(objects: $objects) {
    affected_rows
    returning {
      ...SiteRoute
    }
  }
}
    ${SiteRouteFragmentDoc}`;
export type InsertSiteRouteMutationFn = Apollo.MutationFunction<InsertSiteRouteMutation, InsertSiteRouteMutationVariables>;
export type InsertSiteRouteMutationResult = Apollo.MutationResult<InsertSiteRouteMutation>;
export type InsertSiteRouteMutationOptions = Apollo.BaseMutationOptions<InsertSiteRouteMutation, InsertSiteRouteMutationVariables>;
export const InsertSiteRouteWithOnConflictDocument = gql`
    mutation insertSiteRouteWithOnConflict($objects: [SiteRoute_insert_input!]!, $onConflict: SiteRoute_on_conflict) {
  insert_SiteRoute(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...SiteRoute
    }
  }
}
    ${SiteRouteFragmentDoc}`;
export type InsertSiteRouteWithOnConflictMutationFn = Apollo.MutationFunction<InsertSiteRouteWithOnConflictMutation, InsertSiteRouteWithOnConflictMutationVariables>;
export type InsertSiteRouteWithOnConflictMutationResult = Apollo.MutationResult<InsertSiteRouteWithOnConflictMutation>;
export type InsertSiteRouteWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertSiteRouteWithOnConflictMutation, InsertSiteRouteWithOnConflictMutationVariables>;
export const UpdateSiteRouteByIdDocument = gql`
    mutation updateSiteRouteById($id: uuid, $set: SiteRoute_set_input) {
  update_SiteRoute(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...SiteRoute
    }
  }
}
    ${SiteRouteFragmentDoc}`;
export type UpdateSiteRouteByIdMutationFn = Apollo.MutationFunction<UpdateSiteRouteByIdMutation, UpdateSiteRouteByIdMutationVariables>;
export type UpdateSiteRouteByIdMutationResult = Apollo.MutationResult<UpdateSiteRouteByIdMutation>;
export type UpdateSiteRouteByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSiteRouteByIdMutation, UpdateSiteRouteByIdMutationVariables>;
export const UpdateSiteRouteDocument = gql`
    mutation updateSiteRoute($set: SiteRoute_set_input, $where: SiteRoute_bool_exp!) {
  update_SiteRoute(_set: $set, where: $where) {
    affected_rows
    returning {
      ...SiteRoute
    }
  }
}
    ${SiteRouteFragmentDoc}`;
export type UpdateSiteRouteMutationFn = Apollo.MutationFunction<UpdateSiteRouteMutation, UpdateSiteRouteMutationVariables>;
export type UpdateSiteRouteMutationResult = Apollo.MutationResult<UpdateSiteRouteMutation>;
export type UpdateSiteRouteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteRouteMutation, UpdateSiteRouteMutationVariables>;
export const RemoveSiteRouteModelByIdDocument = gql`
    mutation removeSiteRouteModelById($id: uuid) {
  delete_SiteRoute(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveSiteRouteModelByIdMutationFn = Apollo.MutationFunction<RemoveSiteRouteModelByIdMutation, RemoveSiteRouteModelByIdMutationVariables>;
export type RemoveSiteRouteModelByIdMutationResult = Apollo.MutationResult<RemoveSiteRouteModelByIdMutation>;
export type RemoveSiteRouteModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveSiteRouteModelByIdMutation, RemoveSiteRouteModelByIdMutationVariables>;
export const RemoveSiteRouteModelDocument = gql`
    mutation removeSiteRouteModel($where: SiteRoute_bool_exp!) {
  delete_SiteRoute(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveSiteRouteModelMutationFn = Apollo.MutationFunction<RemoveSiteRouteModelMutation, RemoveSiteRouteModelMutationVariables>;
export type RemoveSiteRouteModelMutationResult = Apollo.MutationResult<RemoveSiteRouteModelMutation>;
export type RemoveSiteRouteModelMutationOptions = Apollo.BaseMutationOptions<RemoveSiteRouteModelMutation, RemoveSiteRouteModelMutationVariables>;
export const QueryTunnelByIdDocument = gql`
    query queryTunnelById($tunnelId: uuid!) {
  Tunnel_by_pk(id: $tunnelId) {
    ...Tunnel
  }
}
    ${TunnelFragmentDoc}`;
export type QueryTunnelByIdQueryResult = Apollo.QueryResult<QueryTunnelByIdQuery, QueryTunnelByIdQueryVariables>;
export const QueryTunnelObjectsDocument = gql`
    query queryTunnelObjects($distinct_on: [Tunnel_select_column!], $where: Tunnel_bool_exp, $limit: Int, $offset: Int, $order_by: [Tunnel_order_by!]) {
  Tunnel(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Tunnel
  }
}
    ${TunnelFragmentDoc}`;
export type QueryTunnelObjectsQueryResult = Apollo.QueryResult<QueryTunnelObjectsQuery, QueryTunnelObjectsQueryVariables>;
export const SubscribeToTunnelByIdDocument = gql`
    subscription subscribeToTunnelById($tunnelId: uuid!) {
  Tunnel_by_pk(id: $tunnelId) {
    ...Tunnel
  }
}
    ${TunnelFragmentDoc}`;
export type SubscribeToTunnelByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTunnelByIdSubscription>;
export const SubscribeToTunnelObjectsDocument = gql`
    subscription subscribeToTunnelObjects($distinct_on: [Tunnel_select_column!], $where: Tunnel_bool_exp, $limit: Int, $offset: Int, $order_by: [Tunnel_order_by!]) {
  Tunnel(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Tunnel
  }
}
    ${TunnelFragmentDoc}`;
export type SubscribeToTunnelObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTunnelObjectsSubscription>;
export const InsertTunnelDocument = gql`
    mutation insertTunnel($objects: [Tunnel_insert_input!]!) {
  insert_Tunnel(objects: $objects) {
    affected_rows
    returning {
      ...Tunnel
    }
  }
}
    ${TunnelFragmentDoc}`;
export type InsertTunnelMutationFn = Apollo.MutationFunction<InsertTunnelMutation, InsertTunnelMutationVariables>;
export type InsertTunnelMutationResult = Apollo.MutationResult<InsertTunnelMutation>;
export type InsertTunnelMutationOptions = Apollo.BaseMutationOptions<InsertTunnelMutation, InsertTunnelMutationVariables>;
export const InsertTunnelWithOnConflictDocument = gql`
    mutation insertTunnelWithOnConflict($objects: [Tunnel_insert_input!]!, $onConflict: Tunnel_on_conflict) {
  insert_Tunnel(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Tunnel
    }
  }
}
    ${TunnelFragmentDoc}`;
export type InsertTunnelWithOnConflictMutationFn = Apollo.MutationFunction<InsertTunnelWithOnConflictMutation, InsertTunnelWithOnConflictMutationVariables>;
export type InsertTunnelWithOnConflictMutationResult = Apollo.MutationResult<InsertTunnelWithOnConflictMutation>;
export type InsertTunnelWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertTunnelWithOnConflictMutation, InsertTunnelWithOnConflictMutationVariables>;
export const UpdateTunnelByIdDocument = gql`
    mutation updateTunnelById($id: uuid, $set: Tunnel_set_input) {
  update_Tunnel(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Tunnel
    }
  }
}
    ${TunnelFragmentDoc}`;
export type UpdateTunnelByIdMutationFn = Apollo.MutationFunction<UpdateTunnelByIdMutation, UpdateTunnelByIdMutationVariables>;
export type UpdateTunnelByIdMutationResult = Apollo.MutationResult<UpdateTunnelByIdMutation>;
export type UpdateTunnelByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTunnelByIdMutation, UpdateTunnelByIdMutationVariables>;
export const UpdateTunnelDocument = gql`
    mutation updateTunnel($set: Tunnel_set_input, $where: Tunnel_bool_exp!) {
  update_Tunnel(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Tunnel
    }
  }
}
    ${TunnelFragmentDoc}`;
export type UpdateTunnelMutationFn = Apollo.MutationFunction<UpdateTunnelMutation, UpdateTunnelMutationVariables>;
export type UpdateTunnelMutationResult = Apollo.MutationResult<UpdateTunnelMutation>;
export type UpdateTunnelMutationOptions = Apollo.BaseMutationOptions<UpdateTunnelMutation, UpdateTunnelMutationVariables>;
export const RemoveTunnelModelByIdDocument = gql`
    mutation removeTunnelModelById($id: uuid) {
  delete_Tunnel(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveTunnelModelByIdMutationFn = Apollo.MutationFunction<RemoveTunnelModelByIdMutation, RemoveTunnelModelByIdMutationVariables>;
export type RemoveTunnelModelByIdMutationResult = Apollo.MutationResult<RemoveTunnelModelByIdMutation>;
export type RemoveTunnelModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveTunnelModelByIdMutation, RemoveTunnelModelByIdMutationVariables>;
export const RemoveTunnelModelDocument = gql`
    mutation removeTunnelModel($where: Tunnel_bool_exp!) {
  delete_Tunnel(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveTunnelModelMutationFn = Apollo.MutationFunction<RemoveTunnelModelMutation, RemoveTunnelModelMutationVariables>;
export type RemoveTunnelModelMutationResult = Apollo.MutationResult<RemoveTunnelModelMutation>;
export type RemoveTunnelModelMutationOptions = Apollo.BaseMutationOptions<RemoveTunnelModelMutation, RemoveTunnelModelMutationVariables>;
export const QueryTunnelProfileByIdDocument = gql`
    query queryTunnelProfileById($tunnelProfileId: uuid!) {
  TunnelProfile_by_pk(id: $tunnelProfileId) {
    ...TunnelProfile
  }
}
    ${TunnelProfileFragmentDoc}`;
export type QueryTunnelProfileByIdQueryResult = Apollo.QueryResult<QueryTunnelProfileByIdQuery, QueryTunnelProfileByIdQueryVariables>;
export const QueryTunnelProfileObjectsDocument = gql`
    query queryTunnelProfileObjects($distinct_on: [TunnelProfile_select_column!], $where: TunnelProfile_bool_exp, $limit: Int, $offset: Int, $order_by: [TunnelProfile_order_by!]) {
  TunnelProfile(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...TunnelProfile
  }
}
    ${TunnelProfileFragmentDoc}`;
export type QueryTunnelProfileObjectsQueryResult = Apollo.QueryResult<QueryTunnelProfileObjectsQuery, QueryTunnelProfileObjectsQueryVariables>;
export const SubscribeToTunnelProfileByIdDocument = gql`
    subscription subscribeToTunnelProfileById($tunnelProfileId: uuid!) {
  TunnelProfile_by_pk(id: $tunnelProfileId) {
    ...TunnelProfile
  }
}
    ${TunnelProfileFragmentDoc}`;
export type SubscribeToTunnelProfileByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTunnelProfileByIdSubscription>;
export const SubscribeToTunnelProfileObjectsDocument = gql`
    subscription subscribeToTunnelProfileObjects($distinct_on: [TunnelProfile_select_column!], $where: TunnelProfile_bool_exp, $limit: Int, $offset: Int, $order_by: [TunnelProfile_order_by!]) {
  TunnelProfile(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...TunnelProfile
  }
}
    ${TunnelProfileFragmentDoc}`;
export type SubscribeToTunnelProfileObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToTunnelProfileObjectsSubscription>;
export const InsertTunnelProfileDocument = gql`
    mutation insertTunnelProfile($objects: [TunnelProfile_insert_input!]!) {
  insert_TunnelProfile(objects: $objects) {
    affected_rows
    returning {
      ...TunnelProfile
    }
  }
}
    ${TunnelProfileFragmentDoc}`;
export type InsertTunnelProfileMutationFn = Apollo.MutationFunction<InsertTunnelProfileMutation, InsertTunnelProfileMutationVariables>;
export type InsertTunnelProfileMutationResult = Apollo.MutationResult<InsertTunnelProfileMutation>;
export type InsertTunnelProfileMutationOptions = Apollo.BaseMutationOptions<InsertTunnelProfileMutation, InsertTunnelProfileMutationVariables>;
export const InsertTunnelProfileWithOnConflictDocument = gql`
    mutation insertTunnelProfileWithOnConflict($objects: [TunnelProfile_insert_input!]!, $onConflict: TunnelProfile_on_conflict) {
  insert_TunnelProfile(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...TunnelProfile
    }
  }
}
    ${TunnelProfileFragmentDoc}`;
export type InsertTunnelProfileWithOnConflictMutationFn = Apollo.MutationFunction<InsertTunnelProfileWithOnConflictMutation, InsertTunnelProfileWithOnConflictMutationVariables>;
export type InsertTunnelProfileWithOnConflictMutationResult = Apollo.MutationResult<InsertTunnelProfileWithOnConflictMutation>;
export type InsertTunnelProfileWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertTunnelProfileWithOnConflictMutation, InsertTunnelProfileWithOnConflictMutationVariables>;
export const UpdateTunnelProfileByIdDocument = gql`
    mutation updateTunnelProfileById($id: uuid, $set: TunnelProfile_set_input) {
  update_TunnelProfile(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...TunnelProfile
    }
  }
}
    ${TunnelProfileFragmentDoc}`;
export type UpdateTunnelProfileByIdMutationFn = Apollo.MutationFunction<UpdateTunnelProfileByIdMutation, UpdateTunnelProfileByIdMutationVariables>;
export type UpdateTunnelProfileByIdMutationResult = Apollo.MutationResult<UpdateTunnelProfileByIdMutation>;
export type UpdateTunnelProfileByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTunnelProfileByIdMutation, UpdateTunnelProfileByIdMutationVariables>;
export const UpdateTunnelProfileDocument = gql`
    mutation updateTunnelProfile($set: TunnelProfile_set_input, $where: TunnelProfile_bool_exp!) {
  update_TunnelProfile(_set: $set, where: $where) {
    affected_rows
    returning {
      ...TunnelProfile
    }
  }
}
    ${TunnelProfileFragmentDoc}`;
export type UpdateTunnelProfileMutationFn = Apollo.MutationFunction<UpdateTunnelProfileMutation, UpdateTunnelProfileMutationVariables>;
export type UpdateTunnelProfileMutationResult = Apollo.MutationResult<UpdateTunnelProfileMutation>;
export type UpdateTunnelProfileMutationOptions = Apollo.BaseMutationOptions<UpdateTunnelProfileMutation, UpdateTunnelProfileMutationVariables>;
export const RemoveTunnelProfileModelByIdDocument = gql`
    mutation removeTunnelProfileModelById($id: uuid) {
  delete_TunnelProfile(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveTunnelProfileModelByIdMutationFn = Apollo.MutationFunction<RemoveTunnelProfileModelByIdMutation, RemoveTunnelProfileModelByIdMutationVariables>;
export type RemoveTunnelProfileModelByIdMutationResult = Apollo.MutationResult<RemoveTunnelProfileModelByIdMutation>;
export type RemoveTunnelProfileModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveTunnelProfileModelByIdMutation, RemoveTunnelProfileModelByIdMutationVariables>;
export const RemoveTunnelProfileModelDocument = gql`
    mutation removeTunnelProfileModel($where: TunnelProfile_bool_exp!) {
  delete_TunnelProfile(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveTunnelProfileModelMutationFn = Apollo.MutationFunction<RemoveTunnelProfileModelMutation, RemoveTunnelProfileModelMutationVariables>;
export type RemoveTunnelProfileModelMutationResult = Apollo.MutationResult<RemoveTunnelProfileModelMutation>;
export type RemoveTunnelProfileModelMutationOptions = Apollo.BaseMutationOptions<RemoveTunnelProfileModelMutation, RemoveTunnelProfileModelMutationVariables>;
export const QueryUserByIdDocument = gql`
    query queryUserById($userId: uuid!) {
  User_by_pk(id: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type QueryUserByIdQueryResult = Apollo.QueryResult<QueryUserByIdQuery, QueryUserByIdQueryVariables>;
export const QueryUserObjectsDocument = gql`
    query queryUserObjects($distinct_on: [User_select_column!], $where: User_bool_exp, $limit: Int, $offset: Int, $order_by: [User_order_by!]) {
  User(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type QueryUserObjectsQueryResult = Apollo.QueryResult<QueryUserObjectsQuery, QueryUserObjectsQueryVariables>;
export const SubscribeToUserByIdDocument = gql`
    subscription subscribeToUserById($userId: uuid!) {
  User_by_pk(id: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SubscribeToUserByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserByIdSubscription>;
export const SubscribeToUserObjectsDocument = gql`
    subscription subscribeToUserObjects($distinct_on: [User_select_column!], $where: User_bool_exp, $limit: Int, $offset: Int, $order_by: [User_order_by!]) {
  User(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type SubscribeToUserObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserObjectsSubscription>;
export const InsertUserDocument = gql`
    mutation insertUser($objects: [User_insert_input!]!) {
  insert_User(objects: $objects) {
    affected_rows
    returning {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type InsertUserMutationFn = Apollo.MutationFunction<InsertUserMutation, InsertUserMutationVariables>;
export type InsertUserMutationResult = Apollo.MutationResult<InsertUserMutation>;
export type InsertUserMutationOptions = Apollo.BaseMutationOptions<InsertUserMutation, InsertUserMutationVariables>;
export const InsertUserWithOnConflictDocument = gql`
    mutation insertUserWithOnConflict($objects: [User_insert_input!]!, $onConflict: User_on_conflict) {
  insert_User(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type InsertUserWithOnConflictMutationFn = Apollo.MutationFunction<InsertUserWithOnConflictMutation, InsertUserWithOnConflictMutationVariables>;
export type InsertUserWithOnConflictMutationResult = Apollo.MutationResult<InsertUserWithOnConflictMutation>;
export type InsertUserWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertUserWithOnConflictMutation, InsertUserWithOnConflictMutationVariables>;
export const UpdateUserByIdDocument = gql`
    mutation updateUserById($id: uuid, $set: User_set_input) {
  update_User(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserByIdMutationFn = Apollo.MutationFunction<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>;
export type UpdateUserByIdMutationResult = Apollo.MutationResult<UpdateUserByIdMutation>;
export type UpdateUserByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserByIdMutation, UpdateUserByIdMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($set: User_set_input, $where: User_bool_exp!) {
  update_User(_set: $set, where: $where) {
    affected_rows
    returning {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const RemoveUserModelByIdDocument = gql`
    mutation removeUserModelById($id: uuid) {
  delete_User(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveUserModelByIdMutationFn = Apollo.MutationFunction<RemoveUserModelByIdMutation, RemoveUserModelByIdMutationVariables>;
export type RemoveUserModelByIdMutationResult = Apollo.MutationResult<RemoveUserModelByIdMutation>;
export type RemoveUserModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveUserModelByIdMutation, RemoveUserModelByIdMutationVariables>;
export const RemoveUserModelDocument = gql`
    mutation removeUserModel($where: User_bool_exp!) {
  delete_User(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveUserModelMutationFn = Apollo.MutationFunction<RemoveUserModelMutation, RemoveUserModelMutationVariables>;
export type RemoveUserModelMutationResult = Apollo.MutationResult<RemoveUserModelMutation>;
export type RemoveUserModelMutationOptions = Apollo.BaseMutationOptions<RemoveUserModelMutation, RemoveUserModelMutationVariables>;
export const QueryUserHistoryByIdDocument = gql`
    query queryUserHistoryById($userHistoryId: uuid!) {
  UserHistory_by_pk(id: $userHistoryId) {
    ...UserHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export type QueryUserHistoryByIdQueryResult = Apollo.QueryResult<QueryUserHistoryByIdQuery, QueryUserHistoryByIdQueryVariables>;
export const QueryUserHistoryObjectsDocument = gql`
    query queryUserHistoryObjects($distinct_on: [UserHistory_select_column!], $where: UserHistory_bool_exp, $limit: Int, $offset: Int, $order_by: [UserHistory_order_by!]) {
  UserHistory(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...UserHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export type QueryUserHistoryObjectsQueryResult = Apollo.QueryResult<QueryUserHistoryObjectsQuery, QueryUserHistoryObjectsQueryVariables>;
export const SubscribeToUserHistoryByIdDocument = gql`
    subscription subscribeToUserHistoryById($userHistoryId: uuid!) {
  UserHistory_by_pk(id: $userHistoryId) {
    ...UserHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export type SubscribeToUserHistoryByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserHistoryByIdSubscription>;
export const SubscribeToUserHistoryObjectsDocument = gql`
    subscription subscribeToUserHistoryObjects($distinct_on: [UserHistory_select_column!], $where: UserHistory_bool_exp, $limit: Int, $offset: Int, $order_by: [UserHistory_order_by!]) {
  UserHistory(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...UserHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export type SubscribeToUserHistoryObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserHistoryObjectsSubscription>;
export const InsertUserHistoryDocument = gql`
    mutation insertUserHistory($objects: [UserHistory_insert_input!]!) {
  insert_UserHistory(objects: $objects) {
    affected_rows
    returning {
      ...UserHistory
    }
  }
}
    ${UserHistoryFragmentDoc}`;
export type InsertUserHistoryMutationFn = Apollo.MutationFunction<InsertUserHistoryMutation, InsertUserHistoryMutationVariables>;
export type InsertUserHistoryMutationResult = Apollo.MutationResult<InsertUserHistoryMutation>;
export type InsertUserHistoryMutationOptions = Apollo.BaseMutationOptions<InsertUserHistoryMutation, InsertUserHistoryMutationVariables>;
export const InsertUserHistoryWithOnConflictDocument = gql`
    mutation insertUserHistoryWithOnConflict($objects: [UserHistory_insert_input!]!, $onConflict: UserHistory_on_conflict) {
  insert_UserHistory(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...UserHistory
    }
  }
}
    ${UserHistoryFragmentDoc}`;
export type InsertUserHistoryWithOnConflictMutationFn = Apollo.MutationFunction<InsertUserHistoryWithOnConflictMutation, InsertUserHistoryWithOnConflictMutationVariables>;
export type InsertUserHistoryWithOnConflictMutationResult = Apollo.MutationResult<InsertUserHistoryWithOnConflictMutation>;
export type InsertUserHistoryWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertUserHistoryWithOnConflictMutation, InsertUserHistoryWithOnConflictMutationVariables>;
export const UpdateUserHistoryByIdDocument = gql`
    mutation updateUserHistoryById($id: uuid, $set: UserHistory_set_input) {
  update_UserHistory(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...UserHistory
    }
  }
}
    ${UserHistoryFragmentDoc}`;
export type UpdateUserHistoryByIdMutationFn = Apollo.MutationFunction<UpdateUserHistoryByIdMutation, UpdateUserHistoryByIdMutationVariables>;
export type UpdateUserHistoryByIdMutationResult = Apollo.MutationResult<UpdateUserHistoryByIdMutation>;
export type UpdateUserHistoryByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserHistoryByIdMutation, UpdateUserHistoryByIdMutationVariables>;
export const UpdateUserHistoryDocument = gql`
    mutation updateUserHistory($set: UserHistory_set_input, $where: UserHistory_bool_exp!) {
  update_UserHistory(_set: $set, where: $where) {
    affected_rows
    returning {
      ...UserHistory
    }
  }
}
    ${UserHistoryFragmentDoc}`;
export type UpdateUserHistoryMutationFn = Apollo.MutationFunction<UpdateUserHistoryMutation, UpdateUserHistoryMutationVariables>;
export type UpdateUserHistoryMutationResult = Apollo.MutationResult<UpdateUserHistoryMutation>;
export type UpdateUserHistoryMutationOptions = Apollo.BaseMutationOptions<UpdateUserHistoryMutation, UpdateUserHistoryMutationVariables>;
export const RemoveUserHistoryModelByIdDocument = gql`
    mutation removeUserHistoryModelById($id: uuid) {
  delete_UserHistory(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveUserHistoryModelByIdMutationFn = Apollo.MutationFunction<RemoveUserHistoryModelByIdMutation, RemoveUserHistoryModelByIdMutationVariables>;
export type RemoveUserHistoryModelByIdMutationResult = Apollo.MutationResult<RemoveUserHistoryModelByIdMutation>;
export type RemoveUserHistoryModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveUserHistoryModelByIdMutation, RemoveUserHistoryModelByIdMutationVariables>;
export const RemoveUserHistoryModelDocument = gql`
    mutation removeUserHistoryModel($where: UserHistory_bool_exp!) {
  delete_UserHistory(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveUserHistoryModelMutationFn = Apollo.MutationFunction<RemoveUserHistoryModelMutation, RemoveUserHistoryModelMutationVariables>;
export type RemoveUserHistoryModelMutationResult = Apollo.MutationResult<RemoveUserHistoryModelMutation>;
export type RemoveUserHistoryModelMutationOptions = Apollo.BaseMutationOptions<RemoveUserHistoryModelMutation, RemoveUserHistoryModelMutationVariables>;
export const QueryUserRoleByIdDocument = gql`
    query queryUserRoleById($userRoleId: uuid!) {
  UserRole_by_pk(id: $userRoleId) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type QueryUserRoleByIdQueryResult = Apollo.QueryResult<QueryUserRoleByIdQuery, QueryUserRoleByIdQueryVariables>;
export const QueryUserRoleObjectsDocument = gql`
    query queryUserRoleObjects($distinct_on: [UserRole_select_column!], $where: UserRole_bool_exp, $limit: Int, $offset: Int, $order_by: [UserRole_order_by!]) {
  UserRole(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type QueryUserRoleObjectsQueryResult = Apollo.QueryResult<QueryUserRoleObjectsQuery, QueryUserRoleObjectsQueryVariables>;
export const SubscribeToUserRoleByIdDocument = gql`
    subscription subscribeToUserRoleById($userRoleId: uuid!) {
  UserRole_by_pk(id: $userRoleId) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type SubscribeToUserRoleByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserRoleByIdSubscription>;
export const SubscribeToUserRoleObjectsDocument = gql`
    subscription subscribeToUserRoleObjects($distinct_on: [UserRole_select_column!], $where: UserRole_bool_exp, $limit: Int, $offset: Int, $order_by: [UserRole_order_by!]) {
  UserRole(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export type SubscribeToUserRoleObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToUserRoleObjectsSubscription>;
export const InsertUserRoleDocument = gql`
    mutation insertUserRole($objects: [UserRole_insert_input!]!) {
  insert_UserRole(objects: $objects) {
    affected_rows
    returning {
      ...UserRole
    }
  }
}
    ${UserRoleFragmentDoc}`;
export type InsertUserRoleMutationFn = Apollo.MutationFunction<InsertUserRoleMutation, InsertUserRoleMutationVariables>;
export type InsertUserRoleMutationResult = Apollo.MutationResult<InsertUserRoleMutation>;
export type InsertUserRoleMutationOptions = Apollo.BaseMutationOptions<InsertUserRoleMutation, InsertUserRoleMutationVariables>;
export const InsertUserRoleWithOnConflictDocument = gql`
    mutation insertUserRoleWithOnConflict($objects: [UserRole_insert_input!]!, $onConflict: UserRole_on_conflict) {
  insert_UserRole(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...UserRole
    }
  }
}
    ${UserRoleFragmentDoc}`;
export type InsertUserRoleWithOnConflictMutationFn = Apollo.MutationFunction<InsertUserRoleWithOnConflictMutation, InsertUserRoleWithOnConflictMutationVariables>;
export type InsertUserRoleWithOnConflictMutationResult = Apollo.MutationResult<InsertUserRoleWithOnConflictMutation>;
export type InsertUserRoleWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertUserRoleWithOnConflictMutation, InsertUserRoleWithOnConflictMutationVariables>;
export const UpdateUserRoleByIdDocument = gql`
    mutation updateUserRoleById($id: uuid, $set: UserRole_set_input) {
  update_UserRole(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...UserRole
    }
  }
}
    ${UserRoleFragmentDoc}`;
export type UpdateUserRoleByIdMutationFn = Apollo.MutationFunction<UpdateUserRoleByIdMutation, UpdateUserRoleByIdMutationVariables>;
export type UpdateUserRoleByIdMutationResult = Apollo.MutationResult<UpdateUserRoleByIdMutation>;
export type UpdateUserRoleByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleByIdMutation, UpdateUserRoleByIdMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($set: UserRole_set_input, $where: UserRole_bool_exp!) {
  update_UserRole(_set: $set, where: $where) {
    affected_rows
    returning {
      ...UserRole
    }
  }
}
    ${UserRoleFragmentDoc}`;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const RemoveUserRoleModelByIdDocument = gql`
    mutation removeUserRoleModelById($id: uuid) {
  delete_UserRole(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveUserRoleModelByIdMutationFn = Apollo.MutationFunction<RemoveUserRoleModelByIdMutation, RemoveUserRoleModelByIdMutationVariables>;
export type RemoveUserRoleModelByIdMutationResult = Apollo.MutationResult<RemoveUserRoleModelByIdMutation>;
export type RemoveUserRoleModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveUserRoleModelByIdMutation, RemoveUserRoleModelByIdMutationVariables>;
export const RemoveUserRoleModelDocument = gql`
    mutation removeUserRoleModel($where: UserRole_bool_exp!) {
  delete_UserRole(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveUserRoleModelMutationFn = Apollo.MutationFunction<RemoveUserRoleModelMutation, RemoveUserRoleModelMutationVariables>;
export type RemoveUserRoleModelMutationResult = Apollo.MutationResult<RemoveUserRoleModelMutation>;
export type RemoveUserRoleModelMutationOptions = Apollo.BaseMutationOptions<RemoveUserRoleModelMutation, RemoveUserRoleModelMutationVariables>;
export const QueryWanByIdDocument = gql`
    query queryWanById($wanId: uuid!) {
  Wan_by_pk(id: $wanId) {
    ...Wan
  }
}
    ${WanFragmentDoc}`;
export type QueryWanByIdQueryResult = Apollo.QueryResult<QueryWanByIdQuery, QueryWanByIdQueryVariables>;
export const QueryWanObjectsDocument = gql`
    query queryWanObjects($distinct_on: [Wan_select_column!], $where: Wan_bool_exp, $limit: Int, $offset: Int, $order_by: [Wan_order_by!]) {
  Wan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Wan
  }
}
    ${WanFragmentDoc}`;
export type QueryWanObjectsQueryResult = Apollo.QueryResult<QueryWanObjectsQuery, QueryWanObjectsQueryVariables>;
export const SubscribeToWanByIdDocument = gql`
    subscription subscribeToWanById($wanId: uuid!) {
  Wan_by_pk(id: $wanId) {
    ...Wan
  }
}
    ${WanFragmentDoc}`;
export type SubscribeToWanByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToWanByIdSubscription>;
export const SubscribeToWanObjectsDocument = gql`
    subscription subscribeToWanObjects($distinct_on: [Wan_select_column!], $where: Wan_bool_exp, $limit: Int, $offset: Int, $order_by: [Wan_order_by!]) {
  Wan(
    distinct_on: $distinct_on
    where: $where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...Wan
  }
}
    ${WanFragmentDoc}`;
export type SubscribeToWanObjectsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToWanObjectsSubscription>;
export const InsertWanDocument = gql`
    mutation insertWan($objects: [Wan_insert_input!]!) {
  insert_Wan(objects: $objects) {
    affected_rows
    returning {
      ...Wan
    }
  }
}
    ${WanFragmentDoc}`;
export type InsertWanMutationFn = Apollo.MutationFunction<InsertWanMutation, InsertWanMutationVariables>;
export type InsertWanMutationResult = Apollo.MutationResult<InsertWanMutation>;
export type InsertWanMutationOptions = Apollo.BaseMutationOptions<InsertWanMutation, InsertWanMutationVariables>;
export const InsertWanWithOnConflictDocument = gql`
    mutation insertWanWithOnConflict($objects: [Wan_insert_input!]!, $onConflict: Wan_on_conflict) {
  insert_Wan(objects: $objects, on_conflict: $onConflict) {
    affected_rows
    returning {
      ...Wan
    }
  }
}
    ${WanFragmentDoc}`;
export type InsertWanWithOnConflictMutationFn = Apollo.MutationFunction<InsertWanWithOnConflictMutation, InsertWanWithOnConflictMutationVariables>;
export type InsertWanWithOnConflictMutationResult = Apollo.MutationResult<InsertWanWithOnConflictMutation>;
export type InsertWanWithOnConflictMutationOptions = Apollo.BaseMutationOptions<InsertWanWithOnConflictMutation, InsertWanWithOnConflictMutationVariables>;
export const UpdateWanByIdDocument = gql`
    mutation updateWanById($id: uuid, $set: Wan_set_input) {
  update_Wan(_set: $set, where: {id: {_eq: $id}}) {
    affected_rows
    returning {
      ...Wan
    }
  }
}
    ${WanFragmentDoc}`;
export type UpdateWanByIdMutationFn = Apollo.MutationFunction<UpdateWanByIdMutation, UpdateWanByIdMutationVariables>;
export type UpdateWanByIdMutationResult = Apollo.MutationResult<UpdateWanByIdMutation>;
export type UpdateWanByIdMutationOptions = Apollo.BaseMutationOptions<UpdateWanByIdMutation, UpdateWanByIdMutationVariables>;
export const UpdateWanDocument = gql`
    mutation updateWan($set: Wan_set_input, $where: Wan_bool_exp!) {
  update_Wan(_set: $set, where: $where) {
    affected_rows
    returning {
      ...Wan
    }
  }
}
    ${WanFragmentDoc}`;
export type UpdateWanMutationFn = Apollo.MutationFunction<UpdateWanMutation, UpdateWanMutationVariables>;
export type UpdateWanMutationResult = Apollo.MutationResult<UpdateWanMutation>;
export type UpdateWanMutationOptions = Apollo.BaseMutationOptions<UpdateWanMutation, UpdateWanMutationVariables>;
export const RemoveWanModelByIdDocument = gql`
    mutation removeWanModelById($id: uuid) {
  delete_Wan(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type RemoveWanModelByIdMutationFn = Apollo.MutationFunction<RemoveWanModelByIdMutation, RemoveWanModelByIdMutationVariables>;
export type RemoveWanModelByIdMutationResult = Apollo.MutationResult<RemoveWanModelByIdMutation>;
export type RemoveWanModelByIdMutationOptions = Apollo.BaseMutationOptions<RemoveWanModelByIdMutation, RemoveWanModelByIdMutationVariables>;
export const RemoveWanModelDocument = gql`
    mutation removeWanModel($where: Wan_bool_exp!) {
  delete_Wan(where: $where) {
    affected_rows
  }
}
    `;
export type RemoveWanModelMutationFn = Apollo.MutationFunction<RemoveWanModelMutation, RemoveWanModelMutationVariables>;
export type RemoveWanModelMutationResult = Apollo.MutationResult<RemoveWanModelMutation>;
export type RemoveWanModelMutationOptions = Apollo.BaseMutationOptions<RemoveWanModelMutation, RemoveWanModelMutationVariables>;
